var city = [
    {
        "citycode": [],
        "adcode": "410000",
        "name": "河南省",
        "center": {
            "lng": 113.753094,
            "lat": 34.767052
        },
        "districtList": [
            {
                "citycode": "0379",
                "adcode": "410300",
                "name": "洛阳市",
                "center": {
                    "lng": 112.453895,
                    "lat": 34.619702
                },
                "districtList": [
                    {
                        "citycode": "0379",
                        "adcode": "410323",
                        "name": "新安县",
                        "center": {
                            "lng": 112.13246,
                            "lat": 34.728909
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410328",
                        "name": "洛宁县",
                        "center": {
                            "lng": 111.652958,
                            "lat": 34.389371
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410327",
                        "name": "宜阳县",
                        "center": {
                            "lng": 112.179187,
                            "lat": 34.51462
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410324",
                        "name": "栾川县",
                        "center": {
                            "lng": 111.615729,
                            "lat": 33.7857
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410329",
                        "name": "伊川县",
                        "center": {
                            "lng": 112.425751,
                            "lat": 34.421741
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410307",
                        "name": "偃师区",
                        "center": {
                            "lng": 112.789375,
                            "lat": 34.72715
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410308",
                        "name": "孟津区",
                        "center": {
                            "lng": 112.44525,
                            "lat": 34.825587
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410305",
                        "name": "涧西区",
                        "center": {
                            "lng": 112.395766,
                            "lat": 34.658177
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410304",
                        "name": "瀍河回族区",
                        "center": {
                            "lng": 112.500131,
                            "lat": 34.679773
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410311",
                        "name": "洛龙区",
                        "center": {
                            "lng": 112.463833,
                            "lat": 34.619711
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410325",
                        "name": "嵩县",
                        "center": {
                            "lng": 112.085432,
                            "lat": 34.134639
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410326",
                        "name": "汝阳县",
                        "center": {
                            "lng": 112.473013,
                            "lat": 34.154283
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410302",
                        "name": "老城区",
                        "center": {
                            "lng": 112.469071,
                            "lat": 34.683645
                        }
                    },
                    {
                        "citycode": "0379",
                        "adcode": "410303",
                        "name": "西工区",
                        "center": {
                            "lng": 112.428183,
                            "lat": 34.659959
                        }
                    }
                ]
            },
            {
                "citycode": "0398",
                "adcode": "411200",
                "name": "三门峡市",
                "center": {
                    "lng": 111.200482,
                    "lat": 34.773196
                },
                "districtList": [
                    {
                        "citycode": "0398",
                        "adcode": "411221",
                        "name": "渑池县",
                        "center": {
                            "lng": 111.761753,
                            "lat": 34.767937
                        }
                    },
                    {
                        "citycode": "0398",
                        "adcode": "411202",
                        "name": "湖滨区",
                        "center": {
                            "lng": 111.188552,
                            "lat": 34.771296
                        }
                    },
                    {
                        "citycode": "0398",
                        "adcode": "411281",
                        "name": "义马市",
                        "center": {
                            "lng": 111.874726,
                            "lat": 34.747563
                        }
                    },
                    {
                        "citycode": "0398",
                        "adcode": "411203",
                        "name": "陕州区",
                        "center": {
                            "lng": 111.103252,
                            "lat": 34.72066
                        }
                    },
                    {
                        "citycode": "0398",
                        "adcode": "411224",
                        "name": "卢氏县",
                        "center": {
                            "lng": 111.04522,
                            "lat": 34.051866
                        }
                    },
                    {
                        "citycode": "0398",
                        "adcode": "411282",
                        "name": "灵宝市",
                        "center": {
                            "lng": 110.894225,
                            "lat": 34.517734
                        }
                    }
                ]
            },
            {
                "citycode": "0395",
                "adcode": "411100",
                "name": "漯河市",
                "center": {
                    "lng": 114.0166,
                    "lat": 33.58038
                },
                "districtList": [
                    {
                        "citycode": "0395",
                        "adcode": "411122",
                        "name": "临颍县",
                        "center": {
                            "lng": 113.931121,
                            "lat": 33.828096
                        }
                    },
                    {
                        "citycode": "0395",
                        "adcode": "411104",
                        "name": "召陵区",
                        "center": {
                            "lng": 114.093879,
                            "lat": 33.586509
                        }
                    },
                    {
                        "citycode": "0395",
                        "adcode": "411102",
                        "name": "源汇区",
                        "center": {
                            "lng": 113.984164,
                            "lat": 33.572319
                        }
                    },
                    {
                        "citycode": "0395",
                        "adcode": "411103",
                        "name": "郾城区",
                        "center": {
                            "lng": 114.006596,
                            "lat": 33.587697
                        }
                    },
                    {
                        "citycode": "0395",
                        "adcode": "411121",
                        "name": "舞阳县",
                        "center": {
                            "lng": 113.609327,
                            "lat": 33.438259
                        }
                    }
                ]
            },
            {
                "citycode": "0374",
                "adcode": "411000",
                "name": "许昌市",
                "center": {
                    "lng": 113.852004,
                    "lat": 34.03732
                },
                "districtList": [
                    {
                        "citycode": "0374",
                        "adcode": "411003",
                        "name": "建安区",
                        "center": {
                            "lng": 113.822869,
                            "lat": 34.124729
                        }
                    },
                    {
                        "citycode": "0374",
                        "adcode": "411025",
                        "name": "襄城县",
                        "center": {
                            "lng": 113.506904,
                            "lat": 33.851609
                        }
                    },
                    {
                        "citycode": "0374",
                        "adcode": "411002",
                        "name": "魏都区",
                        "center": {
                            "lng": 113.830826,
                            "lat": 34.047189
                        }
                    },
                    {
                        "citycode": "0374",
                        "adcode": "411024",
                        "name": "鄢陵县",
                        "center": {
                            "lng": 114.177329,
                            "lat": 34.102985
                        }
                    },
                    {
                        "citycode": "0374",
                        "adcode": "411081",
                        "name": "禹州市",
                        "center": {
                            "lng": 113.488715,
                            "lat": 34.142442
                        }
                    },
                    {
                        "citycode": "0374",
                        "adcode": "411082",
                        "name": "长葛市",
                        "center": {
                            "lng": 113.813972,
                            "lat": 34.195458
                        }
                    }
                ]
            },
            {
                "citycode": "0377",
                "adcode": "411300",
                "name": "南阳市",
                "center": {
                    "lng": 112.584753,
                    "lat": 33.016102
                },
                "districtList": [
                    {
                        "citycode": "0377",
                        "adcode": "411328",
                        "name": "唐河县",
                        "center": {
                            "lng": 112.80829,
                            "lat": 32.682464
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411321",
                        "name": "南召县",
                        "center": {
                            "lng": 112.429277,
                            "lat": 33.489804
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411323",
                        "name": "西峡县",
                        "center": {
                            "lng": 111.473644,
                            "lat": 33.307272
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411303",
                        "name": "卧龙区",
                        "center": {
                            "lng": 112.528524,
                            "lat": 32.990313
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411324",
                        "name": "镇平县",
                        "center": {
                            "lng": 112.234571,
                            "lat": 33.033826
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411326",
                        "name": "淅川县",
                        "center": {
                            "lng": 111.490902,
                            "lat": 33.137831
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411325",
                        "name": "内乡县",
                        "center": {
                            "lng": 111.849354,
                            "lat": 33.044698
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411329",
                        "name": "新野县",
                        "center": {
                            "lng": 112.3601,
                            "lat": 32.521282
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411327",
                        "name": "社旗县",
                        "center": {
                            "lng": 112.948183,
                            "lat": 33.056229
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411322",
                        "name": "方城县",
                        "center": {
                            "lng": 113.012849,
                            "lat": 33.255387
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411381",
                        "name": "邓州市",
                        "center": {
                            "lng": 112.08745,
                            "lat": 32.687732
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411302",
                        "name": "宛城区",
                        "center": {
                            "lng": 112.539506,
                            "lat": 33.003564
                        }
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411330",
                        "name": "桐柏县",
                        "center": {
                            "lng": 113.428702,
                            "lat": 32.379164
                        }
                    }
                ]
            },
            {
                "citycode": "0376",
                "adcode": "411500",
                "name": "信阳市",
                "center": {
                    "lng": 114.091058,
                    "lat": 32.148624
                },
                "districtList": [
                    {
                        "citycode": "0376",
                        "adcode": "411502",
                        "name": "浉河区",
                        "center": {
                            "lng": 114.05867,
                            "lat": 32.116885
                        }
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411525",
                        "name": "固始县",
                        "center": {
                            "lng": 115.654066,
                            "lat": 32.169239
                        }
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411527",
                        "name": "淮滨县",
                        "center": {
                            "lng": 115.420101,
                            "lat": 32.474772
                        }
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411522",
                        "name": "光山县",
                        "center": {
                            "lng": 114.91934,
                            "lat": 32.010736
                        }
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411528",
                        "name": "息县",
                        "center": {
                            "lng": 114.740392,
                            "lat": 32.34312
                        }
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411521",
                        "name": "罗山县",
                        "center": {
                            "lng": 114.512838,
                            "lat": 32.20436
                        }
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411503",
                        "name": "平桥区",
                        "center": {
                            "lng": 114.125595,
                            "lat": 32.101005
                        }
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411524",
                        "name": "商城县",
                        "center": {
                            "lng": 115.406894,
                            "lat": 31.79832
                        }
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411526",
                        "name": "潢川县",
                        "center": {
                            "lng": 115.051683,
                            "lat": 32.131426
                        }
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411523",
                        "name": "新县",
                        "center": {
                            "lng": 114.879309,
                            "lat": 31.643914
                        }
                    }
                ]
            },
            {
                "citycode": "0392",
                "adcode": "410600",
                "name": "鹤壁市",
                "center": {
                    "lng": 114.297305,
                    "lat": 35.748329
                },
                "districtList": [
                    {
                        "citycode": "0392",
                        "adcode": "410622",
                        "name": "淇县",
                        "center": {
                            "lng": 114.208851,
                            "lat": 35.622571
                        }
                    },
                    {
                        "citycode": "0392",
                        "adcode": "410602",
                        "name": "鹤山区",
                        "center": {
                            "lng": 114.163133,
                            "lat": 35.954647
                        }
                    },
                    {
                        "citycode": "0392",
                        "adcode": "410603",
                        "name": "山城区",
                        "center": {
                            "lng": 114.184391,
                            "lat": 35.897862
                        }
                    },
                    {
                        "citycode": "0392",
                        "adcode": "410611",
                        "name": "淇滨区",
                        "center": {
                            "lng": 114.298748,
                            "lat": 35.741763
                        }
                    },
                    {
                        "citycode": "0392",
                        "adcode": "410621",
                        "name": "浚县",
                        "center": {
                            "lng": 114.550611,
                            "lat": 35.677249
                        }
                    }
                ]
            },
            {
                "citycode": "0393",
                "adcode": "410900",
                "name": "濮阳市",
                "center": {
                    "lng": 115.029246,
                    "lat": 35.762731
                },
                "districtList": [
                    {
                        "citycode": "0393",
                        "adcode": "410927",
                        "name": "台前县",
                        "center": {
                            "lng": 115.871671,
                            "lat": 35.970286
                        }
                    },
                    {
                        "citycode": "0393",
                        "adcode": "410922",
                        "name": "清丰县",
                        "center": {
                            "lng": 115.104602,
                            "lat": 35.886694
                        }
                    },
                    {
                        "citycode": "0393",
                        "adcode": "410926",
                        "name": "范县",
                        "center": {
                            "lng": 115.504081,
                            "lat": 35.85302
                        }
                    },
                    {
                        "citycode": "0393",
                        "adcode": "410923",
                        "name": "南乐县",
                        "center": {
                            "lng": 115.205876,
                            "lat": 36.070219
                        }
                    },
                    {
                        "citycode": "0393",
                        "adcode": "410902",
                        "name": "华龙区",
                        "center": {
                            "lng": 115.074453,
                            "lat": 35.778289
                        }
                    },
                    {
                        "citycode": "0393",
                        "adcode": "410928",
                        "name": "濮阳县",
                        "center": {
                            "lng": 115.029165,
                            "lat": 35.713113
                        }
                    }
                ]
            },
            {
                "citycode": "1391",
                "adcode": "419001",
                "name": "济源市",
                "center": {
                    "lng": 112.602347,
                    "lat": 35.069057
                },
                "districtList": [
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "坡头镇",
                        "center": {
                            "lng": 112.580245,
                            "lat": 35.063381
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "梨林镇",
                        "center": {
                            "lng": 112.75322,
                            "lat": 35.088183
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "思礼镇",
                        "center": {
                            "lng": 112.388078,
                            "lat": 35.210276
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "五龙口镇",
                        "center": {
                            "lng": 112.761264,
                            "lat": 35.195598
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "王屋镇",
                        "center": {
                            "lng": 112.168531,
                            "lat": 35.124376
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "玉泉街道",
                        "center": {
                            "lng": 112.623553,
                            "lat": 35.118882
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "轵城镇",
                        "center": {
                            "lng": 112.622105,
                            "lat": 35.06253
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "济水街道",
                        "center": {
                            "lng": 112.595477,
                            "lat": 35.094386
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "沁园街道",
                        "center": {
                            "lng": 112.59321,
                            "lat": 35.082244
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "下冶镇",
                        "center": {
                            "lng": 112.212297,
                            "lat": 35.113088
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "克井镇",
                        "center": {
                            "lng": 112.63491,
                            "lat": 35.255031
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "天坛街道",
                        "center": {
                            "lng": 112.566796,
                            "lat": 35.122905
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "邵原镇",
                        "center": {
                            "lng": 112.114016,
                            "lat": 35.27048
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "北海街道",
                        "center": {
                            "lng": 112.568975,
                            "lat": 35.111552
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "承留镇",
                        "center": {
                            "lng": 112.508612,
                            "lat": 35.024328
                        }
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "大峪镇",
                        "center": {
                            "lng": 112.31891,
                            "lat": 35.079253
                        }
                    }
                ]
            },
            {
                "citycode": "0375",
                "adcode": "410400",
                "name": "平顶山市",
                "center": {
                    "lng": 113.192595,
                    "lat": 33.766554
                },
                "districtList": [
                    {
                        "citycode": "0375",
                        "adcode": "410403",
                        "name": "卫东区",
                        "center": {
                            "lng": 113.335316,
                            "lat": 33.735388
                        }
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410423",
                        "name": "鲁山县",
                        "center": {
                            "lng": 112.908052,
                            "lat": 33.738434
                        }
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410411",
                        "name": "湛河区",
                        "center": {
                            "lng": 113.320873,
                            "lat": 33.725681
                        }
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410481",
                        "name": "舞钢市",
                        "center": {
                            "lng": 113.516427,
                            "lat": 33.314147
                        }
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410402",
                        "name": "新华区",
                        "center": {
                            "lng": 113.293977,
                            "lat": 33.737251
                        }
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410422",
                        "name": "叶县",
                        "center": {
                            "lng": 113.357476,
                            "lat": 33.627437
                        }
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410404",
                        "name": "石龙区",
                        "center": {
                            "lng": 112.898845,
                            "lat": 33.899247
                        }
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410482",
                        "name": "汝州市",
                        "center": {
                            "lng": 112.844696,
                            "lat": 34.16717
                        }
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410421",
                        "name": "宝丰县",
                        "center": {
                            "lng": 113.054538,
                            "lat": 33.869159
                        }
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410425",
                        "name": "郏县",
                        "center": {
                            "lng": 113.21261,
                            "lat": 33.971787
                        }
                    }
                ]
            },
            {
                "citycode": "0378",
                "adcode": "410200",
                "name": "开封市",
                "center": {
                    "lng": 114.314278,
                    "lat": 34.798083
                },
                "districtList": [
                    {
                        "citycode": "0378",
                        "adcode": "410221",
                        "name": "杞县",
                        "center": {
                            "lng": 114.782629,
                            "lat": 34.549731
                        }
                    },
                    {
                        "citycode": "0378",
                        "adcode": "410205",
                        "name": "禹王台区",
                        "center": {
                            "lng": 114.348105,
                            "lat": 34.777052
                        }
                    },
                    {
                        "citycode": "0378",
                        "adcode": "410222",
                        "name": "通许县",
                        "center": {
                            "lng": 114.47315,
                            "lat": 34.502053
                        }
                    },
                    {
                        "citycode": "0378",
                        "adcode": "410223",
                        "name": "尉氏县",
                        "center": {
                            "lng": 114.19305,
                            "lat": 34.411437
                        }
                    },
                    {
                        "citycode": "0378",
                        "adcode": "410225",
                        "name": "兰考县",
                        "center": {
                            "lng": 114.818228,
                            "lat": 34.856372
                        }
                    },
                    {
                        "citycode": "0378",
                        "adcode": "410212",
                        "name": "祥符区",
                        "center": {
                            "lng": 114.441406,
                            "lat": 34.757546
                        }
                    },
                    {
                        "citycode": "0378",
                        "adcode": "410203",
                        "name": "顺河回族区",
                        "center": {
                            "lng": 114.360824,
                            "lat": 34.795933
                        }
                    },
                    {
                        "citycode": "0378",
                        "adcode": "410202",
                        "name": "龙亭区",
                        "center": {
                            "lng": 114.355378,
                            "lat": 34.815515
                        }
                    },
                    {
                        "citycode": "0378",
                        "adcode": "410204",
                        "name": "鼓楼区",
                        "center": {
                            "lng": 114.348356,
                            "lat": 34.788473
                        }
                    }
                ]
            },
            {
                "citycode": "0371",
                "adcode": "410100",
                "name": "郑州市",
                "center": {
                    "lng": 113.625351,
                    "lat": 34.746303
                },
                "districtList": [
                    {
                        "citycode": "0371",
                        "adcode": "410185",
                        "name": "登封市",
                        "center": {
                            "lng": 113.05056,
                            "lat": 34.454877
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410102",
                        "name": "中原区",
                        "center": {
                            "lng": 113.612966,
                            "lat": 34.74828
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410108",
                        "name": "惠济区",
                        "center": {
                            "lng": 113.617055,
                            "lat": 34.867994
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410105",
                        "name": "金水区",
                        "center": {
                            "lng": 113.6603,
                            "lat": 34.800415
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410106",
                        "name": "上街区",
                        "center": {
                            "lng": 113.309185,
                            "lat": 34.803514
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410122",
                        "name": "中牟县",
                        "center": {
                            "lng": 113.975798,
                            "lat": 34.720535
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410103",
                        "name": "二七区",
                        "center": {
                            "lng": 113.640177,
                            "lat": 34.724138
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410181",
                        "name": "巩义市",
                        "center": {
                            "lng": 113.022354,
                            "lat": 34.748207
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410183",
                        "name": "新密市",
                        "center": {
                            "lng": 113.390932,
                            "lat": 34.540216
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410184",
                        "name": "新郑市",
                        "center": {
                            "lng": 113.74024,
                            "lat": 34.396479
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410182",
                        "name": "荥阳市",
                        "center": {
                            "lng": 113.383385,
                            "lat": 34.7866
                        }
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410104",
                        "name": "管城回族区",
                        "center": {
                            "lng": 113.677446,
                            "lat": 34.754436
                        }
                    }
                ]
            },
            {
                "citycode": "0373",
                "adcode": "410700",
                "name": "新乡市",
                "center": {
                    "lng": 113.92679,
                    "lat": 35.303589
                },
                "districtList": [
                    {
                        "citycode": "0373",
                        "adcode": "410724",
                        "name": "获嘉县",
                        "center": {
                            "lng": 113.657551,
                            "lat": 35.260153
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410711",
                        "name": "牧野区",
                        "center": {
                            "lng": 113.908561,
                            "lat": 35.315614
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410703",
                        "name": "卫滨区",
                        "center": {
                            "lng": 113.865666,
                            "lat": 35.301796
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410783",
                        "name": "长垣市",
                        "center": {
                            "lng": 114.66885,
                            "lat": 35.201628
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410721",
                        "name": "新乡县",
                        "center": {
                            "lng": 113.813884,
                            "lat": 35.170066
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410726",
                        "name": "延津县",
                        "center": {
                            "lng": 114.205624,
                            "lat": 35.165876
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410702",
                        "name": "红旗区",
                        "center": {
                            "lng": 113.875211,
                            "lat": 35.302952
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410782",
                        "name": "辉县市",
                        "center": {
                            "lng": 113.80572,
                            "lat": 35.462964
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410781",
                        "name": "卫辉市",
                        "center": {
                            "lng": 114.064584,
                            "lat": 35.398357
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410704",
                        "name": "凤泉区",
                        "center": {
                            "lng": 113.916183,
                            "lat": 35.384428
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410725",
                        "name": "原阳县",
                        "center": {
                            "lng": 113.939829,
                            "lat": 35.066873
                        }
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410727",
                        "name": "封丘县",
                        "center": {
                            "lng": 114.418907,
                            "lat": 35.041237
                        }
                    }
                ]
            },
            {
                "citycode": "0391",
                "adcode": "410800",
                "name": "焦作市",
                "center": {
                    "lng": 113.241902,
                    "lat": 35.215726
                },
                "districtList": [
                    {
                        "citycode": "0391",
                        "adcode": "410803",
                        "name": "中站区",
                        "center": {
                            "lng": 113.182847,
                            "lat": 35.237227
                        }
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410802",
                        "name": "解放区",
                        "center": {
                            "lng": 113.230555,
                            "lat": 35.240403
                        }
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410804",
                        "name": "马村区",
                        "center": {
                            "lng": 113.32212,
                            "lat": 35.257084
                        }
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410821",
                        "name": "修武县",
                        "center": {
                            "lng": 113.447862,
                            "lat": 35.22286
                        }
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410811",
                        "name": "山阳区",
                        "center": {
                            "lng": 113.254581,
                            "lat": 35.215054
                        }
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410883",
                        "name": "孟州市",
                        "center": {
                            "lng": 112.791372,
                            "lat": 34.907229
                        }
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410825",
                        "name": "温县",
                        "center": {
                            "lng": 113.08067,
                            "lat": 34.93961
                        }
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410823",
                        "name": "武陟县",
                        "center": {
                            "lng": 113.401848,
                            "lat": 35.099458
                        }
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410882",
                        "name": "沁阳市",
                        "center": {
                            "lng": 112.950873,
                            "lat": 35.087569
                        }
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410822",
                        "name": "博爱县",
                        "center": {
                            "lng": 113.064701,
                            "lat": 35.170332
                        }
                    }
                ]
            },
            {
                "citycode": "0370",
                "adcode": "411400",
                "name": "商丘市",
                "center": {
                    "lng": 115.656358,
                    "lat": 34.415165
                },
                "districtList": [
                    {
                        "citycode": "0370",
                        "adcode": "411421",
                        "name": "民权县",
                        "center": {
                            "lng": 115.175019,
                            "lat": 34.648384
                        }
                    },
                    {
                        "citycode": "0370",
                        "adcode": "411422",
                        "name": "睢县",
                        "center": {
                            "lng": 115.071957,
                            "lat": 34.446572
                        }
                    },
                    {
                        "citycode": "0370",
                        "adcode": "411424",
                        "name": "柘城县",
                        "center": {
                            "lng": 115.305182,
                            "lat": 34.092015
                        }
                    },
                    {
                        "citycode": "0370",
                        "adcode": "411423",
                        "name": "宁陵县",
                        "center": {
                            "lng": 115.314221,
                            "lat": 34.461226
                        }
                    },
                    {
                        "citycode": "0370",
                        "adcode": "411403",
                        "name": "睢阳区",
                        "center": {
                            "lng": 115.653258,
                            "lat": 34.389048
                        }
                    },
                    {
                        "citycode": "0370",
                        "adcode": "411402",
                        "name": "梁园区",
                        "center": {
                            "lng": 115.613609,
                            "lat": 34.444519
                        }
                    },
                    {
                        "citycode": "0370",
                        "adcode": "411425",
                        "name": "虞城县",
                        "center": {
                            "lng": 115.828519,
                            "lat": 34.400868
                        }
                    },
                    {
                        "citycode": "0370",
                        "adcode": "411481",
                        "name": "永城市",
                        "center": {
                            "lng": 116.449864,
                            "lat": 33.929927
                        }
                    },
                    {
                        "citycode": "0370",
                        "adcode": "411426",
                        "name": "夏邑县",
                        "center": {
                            "lng": 116.131422,
                            "lat": 34.237801
                        }
                    }
                ]
            },
            {
                "citycode": "0394",
                "adcode": "411600",
                "name": "周口市",
                "center": {
                    "lng": 114.701222,
                    "lat": 33.634652
                },
                "districtList": [
                    {
                        "citycode": "0394",
                        "adcode": "411623",
                        "name": "商水县",
                        "center": {
                            "lng": 114.608135,
                            "lat": 33.562072
                        }
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411602",
                        "name": "川汇区",
                        "center": {
                            "lng": 114.650551,
                            "lat": 33.647679
                        }
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411628",
                        "name": "鹿邑县",
                        "center": {
                            "lng": 115.484525,
                            "lat": 33.860698
                        }
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411603",
                        "name": "淮阳区",
                        "center": {
                            "lng": 114.852604,
                            "lat": 33.731543
                        }
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411622",
                        "name": "西华县",
                        "center": {
                            "lng": 114.529709,
                            "lat": 33.768277
                        }
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411627",
                        "name": "太康县",
                        "center": {
                            "lng": 114.837946,
                            "lat": 34.064513
                        }
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411624",
                        "name": "沈丘县",
                        "center": {
                            "lng": 115.098541,
                            "lat": 33.409805
                        }
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411681",
                        "name": "项城市",
                        "center": {
                            "lng": 114.875128,
                            "lat": 33.465609
                        }
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411621",
                        "name": "扶沟县",
                        "center": {
                            "lng": 114.394666,
                            "lat": 34.060062
                        }
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411625",
                        "name": "郸城县",
                        "center": {
                            "lng": 115.177141,
                            "lat": 33.64601
                        }
                    }
                ]
            },
            {
                "citycode": "0396",
                "adcode": "411700",
                "name": "驻马店市",
                "center": {
                    "lng": 114.021988,
                    "lat": 33.014038
                },
                "districtList": [
                    {
                        "citycode": "0396",
                        "adcode": "411728",
                        "name": "遂平县",
                        "center": {
                            "lng": 114.013323,
                            "lat": 33.146316
                        }
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411727",
                        "name": "汝南县",
                        "center": {
                            "lng": 114.362477,
                            "lat": 33.006808
                        }
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411723",
                        "name": "平舆县",
                        "center": {
                            "lng": 114.618537,
                            "lat": 32.96344
                        }
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411721",
                        "name": "西平县",
                        "center": {
                            "lng": 114.021492,
                            "lat": 33.387658
                        }
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411722",
                        "name": "上蔡县",
                        "center": {
                            "lng": 114.264381,
                            "lat": 33.262439
                        }
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411729",
                        "name": "新蔡县",
                        "center": {
                            "lng": 114.965519,
                            "lat": 32.74488
                        }
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411724",
                        "name": "正阳县",
                        "center": {
                            "lng": 114.392774,
                            "lat": 32.605697
                        }
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411725",
                        "name": "确山县",
                        "center": {
                            "lng": 114.016818,
                            "lat": 32.82134
                        }
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411702",
                        "name": "驿城区",
                        "center": {
                            "lng": 113.993753,
                            "lat": 32.97455
                        }
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411726",
                        "name": "泌阳县",
                        "center": {
                            "lng": 113.327144,
                            "lat": 32.723974
                        }
                    }
                ]
            },
            {
                "citycode": "0372",
                "adcode": "410500",
                "name": "安阳市",
                "center": {
                    "lng": 114.39248,
                    "lat": 36.098779
                },
                "districtList": [
                    {
                        "citycode": "0372",
                        "adcode": "410503",
                        "name": "北关区",
                        "center": {
                            "lng": 114.355742,
                            "lat": 36.10766
                        }
                    },
                    {
                        "citycode": "0372",
                        "adcode": "410523",
                        "name": "汤阴县",
                        "center": {
                            "lng": 114.357686,
                            "lat": 35.925155
                        }
                    },
                    {
                        "citycode": "0372",
                        "adcode": "410522",
                        "name": "安阳县",
                        "center": {
                            "lng": 114.462953,
                            "lat": 36.09211
                        }
                    },
                    {
                        "citycode": "0372",
                        "adcode": "410502",
                        "name": "文峰区",
                        "center": {
                            "lng": 114.356967,
                            "lat": 36.090593
                        }
                    },
                    {
                        "citycode": "0372",
                        "adcode": "410505",
                        "name": "殷都区",
                        "center": {
                            "lng": 114.303454,
                            "lat": 36.109938
                        }
                    },
                    {
                        "citycode": "0372",
                        "adcode": "410506",
                        "name": "龙安区",
                        "center": {
                            "lng": 114.301037,
                            "lat": 36.076937
                        }
                    },
                    {
                        "citycode": "0372",
                        "adcode": "410527",
                        "name": "内黄县",
                        "center": {
                            "lng": 114.90146,
                            "lat": 35.972016
                        }
                    },
                    {
                        "citycode": "0372",
                        "adcode": "410581",
                        "name": "林州市",
                        "center": {
                            "lng": 113.819275,
                            "lat": 36.084127
                        }
                    },
                    {
                        "citycode": "0372",
                        "adcode": "410526",
                        "name": "滑县",
                        "center": {
                            "lng": 114.517977,
                            "lat": 35.576128
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "440000",
        "name": "广东省",
        "center": {
            "lng": 113.266887,
            "lat": 23.133306
        },
        "districtList": [
            {
                "citycode": "0754",
                "adcode": "440500",
                "name": "汕头市",
                "center": {
                    "lng": 116.681956,
                    "lat": 23.354152
                },
                "districtList": [
                    {
                        "citycode": "0754",
                        "adcode": "440515",
                        "name": "澄海区",
                        "center": {
                            "lng": 116.755945,
                            "lat": 23.466314
                        }
                    },
                    {
                        "citycode": "0754",
                        "adcode": "440523",
                        "name": "南澳县",
                        "center": {
                            "lng": 117.023482,
                            "lat": 23.421658
                        }
                    },
                    {
                        "citycode": "0754",
                        "adcode": "440512",
                        "name": "濠江区",
                        "center": {
                            "lng": 116.726701,
                            "lat": 23.286605
                        }
                    },
                    {
                        "citycode": "0754",
                        "adcode": "440507",
                        "name": "龙湖区",
                        "center": {
                            "lng": 116.716464,
                            "lat": 23.372211
                        }
                    },
                    {
                        "citycode": "0754",
                        "adcode": "440511",
                        "name": "金平区",
                        "center": {
                            "lng": 116.70341,
                            "lat": 23.365716
                        }
                    },
                    {
                        "citycode": "0754",
                        "adcode": "440514",
                        "name": "潮南区",
                        "center": {
                            "lng": 116.439105,
                            "lat": 23.239196
                        }
                    },
                    {
                        "citycode": "0754",
                        "adcode": "440513",
                        "name": "潮阳区",
                        "center": {
                            "lng": 116.601677,
                            "lat": 23.264923
                        }
                    }
                ]
            },
            {
                "citycode": "0757",
                "adcode": "440600",
                "name": "佛山市",
                "center": {
                    "lng": 113.121586,
                    "lat": 23.021351
                },
                "districtList": [
                    {
                        "citycode": "0757",
                        "adcode": "440608",
                        "name": "高明区",
                        "center": {
                            "lng": 112.892573,
                            "lat": 22.900047
                        }
                    },
                    {
                        "citycode": "0757",
                        "adcode": "440607",
                        "name": "三水区",
                        "center": {
                            "lng": 112.897271,
                            "lat": 23.156675
                        }
                    },
                    {
                        "citycode": "0757",
                        "adcode": "440605",
                        "name": "南海区",
                        "center": {
                            "lng": 113.143246,
                            "lat": 23.028875
                        }
                    },
                    {
                        "citycode": "0757",
                        "adcode": "440604",
                        "name": "禅城区",
                        "center": {
                            "lng": 113.122532,
                            "lat": 23.009475
                        }
                    },
                    {
                        "citycode": "0757",
                        "adcode": "440606",
                        "name": "顺德区",
                        "center": {
                            "lng": 113.293197,
                            "lat": 22.805413
                        }
                    }
                ]
            },
            {
                "citycode": "0758",
                "adcode": "441200",
                "name": "肇庆市",
                "center": {
                    "lng": 112.465245,
                    "lat": 23.047747
                },
                "districtList": [
                    {
                        "citycode": "0758",
                        "adcode": "441224",
                        "name": "怀集县",
                        "center": {
                            "lng": 112.166908,
                            "lat": 23.920806
                        }
                    },
                    {
                        "citycode": "0758",
                        "adcode": "441284",
                        "name": "四会市",
                        "center": {
                            "lng": 112.734309,
                            "lat": 23.326991
                        }
                    },
                    {
                        "citycode": "0758",
                        "adcode": "441226",
                        "name": "德庆县",
                        "center": {
                            "lng": 111.785544,
                            "lat": 23.145035
                        }
                    },
                    {
                        "citycode": "0758",
                        "adcode": "441225",
                        "name": "封开县",
                        "center": {
                            "lng": 111.512177,
                            "lat": 23.423928
                        }
                    },
                    {
                        "citycode": "0758",
                        "adcode": "441223",
                        "name": "广宁县",
                        "center": {
                            "lng": 112.440694,
                            "lat": 23.634808
                        }
                    },
                    {
                        "citycode": "0758",
                        "adcode": "441202",
                        "name": "端州区",
                        "center": {
                            "lng": 112.485577,
                            "lat": 23.051847
                        }
                    },
                    {
                        "citycode": "0758",
                        "adcode": "441203",
                        "name": "鼎湖区",
                        "center": {
                            "lng": 112.56738,
                            "lat": 23.159062
                        }
                    },
                    {
                        "citycode": "0758",
                        "adcode": "441204",
                        "name": "高要区",
                        "center": {
                            "lng": 112.458055,
                            "lat": 23.02474
                        }
                    }
                ]
            },
            {
                "citycode": "0752",
                "adcode": "441300",
                "name": "惠州市",
                "center": {
                    "lng": 114.415587,
                    "lat": 23.112368
                },
                "districtList": [
                    {
                        "citycode": "0752",
                        "adcode": "441324",
                        "name": "龙门县",
                        "center": {
                            "lng": 114.254898,
                            "lat": 23.727873
                        }
                    },
                    {
                        "citycode": "0752",
                        "adcode": "441323",
                        "name": "惠东县",
                        "center": {
                            "lng": 114.720136,
                            "lat": 22.984831
                        }
                    },
                    {
                        "citycode": "0752",
                        "adcode": "441303",
                        "name": "惠阳区",
                        "center": {
                            "lng": 114.456107,
                            "lat": 22.789431
                        }
                    },
                    {
                        "citycode": "0752",
                        "adcode": "441302",
                        "name": "惠城区",
                        "center": {
                            "lng": 114.382526,
                            "lat": 23.084657
                        }
                    },
                    {
                        "citycode": "0752",
                        "adcode": "441322",
                        "name": "博罗县",
                        "center": {
                            "lng": 114.289602,
                            "lat": 23.172587
                        }
                    }
                ]
            },
            {
                "citycode": "0755",
                "adcode": "440300",
                "name": "深圳市",
                "center": {
                    "lng": 114.057939,
                    "lat": 22.543527
                },
                "districtList": [
                    {
                        "citycode": "0755",
                        "adcode": "440306",
                        "name": "宝安区",
                        "center": {
                            "lng": 113.883831,
                            "lat": 22.554986
                        }
                    },
                    {
                        "citycode": "0755",
                        "adcode": "440305",
                        "name": "南山区",
                        "center": {
                            "lng": 113.930478,
                            "lat": 22.533191
                        }
                    },
                    {
                        "citycode": "0755",
                        "adcode": "440304",
                        "name": "福田区",
                        "center": {
                            "lng": 114.055198,
                            "lat": 22.520922
                        }
                    },
                    {
                        "citycode": "0755",
                        "adcode": "440307",
                        "name": "龙岗区",
                        "center": {
                            "lng": 114.246884,
                            "lat": 22.720889
                        }
                    },
                    {
                        "citycode": "0755",
                        "adcode": "440311",
                        "name": "光明区",
                        "center": {
                            "lng": 113.936059,
                            "lat": 22.74875
                        }
                    },
                    {
                        "citycode": "0755",
                        "adcode": "440308",
                        "name": "盐田区",
                        "center": {
                            "lng": 114.236739,
                            "lat": 22.557001
                        }
                    },
                    {
                        "citycode": "0755",
                        "adcode": "440303",
                        "name": "罗湖区",
                        "center": {
                            "lng": 114.131611,
                            "lat": 22.548309
                        }
                    },
                    {
                        "citycode": "0755",
                        "adcode": "440309",
                        "name": "龙华区",
                        "center": {
                            "lng": 114.04491,
                            "lat": 22.696735
                        }
                    },
                    {
                        "citycode": "0755",
                        "adcode": "440310",
                        "name": "坪山区",
                        "center": {
                            "lng": 114.350844,
                            "lat": 22.708786
                        }
                    }
                ]
            },
            {
                "citycode": "0756",
                "adcode": "440400",
                "name": "珠海市",
                "center": {
                    "lng": 113.576892,
                    "lat": 22.271644
                },
                "districtList": [
                    {
                        "citycode": "0756",
                        "adcode": "440402",
                        "name": "香洲区",
                        "center": {
                            "lng": 113.543372,
                            "lat": 22.265635
                        }
                    },
                    {
                        "citycode": "0756",
                        "adcode": "440403",
                        "name": "斗门区",
                        "center": {
                            "lng": 113.296228,
                            "lat": 22.209134
                        }
                    },
                    {
                        "citycode": "0756",
                        "adcode": "440404",
                        "name": "金湾区",
                        "center": {
                            "lng": 113.363224,
                            "lat": 22.146717
                        }
                    },
                    {
                        "citycode": [],
                        "adcode": "440499",
                        "name": "澳门大学横琴校区(由澳门实施管辖)",
                        "center": {
                            "lng": 113.548956,
                            "lat": 22.126197
                        }
                    }
                ]
            },
            {
                "citycode": "0759",
                "adcode": "440800",
                "name": "湛江市",
                "center": {
                    "lng": 110.357538,
                    "lat": 21.270108
                },
                "districtList": [
                    {
                        "citycode": "0759",
                        "adcode": "440883",
                        "name": "吴川市",
                        "center": {
                            "lng": 110.779361,
                            "lat": 21.440763
                        }
                    },
                    {
                        "citycode": "0759",
                        "adcode": "440881",
                        "name": "廉江市",
                        "center": {
                            "lng": 110.286109,
                            "lat": 21.609988
                        }
                    },
                    {
                        "citycode": "0759",
                        "adcode": "440811",
                        "name": "麻章区",
                        "center": {
                            "lng": 110.333833,
                            "lat": 21.26437
                        }
                    },
                    {
                        "citycode": "0759",
                        "adcode": "440825",
                        "name": "徐闻县",
                        "center": {
                            "lng": 110.17595,
                            "lat": 20.325969
                        }
                    },
                    {
                        "citycode": "0759",
                        "adcode": "440803",
                        "name": "霞山区",
                        "center": {
                            "lng": 110.397721,
                            "lat": 21.192463
                        }
                    },
                    {
                        "citycode": "0759",
                        "adcode": "440804",
                        "name": "坡头区",
                        "center": {
                            "lng": 110.455192,
                            "lat": 21.244405
                        }
                    },
                    {
                        "citycode": "0759",
                        "adcode": "440823",
                        "name": "遂溪县",
                        "center": {
                            "lng": 110.25043,
                            "lat": 21.378371
                        }
                    },
                    {
                        "citycode": "0759",
                        "adcode": "440802",
                        "name": "赤坎区",
                        "center": {
                            "lng": 110.365592,
                            "lat": 21.265948
                        }
                    },
                    {
                        "citycode": "0759",
                        "adcode": "440882",
                        "name": "雷州市",
                        "center": {
                            "lng": 110.097011,
                            "lat": 20.914548
                        }
                    }
                ]
            },
            {
                "citycode": "0750",
                "adcode": "440700",
                "name": "江门市",
                "center": {
                    "lng": 113.081548,
                    "lat": 22.578948
                },
                "districtList": [
                    {
                        "citycode": "0750",
                        "adcode": "440784",
                        "name": "鹤山市",
                        "center": {
                            "lng": 112.964203,
                            "lat": 22.765912
                        }
                    },
                    {
                        "citycode": "0750",
                        "adcode": "440781",
                        "name": "台山市",
                        "center": {
                            "lng": 112.793812,
                            "lat": 22.251947
                        }
                    },
                    {
                        "citycode": "0750",
                        "adcode": "440705",
                        "name": "新会区",
                        "center": {
                            "lng": 113.034454,
                            "lat": 22.458519
                        }
                    },
                    {
                        "citycode": "0750",
                        "adcode": "440704",
                        "name": "江海区",
                        "center": {
                            "lng": 113.111029,
                            "lat": 22.561301
                        }
                    },
                    {
                        "citycode": "0750",
                        "adcode": "440703",
                        "name": "蓬江区",
                        "center": {
                            "lng": 113.078914,
                            "lat": 22.595285
                        }
                    },
                    {
                        "citycode": "0750",
                        "adcode": "440783",
                        "name": "开平市",
                        "center": {
                            "lng": 112.698113,
                            "lat": 22.377378
                        }
                    },
                    {
                        "citycode": "0750",
                        "adcode": "440785",
                        "name": "恩平市",
                        "center": {
                            "lng": 112.304904,
                            "lat": 22.183743
                        }
                    }
                ]
            },
            {
                "citycode": "0662",
                "adcode": "441700",
                "name": "阳江市",
                "center": {
                    "lng": 111.98343,
                    "lat": 21.856853
                },
                "districtList": [
                    {
                        "citycode": "0662",
                        "adcode": "441781",
                        "name": "阳春市",
                        "center": {
                            "lng": 111.791587,
                            "lat": 22.17041
                        }
                    },
                    {
                        "citycode": "0662",
                        "adcode": "441721",
                        "name": "阳西县",
                        "center": {
                            "lng": 111.617696,
                            "lat": 21.753935
                        }
                    },
                    {
                        "citycode": "0662",
                        "adcode": "441702",
                        "name": "江城区",
                        "center": {
                            "lng": 111.95486,
                            "lat": 21.862451
                        }
                    },
                    {
                        "citycode": "0662",
                        "adcode": "441704",
                        "name": "阳东区",
                        "center": {
                            "lng": 112.005586,
                            "lat": 21.869081
                        }
                    }
                ]
            },
            {
                "citycode": "0668",
                "adcode": "440900",
                "name": "茂名市",
                "center": {
                    "lng": 110.925533,
                    "lat": 21.662728
                },
                "districtList": [
                    {
                        "citycode": "0668",
                        "adcode": "440982",
                        "name": "化州市",
                        "center": {
                            "lng": 110.639581,
                            "lat": 21.664483
                        }
                    },
                    {
                        "citycode": "0668",
                        "adcode": "440904",
                        "name": "电白区",
                        "center": {
                            "lng": 111.013368,
                            "lat": 21.513946
                        }
                    },
                    {
                        "citycode": "0668",
                        "adcode": "440983",
                        "name": "信宜市",
                        "center": {
                            "lng": 110.946866,
                            "lat": 22.354887
                        }
                    },
                    {
                        "citycode": "0668",
                        "adcode": "440981",
                        "name": "高州市",
                        "center": {
                            "lng": 110.853169,
                            "lat": 21.918017
                        }
                    },
                    {
                        "citycode": "0668",
                        "adcode": "440902",
                        "name": "茂南区",
                        "center": {
                            "lng": 110.918566,
                            "lat": 21.641661
                        }
                    }
                ]
            },
            {
                "citycode": "0660",
                "adcode": "441500",
                "name": "汕尾市",
                "center": {
                    "lng": 115.375557,
                    "lat": 22.787204
                },
                "districtList": [
                    {
                        "citycode": "0660",
                        "adcode": "441523",
                        "name": "陆河县",
                        "center": {
                            "lng": 115.659978,
                            "lat": 23.301557
                        }
                    },
                    {
                        "citycode": "0660",
                        "adcode": "441502",
                        "name": "城区",
                        "center": {
                            "lng": 115.36522,
                            "lat": 22.779204
                        }
                    },
                    {
                        "citycode": "0660",
                        "adcode": "441581",
                        "name": "陆丰市",
                        "center": {
                            "lng": 115.652142,
                            "lat": 22.91874
                        }
                    },
                    {
                        "citycode": "0660",
                        "adcode": "441521",
                        "name": "海丰县",
                        "center": {
                            "lng": 115.322974,
                            "lat": 22.967212
                        }
                    }
                ]
            },
            {
                "citycode": "0766",
                "adcode": "445300",
                "name": "云浮市",
                "center": {
                    "lng": 112.044524,
                    "lat": 22.915163
                },
                "districtList": [
                    {
                        "citycode": "0766",
                        "adcode": "445322",
                        "name": "郁南县",
                        "center": {
                            "lng": 111.535387,
                            "lat": 23.234561
                        }
                    },
                    {
                        "citycode": "0766",
                        "adcode": "445381",
                        "name": "罗定市",
                        "center": {
                            "lng": 111.569788,
                            "lat": 22.768345
                        }
                    },
                    {
                        "citycode": "0766",
                        "adcode": "445321",
                        "name": "新兴县",
                        "center": {
                            "lng": 112.225174,
                            "lat": 22.695915
                        }
                    },
                    {
                        "citycode": "0766",
                        "adcode": "445302",
                        "name": "云城区",
                        "center": {
                            "lng": 112.043945,
                            "lat": 22.92815
                        }
                    },
                    {
                        "citycode": "0766",
                        "adcode": "445303",
                        "name": "云安区",
                        "center": {
                            "lng": 112.002947,
                            "lat": 23.070334
                        }
                    }
                ]
            },
            {
                "citycode": "0762",
                "adcode": "441600",
                "name": "河源市",
                "center": {
                    "lng": 114.700215,
                    "lat": 23.744276
                },
                "districtList": [
                    {
                        "citycode": "0762",
                        "adcode": "441623",
                        "name": "连平县",
                        "center": {
                            "lng": 114.488358,
                            "lat": 24.369552
                        }
                    },
                    {
                        "citycode": "0762",
                        "adcode": "441625",
                        "name": "东源县",
                        "center": {
                            "lng": 114.7466,
                            "lat": 23.790079
                        }
                    },
                    {
                        "citycode": "0762",
                        "adcode": "441602",
                        "name": "源城区",
                        "center": {
                            "lng": 114.703305,
                            "lat": 23.734055
                        }
                    },
                    {
                        "citycode": "0762",
                        "adcode": "441621",
                        "name": "紫金县",
                        "center": {
                            "lng": 115.183814,
                            "lat": 23.635597
                        }
                    },
                    {
                        "citycode": "0762",
                        "adcode": "441624",
                        "name": "和平县",
                        "center": {
                            "lng": 114.935634,
                            "lat": 24.469177
                        }
                    },
                    {
                        "citycode": "0762",
                        "adcode": "441622",
                        "name": "龙川县",
                        "center": {
                            "lng": 115.26002,
                            "lat": 24.100599
                        }
                    }
                ]
            },
            {
                "citycode": "0768",
                "adcode": "445100",
                "name": "潮州市",
                "center": {
                    "lng": 116.621901,
                    "lat": 23.657662
                },
                "districtList": [
                    {
                        "citycode": "0768",
                        "adcode": "445122",
                        "name": "饶平县",
                        "center": {
                            "lng": 117.0045,
                            "lat": 23.663294
                        }
                    },
                    {
                        "citycode": "0768",
                        "adcode": "445103",
                        "name": "潮安区",
                        "center": {
                            "lng": 116.676971,
                            "lat": 23.463598
                        }
                    },
                    {
                        "citycode": "0768",
                        "adcode": "445102",
                        "name": "湘桥区",
                        "center": {
                            "lng": 116.628343,
                            "lat": 23.675104
                        }
                    }
                ]
            },
            {
                "citycode": "0663",
                "adcode": "445200",
                "name": "揭阳市",
                "center": {
                    "lng": 116.372732,
                    "lat": 23.550968
                },
                "districtList": [
                    {
                        "citycode": "0663",
                        "adcode": "445224",
                        "name": "惠来县",
                        "center": {
                            "lng": 116.295038,
                            "lat": 23.033889
                        }
                    },
                    {
                        "citycode": "0663",
                        "adcode": "445203",
                        "name": "揭东区",
                        "center": {
                            "lng": 116.411928,
                            "lat": 23.567252
                        }
                    },
                    {
                        "citycode": "0663",
                        "adcode": "445202",
                        "name": "榕城区",
                        "center": {
                            "lng": 116.36714,
                            "lat": 23.525918
                        }
                    },
                    {
                        "citycode": "0663",
                        "adcode": "445222",
                        "name": "揭西县",
                        "center": {
                            "lng": 115.841742,
                            "lat": 23.431314
                        }
                    },
                    {
                        "citycode": "0663",
                        "adcode": "445281",
                        "name": "普宁市",
                        "center": {
                            "lng": 116.165646,
                            "lat": 23.297742
                        }
                    }
                ]
            },
            {
                "citycode": "0751",
                "adcode": "440200",
                "name": "韶关市",
                "center": {
                    "lng": 113.597324,
                    "lat": 24.810977
                },
                "districtList": [
                    {
                        "citycode": "0751",
                        "adcode": "440204",
                        "name": "浈江区",
                        "center": {
                            "lng": 113.611077,
                            "lat": 24.804898
                        }
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440282",
                        "name": "南雄市",
                        "center": {
                            "lng": 114.31184,
                            "lat": 25.117653
                        }
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440224",
                        "name": "仁化县",
                        "center": {
                            "lng": 113.749175,
                            "lat": 25.085764
                        }
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440232",
                        "name": "乳源瑶族自治县",
                        "center": {
                            "lng": 113.275875,
                            "lat": 24.775856
                        }
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440222",
                        "name": "始兴县",
                        "center": {
                            "lng": 114.061998,
                            "lat": 24.953908
                        }
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440203",
                        "name": "武江区",
                        "center": {
                            "lng": 113.58792,
                            "lat": 24.7929
                        }
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440205",
                        "name": "曲江区",
                        "center": {
                            "lng": 113.604591,
                            "lat": 24.682826
                        }
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440229",
                        "name": "翁源县",
                        "center": {
                            "lng": 114.129986,
                            "lat": 24.350581
                        }
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440233",
                        "name": "新丰县",
                        "center": {
                            "lng": 114.206641,
                            "lat": 24.059909
                        }
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440281",
                        "name": "乐昌市",
                        "center": {
                            "lng": 113.347669,
                            "lat": 25.129892
                        }
                    }
                ]
            },
            {
                "citycode": "0763",
                "adcode": "441800",
                "name": "清远市",
                "center": {
                    "lng": 113.056098,
                    "lat": 23.682064
                },
                "districtList": [
                    {
                        "citycode": "0763",
                        "adcode": "441882",
                        "name": "连州市",
                        "center": {
                            "lng": 112.377255,
                            "lat": 24.780873
                        }
                    },
                    {
                        "citycode": "0763",
                        "adcode": "441826",
                        "name": "连南瑶族自治县",
                        "center": {
                            "lng": 112.287212,
                            "lat": 24.725953
                        }
                    },
                    {
                        "citycode": "0763",
                        "adcode": "441825",
                        "name": "连山壮族瑶族自治县",
                        "center": {
                            "lng": 112.093726,
                            "lat": 24.570553
                        }
                    },
                    {
                        "citycode": "0763",
                        "adcode": "441881",
                        "name": "英德市",
                        "center": {
                            "lng": 113.401827,
                            "lat": 24.20716
                        }
                    },
                    {
                        "citycode": "0763",
                        "adcode": "441823",
                        "name": "阳山县",
                        "center": {
                            "lng": 112.641199,
                            "lat": 24.465234
                        }
                    },
                    {
                        "citycode": "0763",
                        "adcode": "441821",
                        "name": "佛冈县",
                        "center": {
                            "lng": 113.531559,
                            "lat": 23.879455
                        }
                    },
                    {
                        "citycode": "0763",
                        "adcode": "441802",
                        "name": "清城区",
                        "center": {
                            "lng": 113.062612,
                            "lat": 23.697889
                        }
                    },
                    {
                        "citycode": "0763",
                        "adcode": "441803",
                        "name": "清新区",
                        "center": {
                            "lng": 113.017747,
                            "lat": 23.734677
                        }
                    }
                ]
            },
            {
                "citycode": "020",
                "adcode": "440100",
                "name": "广州市",
                "center": {
                    "lng": 113.264499,
                    "lat": 23.130061
                },
                "districtList": [
                    {
                        "citycode": "020",
                        "adcode": "440105",
                        "name": "海珠区",
                        "center": {
                            "lng": 113.317412,
                            "lat": 23.084003
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440114",
                        "name": "花都区",
                        "center": {
                            "lng": 113.220125,
                            "lat": 23.404326
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440117",
                        "name": "从化区",
                        "center": {
                            "lng": 113.586329,
                            "lat": 23.54915
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440112",
                        "name": "黄埔区",
                        "center": {
                            "lng": 113.480613,
                            "lat": 23.181355
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440113",
                        "name": "番禺区",
                        "center": {
                            "lng": 113.383917,
                            "lat": 22.93756
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440106",
                        "name": "天河区",
                        "center": {
                            "lng": 113.361597,
                            "lat": 23.124817
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440103",
                        "name": "荔湾区",
                        "center": {
                            "lng": 113.218998,
                            "lat": 23.107123
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440111",
                        "name": "白云区",
                        "center": {
                            "lng": 113.2732,
                            "lat": 23.157159
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440104",
                        "name": "越秀区",
                        "center": {
                            "lng": 113.267065,
                            "lat": 23.128673
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440115",
                        "name": "南沙区",
                        "center": {
                            "lng": 113.525178,
                            "lat": 22.801435
                        }
                    },
                    {
                        "citycode": "020",
                        "adcode": "440118",
                        "name": "增城区",
                        "center": {
                            "lng": 113.810734,
                            "lat": 23.261452
                        }
                    }
                ]
            },
            {
                "citycode": "0760",
                "adcode": "442000",
                "name": "中山市",
                "center": {
                    "lng": 113.392517,
                    "lat": 22.517024
                },
                "districtList": [
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "横栏镇",
                        "center": {
                            "lng": 113.22363,
                            "lat": 22.604755
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "小榄镇",
                        "center": {
                            "lng": 113.320629,
                            "lat": 22.560691
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "神湾镇",
                        "center": {
                            "lng": 113.376318,
                            "lat": 22.276818
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "古镇镇",
                        "center": {
                            "lng": 113.221289,
                            "lat": 22.609652
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "港口镇",
                        "center": {
                            "lng": 113.354019,
                            "lat": 22.602694
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "三乡镇",
                        "center": {
                            "lng": 113.431869,
                            "lat": 22.387876
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "石岐街道",
                        "center": {
                            "lng": 113.40412,
                            "lat": 22.548351
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "大涌镇",
                        "center": {
                            "lng": 113.296691,
                            "lat": 22.483379
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "阜沙镇",
                        "center": {
                            "lng": 113.340305,
                            "lat": 22.640609
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "西区街道",
                        "center": {
                            "lng": 113.314421,
                            "lat": 22.564923
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "沙溪镇",
                        "center": {
                            "lng": 113.343971,
                            "lat": 22.524791
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "东凤镇",
                        "center": {
                            "lng": 113.307919,
                            "lat": 22.680266
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "坦洲镇",
                        "center": {
                            "lng": 113.395777,
                            "lat": 22.312037
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "三角镇",
                        "center": {
                            "lng": 113.400593,
                            "lat": 22.640197
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "民众街道",
                        "center": {
                            "lng": 113.472738,
                            "lat": 22.653889
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "南头镇",
                        "center": {
                            "lng": 113.299916,
                            "lat": 22.683684
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "黄圃镇",
                        "center": {
                            "lng": 113.359373,
                            "lat": 22.681261
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "东区街道",
                        "center": {
                            "lng": 113.436188,
                            "lat": 22.514086
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "南区街道",
                        "center": {
                            "lng": 113.367676,
                            "lat": 22.488858
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "中山港街道",
                        "center": {
                            "lng": 113.418677,
                            "lat": 22.549913
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "板芙镇",
                        "center": {
                            "lng": 113.368695,
                            "lat": 22.406764
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "五桂山街道",
                        "center": {
                            "lng": 113.476817,
                            "lat": 22.428448
                        }
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "南朗街道",
                        "center": {
                            "lng": 113.486698,
                            "lat": 22.52574
                        }
                    }
                ]
            },
            {
                "citycode": "0769",
                "adcode": "441900",
                "name": "东莞市",
                "center": {
                    "lng": 113.751884,
                    "lat": 23.021016
                },
                "districtList": [
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "黄江镇",
                        "center": {
                            "lng": 113.983316,
                            "lat": 22.883915
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "清溪镇",
                        "center": {
                            "lng": 114.109028,
                            "lat": 22.864049
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "桥头镇",
                        "center": {
                            "lng": 114.065029,
                            "lat": 23.031536
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "洪梅镇",
                        "center": {
                            "lng": 113.606888,
                            "lat": 23.015507
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "高埗镇",
                        "center": {
                            "lng": 113.77292,
                            "lat": 23.100117
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "麻涌镇",
                        "center": {
                            "lng": 113.616702,
                            "lat": 23.088653
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "塘厦镇",
                        "center": {
                            "lng": 114.057782,
                            "lat": 22.833564
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "望牛墩镇",
                        "center": {
                            "lng": 113.675238,
                            "lat": 23.067562
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "万江街道",
                        "center": {
                            "lng": 113.714249,
                            "lat": 23.004871
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "道滘镇",
                        "center": {
                            "lng": 113.687246,
                            "lat": 23.004094
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "莞城街道",
                        "center": {
                            "lng": 113.756157,
                            "lat": 23.026359
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "东坑镇",
                        "center": {
                            "lng": 113.921005,
                            "lat": 22.989113
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "大岭山镇",
                        "center": {
                            "lng": 113.806239,
                            "lat": 22.948285
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "谢岗镇",
                        "center": {
                            "lng": 114.171775,
                            "lat": 22.984642
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "南城街道",
                        "center": {
                            "lng": 113.768809,
                            "lat": 22.941355
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "东城街道",
                        "center": {
                            "lng": 113.77206,
                            "lat": 22.941938
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "企石镇",
                        "center": {
                            "lng": 113.989933,
                            "lat": 23.054588
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "樟木头镇",
                        "center": {
                            "lng": 114.015449,
                            "lat": 22.86927
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "常平镇",
                        "center": {
                            "lng": 114.041069,
                            "lat": 23.007892
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "凤岗镇",
                        "center": {
                            "lng": 114.139781,
                            "lat": 22.777948
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "寮步镇",
                        "center": {
                            "lng": 113.917593,
                            "lat": 22.981271
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "沙田镇",
                        "center": {
                            "lng": 113.582201,
                            "lat": 22.942601
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "横沥镇",
                        "center": {
                            "lng": 114.03027,
                            "lat": 23.035086
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "茶山镇",
                        "center": {
                            "lng": 113.840966,
                            "lat": 23.09276
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "大朗镇",
                        "center": {
                            "lng": 113.947048,
                            "lat": 22.865074
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "石排镇",
                        "center": {
                            "lng": 113.989827,
                            "lat": 23.069114
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "中堂镇",
                        "center": {
                            "lng": 113.612748,
                            "lat": 23.042585
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "长安镇",
                        "center": {
                            "lng": 113.802243,
                            "lat": 22.838519
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "厚街镇",
                        "center": {
                            "lng": 113.631616,
                            "lat": 22.934094
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "虎门镇",
                        "center": {
                            "lng": 113.631506,
                            "lat": 22.832134
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "石龙镇",
                        "center": {
                            "lng": 113.859745,
                            "lat": 23.087788
                        }
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "石碣镇",
                        "center": {
                            "lng": 113.772148,
                            "lat": 23.095617
                        }
                    }
                ]
            },
            {
                "citycode": "0753",
                "adcode": "441400",
                "name": "梅州市",
                "center": {
                    "lng": 116.122046,
                    "lat": 24.288832
                },
                "districtList": [
                    {
                        "citycode": "0753",
                        "adcode": "441426",
                        "name": "平远县",
                        "center": {
                            "lng": 115.891235,
                            "lat": 24.566928
                        }
                    },
                    {
                        "citycode": "0753",
                        "adcode": "441481",
                        "name": "兴宁市",
                        "center": {
                            "lng": 115.731133,
                            "lat": 24.137296
                        }
                    },
                    {
                        "citycode": "0753",
                        "adcode": "441427",
                        "name": "蕉岭县",
                        "center": {
                            "lng": 116.171477,
                            "lat": 24.658963
                        }
                    },
                    {
                        "citycode": "0753",
                        "adcode": "441422",
                        "name": "大埔县",
                        "center": {
                            "lng": 116.694825,
                            "lat": 24.347037
                        }
                    },
                    {
                        "citycode": "0753",
                        "adcode": "441424",
                        "name": "五华县",
                        "center": {
                            "lng": 115.775751,
                            "lat": 23.932568
                        }
                    },
                    {
                        "citycode": "0753",
                        "adcode": "441403",
                        "name": "梅县区",
                        "center": {
                            "lng": 116.081395,
                            "lat": 24.266191
                        }
                    },
                    {
                        "citycode": "0753",
                        "adcode": "441402",
                        "name": "梅江区",
                        "center": {
                            "lng": 116.116686,
                            "lat": 24.31065
                        }
                    },
                    {
                        "citycode": "0753",
                        "adcode": "441423",
                        "name": "丰顺县",
                        "center": {
                            "lng": 116.181895,
                            "lat": 23.739364
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "150000",
        "name": "内蒙古自治区",
        "center": {
            "lng": 111.765226,
            "lat": 40.818233
        },
        "districtList": [
            {
                "citycode": "0473",
                "adcode": "150300",
                "name": "乌海市",
                "center": {
                    "lng": 106.79415,
                    "lat": 39.655048
                },
                "districtList": [
                    {
                        "citycode": "0473",
                        "adcode": "150302",
                        "name": "海勃湾区",
                        "center": {
                            "lng": 106.8228,
                            "lat": 39.690873
                        }
                    },
                    {
                        "citycode": "0473",
                        "adcode": "150303",
                        "name": "海南区",
                        "center": {
                            "lng": 106.891472,
                            "lat": 39.441803
                        }
                    },
                    {
                        "citycode": "0473",
                        "adcode": "150304",
                        "name": "乌达区",
                        "center": {
                            "lng": 106.726043,
                            "lat": 39.505609
                        }
                    }
                ]
            },
            {
                "citycode": "0472",
                "adcode": "150200",
                "name": "包头市",
                "center": {
                    "lng": 109.95315,
                    "lat": 40.621327
                },
                "districtList": [
                    {
                        "citycode": "0472",
                        "adcode": "150221",
                        "name": "土默特右旗",
                        "center": {
                            "lng": 110.527831,
                            "lat": 40.578253
                        }
                    },
                    {
                        "citycode": "0472",
                        "adcode": "150223",
                        "name": "达尔罕茂明安联合旗",
                        "center": {
                            "lng": 110.432626,
                            "lat": 41.698992
                        }
                    },
                    {
                        "citycode": "0472",
                        "adcode": "150206",
                        "name": "白云鄂博矿区",
                        "center": {
                            "lng": 109.973195,
                            "lat": 41.769956
                        }
                    },
                    {
                        "citycode": "0472",
                        "adcode": "150202",
                        "name": "东河区",
                        "center": {
                            "lng": 110.044008,
                            "lat": 40.57626
                        }
                    },
                    {
                        "citycode": "0472",
                        "adcode": "150222",
                        "name": "固阳县",
                        "center": {
                            "lng": 110.060055,
                            "lat": 41.034757
                        }
                    },
                    {
                        "citycode": "0472",
                        "adcode": "150205",
                        "name": "石拐区",
                        "center": {
                            "lng": 110.060783,
                            "lat": 40.676736
                        }
                    },
                    {
                        "citycode": "0472",
                        "adcode": "150204",
                        "name": "青山区",
                        "center": {
                            "lng": 109.902157,
                            "lat": 40.644081
                        }
                    },
                    {
                        "citycode": "0472",
                        "adcode": "150207",
                        "name": "九原区",
                        "center": {
                            "lng": 109.968082,
                            "lat": 40.611346
                        }
                    },
                    {
                        "citycode": "0472",
                        "adcode": "150203",
                        "name": "昆都仑区",
                        "center": {
                            "lng": 109.840249,
                            "lat": 40.658075
                        }
                    }
                ]
            },
            {
                "citycode": "0478",
                "adcode": "150800",
                "name": "巴彦淖尔市",
                "center": {
                    "lng": 107.387767,
                    "lat": 40.742987
                },
                "districtList": [
                    {
                        "citycode": "0478",
                        "adcode": "150824",
                        "name": "乌拉特中旗",
                        "center": {
                            "lng": 108.513653,
                            "lat": 41.58813
                        }
                    },
                    {
                        "citycode": "0478",
                        "adcode": "150822",
                        "name": "磴口县",
                        "center": {
                            "lng": 107.008288,
                            "lat": 40.330534
                        }
                    },
                    {
                        "citycode": "0478",
                        "adcode": "150821",
                        "name": "五原县",
                        "center": {
                            "lng": 108.267466,
                            "lat": 41.088446
                        }
                    },
                    {
                        "citycode": "0478",
                        "adcode": "150823",
                        "name": "乌拉特前旗",
                        "center": {
                            "lng": 108.652114,
                            "lat": 40.737018
                        }
                    },
                    {
                        "citycode": "0478",
                        "adcode": "150825",
                        "name": "乌拉特后旗",
                        "center": {
                            "lng": 107.074748,
                            "lat": 41.08412
                        }
                    },
                    {
                        "citycode": "0478",
                        "adcode": "150826",
                        "name": "杭锦后旗",
                        "center": {
                            "lng": 107.151296,
                            "lat": 40.886596
                        }
                    },
                    {
                        "citycode": "0478",
                        "adcode": "150802",
                        "name": "临河区",
                        "center": {
                            "lng": 107.363536,
                            "lat": 40.750969
                        }
                    }
                ]
            },
            {
                "citycode": "0470",
                "adcode": "150700",
                "name": "呼伦贝尔市",
                "center": {
                    "lng": 119.77845,
                    "lat": 49.166536
                },
                "districtList": [
                    {
                        "citycode": "0470",
                        "adcode": "150785",
                        "name": "根河市",
                        "center": {
                            "lng": 121.520165,
                            "lat": 50.779758
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150782",
                        "name": "牙克石市",
                        "center": {
                            "lng": 120.711639,
                            "lat": 49.285947
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150725",
                        "name": "陈巴尔虎旗",
                        "center": {
                            "lng": 119.424026,
                            "lat": 49.328916
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150702",
                        "name": "海拉尔区",
                        "center": {
                            "lng": 119.824542,
                            "lat": 49.234715
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150724",
                        "name": "鄂温克族自治旗",
                        "center": {
                            "lng": 119.755253,
                            "lat": 49.146692
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150721",
                        "name": "阿荣旗",
                        "center": {
                            "lng": 123.458943,
                            "lat": 48.126553
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150783",
                        "name": "扎兰屯市",
                        "center": {
                            "lng": 122.708475,
                            "lat": 48.028396
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150703",
                        "name": "扎赉诺尔区",
                        "center": {
                            "lng": 117.669939,
                            "lat": 49.511213
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150781",
                        "name": "满洲里市",
                        "center": {
                            "lng": 117.379134,
                            "lat": 49.59862
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150727",
                        "name": "新巴尔虎右旗",
                        "center": {
                            "lng": 116.8237,
                            "lat": 48.671865
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150723",
                        "name": "鄂伦春自治旗",
                        "center": {
                            "lng": 123.725643,
                            "lat": 50.591604
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150784",
                        "name": "额尔古纳市",
                        "center": {
                            "lng": 120.180506,
                            "lat": 50.243102
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150722",
                        "name": "莫力达瓦达斡尔族自治旗",
                        "center": {
                            "lng": 124.519023,
                            "lat": 48.477728
                        }
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150726",
                        "name": "新巴尔虎左旗",
                        "center": {
                            "lng": 118.269782,
                            "lat": 48.21827
                        }
                    }
                ]
            },
            {
                "citycode": "0483",
                "adcode": "152900",
                "name": "阿拉善盟",
                "center": {
                    "lng": 105.729135,
                    "lat": 38.851554
                },
                "districtList": [
                    {
                        "citycode": "0483",
                        "adcode": "152923",
                        "name": "额济纳旗",
                        "center": {
                            "lng": 101.055861,
                            "lat": 41.953963
                        }
                    },
                    {
                        "citycode": "0483",
                        "adcode": "152922",
                        "name": "阿拉善右旗",
                        "center": {
                            "lng": 101.666917,
                            "lat": 39.216185
                        }
                    },
                    {
                        "citycode": "0483",
                        "adcode": "152921",
                        "name": "阿拉善左旗",
                        "center": {
                            "lng": 105.666208,
                            "lat": 38.833589
                        }
                    }
                ]
            },
            {
                "citycode": "0482",
                "adcode": "152200",
                "name": "兴安盟",
                "center": {
                    "lng": 122.037796,
                    "lat": 46.082373
                },
                "districtList": [
                    {
                        "citycode": "0482",
                        "adcode": "152202",
                        "name": "阿尔山市",
                        "center": {
                            "lng": 119.943577,
                            "lat": 47.17744
                        }
                    },
                    {
                        "citycode": "0482",
                        "adcode": "152224",
                        "name": "突泉县",
                        "center": {
                            "lng": 121.593972,
                            "lat": 45.381918
                        }
                    },
                    {
                        "citycode": "0482",
                        "adcode": "152222",
                        "name": "科尔沁右翼中旗",
                        "center": {
                            "lng": 121.476357,
                            "lat": 45.060728
                        }
                    },
                    {
                        "citycode": "0482",
                        "adcode": "152223",
                        "name": "扎赉特旗",
                        "center": {
                            "lng": 122.899627,
                            "lat": 46.723154
                        }
                    },
                    {
                        "citycode": "0482",
                        "adcode": "152221",
                        "name": "科尔沁右翼前旗",
                        "center": {
                            "lng": 121.952638,
                            "lat": 46.079664
                        }
                    },
                    {
                        "citycode": "0482",
                        "adcode": "152201",
                        "name": "乌兰浩特市",
                        "center": {
                            "lng": 122.093309,
                            "lat": 46.072233
                        }
                    }
                ]
            },
            {
                "citycode": "0471",
                "adcode": "150100",
                "name": "呼和浩特市",
                "center": {
                    "lng": 111.748814,
                    "lat": 40.842127
                },
                "districtList": [
                    {
                        "citycode": "0471",
                        "adcode": "150103",
                        "name": "回民区",
                        "center": {
                            "lng": 111.623485,
                            "lat": 40.808906
                        }
                    },
                    {
                        "citycode": "0471",
                        "adcode": "150122",
                        "name": "托克托县",
                        "center": {
                            "lng": 111.193879,
                            "lat": 40.277703
                        }
                    },
                    {
                        "citycode": "0471",
                        "adcode": "150125",
                        "name": "武川县",
                        "center": {
                            "lng": 111.451226,
                            "lat": 41.096511
                        }
                    },
                    {
                        "citycode": "0471",
                        "adcode": "150121",
                        "name": "土默特左旗",
                        "center": {
                            "lng": 111.16373,
                            "lat": 40.729044
                        }
                    },
                    {
                        "citycode": "0471",
                        "adcode": "150102",
                        "name": "新城区",
                        "center": {
                            "lng": 111.665325,
                            "lat": 40.858271
                        }
                    },
                    {
                        "citycode": "0471",
                        "adcode": "150124",
                        "name": "清水河县",
                        "center": {
                            "lng": 111.647351,
                            "lat": 39.921224
                        }
                    },
                    {
                        "citycode": "0471",
                        "adcode": "150123",
                        "name": "和林格尔县",
                        "center": {
                            "lng": 111.821695,
                            "lat": 40.379226
                        }
                    },
                    {
                        "citycode": "0471",
                        "adcode": "150104",
                        "name": "玉泉区",
                        "center": {
                            "lng": 111.674157,
                            "lat": 40.753054
                        }
                    },
                    {
                        "citycode": "0471",
                        "adcode": "150105",
                        "name": "赛罕区",
                        "center": {
                            "lng": 111.701166,
                            "lat": 40.792508
                        }
                    }
                ]
            },
            {
                "citycode": "0477",
                "adcode": "150600",
                "name": "鄂尔多斯市",
                "center": {
                    "lng": 109.782473,
                    "lat": 39.608744
                },
                "districtList": [
                    {
                        "citycode": "0477",
                        "adcode": "150625",
                        "name": "杭锦旗",
                        "center": {
                            "lng": 108.736011,
                            "lat": 39.833243
                        }
                    },
                    {
                        "citycode": "0477",
                        "adcode": "150621",
                        "name": "达拉特旗",
                        "center": {
                            "lng": 110.034133,
                            "lat": 40.412766
                        }
                    },
                    {
                        "citycode": "0477",
                        "adcode": "150624",
                        "name": "鄂托克旗",
                        "center": {
                            "lng": 107.975948,
                            "lat": 39.089549
                        }
                    },
                    {
                        "citycode": "0477",
                        "adcode": "150626",
                        "name": "乌审旗",
                        "center": {
                            "lng": 108.819485,
                            "lat": 38.60453
                        }
                    },
                    {
                        "citycode": "0477",
                        "adcode": "150623",
                        "name": "鄂托克前旗",
                        "center": {
                            "lng": 107.47733,
                            "lat": 38.182402
                        }
                    },
                    {
                        "citycode": "0477",
                        "adcode": "150627",
                        "name": "伊金霍洛旗",
                        "center": {
                            "lng": 109.747435,
                            "lat": 39.565064
                        }
                    },
                    {
                        "citycode": "0477",
                        "adcode": "150603",
                        "name": "康巴什区",
                        "center": {
                            "lng": 109.858586,
                            "lat": 39.60793
                        }
                    },
                    {
                        "citycode": "0477",
                        "adcode": "150602",
                        "name": "东胜区",
                        "center": {
                            "lng": 109.963403,
                            "lat": 39.823066
                        }
                    },
                    {
                        "citycode": "0477",
                        "adcode": "150622",
                        "name": "准格尔旗",
                        "center": {
                            "lng": 111.239436,
                            "lat": 39.864923
                        }
                    }
                ]
            },
            {
                "citycode": "0475",
                "adcode": "150500",
                "name": "通辽市",
                "center": {
                    "lng": 122.243309,
                    "lat": 43.653566
                },
                "districtList": [
                    {
                        "citycode": "0475",
                        "adcode": "150581",
                        "name": "霍林郭勒市",
                        "center": {
                            "lng": 119.681242,
                            "lat": 45.533598
                        }
                    },
                    {
                        "citycode": "0475",
                        "adcode": "150523",
                        "name": "开鲁县",
                        "center": {
                            "lng": 121.319216,
                            "lat": 43.601446
                        }
                    },
                    {
                        "citycode": "0475",
                        "adcode": "150525",
                        "name": "奈曼旗",
                        "center": {
                            "lng": 120.657813,
                            "lat": 42.867433
                        }
                    },
                    {
                        "citycode": "0475",
                        "adcode": "150524",
                        "name": "库伦旗",
                        "center": {
                            "lng": 121.810629,
                            "lat": 42.735556
                        }
                    },
                    {
                        "citycode": "0475",
                        "adcode": "150526",
                        "name": "扎鲁特旗",
                        "center": {
                            "lng": 120.917953,
                            "lat": 44.567093
                        }
                    },
                    {
                        "citycode": "0475",
                        "adcode": "150521",
                        "name": "科尔沁左翼中旗",
                        "center": {
                            "lng": 123.312202,
                            "lat": 44.126606
                        }
                    },
                    {
                        "citycode": "0475",
                        "adcode": "150522",
                        "name": "科尔沁左翼后旗",
                        "center": {
                            "lng": 122.35677,
                            "lat": 42.935105
                        }
                    },
                    {
                        "citycode": "0475",
                        "adcode": "150502",
                        "name": "科尔沁区",
                        "center": {
                            "lng": 122.25545,
                            "lat": 43.623133
                        }
                    }
                ]
            },
            {
                "citycode": "0476",
                "adcode": "150400",
                "name": "赤峰市",
                "center": {
                    "lng": 118.887613,
                    "lat": 42.256876
                },
                "districtList": [
                    {
                        "citycode": "0476",
                        "adcode": "150422",
                        "name": "巴林左旗",
                        "center": {
                            "lng": 119.362832,
                            "lat": 43.961547
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150424",
                        "name": "林西县",
                        "center": {
                            "lng": 118.05545,
                            "lat": 43.61812
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150423",
                        "name": "巴林右旗",
                        "center": {
                            "lng": 118.664235,
                            "lat": 43.534171
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150430",
                        "name": "敖汉旗",
                        "center": {
                            "lng": 119.921413,
                            "lat": 42.290731
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150402",
                        "name": "红山区",
                        "center": {
                            "lng": 118.953989,
                            "lat": 42.296317
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150426",
                        "name": "翁牛特旗",
                        "center": {
                            "lng": 119.006187,
                            "lat": 42.936529
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150425",
                        "name": "克什克腾旗",
                        "center": {
                            "lng": 117.545413,
                            "lat": 43.265057
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150429",
                        "name": "宁城县",
                        "center": {
                            "lng": 119.320056,
                            "lat": 41.600193
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150421",
                        "name": "阿鲁科尔沁旗",
                        "center": {
                            "lng": 120.065533,
                            "lat": 43.872398
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150403",
                        "name": "元宝山区",
                        "center": {
                            "lng": 119.288475,
                            "lat": 42.039602
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150404",
                        "name": "松山区",
                        "center": {
                            "lng": 118.916156,
                            "lat": 42.299795
                        }
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150428",
                        "name": "喀喇沁旗",
                        "center": {
                            "lng": 118.701934,
                            "lat": 41.927103
                        }
                    }
                ]
            },
            {
                "citycode": "0479",
                "adcode": "152500",
                "name": "锡林郭勒盟",
                "center": {
                    "lng": 116.047387,
                    "lat": 43.933212
                },
                "districtList": [
                    {
                        "citycode": "0479",
                        "adcode": "152525",
                        "name": "东乌珠穆沁旗",
                        "center": {
                            "lng": 116.97526,
                            "lat": 45.497329
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152502",
                        "name": "锡林浩特市",
                        "center": {
                            "lng": 116.085814,
                            "lat": 43.933417
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152522",
                        "name": "阿巴嘎旗",
                        "center": {
                            "lng": 114.950185,
                            "lat": 44.022831
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152526",
                        "name": "西乌珠穆沁旗",
                        "center": {
                            "lng": 117.608668,
                            "lat": 44.587746
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152523",
                        "name": "苏尼特左旗",
                        "center": {
                            "lng": 113.667171,
                            "lat": 43.859718
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152501",
                        "name": "二连浩特市",
                        "center": {
                            "lng": 111.949594,
                            "lat": 43.64285
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152524",
                        "name": "苏尼特右旗",
                        "center": {
                            "lng": 112.641806,
                            "lat": 42.742417
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152530",
                        "name": "正蓝旗",
                        "center": {
                            "lng": 115.991648,
                            "lat": 42.241815
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152529",
                        "name": "正镶白旗",
                        "center": {
                            "lng": 115.029748,
                            "lat": 42.287493
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152528",
                        "name": "镶黄旗",
                        "center": {
                            "lng": 113.847287,
                            "lat": 42.232371
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152531",
                        "name": "多伦县",
                        "center": {
                            "lng": 116.485549,
                            "lat": 42.203454
                        }
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152527",
                        "name": "太仆寺旗",
                        "center": {
                            "lng": 115.283173,
                            "lat": 41.876889
                        }
                    }
                ]
            },
            {
                "citycode": "0474",
                "adcode": "150900",
                "name": "乌兰察布市",
                "center": {
                    "lng": 113.132227,
                    "lat": 40.994526
                },
                "districtList": [
                    {
                        "citycode": "0474",
                        "adcode": "150929",
                        "name": "四子王旗",
                        "center": {
                            "lng": 111.706663,
                            "lat": 41.533542
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150922",
                        "name": "化德县",
                        "center": {
                            "lng": 114.01029,
                            "lat": 41.904123
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150928",
                        "name": "察哈尔右翼后旗",
                        "center": {
                            "lng": 113.191505,
                            "lat": 41.435937
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150927",
                        "name": "察哈尔右翼中旗",
                        "center": {
                            "lng": 112.635348,
                            "lat": 41.277449
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150923",
                        "name": "商都县",
                        "center": {
                            "lng": 113.577778,
                            "lat": 41.562176
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150921",
                        "name": "卓资县",
                        "center": {
                            "lng": 112.577716,
                            "lat": 40.894618
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150981",
                        "name": "丰镇市",
                        "center": {
                            "lng": 113.109875,
                            "lat": 40.437022
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150902",
                        "name": "集宁区",
                        "center": {
                            "lng": 113.168973,
                            "lat": 41.000742
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150926",
                        "name": "察哈尔右翼前旗",
                        "center": {
                            "lng": 113.212409,
                            "lat": 40.783551
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150925",
                        "name": "凉城县",
                        "center": {
                            "lng": 112.504243,
                            "lat": 40.532358
                        }
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150924",
                        "name": "兴和县",
                        "center": {
                            "lng": 113.834176,
                            "lat": 40.8723
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "230000",
        "name": "黑龙江省",
        "center": {
            "lng": 126.661998,
            "lat": 45.742253
        },
        "districtList": [
            {
                "citycode": "0457",
                "adcode": "232700",
                "name": "大兴安岭地区",
                "center": {
                    "lng": 124.11786,
                    "lat": 50.41129
                },
                "districtList": [
                    {
                        "citycode": "0457",
                        "adcode": "232701",
                        "name": "漠河市",
                        "center": {
                            "lng": 122.539313,
                            "lat": 52.972465
                        }
                    },
                    {
                        "citycode": "0457",
                        "adcode": "232722",
                        "name": "塔河县",
                        "center": {
                            "lng": 124.709733,
                            "lat": 52.334512
                        }
                    },
                    {
                        "citycode": "0457",
                        "adcode": "232721",
                        "name": "呼玛县",
                        "center": {
                            "lng": 126.651856,
                            "lat": 51.725924
                        }
                    },
                    {
                        "citycode": "0457",
                        "adcode": "232718",
                        "name": "加格达奇区",
                        "center": {
                            "lng": 124.139742,
                            "lat": 50.408822
                        }
                    }
                ]
            },
            {
                "citycode": "0464",
                "adcode": "230900",
                "name": "七台河市",
                "center": {
                    "lng": 131.003015,
                    "lat": 45.771178
                },
                "districtList": [
                    {
                        "citycode": "0464",
                        "adcode": "230903",
                        "name": "桃山区",
                        "center": {
                            "lng": 131.020046,
                            "lat": 45.765733
                        }
                    },
                    {
                        "citycode": "0464",
                        "adcode": "230921",
                        "name": "勃利县",
                        "center": {
                            "lng": 130.592009,
                            "lat": 45.755856
                        }
                    },
                    {
                        "citycode": "0464",
                        "adcode": "230904",
                        "name": "茄子河区",
                        "center": {
                            "lng": 131.067545,
                            "lat": 45.785755
                        }
                    },
                    {
                        "citycode": "0464",
                        "adcode": "230902",
                        "name": "新兴区",
                        "center": {
                            "lng": 130.93226,
                            "lat": 45.816579
                        }
                    }
                ]
            },
            {
                "citycode": "0468",
                "adcode": "230400",
                "name": "鹤岗市",
                "center": {
                    "lng": 130.297687,
                    "lat": 47.350659
                },
                "districtList": [
                    {
                        "citycode": "0468",
                        "adcode": "230422",
                        "name": "绥滨县",
                        "center": {
                            "lng": 131.852863,
                            "lat": 47.289522
                        }
                    },
                    {
                        "citycode": "0468",
                        "adcode": "230403",
                        "name": "工农区",
                        "center": {
                            "lng": 130.27472,
                            "lat": 47.318971
                        }
                    },
                    {
                        "citycode": "0468",
                        "adcode": "230407",
                        "name": "兴山区",
                        "center": {
                            "lng": 130.303598,
                            "lat": 47.357698
                        }
                    },
                    {
                        "citycode": "0468",
                        "adcode": "230402",
                        "name": "向阳区",
                        "center": {
                            "lng": 130.294331,
                            "lat": 47.342478
                        }
                    },
                    {
                        "citycode": "0468",
                        "adcode": "230404",
                        "name": "南山区",
                        "center": {
                            "lng": 130.285991,
                            "lat": 47.315121
                        }
                    },
                    {
                        "citycode": "0468",
                        "adcode": "230406",
                        "name": "东山区",
                        "center": {
                            "lng": 130.317151,
                            "lat": 47.338571
                        }
                    },
                    {
                        "citycode": "0468",
                        "adcode": "230405",
                        "name": "兴安区",
                        "center": {
                            "lng": 130.239289,
                            "lat": 47.252805
                        }
                    },
                    {
                        "citycode": "0468",
                        "adcode": "230421",
                        "name": "萝北县",
                        "center": {
                            "lng": 130.820566,
                            "lat": 47.578979
                        }
                    }
                ]
            },
            {
                "citycode": "0451",
                "adcode": "230100",
                "name": "哈尔滨市",
                "center": {
                    "lng": 126.53505,
                    "lat": 45.802981
                },
                "districtList": [
                    {
                        "citycode": "0451",
                        "adcode": "230126",
                        "name": "巴彦县",
                        "center": {
                            "lng": 127.403521,
                            "lat": 46.086182
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230123",
                        "name": "依兰县",
                        "center": {
                            "lng": 129.567777,
                            "lat": 46.325536
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230128",
                        "name": "通河县",
                        "center": {
                            "lng": 128.74629,
                            "lat": 45.990214
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230127",
                        "name": "木兰县",
                        "center": {
                            "lng": 128.043194,
                            "lat": 45.950649
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230124",
                        "name": "方正县",
                        "center": {
                            "lng": 128.829513,
                            "lat": 45.851673
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230125",
                        "name": "宾县",
                        "center": {
                            "lng": 127.466372,
                            "lat": 45.746313
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230108",
                        "name": "平房区",
                        "center": {
                            "lng": 126.63675,
                            "lat": 45.597529
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230129",
                        "name": "延寿县",
                        "center": {
                            "lng": 128.311071,
                            "lat": 45.445956
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230183",
                        "name": "尚志市",
                        "center": {
                            "lng": 128.009218,
                            "lat": 45.209199
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230184",
                        "name": "五常市",
                        "center": {
                            "lng": 127.167501,
                            "lat": 44.932164
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230112",
                        "name": "阿城区",
                        "center": {
                            "lng": 126.957984,
                            "lat": 45.548671
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230111",
                        "name": "呼兰区",
                        "center": {
                            "lng": 126.587704,
                            "lat": 45.889557
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230109",
                        "name": "松北区",
                        "center": {
                            "lng": 126.516602,
                            "lat": 45.794991
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230113",
                        "name": "双城区",
                        "center": {
                            "lng": 126.31279,
                            "lat": 45.382873
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230104",
                        "name": "道外区",
                        "center": {
                            "lng": 126.649094,
                            "lat": 45.792351
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230110",
                        "name": "香坊区",
                        "center": {
                            "lng": 126.662959,
                            "lat": 45.707871
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230103",
                        "name": "南岗区",
                        "center": {
                            "lng": 126.66882,
                            "lat": 45.759967
                        }
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230102",
                        "name": "道里区",
                        "center": {
                            "lng": 126.616912,
                            "lat": 45.755832
                        }
                    }
                ]
            },
            {
                "citycode": "0454",
                "adcode": "230800",
                "name": "佳木斯市",
                "center": {
                    "lng": 130.318916,
                    "lat": 46.800002
                },
                "districtList": [
                    {
                        "citycode": "0454",
                        "adcode": "230828",
                        "name": "汤原县",
                        "center": {
                            "lng": 129.904747,
                            "lat": 46.730623
                        }
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230803",
                        "name": "向阳区",
                        "center": {
                            "lng": 130.365263,
                            "lat": 46.807808
                        }
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230804",
                        "name": "前进区",
                        "center": {
                            "lng": 130.375254,
                            "lat": 46.81405
                        }
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230822",
                        "name": "桦南县",
                        "center": {
                            "lng": 130.553472,
                            "lat": 46.239314
                        }
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230882",
                        "name": "富锦市",
                        "center": {
                            "lng": 132.037659,
                            "lat": 47.250144
                        }
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230881",
                        "name": "同江市",
                        "center": {
                            "lng": 132.510113,
                            "lat": 47.642475
                        }
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230883",
                        "name": "抚远市",
                        "center": {
                            "lng": 134.30786,
                            "lat": 48.365027
                        }
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230811",
                        "name": "郊区",
                        "center": {
                            "lng": 130.327182,
                            "lat": 46.809596
                        }
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230805",
                        "name": "东风区",
                        "center": {
                            "lng": 130.403588,
                            "lat": 46.822609
                        }
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230826",
                        "name": "桦川县",
                        "center": {
                            "lng": 130.71908,
                            "lat": 47.023001
                        }
                    }
                ]
            },
            {
                "citycode": "0469",
                "adcode": "230500",
                "name": "双鸭山市",
                "center": {
                    "lng": 131.141563,
                    "lat": 46.676157
                },
                "districtList": [
                    {
                        "citycode": "0469",
                        "adcode": "230522",
                        "name": "友谊县",
                        "center": {
                            "lng": 131.807815,
                            "lat": 46.767299
                        }
                    },
                    {
                        "citycode": "0469",
                        "adcode": "230502",
                        "name": "尖山区",
                        "center": {
                            "lng": 131.158372,
                            "lat": 46.646083
                        }
                    },
                    {
                        "citycode": "0469",
                        "adcode": "230503",
                        "name": "岭东区",
                        "center": {
                            "lng": 131.165067,
                            "lat": 46.592663
                        }
                    },
                    {
                        "citycode": "0469",
                        "adcode": "230506",
                        "name": "宝山区",
                        "center": {
                            "lng": 131.401589,
                            "lat": 46.577167
                        }
                    },
                    {
                        "citycode": "0469",
                        "adcode": "230523",
                        "name": "宝清县",
                        "center": {
                            "lng": 132.196907,
                            "lat": 46.327335
                        }
                    },
                    {
                        "citycode": "0469",
                        "adcode": "230505",
                        "name": "四方台区",
                        "center": {
                            "lng": 131.337636,
                            "lat": 46.597143
                        }
                    },
                    {
                        "citycode": "0469",
                        "adcode": "230521",
                        "name": "集贤县",
                        "center": {
                            "lng": 131.141452,
                            "lat": 46.728448
                        }
                    },
                    {
                        "citycode": "0469",
                        "adcode": "230524",
                        "name": "饶河县",
                        "center": {
                            "lng": 134.014125,
                            "lat": 46.79726
                        }
                    }
                ]
            },
            {
                "citycode": "0456",
                "adcode": "231100",
                "name": "黑河市",
                "center": {
                    "lng": 127.528226,
                    "lat": 50.244887
                },
                "districtList": [
                    {
                        "citycode": "0456",
                        "adcode": "231102",
                        "name": "爱辉区",
                        "center": {
                            "lng": 127.500703,
                            "lat": 50.252361
                        }
                    },
                    {
                        "citycode": "0456",
                        "adcode": "231181",
                        "name": "北安市",
                        "center": {
                            "lng": 126.490989,
                            "lat": 48.241168
                        }
                    },
                    {
                        "citycode": "0456",
                        "adcode": "231124",
                        "name": "孙吴县",
                        "center": {
                            "lng": 127.336163,
                            "lat": 49.425645
                        }
                    },
                    {
                        "citycode": "0456",
                        "adcode": "231123",
                        "name": "逊克县",
                        "center": {
                            "lng": 128.478698,
                            "lat": 49.56429
                        }
                    },
                    {
                        "citycode": "0456",
                        "adcode": "231182",
                        "name": "五大连池市",
                        "center": {
                            "lng": 126.205446,
                            "lat": 48.517342
                        }
                    },
                    {
                        "citycode": "0456",
                        "adcode": "231183",
                        "name": "嫩江市",
                        "center": {
                            "lng": 125.221192,
                            "lat": 49.185766
                        }
                    }
                ]
            },
            {
                "citycode": "0453",
                "adcode": "231000",
                "name": "牡丹江市",
                "center": {
                    "lng": 129.632928,
                    "lat": 44.551486
                },
                "districtList": [
                    {
                        "citycode": "0453",
                        "adcode": "231002",
                        "name": "东安区",
                        "center": {
                            "lng": 129.626651,
                            "lat": 44.58125
                        }
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231081",
                        "name": "绥芬河市",
                        "center": {
                            "lng": 131.151805,
                            "lat": 44.412487
                        }
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231004",
                        "name": "爱民区",
                        "center": {
                            "lng": 129.591227,
                            "lat": 44.595897
                        }
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231003",
                        "name": "阳明区",
                        "center": {
                            "lng": 129.635836,
                            "lat": 44.595851
                        }
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231085",
                        "name": "穆棱市",
                        "center": {
                            "lng": 130.52446,
                            "lat": 44.918842
                        }
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231025",
                        "name": "林口县",
                        "center": {
                            "lng": 130.282286,
                            "lat": 45.279754
                        }
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231083",
                        "name": "海林市",
                        "center": {
                            "lng": 129.380756,
                            "lat": 44.594017
                        }
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231086",
                        "name": "东宁市",
                        "center": {
                            "lng": 131.124839,
                            "lat": 44.090361
                        }
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231005",
                        "name": "西安区",
                        "center": {
                            "lng": 129.616021,
                            "lat": 44.577611
                        }
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231084",
                        "name": "宁安市",
                        "center": {
                            "lng": 129.482505,
                            "lat": 44.340617
                        }
                    }
                ]
            },
            {
                "citycode": "0455",
                "adcode": "231200",
                "name": "绥化市",
                "center": {
                    "lng": 126.968714,
                    "lat": 46.654147
                },
                "districtList": [
                    {
                        "citycode": "0455",
                        "adcode": "231226",
                        "name": "绥棱县",
                        "center": {
                            "lng": 127.114928,
                            "lat": 47.235814
                        }
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231283",
                        "name": "海伦市",
                        "center": {
                            "lng": 126.930191,
                            "lat": 47.450661
                        }
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231224",
                        "name": "庆安县",
                        "center": {
                            "lng": 127.507586,
                            "lat": 46.880628
                        }
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231202",
                        "name": "北林区",
                        "center": {
                            "lng": 126.984995,
                            "lat": 46.638114
                        }
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231221",
                        "name": "望奎县",
                        "center": {
                            "lng": 126.486333,
                            "lat": 46.832185
                        }
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231223",
                        "name": "青冈县",
                        "center": {
                            "lng": 126.099314,
                            "lat": 46.70398
                        }
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231225",
                        "name": "明水县",
                        "center": {
                            "lng": 125.90601,
                            "lat": 47.173649
                        }
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231222",
                        "name": "兰西县",
                        "center": {
                            "lng": 126.287734,
                            "lat": 46.252966
                        }
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231282",
                        "name": "肇东市",
                        "center": {
                            "lng": 125.962419,
                            "lat": 46.050664
                        }
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231281",
                        "name": "安达市",
                        "center": {
                            "lng": 125.307629,
                            "lat": 46.451882
                        }
                    }
                ]
            },
            {
                "citycode": "0458",
                "adcode": "230700",
                "name": "伊春市",
                "center": {
                    "lng": 128.840863,
                    "lat": 47.728332
                },
                "districtList": [
                    {
                        "citycode": "0458",
                        "adcode": "230722",
                        "name": "嘉荫县",
                        "center": {
                            "lng": 130.402406,
                            "lat": 48.888613
                        }
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230723",
                        "name": "汤旺县",
                        "center": {
                            "lng": 129.570935,
                            "lat": 48.454639
                        }
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230724",
                        "name": "丰林县",
                        "center": {
                            "lng": 129.533661,
                            "lat": 48.290566
                        }
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230718",
                        "name": "乌翠区",
                        "center": {
                            "lng": 128.669458,
                            "lat": 47.726499
                        }
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230717",
                        "name": "伊美区",
                        "center": {
                            "lng": 128.907156,
                            "lat": 47.728257
                        }
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230719",
                        "name": "友好区",
                        "center": {
                            "lng": 128.836341,
                            "lat": 47.840801
                        }
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230751",
                        "name": "金林区",
                        "center": {
                            "lng": 129.428839,
                            "lat": 47.413019
                        }
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230726",
                        "name": "南岔县",
                        "center": {
                            "lng": 129.283584,
                            "lat": 47.139009
                        }
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230781",
                        "name": "铁力市",
                        "center": {
                            "lng": 128.032554,
                            "lat": 46.986604
                        }
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230725",
                        "name": "大箐山县",
                        "center": {
                            "lng": 129.020519,
                            "lat": 47.028313
                        }
                    }
                ]
            },
            {
                "citycode": "0459",
                "adcode": "230600",
                "name": "大庆市",
                "center": {
                    "lng": 125.104078,
                    "lat": 46.589498
                },
                "districtList": [
                    {
                        "citycode": "0459",
                        "adcode": "230605",
                        "name": "红岗区",
                        "center": {
                            "lng": 124.891041,
                            "lat": 46.398567
                        }
                    },
                    {
                        "citycode": "0459",
                        "adcode": "230606",
                        "name": "大同区",
                        "center": {
                            "lng": 124.812221,
                            "lat": 46.039972
                        }
                    },
                    {
                        "citycode": "0459",
                        "adcode": "230623",
                        "name": "林甸县",
                        "center": {
                            "lng": 124.863628,
                            "lat": 47.171677
                        }
                    },
                    {
                        "citycode": "0459",
                        "adcode": "230621",
                        "name": "肇州县",
                        "center": {
                            "lng": 125.268449,
                            "lat": 45.699543
                        }
                    },
                    {
                        "citycode": "0459",
                        "adcode": "230604",
                        "name": "让胡路区",
                        "center": {
                            "lng": 124.889858,
                            "lat": 46.642567
                        }
                    },
                    {
                        "citycode": "0459",
                        "adcode": "230624",
                        "name": "杜尔伯特蒙古族自治县",
                        "center": {
                            "lng": 124.442829,
                            "lat": 46.862348
                        }
                    },
                    {
                        "citycode": "0459",
                        "adcode": "230622",
                        "name": "肇源县",
                        "center": {
                            "lng": 125.078311,
                            "lat": 45.518982
                        }
                    },
                    {
                        "citycode": "0459",
                        "adcode": "230603",
                        "name": "龙凤区",
                        "center": {
                            "lng": 125.135093,
                            "lat": 46.562369
                        }
                    },
                    {
                        "citycode": "0459",
                        "adcode": "230602",
                        "name": "萨尔图区",
                        "center": {
                            "lng": 125.135269,
                            "lat": 46.629281
                        }
                    }
                ]
            },
            {
                "citycode": "0467",
                "adcode": "230300",
                "name": "鸡西市",
                "center": {
                    "lng": 130.969385,
                    "lat": 45.295087
                },
                "districtList": [
                    {
                        "citycode": "0467",
                        "adcode": "230304",
                        "name": "滴道区",
                        "center": {
                            "lng": 130.844193,
                            "lat": 45.349068
                        }
                    },
                    {
                        "citycode": "0467",
                        "adcode": "230306",
                        "name": "城子河区",
                        "center": {
                            "lng": 131.011504,
                            "lat": 45.338342
                        }
                    },
                    {
                        "citycode": "0467",
                        "adcode": "230307",
                        "name": "麻山区",
                        "center": {
                            "lng": 130.477691,
                            "lat": 45.211863
                        }
                    },
                    {
                        "citycode": "0467",
                        "adcode": "230302",
                        "name": "鸡冠区",
                        "center": {
                            "lng": 130.981342,
                            "lat": 45.303892
                        }
                    },
                    {
                        "citycode": "0467",
                        "adcode": "230303",
                        "name": "恒山区",
                        "center": {
                            "lng": 130.90466,
                            "lat": 45.21119
                        }
                    },
                    {
                        "citycode": "0467",
                        "adcode": "230305",
                        "name": "梨树区",
                        "center": {
                            "lng": 130.69699,
                            "lat": 45.092046
                        }
                    },
                    {
                        "citycode": "0467",
                        "adcode": "230321",
                        "name": "鸡东县",
                        "center": {
                            "lng": 131.124083,
                            "lat": 45.260413
                        }
                    },
                    {
                        "citycode": "0467",
                        "adcode": "230381",
                        "name": "虎林市",
                        "center": {
                            "lng": 132.937002,
                            "lat": 45.763262
                        }
                    },
                    {
                        "citycode": "0467",
                        "adcode": "230382",
                        "name": "密山市",
                        "center": {
                            "lng": 131.846824,
                            "lat": 45.529482
                        }
                    }
                ]
            },
            {
                "citycode": "0452",
                "adcode": "230200",
                "name": "齐齐哈尔市",
                "center": {
                    "lng": 123.918193,
                    "lat": 47.354892
                },
                "districtList": [
                    {
                        "citycode": "0452",
                        "adcode": "230229",
                        "name": "克山县",
                        "center": {
                            "lng": 125.875103,
                            "lat": 48.037748
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230225",
                        "name": "甘南县",
                        "center": {
                            "lng": 123.507935,
                            "lat": 47.921698
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230230",
                        "name": "克东县",
                        "center": {
                            "lng": 126.249124,
                            "lat": 48.041562
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230223",
                        "name": "依安县",
                        "center": {
                            "lng": 125.306161,
                            "lat": 47.893442
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230227",
                        "name": "富裕县",
                        "center": {
                            "lng": 124.474411,
                            "lat": 47.774038
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230208",
                        "name": "梅里斯达斡尔族区",
                        "center": {
                            "lng": 123.752482,
                            "lat": 47.309755
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230207",
                        "name": "碾子山区",
                        "center": {
                            "lng": 122.887548,
                            "lat": 47.516614
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230221",
                        "name": "龙江县",
                        "center": {
                            "lng": 123.204953,
                            "lat": 47.338512
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230203",
                        "name": "建华区",
                        "center": {
                            "lng": 123.95555,
                            "lat": 47.354212
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230204",
                        "name": "铁锋区",
                        "center": {
                            "lng": 123.978079,
                            "lat": 47.340719
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230206",
                        "name": "富拉尔基区",
                        "center": {
                            "lng": 123.628926,
                            "lat": 47.20873
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230202",
                        "name": "龙沙区",
                        "center": {
                            "lng": 123.958447,
                            "lat": 47.317103
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230205",
                        "name": "昂昂溪区",
                        "center": {
                            "lng": 123.822137,
                            "lat": 47.154806
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230224",
                        "name": "泰来县",
                        "center": {
                            "lng": 123.416631,
                            "lat": 46.393694
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230231",
                        "name": "拜泉县",
                        "center": {
                            "lng": 126.09905,
                            "lat": 47.59586
                        }
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230281",
                        "name": "讷河市",
                        "center": {
                            "lng": 124.88293,
                            "lat": 48.466829
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "650000",
        "name": "新疆维吾尔自治区",
        "center": {
            "lng": 87.628579,
            "lat": 43.793301
        },
        "districtList": [
            {
                "citycode": "1996",
                "adcode": "659006",
                "name": "铁门关市",
                "center": {
                    "lng": 85.670291,
                    "lat": 41.862997
                },
                "districtList": [
                    {
                        "citycode": "1996",
                        "adcode": "659006",
                        "name": "博古其镇",
                        "center": {
                            "lng": 85.584894,
                            "lat": 41.882542
                        }
                    },
                    {
                        "citycode": "1996",
                        "adcode": "659006",
                        "name": "双丰镇",
                        "center": {
                            "lng": 85.635217,
                            "lat": 41.880304
                        }
                    }
                ]
            },
            {
                "citycode": "1906",
                "adcode": "659005",
                "name": "北屯市",
                "center": {
                    "lng": 87.834419,
                    "lat": 47.326733
                },
                "districtList": [
                    {
                        "citycode": "1906",
                        "adcode": "659005",
                        "name": "海川镇",
                        "center": {
                            "lng": 87.518571,
                            "lat": 47.409865
                        }
                    },
                    {
                        "citycode": "1906",
                        "adcode": "659005",
                        "name": "丰庆镇",
                        "center": {
                            "lng": 87.927121,
                            "lat": 47.333864
                        }
                    },
                    {
                        "citycode": "1906",
                        "adcode": "659005",
                        "name": "双渠镇",
                        "center": {
                            "lng": 88.122468,
                            "lat": 47.126579
                        }
                    },
                    {
                        "citycode": "1906",
                        "adcode": "659005",
                        "name": "北屯镇",
                        "center": {
                            "lng": 87.871109,
                            "lat": 47.357426
                        }
                    }
                ]
            },
            {
                "citycode": "1909",
                "adcode": "659007",
                "name": "双河市",
                "center": {
                    "lng": 82.353656,
                    "lat": 44.840524
                },
                "districtList": [
                    {
                        "citycode": "1909",
                        "adcode": "659007",
                        "name": "兵团八十九团",
                        "center": {
                            "lng": 82.455805,
                            "lat": 44.812134
                        }
                    },
                    {
                        "citycode": "1909",
                        "adcode": "659007",
                        "name": "博河镇",
                        "center": {
                            "lng": 82.158974,
                            "lat": 44.79635
                        }
                    },
                    {
                        "citycode": "1909",
                        "adcode": "659007",
                        "name": "双桥镇",
                        "center": {
                            "lng": 82.490803,
                            "lat": 44.746864
                        }
                    },
                    {
                        "citycode": "1909",
                        "adcode": "659007",
                        "name": "石峪镇",
                        "center": {
                            "lng": 82.066675,
                            "lat": 45.04083
                        }
                    },
                    {
                        "citycode": "1909",
                        "adcode": "659007",
                        "name": "双乐镇",
                        "center": {
                            "lng": 82.473143,
                            "lat": 44.826624
                        }
                    }
                ]
            },
            {
                "citycode": "0909",
                "adcode": "652700",
                "name": "博尔塔拉蒙古自治州",
                "center": {
                    "lng": 82.066363,
                    "lat": 44.906039
                },
                "districtList": [
                    {
                        "citycode": "0909",
                        "adcode": "652723",
                        "name": "温泉县",
                        "center": {
                            "lng": 81.024827,
                            "lat": 44.968857
                        }
                    },
                    {
                        "citycode": "0909",
                        "adcode": "652702",
                        "name": "阿拉山口市",
                        "center": {
                            "lng": 82.554609,
                            "lat": 45.173274
                        }
                    },
                    {
                        "citycode": "0909",
                        "adcode": "652701",
                        "name": "博乐市",
                        "center": {
                            "lng": 82.051433,
                            "lat": 44.853882
                        }
                    },
                    {
                        "citycode": "0909",
                        "adcode": "652722",
                        "name": "精河县",
                        "center": {
                            "lng": 82.890709,
                            "lat": 44.599202
                        }
                    }
                ]
            },
            {
                "citycode": "1999",
                "adcode": "659008",
                "name": "可克达拉市",
                "center": {
                    "lng": 80.994153,
                    "lat": 43.940381
                },
                "districtList": [
                    {
                        "citycode": "1999",
                        "adcode": "659008",
                        "name": "长丰镇",
                        "center": {
                            "lng": 80.990266,
                            "lat": 43.889725
                        }
                    },
                    {
                        "citycode": "1999",
                        "adcode": "659008",
                        "name": "金屯镇",
                        "center": {
                            "lng": 80.606773,
                            "lat": 43.765174
                        }
                    },
                    {
                        "citycode": "1999",
                        "adcode": "659008",
                        "name": "都拉塔口岸",
                        "center": {
                            "lng": 80.661467,
                            "lat": 43.706479
                        }
                    },
                    {
                        "citycode": "1999",
                        "adcode": "659008",
                        "name": "榆树庄镇",
                        "center": {
                            "lng": 80.484243,
                            "lat": 43.931223
                        }
                    },
                    {
                        "citycode": "1999",
                        "adcode": "659008",
                        "name": "苇湖镇",
                        "center": {
                            "lng": 80.64837,
                            "lat": 44.180308
                        }
                    },
                    {
                        "citycode": "1999",
                        "adcode": "659008",
                        "name": "金梁镇",
                        "center": {
                            "lng": 81.021339,
                            "lat": 43.908278
                        }
                    }
                ]
            },
            {
                "citycode": "0901",
                "adcode": "654200",
                "name": "塔城地区",
                "center": {
                    "lng": 82.980316,
                    "lat": 46.745364
                },
                "districtList": [
                    {
                        "citycode": "0901",
                        "adcode": "654201",
                        "name": "塔城市",
                        "center": {
                            "lng": 82.986923,
                            "lat": 46.751669
                        }
                    },
                    {
                        "citycode": "0901",
                        "adcode": "654226",
                        "name": "和布克赛尔蒙古自治县",
                        "center": {
                            "lng": 85.728328,
                            "lat": 46.793235
                        }
                    },
                    {
                        "citycode": "0901",
                        "adcode": "654221",
                        "name": "额敏县",
                        "center": {
                            "lng": 83.628303,
                            "lat": 46.524673
                        }
                    },
                    {
                        "citycode": "0901",
                        "adcode": "654225",
                        "name": "裕民县",
                        "center": {
                            "lng": 82.982252,
                            "lat": 46.201049
                        }
                    },
                    {
                        "citycode": "0901",
                        "adcode": "654224",
                        "name": "托里县",
                        "center": {
                            "lng": 83.606372,
                            "lat": 45.948935
                        }
                    },
                    {
                        "citycode": "0901",
                        "adcode": "654202",
                        "name": "乌苏市",
                        "center": {
                            "lng": 84.713762,
                            "lat": 44.418693
                        }
                    },
                    {
                        "citycode": "0901",
                        "adcode": "654203",
                        "name": "沙湾市",
                        "center": {
                            "lng": 85.619483,
                            "lat": 44.326267
                        }
                    }
                ]
            },
            {
                "citycode": "1903",
                "adcode": "659009",
                "name": "昆玉市",
                "center": {
                    "lng": 79.270193,
                    "lat": 37.215372
                },
                "districtList": [
                    {
                        "citycode": "1903",
                        "adcode": "659009",
                        "name": "老兵镇",
                        "center": {
                            "lng": 79.603916,
                            "lat": 37.366638
                        }
                    },
                    {
                        "citycode": "1903",
                        "adcode": "659009",
                        "name": "昆牧镇",
                        "center": {
                            "lng": 81.029494,
                            "lat": 36.315217
                        }
                    },
                    {
                        "citycode": "1903",
                        "adcode": "659009",
                        "name": "昆泉镇",
                        "center": {
                            "lng": 78.514768,
                            "lat": 37.566112
                        }
                    },
                    {
                        "citycode": "1903",
                        "adcode": "659009",
                        "name": "兵团二二四团",
                        "center": {
                            "lng": 79.377194,
                            "lat": 37.416433
                        }
                    }
                ]
            },
            {
                "citycode": "0903",
                "adcode": "653200",
                "name": "和田地区",
                "center": {
                    "lng": 79.921646,
                    "lat": 37.114406
                },
                "districtList": [
                    {
                        "citycode": "0903",
                        "adcode": "653226",
                        "name": "于田县",
                        "center": {
                            "lng": 81.677417,
                            "lat": 36.85708
                        }
                    },
                    {
                        "citycode": "0903",
                        "adcode": "653227",
                        "name": "民丰县",
                        "center": {
                            "lng": 82.695946,
                            "lat": 37.064428
                        }
                    },
                    {
                        "citycode": "0903",
                        "adcode": "653201",
                        "name": "和田市",
                        "center": {
                            "lng": 79.912881,
                            "lat": 37.112246
                        }
                    },
                    {
                        "citycode": "0903",
                        "adcode": "653224",
                        "name": "洛浦县",
                        "center": {
                            "lng": 80.179911,
                            "lat": 37.066226
                        }
                    },
                    {
                        "citycode": "0903",
                        "adcode": "653223",
                        "name": "皮山县",
                        "center": {
                            "lng": 78.28548,
                            "lat": 37.578264
                        }
                    },
                    {
                        "citycode": "0903",
                        "adcode": "653222",
                        "name": "墨玉县",
                        "center": {
                            "lng": 79.728434,
                            "lat": 37.277518
                        }
                    },
                    {
                        "citycode": "0903",
                        "adcode": "653225",
                        "name": "策勒县",
                        "center": {
                            "lng": 80.801433,
                            "lat": 36.99785
                        }
                    },
                    {
                        "citycode": "0903",
                        "adcode": "653221",
                        "name": "和田县",
                        "center": {
                            "lng": 79.81907,
                            "lat": 37.120031
                        }
                    }
                ]
            },
            {
                "citycode": "0906",
                "adcode": "654300",
                "name": "阿勒泰地区",
                "center": {
                    "lng": 88.141253,
                    "lat": 47.844924
                },
                "districtList": [
                    {
                        "citycode": "0906",
                        "adcode": "654321",
                        "name": "布尔津县",
                        "center": {
                            "lng": 86.875043,
                            "lat": 47.701892
                        }
                    },
                    {
                        "citycode": "0906",
                        "adcode": "654324",
                        "name": "哈巴河县",
                        "center": {
                            "lng": 86.418621,
                            "lat": 48.060846
                        }
                    },
                    {
                        "citycode": "0906",
                        "adcode": "654322",
                        "name": "富蕴县",
                        "center": {
                            "lng": 89.525463,
                            "lat": 46.994046
                        }
                    },
                    {
                        "citycode": "0906",
                        "adcode": "654326",
                        "name": "吉木乃县",
                        "center": {
                            "lng": 85.874096,
                            "lat": 47.443101
                        }
                    },
                    {
                        "citycode": "0906",
                        "adcode": "654325",
                        "name": "青河县",
                        "center": {
                            "lng": 90.375159,
                            "lat": 46.678532
                        }
                    },
                    {
                        "citycode": "0906",
                        "adcode": "654323",
                        "name": "福海县",
                        "center": {
                            "lng": 87.486703,
                            "lat": 47.111918
                        }
                    },
                    {
                        "citycode": "0906",
                        "adcode": "654301",
                        "name": "阿勒泰市",
                        "center": {
                            "lng": 88.131842,
                            "lat": 47.827308
                        }
                    }
                ]
            },
            {
                "citycode": "0993",
                "adcode": "659001",
                "name": "石河子市",
                "center": {
                    "lng": 86.080397,
                    "lat": 44.305368
                },
                "districtList": [
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "兵团一五二团",
                        "center": {
                            "lng": 86.070393,
                            "lat": 44.2827
                        }
                    },
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "红山街道",
                        "center": {
                            "lng": 86.048043,
                            "lat": 44.268209
                        }
                    },
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "向阳街道",
                        "center": {
                            "lng": 86.039719,
                            "lat": 44.342873
                        }
                    },
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "兵团一四四团",
                        "center": {
                            "lng": 85.825763,
                            "lat": 44.456171
                        }
                    },
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "东城街道",
                        "center": {
                            "lng": 86.068708,
                            "lat": 44.287316
                        }
                    },
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "石河子镇",
                        "center": {
                            "lng": 86.102202,
                            "lat": 44.135229
                        }
                    },
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "老街街道",
                        "center": {
                            "lng": 85.990921,
                            "lat": 44.349559
                        }
                    },
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "新城街道",
                        "center": {
                            "lng": 85.982288,
                            "lat": 44.289311
                        }
                    },
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "北泉镇",
                        "center": {
                            "lng": 86.098308,
                            "lat": 44.434587
                        }
                    }
                ]
            },
            {
                "citycode": "0994",
                "adcode": "652300",
                "name": "昌吉回族自治州",
                "center": {
                    "lng": 87.308995,
                    "lat": 44.011044
                },
                "districtList": [
                    {
                        "citycode": "0994",
                        "adcode": "652325",
                        "name": "奇台县",
                        "center": {
                            "lng": 89.593879,
                            "lat": 44.022001
                        }
                    },
                    {
                        "citycode": "0994",
                        "adcode": "652324",
                        "name": "玛纳斯县",
                        "center": {
                            "lng": 86.20488,
                            "lat": 44.284601
                        }
                    },
                    {
                        "citycode": "0994",
                        "adcode": "652323",
                        "name": "呼图壁县",
                        "center": {
                            "lng": 86.871532,
                            "lat": 44.179362
                        }
                    },
                    {
                        "citycode": "0994",
                        "adcode": "652328",
                        "name": "木垒哈萨克自治县",
                        "center": {
                            "lng": 90.286013,
                            "lat": 43.834631
                        }
                    },
                    {
                        "citycode": "0994",
                        "adcode": "652302",
                        "name": "阜康市",
                        "center": {
                            "lng": 87.953826,
                            "lat": 44.164525
                        }
                    },
                    {
                        "citycode": "0994",
                        "adcode": "652327",
                        "name": "吉木萨尔县",
                        "center": {
                            "lng": 89.179698,
                            "lat": 44.000404
                        }
                    },
                    {
                        "citycode": "0994",
                        "adcode": "652301",
                        "name": "昌吉市",
                        "center": {
                            "lng": 87.267432,
                            "lat": 44.014468
                        }
                    }
                ]
            },
            {
                "citycode": "0996",
                "adcode": "652800",
                "name": "巴音郭楞蒙古自治州",
                "center": {
                    "lng": 86.145298,
                    "lat": 41.764115
                },
                "districtList": [
                    {
                        "citycode": "0996",
                        "adcode": "652827",
                        "name": "和静县",
                        "center": {
                            "lng": 86.384065,
                            "lat": 42.323625
                        }
                    },
                    {
                        "citycode": "0996",
                        "adcode": "652828",
                        "name": "和硕县",
                        "center": {
                            "lng": 86.877688,
                            "lat": 42.28361
                        }
                    },
                    {
                        "citycode": "0996",
                        "adcode": "652826",
                        "name": "焉耆回族自治县",
                        "center": {
                            "lng": 86.57434,
                            "lat": 42.059509
                        }
                    },
                    {
                        "citycode": "0996",
                        "adcode": "652829",
                        "name": "博湖县",
                        "center": {
                            "lng": 86.632116,
                            "lat": 41.980745
                        }
                    },
                    {
                        "citycode": "0996",
                        "adcode": "652824",
                        "name": "若羌县",
                        "center": {
                            "lng": 88.167226,
                            "lat": 39.022626
                        }
                    },
                    {
                        "citycode": "0996",
                        "adcode": "652825",
                        "name": "且末县",
                        "center": {
                            "lng": 85.529619,
                            "lat": 38.145749
                        }
                    },
                    {
                        "citycode": "0996",
                        "adcode": "652801",
                        "name": "库尔勒市",
                        "center": {
                            "lng": 86.174633,
                            "lat": 41.725891
                        }
                    },
                    {
                        "citycode": "0996",
                        "adcode": "652822",
                        "name": "轮台县",
                        "center": {
                            "lng": 84.251508,
                            "lat": 41.778043
                        }
                    },
                    {
                        "citycode": "0996",
                        "adcode": "652823",
                        "name": "尉犁县",
                        "center": {
                            "lng": 86.261613,
                            "lat": 41.343871
                        }
                    }
                ]
            },
            {
                "citycode": "0999",
                "adcode": "654000",
                "name": "伊犁哈萨克自治州",
                "center": {
                    "lng": 81.323691,
                    "lat": 43.917106
                },
                "districtList": [
                    {
                        "citycode": "0999",
                        "adcode": "654021",
                        "name": "伊宁县",
                        "center": {
                            "lng": 81.52745,
                            "lat": 43.977119
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654028",
                        "name": "尼勒克县",
                        "center": {
                            "lng": 82.511884,
                            "lat": 43.798627
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654024",
                        "name": "巩留县",
                        "center": {
                            "lng": 82.231219,
                            "lat": 43.48313
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654026",
                        "name": "昭苏县",
                        "center": {
                            "lng": 81.130974,
                            "lat": 43.157293
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654027",
                        "name": "特克斯县",
                        "center": {
                            "lng": 81.835732,
                            "lat": 43.218435
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654025",
                        "name": "新源县",
                        "center": {
                            "lng": 83.233002,
                            "lat": 43.434803
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654023",
                        "name": "霍城县",
                        "center": {
                            "lng": 80.878845,
                            "lat": 44.056329
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654022",
                        "name": "察布查尔锡伯自治县",
                        "center": {
                            "lng": 81.151337,
                            "lat": 43.840726
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654004",
                        "name": "霍尔果斯市",
                        "center": {
                            "lng": 80.414614,
                            "lat": 44.218381
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654002",
                        "name": "伊宁市",
                        "center": {
                            "lng": 81.277715,
                            "lat": 43.908021
                        }
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654003",
                        "name": "奎屯市",
                        "center": {
                            "lng": 84.903216,
                            "lat": 44.426452
                        }
                    }
                ]
            },
            {
                "citycode": "1997",
                "adcode": "659002",
                "name": "阿拉尔市",
                "center": {
                    "lng": 81.280532,
                    "lat": 40.547205
                },
                "districtList": [
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "玛滩镇",
                        "center": {
                            "lng": 80.654296,
                            "lat": 40.656858
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "花桥镇",
                        "center": {
                            "lng": 81.561898,
                            "lat": 40.627686
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "沙河镇",
                        "center": {
                            "lng": 80.734788,
                            "lat": 41.289273
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "托喀依乡",
                        "center": {
                            "lng": 81.35414,
                            "lat": 40.581819
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "青松路街道",
                        "center": {
                            "lng": 81.254474,
                            "lat": 40.542004
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "塔门镇",
                        "center": {
                            "lng": 80.799573,
                            "lat": 40.597311
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "南口街道",
                        "center": {
                            "lng": 81.298804,
                            "lat": 40.515367
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "金杨镇",
                        "center": {
                            "lng": 81.873439,
                            "lat": 40.928322
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "新井子镇",
                        "center": {
                            "lng": 80.027429,
                            "lat": 40.565638
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "甘泉镇",
                        "center": {
                            "lng": 79.814651,
                            "lat": 40.47728
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "兵团农一师沙井子水利管理处",
                        "center": {
                            "lng": 79.726734,
                            "lat": 40.436977
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "金银川镇",
                        "center": {
                            "lng": 80.086552,
                            "lat": 40.691135
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "幸福镇",
                        "center": {
                            "lng": 81.665359,
                            "lat": 40.707751
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "新开岭镇",
                        "center": {
                            "lng": 80.61682,
                            "lat": 40.429603
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "幸福路街道",
                        "center": {
                            "lng": 81.270919,
                            "lat": 40.577037
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "塔南镇",
                        "center": {
                            "lng": 81.360828,
                            "lat": 40.548449
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "昌安镇",
                        "center": {
                            "lng": 81.281049,
                            "lat": 40.57557
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "金银川路街道",
                        "center": {
                            "lng": 81.262521,
                            "lat": 40.536818
                        }
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "双城镇",
                        "center": {
                            "lng": 80.403007,
                            "lat": 41.029144
                        }
                    }
                ]
            },
            {
                "citycode": "0998",
                "adcode": "653100",
                "name": "喀什地区",
                "center": {
                    "lng": 75.989746,
                    "lat": 39.470492
                },
                "districtList": [
                    {
                        "citycode": "0998",
                        "adcode": "653129",
                        "name": "伽师县",
                        "center": {
                            "lng": 76.723719,
                            "lat": 39.488181
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653122",
                        "name": "疏勒县",
                        "center": {
                            "lng": 76.047169,
                            "lat": 39.401173
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653127",
                        "name": "麦盖提县",
                        "center": {
                            "lng": 77.609099,
                            "lat": 38.898986
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653126",
                        "name": "叶城县",
                        "center": {
                            "lng": 77.413669,
                            "lat": 37.882994
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653125",
                        "name": "莎车县",
                        "center": {
                            "lng": 77.223197,
                            "lat": 38.390881
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653131",
                        "name": "塔什库尔干塔吉克自治县",
                        "center": {
                            "lng": 75.229889,
                            "lat": 37.772094
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653124",
                        "name": "泽普县",
                        "center": {
                            "lng": 77.260375,
                            "lat": 38.184639
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653130",
                        "name": "巴楚县",
                        "center": {
                            "lng": 78.54799,
                            "lat": 39.79923
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653123",
                        "name": "英吉沙县",
                        "center": {
                            "lng": 76.175729,
                            "lat": 38.930381
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653128",
                        "name": "岳普湖县",
                        "center": {
                            "lng": 76.821269,
                            "lat": 39.219857
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653101",
                        "name": "喀什市",
                        "center": {
                            "lng": 75.993936,
                            "lat": 39.46823
                        }
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653121",
                        "name": "疏附县",
                        "center": {
                            "lng": 75.862839,
                            "lat": 39.375052
                        }
                    }
                ]
            },
            {
                "citycode": "0908",
                "adcode": "653000",
                "name": "克孜勒苏柯尔克孜自治州",
                "center": {
                    "lng": 76.167327,
                    "lat": 39.714734
                },
                "districtList": [
                    {
                        "citycode": "0908",
                        "adcode": "653024",
                        "name": "乌恰县",
                        "center": {
                            "lng": 75.259228,
                            "lat": 39.7205
                        }
                    },
                    {
                        "citycode": "0908",
                        "adcode": "653001",
                        "name": "阿图什市",
                        "center": {
                            "lng": 76.084541,
                            "lat": 39.667719
                        }
                    },
                    {
                        "citycode": "0908",
                        "adcode": "653022",
                        "name": "阿克陶县",
                        "center": {
                            "lng": 75.947396,
                            "lat": 39.147785
                        }
                    },
                    {
                        "citycode": "0908",
                        "adcode": "653023",
                        "name": "阿合奇县",
                        "center": {
                            "lng": 78.402073,
                            "lat": 40.937581
                        }
                    }
                ]
            },
            {
                "citycode": "0990",
                "adcode": "650200",
                "name": "克拉玛依市",
                "center": {
                    "lng": 84.889239,
                    "lat": 45.577712
                },
                "districtList": [
                    {
                        "citycode": "0990",
                        "adcode": "650205",
                        "name": "乌尔禾区",
                        "center": {
                            "lng": 85.692518,
                            "lat": 46.085819
                        }
                    },
                    {
                        "citycode": "0990",
                        "adcode": "650202",
                        "name": "独山子区",
                        "center": {
                            "lng": 84.886973,
                            "lat": 44.328096
                        }
                    },
                    {
                        "citycode": "0990",
                        "adcode": "650204",
                        "name": "白碱滩区",
                        "center": {
                            "lng": 85.119047,
                            "lat": 45.685416
                        }
                    },
                    {
                        "citycode": "0990",
                        "adcode": "650203",
                        "name": "克拉玛依区",
                        "center": {
                            "lng": 84.867862,
                            "lat": 45.602347
                        }
                    }
                ]
            },
            {
                "citycode": "0995",
                "adcode": "650400",
                "name": "吐鲁番市",
                "center": {
                    "lng": 89.190374,
                    "lat": 42.950736
                },
                "districtList": [
                    {
                        "citycode": "0995",
                        "adcode": "650402",
                        "name": "高昌区",
                        "center": {
                            "lng": 89.185891,
                            "lat": 42.942728
                        }
                    },
                    {
                        "citycode": "0995",
                        "adcode": "650421",
                        "name": "鄯善县",
                        "center": {
                            "lng": 90.242843,
                            "lat": 42.900575
                        }
                    },
                    {
                        "citycode": "0995",
                        "adcode": "650422",
                        "name": "托克逊县",
                        "center": {
                            "lng": 88.643739,
                            "lat": 42.802585
                        }
                    }
                ]
            },
            {
                "citycode": "0902",
                "adcode": "650500",
                "name": "哈密市",
                "center": {
                    "lng": 93.515053,
                    "lat": 42.819346
                },
                "districtList": [
                    {
                        "citycode": "0902",
                        "adcode": "650522",
                        "name": "伊吾县",
                        "center": {
                            "lng": 94.697074,
                            "lat": 43.254978
                        }
                    },
                    {
                        "citycode": "0902",
                        "adcode": "650521",
                        "name": "巴里坤哈萨克自治县",
                        "center": {
                            "lng": 93.016563,
                            "lat": 43.598756
                        }
                    },
                    {
                        "citycode": "0902",
                        "adcode": "650502",
                        "name": "伊州区",
                        "center": {
                            "lng": 93.515085,
                            "lat": 42.827376
                        }
                    }
                ]
            },
            {
                "citycode": "2940",
                "adcode": "659011",
                "name": "新星市",
                "center": {
                    "lng": 93.74831,
                    "lat": 42.797043
                },
                "districtList": [
                    {
                        "citycode": "2940",
                        "adcode": "659011",
                        "name": "兵团红星四场",
                        "center": {
                            "lng": 94.068557,
                            "lat": 42.529865
                        }
                    },
                    {
                        "citycode": "2940",
                        "adcode": "659011",
                        "name": "兵团黄田农场",
                        "center": {
                            "lng": 93.719461,
                            "lat": 42.567696
                        }
                    },
                    {
                        "citycode": "2940",
                        "adcode": "659011",
                        "name": "兵团红星一场",
                        "center": {
                            "lng": 93.64524,
                            "lat": 42.68662
                        }
                    }
                ]
            },
            {
                "citycode": "1998",
                "adcode": "659003",
                "name": "图木舒克市",
                "center": {
                    "lng": 79.074965,
                    "lat": 39.867776
                },
                "districtList": [
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "海安镇",
                        "center": {
                            "lng": 78.756041,
                            "lat": 39.822379
                        }
                    },
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "唐驿镇",
                        "center": {
                            "lng": 79.290232,
                            "lat": 39.988845
                        }
                    },
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "前海街道",
                        "center": {
                            "lng": 79.077771,
                            "lat": 39.855038
                        }
                    },
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "喀拉拜勒镇",
                        "center": {
                            "lng": 79.011211,
                            "lat": 39.852615
                        }
                    },
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "齐干却勒街道",
                        "center": {
                            "lng": 79.090585,
                            "lat": 39.875314
                        }
                    },
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "金胡杨镇",
                        "center": {
                            "lng": 79.321433,
                            "lat": 40.031839
                        }
                    },
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "夏河镇",
                        "center": {
                            "lng": 79.231481,
                            "lat": 39.954869
                        }
                    },
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "永安镇",
                        "center": {
                            "lng": 79.19262,
                            "lat": 39.916764
                        }
                    },
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "永安坝街道",
                        "center": {
                            "lng": 79.025712,
                            "lat": 39.850697
                        }
                    }
                ]
            },
            {
                "citycode": "0997",
                "adcode": "652900",
                "name": "阿克苏地区",
                "center": {
                    "lng": 80.265068,
                    "lat": 41.170712
                },
                "districtList": [
                    {
                        "citycode": "0997",
                        "adcode": "652926",
                        "name": "拜城县",
                        "center": {
                            "lng": 81.851289,
                            "lat": 41.795289
                        }
                    },
                    {
                        "citycode": "0997",
                        "adcode": "652902",
                        "name": "库车市",
                        "center": {
                            "lng": 82.998544,
                            "lat": 41.719073
                        }
                    },
                    {
                        "citycode": "0997",
                        "adcode": "652925",
                        "name": "新和县",
                        "center": {
                            "lng": 82.620371,
                            "lat": 41.552097
                        }
                    },
                    {
                        "citycode": "0997",
                        "adcode": "652924",
                        "name": "沙雅县",
                        "center": {
                            "lng": 82.781774,
                            "lat": 41.221413
                        }
                    },
                    {
                        "citycode": "0997",
                        "adcode": "652901",
                        "name": "阿克苏市",
                        "center": {
                            "lng": 80.263387,
                            "lat": 41.16755
                        }
                    },
                    {
                        "citycode": "0997",
                        "adcode": "652927",
                        "name": "乌什县",
                        "center": {
                            "lng": 79.22118,
                            "lat": 41.222706
                        }
                    },
                    {
                        "citycode": "0997",
                        "adcode": "652929",
                        "name": "柯坪县",
                        "center": {
                            "lng": 79.054019,
                            "lat": 40.501645
                        }
                    },
                    {
                        "citycode": "0997",
                        "adcode": "652928",
                        "name": "阿瓦提县",
                        "center": {
                            "lng": 80.375053,
                            "lat": 40.643647
                        }
                    },
                    {
                        "citycode": "0997",
                        "adcode": "652922",
                        "name": "温宿县",
                        "center": {
                            "lng": 80.243273,
                            "lat": 41.272995
                        }
                    }
                ]
            },
            {
                "citycode": "0991",
                "adcode": "650100",
                "name": "乌鲁木齐市",
                "center": {
                    "lng": 87.616824,
                    "lat": 43.825377
                },
                "districtList": [
                    {
                        "citycode": "0991",
                        "adcode": "650107",
                        "name": "达坂城区",
                        "center": {
                            "lng": 88.311099,
                            "lat": 43.363668
                        }
                    },
                    {
                        "citycode": "0991",
                        "adcode": "650102",
                        "name": "天山区",
                        "center": {
                            "lng": 87.631986,
                            "lat": 43.794312
                        }
                    },
                    {
                        "citycode": "0991",
                        "adcode": "650105",
                        "name": "水磨沟区",
                        "center": {
                            "lng": 87.64208,
                            "lat": 43.832714
                        }
                    },
                    {
                        "citycode": "0991",
                        "adcode": "650109",
                        "name": "米东区",
                        "center": {
                            "lng": 87.655122,
                            "lat": 43.97444
                        }
                    },
                    {
                        "citycode": "0991",
                        "adcode": "650121",
                        "name": "乌鲁木齐县",
                        "center": {
                            "lng": 87.464257,
                            "lat": 43.509016
                        }
                    },
                    {
                        "citycode": "0991",
                        "adcode": "650103",
                        "name": "沙依巴克区",
                        "center": {
                            "lng": 87.598043,
                            "lat": 43.800994
                        }
                    },
                    {
                        "citycode": "0991",
                        "adcode": "650106",
                        "name": "头屯河区",
                        "center": {
                            "lng": 87.425823,
                            "lat": 43.876052
                        }
                    },
                    {
                        "citycode": "0991",
                        "adcode": "650104",
                        "name": "新市区",
                        "center": {
                            "lng": 87.592684,
                            "lat": 43.893023
                        }
                    }
                ]
            },
            {
                "citycode": "0992",
                "adcode": "659010",
                "name": "胡杨河市",
                "center": {
                    "lng": 84.827592,
                    "lat": 44.692894
                },
                "districtList": [
                    {
                        "citycode": "0992",
                        "adcode": "659010",
                        "name": "兵团一三零团",
                        "center": {
                            "lng": 84.642314,
                            "lat": 44.75404
                        }
                    },
                    {
                        "citycode": "0992",
                        "adcode": "659010",
                        "name": "兵团一二九团",
                        "center": {
                            "lng": 84.733352,
                            "lat": 44.711517
                        }
                    }
                ]
            },
            {
                "citycode": "1994",
                "adcode": "659004",
                "name": "五家渠市",
                "center": {
                    "lng": 87.542852,
                    "lat": 44.166489
                },
                "districtList": [
                    {
                        "citycode": "1994",
                        "adcode": "659004",
                        "name": "梧桐镇",
                        "center": {
                            "lng": 87.592476,
                            "lat": 44.269442
                        }
                    },
                    {
                        "citycode": "1994",
                        "adcode": "659004",
                        "name": "人民路街道",
                        "center": {
                            "lng": 87.572823,
                            "lat": 44.182157
                        }
                    },
                    {
                        "citycode": "1994",
                        "adcode": "659004",
                        "name": "兵团一零一团",
                        "center": {
                            "lng": 87.556234,
                            "lat": 44.17516
                        }
                    },
                    {
                        "citycode": "1994",
                        "adcode": "659004",
                        "name": "蔡家湖镇",
                        "center": {
                            "lng": 87.407474,
                            "lat": 44.531659
                        }
                    },
                    {
                        "citycode": "1994",
                        "adcode": "659004",
                        "name": "青湖路街道",
                        "center": {
                            "lng": 87.524481,
                            "lat": 44.176392
                        }
                    },
                    {
                        "citycode": "1994",
                        "adcode": "659004",
                        "name": "军垦路街道",
                        "center": {
                            "lng": 87.50816,
                            "lat": 44.188534
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "420000",
        "name": "湖北省",
        "center": {
            "lng": 114.341552,
            "lat": 30.546222
        },
        "districtList": [
            {
                "citycode": "0710",
                "adcode": "420600",
                "name": "襄阳市",
                "center": {
                    "lng": 112.121743,
                    "lat": 32.010161
                },
                "districtList": [
                    {
                        "citycode": "0710",
                        "adcode": "420625",
                        "name": "谷城县",
                        "center": {
                            "lng": 111.653077,
                            "lat": 32.26339
                        }
                    },
                    {
                        "citycode": "0710",
                        "adcode": "420684",
                        "name": "宜城市",
                        "center": {
                            "lng": 112.256486,
                            "lat": 31.720278
                        }
                    },
                    {
                        "citycode": "0710",
                        "adcode": "420683",
                        "name": "枣阳市",
                        "center": {
                            "lng": 112.772723,
                            "lat": 32.128968
                        }
                    },
                    {
                        "citycode": "0710",
                        "adcode": "420626",
                        "name": "保康县",
                        "center": {
                            "lng": 111.261308,
                            "lat": 31.87831
                        }
                    },
                    {
                        "citycode": "0710",
                        "adcode": "420624",
                        "name": "南漳县",
                        "center": {
                            "lng": 111.838997,
                            "lat": 31.774649
                        }
                    },
                    {
                        "citycode": "0710",
                        "adcode": "420607",
                        "name": "襄州区",
                        "center": {
                            "lng": 112.211365,
                            "lat": 32.088651
                        }
                    },
                    {
                        "citycode": "0710",
                        "adcode": "420602",
                        "name": "襄城区",
                        "center": {
                            "lng": 112.134025,
                            "lat": 32.009932
                        }
                    },
                    {
                        "citycode": "0710",
                        "adcode": "420606",
                        "name": "樊城区",
                        "center": {
                            "lng": 112.135241,
                            "lat": 32.045065
                        }
                    },
                    {
                        "citycode": "0710",
                        "adcode": "420682",
                        "name": "老河口市",
                        "center": {
                            "lng": 111.683861,
                            "lat": 32.359068
                        }
                    }
                ]
            },
            {
                "citycode": "0719",
                "adcode": "420300",
                "name": "十堰市",
                "center": {
                    "lng": 110.798921,
                    "lat": 32.629057
                },
                "districtList": [
                    {
                        "citycode": "0719",
                        "adcode": "420304",
                        "name": "郧阳区",
                        "center": {
                            "lng": 110.812101,
                            "lat": 32.834847
                        }
                    },
                    {
                        "citycode": "0719",
                        "adcode": "420302",
                        "name": "茅箭区",
                        "center": {
                            "lng": 110.813478,
                            "lat": 32.591847
                        }
                    },
                    {
                        "citycode": "0719",
                        "adcode": "420303",
                        "name": "张湾区",
                        "center": {
                            "lng": 110.769132,
                            "lat": 32.652297
                        }
                    },
                    {
                        "citycode": "0719",
                        "adcode": "420323",
                        "name": "竹山县",
                        "center": {
                            "lng": 110.229696,
                            "lat": 32.225039
                        }
                    },
                    {
                        "citycode": "0719",
                        "adcode": "420324",
                        "name": "竹溪县",
                        "center": {
                            "lng": 109.715322,
                            "lat": 32.318257
                        }
                    },
                    {
                        "citycode": "0719",
                        "adcode": "420325",
                        "name": "房县",
                        "center": {
                            "lng": 110.726754,
                            "lat": 32.04017
                        }
                    },
                    {
                        "citycode": "0719",
                        "adcode": "420322",
                        "name": "郧西县",
                        "center": {
                            "lng": 110.426005,
                            "lat": 32.993095
                        }
                    },
                    {
                        "citycode": "0719",
                        "adcode": "420381",
                        "name": "丹江口市",
                        "center": {
                            "lng": 111.513318,
                            "lat": 32.540287
                        }
                    }
                ]
            },
            {
                "citycode": "0717",
                "adcode": "420500",
                "name": "宜昌市",
                "center": {
                    "lng": 111.286962,
                    "lat": 30.69217
                },
                "districtList": [
                    {
                        "citycode": "0717",
                        "adcode": "420526",
                        "name": "兴山县",
                        "center": {
                            "lng": 110.746831,
                            "lat": 31.348065
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420527",
                        "name": "秭归县",
                        "center": {
                            "lng": 110.97793,
                            "lat": 30.825882
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420504",
                        "name": "点军区",
                        "center": {
                            "lng": 111.268338,
                            "lat": 30.69343
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420582",
                        "name": "当阳市",
                        "center": {
                            "lng": 111.78836,
                            "lat": 30.820893
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420581",
                        "name": "宜都市",
                        "center": {
                            "lng": 111.450128,
                            "lat": 30.378444
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420525",
                        "name": "远安县",
                        "center": {
                            "lng": 111.640329,
                            "lat": 31.060904
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420503",
                        "name": "伍家岗区",
                        "center": {
                            "lng": 111.360882,
                            "lat": 30.644048
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420505",
                        "name": "猇亭区",
                        "center": {
                            "lng": 111.434378,
                            "lat": 30.531133
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420583",
                        "name": "枝江市",
                        "center": {
                            "lng": 111.760616,
                            "lat": 30.425758
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420529",
                        "name": "五峰土家族自治县",
                        "center": {
                            "lng": 111.07374,
                            "lat": 30.156741
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420506",
                        "name": "夷陵区",
                        "center": {
                            "lng": 111.326371,
                            "lat": 30.769875
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420502",
                        "name": "西陵区",
                        "center": {
                            "lng": 111.285696,
                            "lat": 30.710765
                        }
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420528",
                        "name": "长阳土家族自治县",
                        "center": {
                            "lng": 111.20697,
                            "lat": 30.473038
                        }
                    }
                ]
            },
            {
                "citycode": "027",
                "adcode": "420100",
                "name": "武汉市",
                "center": {
                    "lng": 114.304569,
                    "lat": 30.593354
                },
                "districtList": [
                    {
                        "citycode": "027",
                        "adcode": "420117",
                        "name": "新洲区",
                        "center": {
                            "lng": 114.801284,
                            "lat": 30.841304
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420113",
                        "name": "汉南区",
                        "center": {
                            "lng": 114.084582,
                            "lat": 30.308776
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420114",
                        "name": "蔡甸区",
                        "center": {
                            "lng": 114.087279,
                            "lat": 30.536395
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420115",
                        "name": "江夏区",
                        "center": {
                            "lng": 114.320884,
                            "lat": 30.37558
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420106",
                        "name": "武昌区",
                        "center": {
                            "lng": 114.316464,
                            "lat": 30.55418
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420102",
                        "name": "江岸区",
                        "center": {
                            "lng": 114.309317,
                            "lat": 30.600008
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420112",
                        "name": "东西湖区",
                        "center": {
                            "lng": 114.136295,
                            "lat": 30.620079
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420107",
                        "name": "青山区",
                        "center": {
                            "lng": 114.385424,
                            "lat": 30.639842
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420105",
                        "name": "汉阳区",
                        "center": {
                            "lng": 114.21859,
                            "lat": 30.554287
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420116",
                        "name": "黄陂区",
                        "center": {
                            "lng": 114.375698,
                            "lat": 30.882305
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420111",
                        "name": "洪山区",
                        "center": {
                            "lng": 114.342664,
                            "lat": 30.500642
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420103",
                        "name": "江汉区",
                        "center": {
                            "lng": 114.270763,
                            "lat": 30.601129
                        }
                    },
                    {
                        "citycode": "027",
                        "adcode": "420104",
                        "name": "硚口区",
                        "center": {
                            "lng": 114.214746,
                            "lat": 30.582559
                        }
                    }
                ]
            },
            {
                "citycode": "0713",
                "adcode": "421100",
                "name": "黄冈市",
                "center": {
                    "lng": 114.872425,
                    "lat": 30.453722
                },
                "districtList": [
                    {
                        "citycode": "0713",
                        "adcode": "421181",
                        "name": "麻城市",
                        "center": {
                            "lng": 115.008011,
                            "lat": 31.172917
                        }
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421102",
                        "name": "黄州区",
                        "center": {
                            "lng": 114.880104,
                            "lat": 30.434354
                        }
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421124",
                        "name": "英山县",
                        "center": {
                            "lng": 115.680953,
                            "lat": 30.734989
                        }
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421121",
                        "name": "团风县",
                        "center": {
                            "lng": 114.872364,
                            "lat": 30.643225
                        }
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421123",
                        "name": "罗田县",
                        "center": {
                            "lng": 115.399149,
                            "lat": 30.783047
                        }
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421127",
                        "name": "黄梅县",
                        "center": {
                            "lng": 115.944219,
                            "lat": 30.070453
                        }
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421122",
                        "name": "红安县",
                        "center": {
                            "lng": 114.618134,
                            "lat": 31.288167
                        }
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421125",
                        "name": "浠水县",
                        "center": {
                            "lng": 115.265155,
                            "lat": 30.452212
                        }
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421126",
                        "name": "蕲春县",
                        "center": {
                            "lng": 115.436423,
                            "lat": 30.226146
                        }
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421182",
                        "name": "武穴市",
                        "center": {
                            "lng": 115.595451,
                            "lat": 29.869602
                        }
                    }
                ]
            },
            {
                "citycode": "1728",
                "adcode": "429006",
                "name": "天门市",
                "center": {
                    "lng": 113.166545,
                    "lat": 30.663706
                },
                "districtList": [
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "胡市镇",
                        "center": {
                            "lng": 113.422187,
                            "lat": 30.802027
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "黄潭镇",
                        "center": {
                            "lng": 113.038506,
                            "lat": 30.69216
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "多祥镇",
                        "center": {
                            "lng": 113.357891,
                            "lat": 30.423413
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "沉湖管委会",
                        "center": {
                            "lng": 113.398615,
                            "lat": 30.458799
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "干驿镇",
                        "center": {
                            "lng": 113.450967,
                            "lat": 30.502984
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "马湾镇",
                        "center": {
                            "lng": 113.312283,
                            "lat": 30.599323
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "横林镇",
                        "center": {
                            "lng": 113.21459,
                            "lat": 30.564294
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "蒋湖农场",
                        "center": {
                            "lng": 112.779827,
                            "lat": 30.630562
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "小板镇",
                        "center": {
                            "lng": 113.263987,
                            "lat": 30.615139
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "岳口镇",
                        "center": {
                            "lng": 113.105,
                            "lat": 30.586764
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "蒋场镇",
                        "center": {
                            "lng": 112.927266,
                            "lat": 30.646031
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "石家河镇",
                        "center": {
                            "lng": 113.076431,
                            "lat": 30.821122
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "彭市镇",
                        "center": {
                            "lng": 113.157308,
                            "lat": 30.431522
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "九真镇",
                        "center": {
                            "lng": 113.206379,
                            "lat": 30.824523
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "佛子山镇",
                        "center": {
                            "lng": 113.067782,
                            "lat": 30.689228
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "竟陵街道",
                        "center": {
                            "lng": 113.182938,
                            "lat": 30.706618
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "侯口街道",
                        "center": {
                            "lng": 113.133899,
                            "lat": 30.652014
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "麻洋镇",
                        "center": {
                            "lng": 113.309397,
                            "lat": 30.5249
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "杨林街道",
                        "center": {
                            "lng": 113.265467,
                            "lat": 30.685636
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "汪场镇",
                        "center": {
                            "lng": 112.978692,
                            "lat": 30.638003
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "白茅湖农场",
                        "center": {
                            "lng": 113.063412,
                            "lat": 30.586804
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "皂市镇",
                        "center": {
                            "lng": 113.223245,
                            "lat": 30.795738
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "拖市镇",
                        "center": {
                            "lng": 112.841174,
                            "lat": 30.729303
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "卢市镇",
                        "center": {
                            "lng": 113.396655,
                            "lat": 30.659558
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "净潭乡",
                        "center": {
                            "lng": 113.450669,
                            "lat": 30.646405
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "多宝镇",
                        "center": {
                            "lng": 112.705302,
                            "lat": 30.627076
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "渔薪镇",
                        "center": {
                            "lng": 112.889649,
                            "lat": 30.668912
                        }
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "张港镇",
                        "center": {
                            "lng": 112.911875,
                            "lat": 30.578584
                        }
                    }
                ]
            },
            {
                "citycode": "0712",
                "adcode": "420900",
                "name": "孝感市",
                "center": {
                    "lng": 113.956962,
                    "lat": 30.918311
                },
                "districtList": [
                    {
                        "citycode": "0712",
                        "adcode": "420923",
                        "name": "云梦县",
                        "center": {
                            "lng": 113.752958,
                            "lat": 31.021736
                        }
                    },
                    {
                        "citycode": "0712",
                        "adcode": "420902",
                        "name": "孝南区",
                        "center": {
                            "lng": 113.910769,
                            "lat": 30.91695
                        }
                    },
                    {
                        "citycode": "0712",
                        "adcode": "420984",
                        "name": "汉川市",
                        "center": {
                            "lng": 113.838068,
                            "lat": 30.673219
                        }
                    },
                    {
                        "citycode": "0712",
                        "adcode": "420981",
                        "name": "应城市",
                        "center": {
                            "lng": 113.571864,
                            "lat": 30.928592
                        }
                    },
                    {
                        "citycode": "0712",
                        "adcode": "420982",
                        "name": "安陆市",
                        "center": {
                            "lng": 113.688955,
                            "lat": 31.25565
                        }
                    },
                    {
                        "citycode": "0712",
                        "adcode": "420921",
                        "name": "孝昌县",
                        "center": {
                            "lng": 113.997794,
                            "lat": 31.258225
                        }
                    },
                    {
                        "citycode": "0712",
                        "adcode": "420922",
                        "name": "大悟县",
                        "center": {
                            "lng": 114.127122,
                            "lat": 31.561179
                        }
                    }
                ]
            },
            {
                "citycode": "0724",
                "adcode": "420800",
                "name": "荆门市",
                "center": {
                    "lng": 112.199009,
                    "lat": 31.035445
                },
                "districtList": [
                    {
                        "citycode": "0724",
                        "adcode": "420882",
                        "name": "京山市",
                        "center": {
                            "lng": 113.119561,
                            "lat": 31.018414
                        }
                    },
                    {
                        "citycode": "0724",
                        "adcode": "420822",
                        "name": "沙洋县",
                        "center": {
                            "lng": 112.588675,
                            "lat": 30.709167
                        }
                    },
                    {
                        "citycode": "0724",
                        "adcode": "420804",
                        "name": "掇刀区",
                        "center": {
                            "lng": 112.2079,
                            "lat": 30.973397
                        }
                    },
                    {
                        "citycode": "0724",
                        "adcode": "420802",
                        "name": "东宝区",
                        "center": {
                            "lng": 112.201657,
                            "lat": 31.05187
                        }
                    },
                    {
                        "citycode": "0724",
                        "adcode": "420881",
                        "name": "钟祥市",
                        "center": {
                            "lng": 112.588032,
                            "lat": 31.167933
                        }
                    }
                ]
            },
            {
                "citycode": "2728",
                "adcode": "429005",
                "name": "潜江市",
                "center": {
                    "lng": 112.900279,
                    "lat": 30.401954
                },
                "districtList": [
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "广华寺街道",
                        "center": {
                            "lng": 112.666286,
                            "lat": 30.463319
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "泰丰街道",
                        "center": {
                            "lng": 112.980898,
                            "lat": 30.416671
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "周矶管理区",
                        "center": {
                            "lng": 112.785657,
                            "lat": 30.463577
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "高场街道",
                        "center": {
                            "lng": 112.774574,
                            "lat": 30.407577
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "总口管理区",
                        "center": {
                            "lng": 112.890449,
                            "lat": 30.258095
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "王场镇",
                        "center": {
                            "lng": 112.818521,
                            "lat": 30.490597
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "运粮湖管理区",
                        "center": {
                            "lng": 112.58182,
                            "lat": 30.252044
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "园林街道",
                        "center": {
                            "lng": 112.910007,
                            "lat": 30.376965
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "白鹭湖管理区",
                        "center": {
                            "lng": 112.715593,
                            "lat": 30.178757
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "竹根滩镇",
                        "center": {
                            "lng": 112.979245,
                            "lat": 30.471601
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "渔洋镇",
                        "center": {
                            "lng": 112.966486,
                            "lat": 30.239237
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "熊口镇",
                        "center": {
                            "lng": 112.724425,
                            "lat": 30.340363
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "熊口管理区",
                        "center": {
                            "lng": 112.806208,
                            "lat": 30.256835
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "后湖管理区",
                        "center": {
                            "lng": 112.767709,
                            "lat": 30.404874
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "张金镇",
                        "center": {
                            "lng": 112.57725,
                            "lat": 30.238919
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "杨市街道",
                        "center": {
                            "lng": 112.914959,
                            "lat": 30.383464
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "高石碑镇",
                        "center": {
                            "lng": 112.62557,
                            "lat": 30.62034
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "周矶街道",
                        "center": {
                            "lng": 112.781398,
                            "lat": 30.391044
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "积玉口镇",
                        "center": {
                            "lng": 112.634123,
                            "lat": 30.398499
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "泽口街道",
                        "center": {
                            "lng": 112.915656,
                            "lat": 30.48816
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "浩口镇",
                        "center": {
                            "lng": 112.566899,
                            "lat": 30.307792
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "老新镇",
                        "center": {
                            "lng": 112.887009,
                            "lat": 30.215033
                        }
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "龙湾镇",
                        "center": {
                            "lng": 112.780855,
                            "lat": 30.253634
                        }
                    }
                ]
            },
            {
                "citycode": "0718",
                "adcode": "422800",
                "name": "恩施土家族苗族自治州",
                "center": {
                    "lng": 109.488076,
                    "lat": 30.272104
                },
                "districtList": [
                    {
                        "citycode": "0718",
                        "adcode": "422822",
                        "name": "建始县",
                        "center": {
                            "lng": 109.722333,
                            "lat": 30.602195
                        }
                    },
                    {
                        "citycode": "0718",
                        "adcode": "422801",
                        "name": "恩施市",
                        "center": {
                            "lng": 109.479572,
                            "lat": 30.295148
                        }
                    },
                    {
                        "citycode": "0718",
                        "adcode": "422802",
                        "name": "利川市",
                        "center": {
                            "lng": 108.936456,
                            "lat": 30.290974
                        }
                    },
                    {
                        "citycode": "0718",
                        "adcode": "422825",
                        "name": "宣恩县",
                        "center": {
                            "lng": 109.489918,
                            "lat": 29.986856
                        }
                    },
                    {
                        "citycode": "0718",
                        "adcode": "422826",
                        "name": "咸丰县",
                        "center": {
                            "lng": 109.140163,
                            "lat": 29.665215
                        }
                    },
                    {
                        "citycode": "0718",
                        "adcode": "422827",
                        "name": "来凤县",
                        "center": {
                            "lng": 109.407697,
                            "lat": 29.493474
                        }
                    },
                    {
                        "citycode": "0718",
                        "adcode": "422828",
                        "name": "鹤峰县",
                        "center": {
                            "lng": 110.034011,
                            "lat": 29.890073
                        }
                    },
                    {
                        "citycode": "0718",
                        "adcode": "422823",
                        "name": "巴东县",
                        "center": {
                            "lng": 110.340921,
                            "lat": 31.042854
                        }
                    }
                ]
            },
            {
                "citycode": "0728",
                "adcode": "429004",
                "name": "仙桃市",
                "center": {
                    "lng": 113.442973,
                    "lat": 30.328407
                },
                "districtList": [
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "通海口镇",
                        "center": {
                            "lng": 113.20573,
                            "lat": 30.272193
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "胡场镇",
                        "center": {
                            "lng": 113.290392,
                            "lat": 30.4278
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "干河街道",
                        "center": {
                            "lng": 113.451023,
                            "lat": 30.375391
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "杨林尾镇",
                        "center": {
                            "lng": 113.561091,
                            "lat": 30.20143
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "彭场镇",
                        "center": {
                            "lng": 113.445865,
                            "lat": 30.251787
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "沔城回族镇",
                        "center": {
                            "lng": 113.200597,
                            "lat": 30.192111
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "龙华山街道",
                        "center": {
                            "lng": 113.460323,
                            "lat": 30.364932
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "沙湖原种场",
                        "center": {
                            "lng": 113.642513,
                            "lat": 30.148174
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "郑场镇",
                        "center": {
                            "lng": 112.978652,
                            "lat": 30.470679
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "郭河镇",
                        "center": {
                            "lng": 113.303624,
                            "lat": 30.302698
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "排湖风景区",
                        "center": {
                            "lng": 113.223499,
                            "lat": 30.298659
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "沙嘴街道",
                        "center": {
                            "lng": 113.441389,
                            "lat": 30.359636
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "毛嘴镇",
                        "center": {
                            "lng": 113.045359,
                            "lat": 30.418813
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "张沟镇",
                        "center": {
                            "lng": 113.438252,
                            "lat": 30.296766
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "三伏潭镇",
                        "center": {
                            "lng": 113.206929,
                            "lat": 30.339491
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "五湖渔场",
                        "center": {
                            "lng": 113.768784,
                            "lat": 30.187345
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "西流河镇",
                        "center": {
                            "lng": 113.762133,
                            "lat": 30.296361
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "长埫口镇",
                        "center": {
                            "lng": 113.744972,
                            "lat": 30.356683
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "杜湖街道",
                        "center": {
                            "lng": 113.364736,
                            "lat": 30.306324
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "剅河镇",
                        "center": {
                            "lng": 112.98767,
                            "lat": 30.375691
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "沙湖镇",
                        "center": {
                            "lng": 113.71982,
                            "lat": 30.118003
                        }
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "陈场镇",
                        "center": {
                            "lng": 113.0599,
                            "lat": 30.294262
                        }
                    }
                ]
            },
            {
                "citycode": "0715",
                "adcode": "421200",
                "name": "咸宁市",
                "center": {
                    "lng": 114.322601,
                    "lat": 29.84135
                },
                "districtList": [
                    {
                        "citycode": "0715",
                        "adcode": "421221",
                        "name": "嘉鱼县",
                        "center": {
                            "lng": 113.939249,
                            "lat": 29.970575
                        }
                    },
                    {
                        "citycode": "0715",
                        "adcode": "421202",
                        "name": "咸安区",
                        "center": {
                            "lng": 114.299002,
                            "lat": 29.852726
                        }
                    },
                    {
                        "citycode": "0715",
                        "adcode": "421224",
                        "name": "通山县",
                        "center": {
                            "lng": 114.482832,
                            "lat": 29.606468
                        }
                    },
                    {
                        "citycode": "0715",
                        "adcode": "421281",
                        "name": "赤壁市",
                        "center": {
                            "lng": 113.900385,
                            "lat": 29.725122
                        }
                    },
                    {
                        "citycode": "0715",
                        "adcode": "421223",
                        "name": "崇阳县",
                        "center": {
                            "lng": 114.039484,
                            "lat": 29.556866
                        }
                    },
                    {
                        "citycode": "0715",
                        "adcode": "421222",
                        "name": "通城县",
                        "center": {
                            "lng": 113.816811,
                            "lat": 29.2454
                        }
                    }
                ]
            },
            {
                "citycode": "0716",
                "adcode": "421000",
                "name": "荆州市",
                "center": {
                    "lng": 112.24143,
                    "lat": 30.336282
                },
                "districtList": [
                    {
                        "citycode": "0716",
                        "adcode": "421024",
                        "name": "江陵县",
                        "center": {
                            "lng": 112.424581,
                            "lat": 30.042227
                        }
                    },
                    {
                        "citycode": "0716",
                        "adcode": "421088",
                        "name": "监利市",
                        "center": {
                            "lng": 112.904634,
                            "lat": 29.840229
                        }
                    },
                    {
                        "citycode": "0716",
                        "adcode": "421087",
                        "name": "松滋市",
                        "center": {
                            "lng": 111.756455,
                            "lat": 30.174717
                        }
                    },
                    {
                        "citycode": "0716",
                        "adcode": "421083",
                        "name": "洪湖市",
                        "center": {
                            "lng": 113.475984,
                            "lat": 29.827256
                        }
                    },
                    {
                        "citycode": "0716",
                        "adcode": "421022",
                        "name": "公安县",
                        "center": {
                            "lng": 112.229742,
                            "lat": 30.058519
                        }
                    },
                    {
                        "citycode": "0716",
                        "adcode": "421081",
                        "name": "石首市",
                        "center": {
                            "lng": 112.42538,
                            "lat": 29.720944
                        }
                    },
                    {
                        "citycode": "0716",
                        "adcode": "421003",
                        "name": "荆州区",
                        "center": {
                            "lng": 112.190282,
                            "lat": 30.352984
                        }
                    },
                    {
                        "citycode": "0716",
                        "adcode": "421002",
                        "name": "沙市区",
                        "center": {
                            "lng": 112.251975,
                            "lat": 30.326693
                        }
                    }
                ]
            },
            {
                "citycode": "1719",
                "adcode": "429021",
                "name": "神农架林区",
                "center": {
                    "lng": 110.675879,
                    "lat": 31.745103
                },
                "districtList": [
                    {
                        "citycode": "1719",
                        "adcode": "429021",
                        "name": "木鱼镇",
                        "center": {
                            "lng": 110.566502,
                            "lat": 31.366101
                        }
                    },
                    {
                        "citycode": "1719",
                        "adcode": "429021",
                        "name": "新华镇",
                        "center": {
                            "lng": 110.842423,
                            "lat": 31.621763
                        }
                    },
                    {
                        "citycode": "1719",
                        "adcode": "429021",
                        "name": "红坪镇",
                        "center": {
                            "lng": 110.196111,
                            "lat": 31.471819
                        }
                    },
                    {
                        "citycode": "1719",
                        "adcode": "429021",
                        "name": "宋洛乡",
                        "center": {
                            "lng": 110.589789,
                            "lat": 31.73029
                        }
                    },
                    {
                        "citycode": "1719",
                        "adcode": "429021",
                        "name": "松柏镇",
                        "center": {
                            "lng": 110.609207,
                            "lat": 31.704132
                        }
                    },
                    {
                        "citycode": "1719",
                        "adcode": "429021",
                        "name": "阳日镇",
                        "center": {
                            "lng": 110.763336,
                            "lat": 31.676979
                        }
                    },
                    {
                        "citycode": "1719",
                        "adcode": "429021",
                        "name": "下谷坪土家族乡",
                        "center": {
                            "lng": 110.124191,
                            "lat": 31.394918
                        }
                    },
                    {
                        "citycode": "1719",
                        "adcode": "429021",
                        "name": "大九湖镇",
                        "center": {
                            "lng": 110.106251,
                            "lat": 31.408207
                        }
                    }
                ]
            },
            {
                "citycode": "0722",
                "adcode": "421300",
                "name": "随州市",
                "center": {
                    "lng": 113.382324,
                    "lat": 31.690275
                },
                "districtList": [
                    {
                        "citycode": "0722",
                        "adcode": "421321",
                        "name": "随县",
                        "center": {
                            "lng": 113.29097,
                            "lat": 31.883233
                        }
                    },
                    {
                        "citycode": "0722",
                        "adcode": "421303",
                        "name": "曾都区",
                        "center": {
                            "lng": 113.371052,
                            "lat": 31.716423
                        }
                    },
                    {
                        "citycode": "0722",
                        "adcode": "421381",
                        "name": "广水市",
                        "center": {
                            "lng": 113.825977,
                            "lat": 31.617015
                        }
                    }
                ]
            },
            {
                "citycode": "0711",
                "adcode": "420700",
                "name": "鄂州市",
                "center": {
                    "lng": 114.894909,
                    "lat": 30.391461
                },
                "districtList": [
                    {
                        "citycode": "0711",
                        "adcode": "420703",
                        "name": "华容区",
                        "center": {
                            "lng": 114.729945,
                            "lat": 30.53515
                        }
                    },
                    {
                        "citycode": "0711",
                        "adcode": "420702",
                        "name": "梁子湖区",
                        "center": {
                            "lng": 114.684805,
                            "lat": 30.100146
                        }
                    },
                    {
                        "citycode": "0711",
                        "adcode": "420704",
                        "name": "鄂城区",
                        "center": {
                            "lng": 114.89157,
                            "lat": 30.400535
                        }
                    }
                ]
            },
            {
                "citycode": "0714",
                "adcode": "420200",
                "name": "黄石市",
                "center": {
                    "lng": 115.038999,
                    "lat": 30.201082
                },
                "districtList": [
                    {
                        "citycode": "0714",
                        "adcode": "420205",
                        "name": "铁山区",
                        "center": {
                            "lng": 114.891603,
                            "lat": 30.203152
                        }
                    },
                    {
                        "citycode": "0714",
                        "adcode": "420204",
                        "name": "下陆区",
                        "center": {
                            "lng": 114.960914,
                            "lat": 30.174148
                        }
                    },
                    {
                        "citycode": "0714",
                        "adcode": "420203",
                        "name": "西塞山区",
                        "center": {
                            "lng": 115.110067,
                            "lat": 30.205114
                        }
                    },
                    {
                        "citycode": "0714",
                        "adcode": "420281",
                        "name": "大冶市",
                        "center": {
                            "lng": 114.98046,
                            "lat": 30.096263
                        }
                    },
                    {
                        "citycode": "0714",
                        "adcode": "420222",
                        "name": "阳新县",
                        "center": {
                            "lng": 115.215211,
                            "lat": 29.830236
                        }
                    },
                    {
                        "citycode": "0714",
                        "adcode": "420202",
                        "name": "黄石港区",
                        "center": {
                            "lng": 115.065653,
                            "lat": 30.223194
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "210000",
        "name": "辽宁省",
        "center": {
            "lng": 123.435093,
            "lat": 41.836743
        },
        "districtList": [
            {
                "citycode": "0429",
                "adcode": "211400",
                "name": "葫芦岛市",
                "center": {
                    "lng": 120.836783,
                    "lat": 40.710974
                },
                "districtList": [
                    {
                        "citycode": "0429",
                        "adcode": "211422",
                        "name": "建昌县",
                        "center": {
                            "lng": 119.836669,
                            "lat": 40.824484
                        }
                    },
                    {
                        "citycode": "0429",
                        "adcode": "211403",
                        "name": "龙港区",
                        "center": {
                            "lng": 120.894054,
                            "lat": 40.735717
                        }
                    },
                    {
                        "citycode": "0429",
                        "adcode": "211481",
                        "name": "兴城市",
                        "center": {
                            "lng": 120.756661,
                            "lat": 40.60999
                        }
                    },
                    {
                        "citycode": "0429",
                        "adcode": "211404",
                        "name": "南票区",
                        "center": {
                            "lng": 120.74971,
                            "lat": 41.10721
                        }
                    },
                    {
                        "citycode": "0429",
                        "adcode": "211402",
                        "name": "连山区",
                        "center": {
                            "lng": 120.869157,
                            "lat": 40.774784
                        }
                    },
                    {
                        "citycode": "0429",
                        "adcode": "211421",
                        "name": "绥中县",
                        "center": {
                            "lng": 120.34432,
                            "lat": 40.325576
                        }
                    }
                ]
            },
            {
                "citycode": "0411",
                "adcode": "210200",
                "name": "大连市",
                "center": {
                    "lng": 121.614786,
                    "lat": 38.913962
                },
                "districtList": [
                    {
                        "citycode": "0411",
                        "adcode": "210281",
                        "name": "瓦房店市",
                        "center": {
                            "lng": 121.979463,
                            "lat": 39.62701
                        }
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210214",
                        "name": "普兰店区",
                        "center": {
                            "lng": 121.938299,
                            "lat": 39.391565
                        }
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210283",
                        "name": "庄河市",
                        "center": {
                            "lng": 122.965881,
                            "lat": 39.680825
                        }
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210213",
                        "name": "金州区",
                        "center": {
                            "lng": 121.782513,
                            "lat": 39.050211
                        }
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210224",
                        "name": "长海县",
                        "center": {
                            "lng": 122.588487,
                            "lat": 39.272779
                        }
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210211",
                        "name": "甘井子区",
                        "center": {
                            "lng": 121.525469,
                            "lat": 38.952998
                        }
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210202",
                        "name": "中山区",
                        "center": {
                            "lng": 121.644996,
                            "lat": 38.918357
                        }
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210212",
                        "name": "旅顺口区",
                        "center": {
                            "lng": 121.261982,
                            "lat": 38.851742
                        }
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210203",
                        "name": "西岗区",
                        "center": {
                            "lng": 121.612461,
                            "lat": 38.914751
                        }
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210204",
                        "name": "沙河口区",
                        "center": {
                            "lng": 121.594201,
                            "lat": 38.904771
                        }
                    }
                ]
            },
            {
                "citycode": "0415",
                "adcode": "210600",
                "name": "丹东市",
                "center": {
                    "lng": 124.354419,
                    "lat": 40.000646
                },
                "districtList": [
                    {
                        "citycode": "0415",
                        "adcode": "210682",
                        "name": "凤城市",
                        "center": {
                            "lng": 124.066873,
                            "lat": 40.45218
                        }
                    },
                    {
                        "citycode": "0415",
                        "adcode": "210604",
                        "name": "振安区",
                        "center": {
                            "lng": 124.470005,
                            "lat": 40.20154
                        }
                    },
                    {
                        "citycode": "0415",
                        "adcode": "210681",
                        "name": "东港市",
                        "center": {
                            "lng": 124.152581,
                            "lat": 39.863193
                        }
                    },
                    {
                        "citycode": "0415",
                        "adcode": "210603",
                        "name": "振兴区",
                        "center": {
                            "lng": 124.383382,
                            "lat": 40.129706
                        }
                    },
                    {
                        "citycode": "0415",
                        "adcode": "210624",
                        "name": "宽甸满族自治县",
                        "center": {
                            "lng": 124.783674,
                            "lat": 40.731319
                        }
                    },
                    {
                        "citycode": "0415",
                        "adcode": "210602",
                        "name": "元宝区",
                        "center": {
                            "lng": 124.395577,
                            "lat": 40.136549
                        }
                    }
                ]
            },
            {
                "citycode": "0416",
                "adcode": "210700",
                "name": "锦州市",
                "center": {
                    "lng": 121.126859,
                    "lat": 41.096114
                },
                "districtList": [
                    {
                        "citycode": "0416",
                        "adcode": "210711",
                        "name": "太和区",
                        "center": {
                            "lng": 121.103445,
                            "lat": 41.109232
                        }
                    },
                    {
                        "citycode": "0416",
                        "adcode": "210781",
                        "name": "凌海市",
                        "center": {
                            "lng": 121.35499,
                            "lat": 41.160636
                        }
                    },
                    {
                        "citycode": "0416",
                        "adcode": "210782",
                        "name": "北镇市",
                        "center": {
                            "lng": 121.777503,
                            "lat": 41.588657
                        }
                    },
                    {
                        "citycode": "0416",
                        "adcode": "210703",
                        "name": "凌河区",
                        "center": {
                            "lng": 121.151069,
                            "lat": 41.115058
                        }
                    },
                    {
                        "citycode": "0416",
                        "adcode": "210702",
                        "name": "古塔区",
                        "center": {
                            "lng": 121.128414,
                            "lat": 41.117481
                        }
                    },
                    {
                        "citycode": "0416",
                        "adcode": "210726",
                        "name": "黑山县",
                        "center": {
                            "lng": 122.126645,
                            "lat": 41.653552
                        }
                    },
                    {
                        "citycode": "0416",
                        "adcode": "210727",
                        "name": "义县",
                        "center": {
                            "lng": 121.239558,
                            "lat": 41.533553
                        }
                    }
                ]
            },
            {
                "citycode": "024",
                "adcode": "210100",
                "name": "沈阳市",
                "center": {
                    "lng": 123.464675,
                    "lat": 41.677576
                },
                "districtList": [
                    {
                        "citycode": "024",
                        "adcode": "210114",
                        "name": "于洪区",
                        "center": {
                            "lng": 123.308062,
                            "lat": 41.793925
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210123",
                        "name": "康平县",
                        "center": {
                            "lng": 123.343701,
                            "lat": 42.727249
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210115",
                        "name": "辽中区",
                        "center": {
                            "lng": 122.766159,
                            "lat": 41.517449
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210106",
                        "name": "铁西区",
                        "center": {
                            "lng": 123.334781,
                            "lat": 41.821721
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210113",
                        "name": "沈北新区",
                        "center": {
                            "lng": 123.584209,
                            "lat": 41.913071
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210102",
                        "name": "和平区",
                        "center": {
                            "lng": 123.420401,
                            "lat": 41.789766
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210181",
                        "name": "新民市",
                        "center": {
                            "lng": 122.835964,
                            "lat": 41.985757
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210124",
                        "name": "法库县",
                        "center": {
                            "lng": 123.440294,
                            "lat": 42.50108
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210112",
                        "name": "浑南区",
                        "center": {
                            "lng": 123.449597,
                            "lat": 41.714729
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210111",
                        "name": "苏家屯区",
                        "center": {
                            "lng": 123.343937,
                            "lat": 41.665153
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210103",
                        "name": "沈河区",
                        "center": {
                            "lng": 123.45884,
                            "lat": 41.795688
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210104",
                        "name": "大东区",
                        "center": {
                            "lng": 123.469828,
                            "lat": 41.805292
                        }
                    },
                    {
                        "citycode": "024",
                        "adcode": "210105",
                        "name": "皇姑区",
                        "center": {
                            "lng": 123.441468,
                            "lat": 41.824574
                        }
                    }
                ]
            },
            {
                "citycode": "0410",
                "adcode": "211200",
                "name": "铁岭市",
                "center": {
                    "lng": 123.726008,
                    "lat": 42.223709
                },
                "districtList": [
                    {
                        "citycode": "0410",
                        "adcode": "211282",
                        "name": "开原市",
                        "center": {
                            "lng": 124.051886,
                            "lat": 42.577645
                        }
                    },
                    {
                        "citycode": "0410",
                        "adcode": "211204",
                        "name": "清河区",
                        "center": {
                            "lng": 124.159232,
                            "lat": 42.54714
                        }
                    },
                    {
                        "citycode": "0410",
                        "adcode": "211281",
                        "name": "调兵山市",
                        "center": {
                            "lng": 123.567039,
                            "lat": 42.468007
                        }
                    },
                    {
                        "citycode": "0410",
                        "adcode": "211221",
                        "name": "铁岭县",
                        "center": {
                            "lng": 123.728933,
                            "lat": 42.223395
                        }
                    },
                    {
                        "citycode": "0410",
                        "adcode": "211202",
                        "name": "银州区",
                        "center": {
                            "lng": 123.842472,
                            "lat": 42.286575
                        }
                    },
                    {
                        "citycode": "0410",
                        "adcode": "211223",
                        "name": "西丰县",
                        "center": {
                            "lng": 124.727491,
                            "lat": 42.738178
                        }
                    },
                    {
                        "citycode": "0410",
                        "adcode": "211224",
                        "name": "昌图县",
                        "center": {
                            "lng": 124.086628,
                            "lat": 42.779333
                        }
                    }
                ]
            },
            {
                "citycode": "0418",
                "adcode": "210900",
                "name": "阜新市",
                "center": {
                    "lng": 121.670052,
                    "lat": 42.022028
                },
                "districtList": [
                    {
                        "citycode": "0418",
                        "adcode": "210904",
                        "name": "太平区",
                        "center": {
                            "lng": 121.678637,
                            "lat": 42.010689
                        }
                    },
                    {
                        "citycode": "0418",
                        "adcode": "210905",
                        "name": "清河门区",
                        "center": {
                            "lng": 121.416105,
                            "lat": 41.7831
                        }
                    },
                    {
                        "citycode": "0418",
                        "adcode": "210903",
                        "name": "新邱区",
                        "center": {
                            "lng": 121.792067,
                            "lat": 42.087549
                        }
                    },
                    {
                        "citycode": "0418",
                        "adcode": "210921",
                        "name": "阜新蒙古族自治县",
                        "center": {
                            "lng": 121.757901,
                            "lat": 42.065175
                        }
                    },
                    {
                        "citycode": "0418",
                        "adcode": "210922",
                        "name": "彰武县",
                        "center": {
                            "lng": 122.538563,
                            "lat": 42.386264
                        }
                    },
                    {
                        "citycode": "0418",
                        "adcode": "210911",
                        "name": "细河区",
                        "center": {
                            "lng": 121.680157,
                            "lat": 42.025412
                        }
                    },
                    {
                        "citycode": "0418",
                        "adcode": "210902",
                        "name": "海州区",
                        "center": {
                            "lng": 121.662594,
                            "lat": 42.017794
                        }
                    }
                ]
            },
            {
                "citycode": "0414",
                "adcode": "210500",
                "name": "本溪市",
                "center": {
                    "lng": 123.684984,
                    "lat": 41.486834
                },
                "districtList": [
                    {
                        "citycode": "0414",
                        "adcode": "210522",
                        "name": "桓仁满族自治县",
                        "center": {
                            "lng": 125.361061,
                            "lat": 41.267048
                        }
                    },
                    {
                        "citycode": "0414",
                        "adcode": "210505",
                        "name": "南芬区",
                        "center": {
                            "lng": 123.744822,
                            "lat": 41.100273
                        }
                    },
                    {
                        "citycode": "0414",
                        "adcode": "210504",
                        "name": "明山区",
                        "center": {
                            "lng": 123.861747,
                            "lat": 41.343624
                        }
                    },
                    {
                        "citycode": "0414",
                        "adcode": "210521",
                        "name": "本溪满族自治县",
                        "center": {
                            "lng": 124.119545,
                            "lat": 41.301553
                        }
                    },
                    {
                        "citycode": "0414",
                        "adcode": "210503",
                        "name": "溪湖区",
                        "center": {
                            "lng": 123.767817,
                            "lat": 41.32931
                        }
                    },
                    {
                        "citycode": "0414",
                        "adcode": "210502",
                        "name": "平山区",
                        "center": {
                            "lng": 123.769081,
                            "lat": 41.299658
                        }
                    }
                ]
            },
            {
                "citycode": "0419",
                "adcode": "211000",
                "name": "辽阳市",
                "center": {
                    "lng": 123.239669,
                    "lat": 41.267396
                },
                "districtList": [
                    {
                        "citycode": "0419",
                        "adcode": "211011",
                        "name": "太子河区",
                        "center": {
                            "lng": 123.18144,
                            "lat": 41.295023
                        }
                    },
                    {
                        "citycode": "0419",
                        "adcode": "211081",
                        "name": "灯塔市",
                        "center": {
                            "lng": 123.339398,
                            "lat": 41.426537
                        }
                    },
                    {
                        "citycode": "0419",
                        "adcode": "211005",
                        "name": "弓长岭区",
                        "center": {
                            "lng": 123.419567,
                            "lat": 41.151787
                        }
                    },
                    {
                        "citycode": "0419",
                        "adcode": "211003",
                        "name": "文圣区",
                        "center": {
                            "lng": 123.231262,
                            "lat": 41.282378
                        }
                    },
                    {
                        "citycode": "0419",
                        "adcode": "211021",
                        "name": "辽阳县",
                        "center": {
                            "lng": 123.106426,
                            "lat": 41.206246
                        }
                    },
                    {
                        "citycode": "0419",
                        "adcode": "211004",
                        "name": "宏伟区",
                        "center": {
                            "lng": 123.196725,
                            "lat": 41.217852
                        }
                    },
                    {
                        "citycode": "0419",
                        "adcode": "211002",
                        "name": "白塔区",
                        "center": {
                            "lng": 123.174347,
                            "lat": 41.270397
                        }
                    }
                ]
            },
            {
                "citycode": "0413",
                "adcode": "210400",
                "name": "抚顺市",
                "center": {
                    "lng": 123.957053,
                    "lat": 41.881311
                },
                "districtList": [
                    {
                        "citycode": "0413",
                        "adcode": "210422",
                        "name": "新宾满族自治县",
                        "center": {
                            "lng": 125.039994,
                            "lat": 41.734031
                        }
                    },
                    {
                        "citycode": "0413",
                        "adcode": "210421",
                        "name": "抚顺县",
                        "center": {
                            "lng": 123.899923,
                            "lat": 41.730094
                        }
                    },
                    {
                        "citycode": "0413",
                        "adcode": "210404",
                        "name": "望花区",
                        "center": {
                            "lng": 123.784235,
                            "lat": 41.853484
                        }
                    },
                    {
                        "citycode": "0413",
                        "adcode": "210402",
                        "name": "新抚区",
                        "center": {
                            "lng": 123.91293,
                            "lat": 41.861922
                        }
                    },
                    {
                        "citycode": "0413",
                        "adcode": "210411",
                        "name": "顺城区",
                        "center": {
                            "lng": 123.94504,
                            "lat": 41.883375
                        }
                    },
                    {
                        "citycode": "0413",
                        "adcode": "210403",
                        "name": "东洲区",
                        "center": {
                            "lng": 124.038491,
                            "lat": 41.853001
                        }
                    },
                    {
                        "citycode": "0413",
                        "adcode": "210423",
                        "name": "清原满族自治县",
                        "center": {
                            "lng": 124.924028,
                            "lat": 42.100804
                        }
                    }
                ]
            },
            {
                "citycode": "0412",
                "adcode": "210300",
                "name": "鞍山市",
                "center": {
                    "lng": 122.994183,
                    "lat": 41.108239
                },
                "districtList": [
                    {
                        "citycode": "0412",
                        "adcode": "210311",
                        "name": "千山区",
                        "center": {
                            "lng": 122.944751,
                            "lat": 41.068901
                        }
                    },
                    {
                        "citycode": "0412",
                        "adcode": "210323",
                        "name": "岫岩满族自治县",
                        "center": {
                            "lng": 123.280933,
                            "lat": 40.290995
                        }
                    },
                    {
                        "citycode": "0412",
                        "adcode": "210304",
                        "name": "立山区",
                        "center": {
                            "lng": 123.029091,
                            "lat": 41.150401
                        }
                    },
                    {
                        "citycode": "0412",
                        "adcode": "210302",
                        "name": "铁东区",
                        "center": {
                            "lng": 122.990888,
                            "lat": 41.089578
                        }
                    },
                    {
                        "citycode": "0412",
                        "adcode": "210303",
                        "name": "铁西区",
                        "center": {
                            "lng": 122.969531,
                            "lat": 41.119719
                        }
                    },
                    {
                        "citycode": "0412",
                        "adcode": "210381",
                        "name": "海城市",
                        "center": {
                            "lng": 122.685176,
                            "lat": 40.882548
                        }
                    },
                    {
                        "citycode": "0412",
                        "adcode": "210321",
                        "name": "台安县",
                        "center": {
                            "lng": 122.436037,
                            "lat": 41.412866
                        }
                    }
                ]
            },
            {
                "citycode": "0427",
                "adcode": "211100",
                "name": "盘锦市",
                "center": {
                    "lng": 122.170729,
                    "lat": 40.71956
                },
                "districtList": [
                    {
                        "citycode": "0427",
                        "adcode": "211122",
                        "name": "盘山县",
                        "center": {
                            "lng": 121.996408,
                            "lat": 41.243367
                        }
                    },
                    {
                        "citycode": "0427",
                        "adcode": "211103",
                        "name": "兴隆台区",
                        "center": {
                            "lng": 122.070685,
                            "lat": 41.120261
                        }
                    },
                    {
                        "citycode": "0427",
                        "adcode": "211102",
                        "name": "双台子区",
                        "center": {
                            "lng": 122.07597,
                            "lat": 41.212401
                        }
                    },
                    {
                        "citycode": "0427",
                        "adcode": "211104",
                        "name": "大洼区",
                        "center": {
                            "lng": 122.082227,
                            "lat": 41.002679
                        }
                    }
                ]
            },
            {
                "citycode": "0417",
                "adcode": "210800",
                "name": "营口市",
                "center": {
                    "lng": 122.219148,
                    "lat": 40.625027
                },
                "districtList": [
                    {
                        "citycode": "0417",
                        "adcode": "210803",
                        "name": "西市区",
                        "center": {
                            "lng": 122.206431,
                            "lat": 40.666707
                        }
                    },
                    {
                        "citycode": "0417",
                        "adcode": "210882",
                        "name": "大石桥市",
                        "center": {
                            "lng": 122.509006,
                            "lat": 40.644482
                        }
                    },
                    {
                        "citycode": "0417",
                        "adcode": "210802",
                        "name": "站前区",
                        "center": {
                            "lng": 122.259058,
                            "lat": 40.673063
                        }
                    },
                    {
                        "citycode": "0417",
                        "adcode": "210811",
                        "name": "老边区",
                        "center": {
                            "lng": 122.307956,
                            "lat": 40.671279
                        }
                    },
                    {
                        "citycode": "0417",
                        "adcode": "210804",
                        "name": "鲅鱼圈区",
                        "center": {
                            "lng": 122.121764,
                            "lat": 40.226708
                        }
                    },
                    {
                        "citycode": "0417",
                        "adcode": "210881",
                        "name": "盖州市",
                        "center": {
                            "lng": 122.34845,
                            "lat": 40.400259
                        }
                    }
                ]
            },
            {
                "citycode": "0421",
                "adcode": "211300",
                "name": "朝阳市",
                "center": {
                    "lng": 120.488801,
                    "lat": 41.601855
                },
                "districtList": [
                    {
                        "citycode": "0421",
                        "adcode": "211324",
                        "name": "喀喇沁左翼蒙古族自治县",
                        "center": {
                            "lng": 119.741223,
                            "lat": 41.12815
                        }
                    },
                    {
                        "citycode": "0421",
                        "adcode": "211382",
                        "name": "凌源市",
                        "center": {
                            "lng": 119.401574,
                            "lat": 41.245445
                        }
                    },
                    {
                        "citycode": "0421",
                        "adcode": "211381",
                        "name": "北票市",
                        "center": {
                            "lng": 120.771389,
                            "lat": 41.801117
                        }
                    },
                    {
                        "citycode": "0421",
                        "adcode": "211303",
                        "name": "龙城区",
                        "center": {
                            "lng": 120.413376,
                            "lat": 41.576749
                        }
                    },
                    {
                        "citycode": "0421",
                        "adcode": "211302",
                        "name": "双塔区",
                        "center": {
                            "lng": 120.453717,
                            "lat": 41.565814
                        }
                    },
                    {
                        "citycode": "0421",
                        "adcode": "211321",
                        "name": "朝阳县",
                        "center": {
                            "lng": 120.390001,
                            "lat": 41.497923
                        }
                    },
                    {
                        "citycode": "0421",
                        "adcode": "211322",
                        "name": "建平县",
                        "center": {
                            "lng": 119.64328,
                            "lat": 41.402891
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "370000",
        "name": "山东省",
        "center": {
            "lng": 117.020725,
            "lat": 36.670201
        },
        "districtList": [
            {
                "citycode": "0546",
                "adcode": "370500",
                "name": "东营市",
                "center": {
                    "lng": 118.674633,
                    "lat": 37.433992
                },
                "districtList": [
                    {
                        "citycode": "0546",
                        "adcode": "370522",
                        "name": "利津县",
                        "center": {
                            "lng": 118.255084,
                            "lat": 37.490919
                        }
                    },
                    {
                        "citycode": "0546",
                        "adcode": "370523",
                        "name": "广饶县",
                        "center": {
                            "lng": 118.419437,
                            "lat": 37.053915
                        }
                    },
                    {
                        "citycode": "0546",
                        "adcode": "370502",
                        "name": "东营区",
                        "center": {
                            "lng": 118.582182,
                            "lat": 37.449035
                        }
                    },
                    {
                        "citycode": "0546",
                        "adcode": "370503",
                        "name": "河口区",
                        "center": {
                            "lng": 118.525519,
                            "lat": 37.886217
                        }
                    },
                    {
                        "citycode": "0546",
                        "adcode": "370505",
                        "name": "垦利区",
                        "center": {
                            "lng": 118.575234,
                            "lat": 37.573412
                        }
                    }
                ]
            },
            {
                "citycode": "0543",
                "adcode": "371600",
                "name": "滨州市",
                "center": {
                    "lng": 117.970731,
                    "lat": 37.382687
                },
                "districtList": [
                    {
                        "citycode": "0543",
                        "adcode": "371602",
                        "name": "滨城区",
                        "center": {
                            "lng": 118.019567,
                            "lat": 37.431997
                        }
                    },
                    {
                        "citycode": "0543",
                        "adcode": "371625",
                        "name": "博兴县",
                        "center": {
                            "lng": 118.110715,
                            "lat": 37.154529
                        }
                    },
                    {
                        "citycode": "0543",
                        "adcode": "371603",
                        "name": "沾化区",
                        "center": {
                            "lng": 118.098962,
                            "lat": 37.698952
                        }
                    },
                    {
                        "citycode": "0543",
                        "adcode": "371623",
                        "name": "无棣县",
                        "center": {
                            "lng": 117.625846,
                            "lat": 37.770579
                        }
                    },
                    {
                        "citycode": "0543",
                        "adcode": "371621",
                        "name": "惠民县",
                        "center": {
                            "lng": 117.593744,
                            "lat": 37.47528
                        }
                    },
                    {
                        "citycode": "0543",
                        "adcode": "371622",
                        "name": "阳信县",
                        "center": {
                            "lng": 117.603407,
                            "lat": 37.632773
                        }
                    },
                    {
                        "citycode": "0543",
                        "adcode": "371681",
                        "name": "邹平市",
                        "center": {
                            "lng": 117.74313,
                            "lat": 36.863393
                        }
                    }
                ]
            },
            {
                "citycode": "0635",
                "adcode": "371500",
                "name": "聊城市",
                "center": {
                    "lng": 115.985238,
                    "lat": 36.455857
                },
                "districtList": [
                    {
                        "citycode": "0635",
                        "adcode": "371503",
                        "name": "茌平区",
                        "center": {
                            "lng": 116.254865,
                            "lat": 36.580814
                        }
                    },
                    {
                        "citycode": "0635",
                        "adcode": "371526",
                        "name": "高唐县",
                        "center": {
                            "lng": 116.230126,
                            "lat": 36.84715
                        }
                    },
                    {
                        "citycode": "0635",
                        "adcode": "371525",
                        "name": "冠县",
                        "center": {
                            "lng": 115.441684,
                            "lat": 36.484011
                        }
                    },
                    {
                        "citycode": "0635",
                        "adcode": "371522",
                        "name": "莘县",
                        "center": {
                            "lng": 115.669843,
                            "lat": 36.233711
                        }
                    },
                    {
                        "citycode": "0635",
                        "adcode": "371502",
                        "name": "东昌府区",
                        "center": {
                            "lng": 116.006399,
                            "lat": 36.412737
                        }
                    },
                    {
                        "citycode": "0635",
                        "adcode": "371581",
                        "name": "临清市",
                        "center": {
                            "lng": 115.704982,
                            "lat": 36.83828
                        }
                    },
                    {
                        "citycode": "0635",
                        "adcode": "371524",
                        "name": "东阿县",
                        "center": {
                            "lng": 116.247655,
                            "lat": 36.335198
                        }
                    },
                    {
                        "citycode": "0635",
                        "adcode": "371521",
                        "name": "阳谷县",
                        "center": {
                            "lng": 115.791822,
                            "lat": 36.114392
                        }
                    }
                ]
            },
            {
                "citycode": "0536",
                "adcode": "370700",
                "name": "潍坊市",
                "center": {
                    "lng": 119.161721,
                    "lat": 36.707668
                },
                "districtList": [
                    {
                        "citycode": "0536",
                        "adcode": "370702",
                        "name": "潍城区",
                        "center": {
                            "lng": 119.02491,
                            "lat": 36.728077
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370783",
                        "name": "寿光市",
                        "center": {
                            "lng": 118.791062,
                            "lat": 36.857133
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370782",
                        "name": "诸城市",
                        "center": {
                            "lng": 119.410051,
                            "lat": 35.996404
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370786",
                        "name": "昌邑市",
                        "center": {
                            "lng": 119.403185,
                            "lat": 36.843256
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370785",
                        "name": "高密市",
                        "center": {
                            "lng": 119.755271,
                            "lat": 36.382973
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370703",
                        "name": "寒亭区",
                        "center": {
                            "lng": 119.211251,
                            "lat": 36.755925
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370705",
                        "name": "奎文区",
                        "center": {
                            "lng": 119.132288,
                            "lat": 36.707459
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370704",
                        "name": "坊子区",
                        "center": {
                            "lng": 119.166343,
                            "lat": 36.653671
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370784",
                        "name": "安丘市",
                        "center": {
                            "lng": 119.21892,
                            "lat": 36.479642
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370725",
                        "name": "昌乐县",
                        "center": {
                            "lng": 118.841035,
                            "lat": 36.688035
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370724",
                        "name": "临朐县",
                        "center": {
                            "lng": 118.543274,
                            "lat": 36.51246
                        }
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370781",
                        "name": "青州市",
                        "center": {
                            "lng": 118.479637,
                            "lat": 36.685178
                        }
                    }
                ]
            },
            {
                "citycode": "0535",
                "adcode": "370600",
                "name": "烟台市",
                "center": {
                    "lng": 121.447755,
                    "lat": 37.464551
                },
                "districtList": [
                    {
                        "citycode": "0535",
                        "adcode": "370683",
                        "name": "莱州市",
                        "center": {
                            "lng": 119.942057,
                            "lat": 37.178187
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370602",
                        "name": "芝罘区",
                        "center": {
                            "lng": 121.400303,
                            "lat": 37.541312
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370612",
                        "name": "牟平区",
                        "center": {
                            "lng": 121.601015,
                            "lat": 37.387454
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370614",
                        "name": "蓬莱区",
                        "center": {
                            "lng": 120.829141,
                            "lat": 37.795697
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370613",
                        "name": "莱山区",
                        "center": {
                            "lng": 121.444949,
                            "lat": 37.511322
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370686",
                        "name": "栖霞市",
                        "center": {
                            "lng": 120.849595,
                            "lat": 37.335993
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370687",
                        "name": "海阳市",
                        "center": {
                            "lng": 121.173506,
                            "lat": 36.688316
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370681",
                        "name": "龙口市",
                        "center": {
                            "lng": 120.47614,
                            "lat": 37.645281
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370611",
                        "name": "福山区",
                        "center": {
                            "lng": 121.267638,
                            "lat": 37.49833
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370682",
                        "name": "莱阳市",
                        "center": {
                            "lng": 120.711555,
                            "lat": 36.979757
                        }
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370685",
                        "name": "招远市",
                        "center": {
                            "lng": 120.433904,
                            "lat": 37.354517
                        }
                    }
                ]
            },
            {
                "citycode": "0631",
                "adcode": "371000",
                "name": "威海市",
                "center": {
                    "lng": 122.120519,
                    "lat": 37.513315
                },
                "districtList": [
                    {
                        "citycode": "0631",
                        "adcode": "371083",
                        "name": "乳山市",
                        "center": {
                            "lng": 121.539557,
                            "lat": 36.920329
                        }
                    },
                    {
                        "citycode": "0631",
                        "adcode": "371002",
                        "name": "环翠区",
                        "center": {
                            "lng": 122.123115,
                            "lat": 37.501735
                        }
                    },
                    {
                        "citycode": "0631",
                        "adcode": "371082",
                        "name": "荣成市",
                        "center": {
                            "lng": 122.487036,
                            "lat": 37.165698
                        }
                    },
                    {
                        "citycode": "0631",
                        "adcode": "371003",
                        "name": "文登区",
                        "center": {
                            "lng": 122.08832,
                            "lat": 37.196032
                        }
                    }
                ]
            },
            {
                "citycode": "0532",
                "adcode": "370200",
                "name": "青岛市",
                "center": {
                    "lng": 120.382665,
                    "lat": 36.066938
                },
                "districtList": [
                    {
                        "citycode": "0532",
                        "adcode": "370285",
                        "name": "莱西市",
                        "center": {
                            "lng": 120.517581,
                            "lat": 36.889167
                        }
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370283",
                        "name": "平度市",
                        "center": {
                            "lng": 119.970192,
                            "lat": 36.753895
                        }
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370214",
                        "name": "城阳区",
                        "center": {
                            "lng": 120.396255,
                            "lat": 36.307624
                        }
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370215",
                        "name": "即墨区",
                        "center": {
                            "lng": 120.447691,
                            "lat": 36.390217
                        }
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370212",
                        "name": "崂山区",
                        "center": {
                            "lng": 120.469282,
                            "lat": 36.107069
                        }
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370211",
                        "name": "黄岛区",
                        "center": {
                            "lng": 120.19777,
                            "lat": 35.960688
                        }
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370281",
                        "name": "胶州市",
                        "center": {
                            "lng": 120.033382,
                            "lat": 36.26468
                        }
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370213",
                        "name": "李沧区",
                        "center": {
                            "lng": 120.432652,
                            "lat": 36.145987
                        }
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370203",
                        "name": "市北区",
                        "center": {
                            "lng": 120.374675,
                            "lat": 36.08765
                        }
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370202",
                        "name": "市南区",
                        "center": {
                            "lng": 120.412002,
                            "lat": 36.075867
                        }
                    }
                ]
            },
            {
                "citycode": "0537",
                "adcode": "370800",
                "name": "济宁市",
                "center": {
                    "lng": 116.587116,
                    "lat": 35.415117
                },
                "districtList": [
                    {
                        "citycode": "0537",
                        "adcode": "370826",
                        "name": "微山县",
                        "center": {
                            "lng": 117.129188,
                            "lat": 34.806657
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370827",
                        "name": "鱼台县",
                        "center": {
                            "lng": 116.650526,
                            "lat": 35.012706
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370832",
                        "name": "梁山县",
                        "center": {
                            "lng": 116.131779,
                            "lat": 35.765957
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370881",
                        "name": "曲阜市",
                        "center": {
                            "lng": 116.986212,
                            "lat": 35.581933
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370883",
                        "name": "邹城市",
                        "center": {
                            "lng": 117.007406,
                            "lat": 35.402536
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370829",
                        "name": "嘉祥县",
                        "center": {
                            "lng": 116.342308,
                            "lat": 35.40794
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370828",
                        "name": "金乡县",
                        "center": {
                            "lng": 116.311549,
                            "lat": 35.06658
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370831",
                        "name": "泗水县",
                        "center": {
                            "lng": 117.250824,
                            "lat": 35.664719
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370830",
                        "name": "汶上县",
                        "center": {
                            "lng": 116.497277,
                            "lat": 35.711891
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370812",
                        "name": "兖州区",
                        "center": {
                            "lng": 116.78365,
                            "lat": 35.551938
                        }
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370811",
                        "name": "任城区",
                        "center": {
                            "lng": 116.605763,
                            "lat": 35.444226
                        }
                    }
                ]
            },
            {
                "citycode": "0632",
                "adcode": "370400",
                "name": "枣庄市",
                "center": {
                    "lng": 117.323759,
                    "lat": 34.810858
                },
                "districtList": [
                    {
                        "citycode": "0632",
                        "adcode": "370405",
                        "name": "台儿庄区",
                        "center": {
                            "lng": 117.734287,
                            "lat": 34.563103
                        }
                    },
                    {
                        "citycode": "0632",
                        "adcode": "370402",
                        "name": "市中区",
                        "center": {
                            "lng": 117.556125,
                            "lat": 34.863791
                        }
                    },
                    {
                        "citycode": "0632",
                        "adcode": "370404",
                        "name": "峄城区",
                        "center": {
                            "lng": 117.590738,
                            "lat": 34.772931
                        }
                    },
                    {
                        "citycode": "0632",
                        "adcode": "370406",
                        "name": "山亭区",
                        "center": {
                            "lng": 117.461866,
                            "lat": 35.099638
                        }
                    },
                    {
                        "citycode": "0632",
                        "adcode": "370403",
                        "name": "薛城区",
                        "center": {
                            "lng": 117.286371,
                            "lat": 34.783282
                        }
                    },
                    {
                        "citycode": "0632",
                        "adcode": "370481",
                        "name": "滕州市",
                        "center": {
                            "lng": 117.165881,
                            "lat": 35.11412
                        }
                    }
                ]
            },
            {
                "citycode": "0534",
                "adcode": "371400",
                "name": "德州市",
                "center": {
                    "lng": 116.359244,
                    "lat": 37.436492
                },
                "districtList": [
                    {
                        "citycode": "0534",
                        "adcode": "371422",
                        "name": "宁津县",
                        "center": {
                            "lng": 116.800279,
                            "lat": 37.652456
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371481",
                        "name": "乐陵市",
                        "center": {
                            "lng": 117.232085,
                            "lat": 37.729769
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371428",
                        "name": "武城县",
                        "center": {
                            "lng": 116.069312,
                            "lat": 37.213398
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371426",
                        "name": "平原县",
                        "center": {
                            "lng": 116.434016,
                            "lat": 37.165453
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371427",
                        "name": "夏津县",
                        "center": {
                            "lng": 116.001796,
                            "lat": 36.948013
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371482",
                        "name": "禹城市",
                        "center": {
                            "lng": 116.638558,
                            "lat": 36.934198
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371425",
                        "name": "齐河县",
                        "center": {
                            "lng": 116.762767,
                            "lat": 36.784164
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371424",
                        "name": "临邑县",
                        "center": {
                            "lng": 116.866568,
                            "lat": 37.190139
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371423",
                        "name": "庆云县",
                        "center": {
                            "lng": 117.384163,
                            "lat": 37.774376
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371403",
                        "name": "陵城区",
                        "center": {
                            "lng": 116.576148,
                            "lat": 37.336444
                        }
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371402",
                        "name": "德城区",
                        "center": {
                            "lng": 116.299558,
                            "lat": 37.451051
                        }
                    }
                ]
            },
            {
                "citycode": "0539",
                "adcode": "371300",
                "name": "临沂市",
                "center": {
                    "lng": 118.356464,
                    "lat": 35.103771
                },
                "districtList": [
                    {
                        "citycode": "0539",
                        "adcode": "371321",
                        "name": "沂南县",
                        "center": {
                            "lng": 118.465259,
                            "lat": 35.550078
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371312",
                        "name": "河东区",
                        "center": {
                            "lng": 118.403073,
                            "lat": 35.088936
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371324",
                        "name": "兰陵县",
                        "center": {
                            "lng": 118.070912,
                            "lat": 34.858235
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371322",
                        "name": "郯城县",
                        "center": {
                            "lng": 118.390701,
                            "lat": 34.619281
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371323",
                        "name": "沂水县",
                        "center": {
                            "lng": 118.628142,
                            "lat": 35.790919
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371328",
                        "name": "蒙阴县",
                        "center": {
                            "lng": 117.953367,
                            "lat": 35.720128
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371327",
                        "name": "莒南县",
                        "center": {
                            "lng": 118.835166,
                            "lat": 35.206252
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371326",
                        "name": "平邑县",
                        "center": {
                            "lng": 117.615201,
                            "lat": 35.516849
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371311",
                        "name": "罗庄区",
                        "center": {
                            "lng": 118.284693,
                            "lat": 34.997061
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371302",
                        "name": "兰山区",
                        "center": {
                            "lng": 118.347332,
                            "lat": 35.052797
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371325",
                        "name": "费县",
                        "center": {
                            "lng": 117.9776,
                            "lat": 35.265851
                        }
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371329",
                        "name": "临沭县",
                        "center": {
                            "lng": 118.650828,
                            "lat": 34.920171
                        }
                    }
                ]
            },
            {
                "citycode": "0538",
                "adcode": "370900",
                "name": "泰安市",
                "center": {
                    "lng": 117.086963,
                    "lat": 36.201784
                },
                "districtList": [
                    {
                        "citycode": "0538",
                        "adcode": "370902",
                        "name": "泰山区",
                        "center": {
                            "lng": 117.135215,
                            "lat": 36.192833
                        }
                    },
                    {
                        "citycode": "0538",
                        "adcode": "370983",
                        "name": "肥城市",
                        "center": {
                            "lng": 116.769098,
                            "lat": 36.181975
                        }
                    },
                    {
                        "citycode": "0538",
                        "adcode": "370982",
                        "name": "新泰市",
                        "center": {
                            "lng": 117.768069,
                            "lat": 35.90953
                        }
                    },
                    {
                        "citycode": "0538",
                        "adcode": "370921",
                        "name": "宁阳县",
                        "center": {
                            "lng": 116.805578,
                            "lat": 35.758919
                        }
                    },
                    {
                        "citycode": "0538",
                        "adcode": "370911",
                        "name": "岱岳区",
                        "center": {
                            "lng": 117.041651,
                            "lat": 36.188088
                        }
                    },
                    {
                        "citycode": "0538",
                        "adcode": "370923",
                        "name": "东平县",
                        "center": {
                            "lng": 116.470211,
                            "lat": 35.937049
                        }
                    }
                ]
            },
            {
                "citycode": "0531",
                "adcode": "370100",
                "name": "济南市",
                "center": {
                    "lng": 117.120128,
                    "lat": 36.652069
                },
                "districtList": [
                    {
                        "citycode": "0531",
                        "adcode": "370117",
                        "name": "钢城区",
                        "center": {
                            "lng": 117.811604,
                            "lat": 36.059393
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370115",
                        "name": "济阳区",
                        "center": {
                            "lng": 117.173722,
                            "lat": 36.978299
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370113",
                        "name": "长清区",
                        "center": {
                            "lng": 116.752101,
                            "lat": 36.554251
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370126",
                        "name": "商河县",
                        "center": {
                            "lng": 117.157165,
                            "lat": 37.309694
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370124",
                        "name": "平阴县",
                        "center": {
                            "lng": 116.455865,
                            "lat": 36.289813
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370103",
                        "name": "市中区",
                        "center": {
                            "lng": 116.997472,
                            "lat": 36.651121
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370104",
                        "name": "槐荫区",
                        "center": {
                            "lng": 116.901057,
                            "lat": 36.652264
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370112",
                        "name": "历城区",
                        "center": {
                            "lng": 117.065233,
                            "lat": 36.680731
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370114",
                        "name": "章丘区",
                        "center": {
                            "lng": 117.526228,
                            "lat": 36.681258
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370116",
                        "name": "莱芜区",
                        "center": {
                            "lng": 117.675828,
                            "lat": 36.214895
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370105",
                        "name": "天桥区",
                        "center": {
                            "lng": 116.987106,
                            "lat": 36.678665
                        }
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370102",
                        "name": "历下区",
                        "center": {
                            "lng": 117.07632,
                            "lat": 36.666395
                        }
                    }
                ]
            },
            {
                "citycode": "0530",
                "adcode": "371700",
                "name": "菏泽市",
                "center": {
                    "lng": 115.479646,
                    "lat": 35.234309
                },
                "districtList": [
                    {
                        "citycode": "0530",
                        "adcode": "371724",
                        "name": "巨野县",
                        "center": {
                            "lng": 116.062585,
                            "lat": 35.388543
                        }
                    },
                    {
                        "citycode": "0530",
                        "adcode": "371726",
                        "name": "鄄城县",
                        "center": {
                            "lng": 115.544507,
                            "lat": 35.534088
                        }
                    },
                    {
                        "citycode": "0530",
                        "adcode": "371722",
                        "name": "单县",
                        "center": {
                            "lng": 116.106396,
                            "lat": 34.779282
                        }
                    },
                    {
                        "citycode": "0530",
                        "adcode": "371725",
                        "name": "郓城县",
                        "center": {
                            "lng": 115.938939,
                            "lat": 35.575276
                        }
                    },
                    {
                        "citycode": "0530",
                        "adcode": "371721",
                        "name": "曹县",
                        "center": {
                            "lng": 115.556393,
                            "lat": 34.85875
                        }
                    },
                    {
                        "citycode": "0530",
                        "adcode": "371702",
                        "name": "牡丹区",
                        "center": {
                            "lng": 115.417021,
                            "lat": 35.251911
                        }
                    },
                    {
                        "citycode": "0530",
                        "adcode": "371728",
                        "name": "东明县",
                        "center": {
                            "lng": 115.107402,
                            "lat": 35.275664
                        }
                    },
                    {
                        "citycode": "0530",
                        "adcode": "371703",
                        "name": "定陶区",
                        "center": {
                            "lng": 115.583172,
                            "lat": 35.105742
                        }
                    },
                    {
                        "citycode": "0530",
                        "adcode": "371723",
                        "name": "成武县",
                        "center": {
                            "lng": 115.889775,
                            "lat": 34.95278
                        }
                    }
                ]
            },
            {
                "citycode": "0633",
                "adcode": "371100",
                "name": "日照市",
                "center": {
                    "lng": 119.52685,
                    "lat": 35.416912
                },
                "districtList": [
                    {
                        "citycode": "0633",
                        "adcode": "371121",
                        "name": "五莲县",
                        "center": {
                            "lng": 119.213673,
                            "lat": 35.760154
                        }
                    },
                    {
                        "citycode": "0633",
                        "adcode": "371102",
                        "name": "东港区",
                        "center": {
                            "lng": 119.462287,
                            "lat": 35.426037
                        }
                    },
                    {
                        "citycode": "0633",
                        "adcode": "371122",
                        "name": "莒县",
                        "center": {
                            "lng": 118.869059,
                            "lat": 35.59125
                        }
                    },
                    {
                        "citycode": "0633",
                        "adcode": "371103",
                        "name": "岚山区",
                        "center": {
                            "lng": 119.31881,
                            "lat": 35.121985
                        }
                    }
                ]
            },
            {
                "citycode": "0533",
                "adcode": "370300",
                "name": "淄博市",
                "center": {
                    "lng": 118.054994,
                    "lat": 36.813787
                },
                "districtList": [
                    {
                        "citycode": "0533",
                        "adcode": "370321",
                        "name": "桓台县",
                        "center": {
                            "lng": 118.097923,
                            "lat": 36.959794
                        }
                    },
                    {
                        "citycode": "0533",
                        "adcode": "370322",
                        "name": "高青县",
                        "center": {
                            "lng": 117.826743,
                            "lat": 37.171042
                        }
                    },
                    {
                        "citycode": "0533",
                        "adcode": "370304",
                        "name": "博山区",
                        "center": {
                            "lng": 117.8627,
                            "lat": 36.495014
                        }
                    },
                    {
                        "citycode": "0533",
                        "adcode": "370305",
                        "name": "临淄区",
                        "center": {
                            "lng": 118.309398,
                            "lat": 36.826882
                        }
                    },
                    {
                        "citycode": "0533",
                        "adcode": "370323",
                        "name": "沂源县",
                        "center": {
                            "lng": 118.170856,
                            "lat": 36.185402
                        }
                    },
                    {
                        "citycode": "0533",
                        "adcode": "370306",
                        "name": "周村区",
                        "center": {
                            "lng": 117.869686,
                            "lat": 36.80309
                        }
                    },
                    {
                        "citycode": "0533",
                        "adcode": "370303",
                        "name": "张店区",
                        "center": {
                            "lng": 118.017877,
                            "lat": 36.807011
                        }
                    },
                    {
                        "citycode": "0533",
                        "adcode": "370302",
                        "name": "淄川区",
                        "center": {
                            "lng": 117.966978,
                            "lat": 36.644211
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "610000",
        "name": "陕西省",
        "center": {
            "lng": 108.953939,
            "lat": 34.266611
        },
        "districtList": [
            {
                "citycode": "0914",
                "adcode": "611000",
                "name": "商洛市",
                "center": {
                    "lng": 109.918646,
                    "lat": 33.873358
                },
                "districtList": [
                    {
                        "citycode": "0914",
                        "adcode": "611022",
                        "name": "丹凤县",
                        "center": {
                            "lng": 110.327542,
                            "lat": 33.696254
                        }
                    },
                    {
                        "citycode": "0914",
                        "adcode": "611023",
                        "name": "商南县",
                        "center": {
                            "lng": 110.881741,
                            "lat": 33.531071
                        }
                    },
                    {
                        "citycode": "0914",
                        "adcode": "611021",
                        "name": "洛南县",
                        "center": {
                            "lng": 110.148526,
                            "lat": 34.090815
                        }
                    },
                    {
                        "citycode": "0914",
                        "adcode": "611002",
                        "name": "商州区",
                        "center": {
                            "lng": 109.941452,
                            "lat": 33.862979
                        }
                    },
                    {
                        "citycode": "0914",
                        "adcode": "611026",
                        "name": "柞水县",
                        "center": {
                            "lng": 109.114006,
                            "lat": 33.686048
                        }
                    },
                    {
                        "citycode": "0914",
                        "adcode": "611024",
                        "name": "山阳县",
                        "center": {
                            "lng": 109.882289,
                            "lat": 33.532172
                        }
                    },
                    {
                        "citycode": "0914",
                        "adcode": "611025",
                        "name": "镇安县",
                        "center": {
                            "lng": 109.152833,
                            "lat": 33.423764
                        }
                    }
                ]
            },
            {
                "citycode": "0916",
                "adcode": "610700",
                "name": "汉中市",
                "center": {
                    "lng": 107.02319,
                    "lat": 33.066373
                },
                "districtList": [
                    {
                        "citycode": "0916",
                        "adcode": "610729",
                        "name": "留坝县",
                        "center": {
                            "lng": 106.920781,
                            "lat": 33.617637
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610726",
                        "name": "宁强县",
                        "center": {
                            "lng": 106.257636,
                            "lat": 32.830032
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610723",
                        "name": "洋县",
                        "center": {
                            "lng": 107.545678,
                            "lat": 33.222808
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610727",
                        "name": "略阳县",
                        "center": {
                            "lng": 106.15658,
                            "lat": 33.327293
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610725",
                        "name": "勉县",
                        "center": {
                            "lng": 106.673217,
                            "lat": 33.153636
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610702",
                        "name": "汉台区",
                        "center": {
                            "lng": 107.03201,
                            "lat": 33.067523
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610703",
                        "name": "南郑区",
                        "center": {
                            "lng": 106.936235,
                            "lat": 33.000034
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610728",
                        "name": "镇巴县",
                        "center": {
                            "lng": 107.895015,
                            "lat": 32.536706
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610722",
                        "name": "城固县",
                        "center": {
                            "lng": 107.333787,
                            "lat": 33.156937
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610724",
                        "name": "西乡县",
                        "center": {
                            "lng": 107.766477,
                            "lat": 32.983282
                        }
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610730",
                        "name": "佛坪县",
                        "center": {
                            "lng": 107.990551,
                            "lat": 33.524261
                        }
                    }
                ]
            },
            {
                "citycode": "0911",
                "adcode": "610600",
                "name": "延安市",
                "center": {
                    "lng": 109.49468,
                    "lat": 36.650109
                },
                "districtList": [
                    {
                        "citycode": "0911",
                        "adcode": "610681",
                        "name": "子长市",
                        "center": {
                            "lng": 109.675284,
                            "lat": 37.142462
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610626",
                        "name": "吴起县",
                        "center": {
                            "lng": 108.176501,
                            "lat": 36.92746
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610603",
                        "name": "安塞区",
                        "center": {
                            "lng": 109.329236,
                            "lat": 36.864571
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610625",
                        "name": "志丹县",
                        "center": {
                            "lng": 108.767816,
                            "lat": 36.822232
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610622",
                        "name": "延川县",
                        "center": {
                            "lng": 110.193503,
                            "lat": 36.878324
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610602",
                        "name": "宝塔区",
                        "center": {
                            "lng": 109.489726,
                            "lat": 36.585138
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610621",
                        "name": "延长县",
                        "center": {
                            "lng": 110.012455,
                            "lat": 36.579354
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610627",
                        "name": "甘泉县",
                        "center": {
                            "lng": 109.351046,
                            "lat": 36.276645
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610630",
                        "name": "宜川县",
                        "center": {
                            "lng": 110.168963,
                            "lat": 36.050178
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610628",
                        "name": "富县",
                        "center": {
                            "lng": 109.37884,
                            "lat": 35.988111
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610629",
                        "name": "洛川县",
                        "center": {
                            "lng": 109.43249,
                            "lat": 35.762626
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610632",
                        "name": "黄陵县",
                        "center": {
                            "lng": 109.262919,
                            "lat": 35.579421
                        }
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610631",
                        "name": "黄龙县",
                        "center": {
                            "lng": 109.84029,
                            "lat": 35.584655
                        }
                    }
                ]
            },
            {
                "citycode": "029",
                "adcode": "610100",
                "name": "西安市",
                "center": {
                    "lng": 108.939645,
                    "lat": 34.343207
                },
                "districtList": [
                    {
                        "citycode": "029",
                        "adcode": "610115",
                        "name": "临潼区",
                        "center": {
                            "lng": 109.214249,
                            "lat": 34.367181
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610111",
                        "name": "灞桥区",
                        "center": {
                            "lng": 109.064675,
                            "lat": 34.273111
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610116",
                        "name": "长安区",
                        "center": {
                            "lng": 108.906944,
                            "lat": 34.158668
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610118",
                        "name": "鄠邑区",
                        "center": {
                            "lng": 108.604772,
                            "lat": 34.108707
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610122",
                        "name": "蓝田县",
                        "center": {
                            "lng": 109.323473,
                            "lat": 34.151256
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610124",
                        "name": "周至县",
                        "center": {
                            "lng": 108.222219,
                            "lat": 34.163592
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610114",
                        "name": "阎良区",
                        "center": {
                            "lng": 109.226124,
                            "lat": 34.662232
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610113",
                        "name": "雁塔区",
                        "center": {
                            "lng": 108.948592,
                            "lat": 34.222517
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610117",
                        "name": "高陵区",
                        "center": {
                            "lng": 109.088269,
                            "lat": 34.53502
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610112",
                        "name": "未央区",
                        "center": {
                            "lng": 108.946665,
                            "lat": 34.293109
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610103",
                        "name": "碑林区",
                        "center": {
                            "lng": 108.940681,
                            "lat": 34.256727
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610102",
                        "name": "新城区",
                        "center": {
                            "lng": 108.960707,
                            "lat": 34.266601
                        }
                    },
                    {
                        "citycode": "029",
                        "adcode": "610104",
                        "name": "莲湖区",
                        "center": {
                            "lng": 108.944161,
                            "lat": 34.26535
                        }
                    }
                ]
            },
            {
                "citycode": "0910",
                "adcode": "610400",
                "name": "咸阳市",
                "center": {
                    "lng": 108.708837,
                    "lat": 34.329896
                },
                "districtList": [
                    {
                        "citycode": "0910",
                        "adcode": "610424",
                        "name": "乾县",
                        "center": {
                            "lng": 108.239316,
                            "lat": 34.528262
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610422",
                        "name": "三原县",
                        "center": {
                            "lng": 108.940754,
                            "lat": 34.617282
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610430",
                        "name": "淳化县",
                        "center": {
                            "lng": 108.580164,
                            "lat": 34.798596
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610403",
                        "name": "杨陵区",
                        "center": {
                            "lng": 108.084661,
                            "lat": 34.272084
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610431",
                        "name": "武功县",
                        "center": {
                            "lng": 108.200275,
                            "lat": 34.261026
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610429",
                        "name": "旬邑县",
                        "center": {
                            "lng": 108.333815,
                            "lat": 35.111787
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610428",
                        "name": "长武县",
                        "center": {
                            "lng": 107.79906,
                            "lat": 35.206273
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610426",
                        "name": "永寿县",
                        "center": {
                            "lng": 108.142197,
                            "lat": 34.69188
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610482",
                        "name": "彬州市",
                        "center": {
                            "lng": 108.081892,
                            "lat": 35.035702
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610425",
                        "name": "礼泉县",
                        "center": {
                            "lng": 108.424682,
                            "lat": 34.481875
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610423",
                        "name": "泾阳县",
                        "center": {
                            "lng": 108.843029,
                            "lat": 34.526557
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610404",
                        "name": "渭城区",
                        "center": {
                            "lng": 108.737062,
                            "lat": 34.36202
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610481",
                        "name": "兴平市",
                        "center": {
                            "lng": 108.490497,
                            "lat": 34.299199
                        }
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610402",
                        "name": "秦都区",
                        "center": {
                            "lng": 108.706347,
                            "lat": 34.329478
                        }
                    }
                ]
            },
            {
                "citycode": "0917",
                "adcode": "610300",
                "name": "宝鸡市",
                "center": {
                    "lng": 107.237682,
                    "lat": 34.362862
                },
                "districtList": [
                    {
                        "citycode": "0917",
                        "adcode": "610327",
                        "name": "陇县",
                        "center": {
                            "lng": 106.864404,
                            "lat": 34.892985
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610328",
                        "name": "千阳县",
                        "center": {
                            "lng": 107.132421,
                            "lat": 34.642374
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610303",
                        "name": "金台区",
                        "center": {
                            "lng": 107.232733,
                            "lat": 34.397071
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610302",
                        "name": "渭滨区",
                        "center": {
                            "lng": 107.155344,
                            "lat": 34.355068
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610330",
                        "name": "凤县",
                        "center": {
                            "lng": 106.515841,
                            "lat": 33.910797
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610331",
                        "name": "太白县",
                        "center": {
                            "lng": 107.318932,
                            "lat": 34.058299
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610304",
                        "name": "陈仓区",
                        "center": {
                            "lng": 107.368993,
                            "lat": 34.35073
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610305",
                        "name": "凤翔区",
                        "center": {
                            "lng": 107.401029,
                            "lat": 34.522167
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610323",
                        "name": "岐山县",
                        "center": {
                            "lng": 107.621397,
                            "lat": 34.44373
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610329",
                        "name": "麟游县",
                        "center": {
                            "lng": 107.793524,
                            "lat": 34.677902
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610324",
                        "name": "扶风县",
                        "center": {
                            "lng": 107.900157,
                            "lat": 34.375636
                        }
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610326",
                        "name": "眉县",
                        "center": {
                            "lng": 107.750039,
                            "lat": 34.274774
                        }
                    }
                ]
            },
            {
                "citycode": "0919",
                "adcode": "610200",
                "name": "铜川市",
                "center": {
                    "lng": 108.945116,
                    "lat": 34.897133
                },
                "districtList": [
                    {
                        "citycode": "0919",
                        "adcode": "610222",
                        "name": "宜君县",
                        "center": {
                            "lng": 109.117063,
                            "lat": 35.398624
                        }
                    },
                    {
                        "citycode": "0919",
                        "adcode": "610203",
                        "name": "印台区",
                        "center": {
                            "lng": 109.099848,
                            "lat": 35.11454
                        }
                    },
                    {
                        "citycode": "0919",
                        "adcode": "610202",
                        "name": "王益区",
                        "center": {
                            "lng": 109.075615,
                            "lat": 35.068925
                        }
                    },
                    {
                        "citycode": "0919",
                        "adcode": "610204",
                        "name": "耀州区",
                        "center": {
                            "lng": 108.980095,
                            "lat": 34.909685
                        }
                    }
                ]
            },
            {
                "citycode": "0913",
                "adcode": "610500",
                "name": "渭南市",
                "center": {
                    "lng": 109.470962,
                    "lat": 34.520632
                },
                "districtList": [
                    {
                        "citycode": "0913",
                        "adcode": "610527",
                        "name": "白水县",
                        "center": {
                            "lng": 109.590501,
                            "lat": 35.177497
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610522",
                        "name": "潼关县",
                        "center": {
                            "lng": 110.246105,
                            "lat": 34.544294
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610525",
                        "name": "澄城县",
                        "center": {
                            "lng": 109.932439,
                            "lat": 35.190256
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610526",
                        "name": "蒲城县",
                        "center": {
                            "lng": 109.586263,
                            "lat": 34.955755
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610582",
                        "name": "华阴市",
                        "center": {
                            "lng": 110.092286,
                            "lat": 34.566552
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610523",
                        "name": "大荔县",
                        "center": {
                            "lng": 109.941784,
                            "lat": 34.797073
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610502",
                        "name": "临渭区",
                        "center": {
                            "lng": 109.510051,
                            "lat": 34.498902
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610503",
                        "name": "华州区",
                        "center": {
                            "lng": 109.775765,
                            "lat": 34.497019
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610528",
                        "name": "富平县",
                        "center": {
                            "lng": 109.179903,
                            "lat": 34.751599
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610581",
                        "name": "韩城市",
                        "center": {
                            "lng": 110.44295,
                            "lat": 35.477145
                        }
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610524",
                        "name": "合阳县",
                        "center": {
                            "lng": 110.149412,
                            "lat": 35.237881
                        }
                    }
                ]
            },
            {
                "citycode": "0915",
                "adcode": "610900",
                "name": "安康市",
                "center": {
                    "lng": 109.029017,
                    "lat": 32.685435
                },
                "districtList": [
                    {
                        "citycode": "0915",
                        "adcode": "610924",
                        "name": "紫阳县",
                        "center": {
                            "lng": 108.534291,
                            "lat": 32.520209
                        }
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610927",
                        "name": "镇坪县",
                        "center": {
                            "lng": 109.526873,
                            "lat": 31.883672
                        }
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610925",
                        "name": "岚皋县",
                        "center": {
                            "lng": 108.902049,
                            "lat": 32.307001
                        }
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610929",
                        "name": "白河县",
                        "center": {
                            "lng": 110.112608,
                            "lat": 32.80901
                        }
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610981",
                        "name": "旬阳市",
                        "center": {
                            "lng": 109.361783,
                            "lat": 32.832213
                        }
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610926",
                        "name": "平利县",
                        "center": {
                            "lng": 109.361919,
                            "lat": 32.389061
                        }
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610923",
                        "name": "宁陕县",
                        "center": {
                            "lng": 108.314299,
                            "lat": 33.310284
                        }
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610902",
                        "name": "汉滨区",
                        "center": {
                            "lng": 109.026928,
                            "lat": 32.695436
                        }
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610921",
                        "name": "汉阴县",
                        "center": {
                            "lng": 108.508792,
                            "lat": 32.893057
                        }
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610922",
                        "name": "石泉县",
                        "center": {
                            "lng": 108.248061,
                            "lat": 33.03805
                        }
                    }
                ]
            },
            {
                "citycode": "0912",
                "adcode": "610800",
                "name": "榆林市",
                "center": {
                    "lng": 109.734104,
                    "lat": 38.28576
                },
                "districtList": [
                    {
                        "citycode": "0912",
                        "adcode": "610802",
                        "name": "榆阳区",
                        "center": {
                            "lng": 109.72054,
                            "lat": 38.277078
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610826",
                        "name": "绥德县",
                        "center": {
                            "lng": 110.263226,
                            "lat": 37.502984
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610830",
                        "name": "清涧县",
                        "center": {
                            "lng": 110.121181,
                            "lat": 37.088921
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610824",
                        "name": "靖边县",
                        "center": {
                            "lng": 108.794153,
                            "lat": 37.600351
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610831",
                        "name": "子洲县",
                        "center": {
                            "lng": 110.035124,
                            "lat": 37.610554
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610827",
                        "name": "米脂县",
                        "center": {
                            "lng": 110.183984,
                            "lat": 37.755134
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610829",
                        "name": "吴堡县",
                        "center": {
                            "lng": 110.739726,
                            "lat": 37.452179
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610881",
                        "name": "神木市",
                        "center": {
                            "lng": 110.466867,
                            "lat": 38.899742
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610825",
                        "name": "定边县",
                        "center": {
                            "lng": 107.601048,
                            "lat": 37.594976
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610828",
                        "name": "佳县",
                        "center": {
                            "lng": 110.491345,
                            "lat": 38.01951
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610803",
                        "name": "横山区",
                        "center": {
                            "lng": 109.294144,
                            "lat": 37.962477
                        }
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610822",
                        "name": "府谷县",
                        "center": {
                            "lng": 111.016431,
                            "lat": 39.015658
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": "021",
        "adcode": "310000",
        "name": "上海市",
        "center": {
            "lng": 121.473667,
            "lat": 31.230525
        },
        "districtList": [
            {
                "citycode": "021",
                "adcode": "310100",
                "name": "上海城区",
                "center": {
                    "lng": 121.472644,
                    "lat": 31.231706
                },
                "districtList": [
                    {
                        "citycode": "021",
                        "adcode": "310151",
                        "name": "崇明区",
                        "center": {
                            "lng": 121.397662,
                            "lat": 31.623863
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310115",
                        "name": "浦东新区",
                        "center": {
                            "lng": 121.544346,
                            "lat": 31.221461
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310116",
                        "name": "金山区",
                        "center": {
                            "lng": 121.341774,
                            "lat": 30.742769
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310101",
                        "name": "黄浦区",
                        "center": {
                            "lng": 121.48442,
                            "lat": 31.231661
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310110",
                        "name": "杨浦区",
                        "center": {
                            "lng": 121.525409,
                            "lat": 31.259588
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310109",
                        "name": "虹口区",
                        "center": {
                            "lng": 121.504994,
                            "lat": 31.264917
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310104",
                        "name": "徐汇区",
                        "center": {
                            "lng": 121.436307,
                            "lat": 31.188334
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310106",
                        "name": "静安区",
                        "center": {
                            "lng": 121.447348,
                            "lat": 31.227718
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310114",
                        "name": "嘉定区",
                        "center": {
                            "lng": 121.265276,
                            "lat": 31.375566
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310117",
                        "name": "松江区",
                        "center": {
                            "lng": 121.227676,
                            "lat": 31.03257
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310105",
                        "name": "长宁区",
                        "center": {
                            "lng": 121.424751,
                            "lat": 31.220537
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310120",
                        "name": "奉贤区",
                        "center": {
                            "lng": 121.473945,
                            "lat": 30.918406
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310118",
                        "name": "青浦区",
                        "center": {
                            "lng": 121.124249,
                            "lat": 31.15098
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310112",
                        "name": "闵行区",
                        "center": {
                            "lng": 121.380857,
                            "lat": 31.112834
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310113",
                        "name": "宝山区",
                        "center": {
                            "lng": 121.489431,
                            "lat": 31.405242
                        }
                    },
                    {
                        "citycode": "021",
                        "adcode": "310107",
                        "name": "普陀区",
                        "center": {
                            "lng": 121.39547,
                            "lat": 31.249618
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "520000",
        "name": "贵州省",
        "center": {
            "lng": 106.705251,
            "lat": 26.600328
        },
        "districtList": [
            {
                "citycode": "0852",
                "adcode": "520300",
                "name": "遵义市",
                "center": {
                    "lng": 107.031922,
                    "lat": 27.721931
                },
                "districtList": [
                    {
                        "citycode": "0852",
                        "adcode": "520329",
                        "name": "余庆县",
                        "center": {
                            "lng": 107.906043,
                            "lat": 27.21513
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520323",
                        "name": "绥阳县",
                        "center": {
                            "lng": 107.191326,
                            "lat": 27.946049
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520325",
                        "name": "道真仡佬族苗族自治县",
                        "center": {
                            "lng": 107.613076,
                            "lat": 28.862548
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520326",
                        "name": "务川仡佬族苗族自治县",
                        "center": {
                            "lng": 107.899353,
                            "lat": 28.562921
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520324",
                        "name": "正安县",
                        "center": {
                            "lng": 107.454463,
                            "lat": 28.553507
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520330",
                        "name": "习水县",
                        "center": {
                            "lng": 106.19715,
                            "lat": 28.332923
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520302",
                        "name": "红花岗区",
                        "center": {
                            "lng": 106.893598,
                            "lat": 27.644793
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520382",
                        "name": "仁怀市",
                        "center": {
                            "lng": 106.401322,
                            "lat": 27.791883
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520381",
                        "name": "赤水市",
                        "center": {
                            "lng": 105.697501,
                            "lat": 28.590474
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520328",
                        "name": "湄潭县",
                        "center": {
                            "lng": 107.465492,
                            "lat": 27.748942
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520327",
                        "name": "凤冈县",
                        "center": {
                            "lng": 107.71646,
                            "lat": 27.954424
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520322",
                        "name": "桐梓县",
                        "center": {
                            "lng": 106.824661,
                            "lat": 28.132991
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520303",
                        "name": "汇川区",
                        "center": {
                            "lng": 106.933727,
                            "lat": 27.749716
                        }
                    },
                    {
                        "citycode": "0852",
                        "adcode": "520304",
                        "name": "播州区",
                        "center": {
                            "lng": 106.829081,
                            "lat": 27.535735
                        }
                    }
                ]
            },
            {
                "citycode": "0856",
                "adcode": "520600",
                "name": "铜仁市",
                "center": {
                    "lng": 109.189528,
                    "lat": 27.731555
                },
                "districtList": [
                    {
                        "citycode": "0856",
                        "adcode": "520623",
                        "name": "石阡县",
                        "center": {
                            "lng": 108.223686,
                            "lat": 27.513499
                        }
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520626",
                        "name": "德江县",
                        "center": {
                            "lng": 108.120773,
                            "lat": 28.264028
                        }
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520624",
                        "name": "思南县",
                        "center": {
                            "lng": 108.253798,
                            "lat": 27.937464
                        }
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520628",
                        "name": "松桃苗族自治县",
                        "center": {
                            "lng": 109.202877,
                            "lat": 28.15427
                        }
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520621",
                        "name": "江口县",
                        "center": {
                            "lng": 108.843993,
                            "lat": 27.704883
                        }
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520625",
                        "name": "印江土家族苗族自治县",
                        "center": {
                            "lng": 108.409638,
                            "lat": 27.994442
                        }
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520602",
                        "name": "碧江区",
                        "center": {
                            "lng": 109.264271,
                            "lat": 27.815244
                        }
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520603",
                        "name": "万山区",
                        "center": {
                            "lng": 109.153685,
                            "lat": 27.671268
                        }
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520627",
                        "name": "沿河土家族自治县",
                        "center": {
                            "lng": 108.503152,
                            "lat": 28.564083
                        }
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520622",
                        "name": "玉屏侗族自治县",
                        "center": {
                            "lng": 108.906415,
                            "lat": 27.235816
                        }
                    }
                ]
            },
            {
                "citycode": "0858",
                "adcode": "520200",
                "name": "六盘水市",
                "center": {
                    "lng": 104.830357,
                    "lat": 26.592538
                },
                "districtList": [
                    {
                        "citycode": "0858",
                        "adcode": "520201",
                        "name": "钟山区",
                        "center": {
                            "lng": 104.843723,
                            "lat": 26.574699
                        }
                    },
                    {
                        "citycode": "0858",
                        "adcode": "520204",
                        "name": "水城区",
                        "center": {
                            "lng": 104.957871,
                            "lat": 26.547604
                        }
                    },
                    {
                        "citycode": "0858",
                        "adcode": "520281",
                        "name": "盘州市",
                        "center": {
                            "lng": 104.471554,
                            "lat": 25.709878
                        }
                    },
                    {
                        "citycode": "0858",
                        "adcode": "520203",
                        "name": "六枝特区",
                        "center": {
                            "lng": 105.477199,
                            "lat": 26.214356
                        }
                    }
                ]
            },
            {
                "citycode": "0854",
                "adcode": "522700",
                "name": "黔南布依族苗族自治州",
                "center": {
                    "lng": 107.522303,
                    "lat": 26.253136
                },
                "districtList": [
                    {
                        "citycode": "0854",
                        "adcode": "522728",
                        "name": "罗甸县",
                        "center": {
                            "lng": 106.751724,
                            "lat": 25.42616
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522722",
                        "name": "荔波县",
                        "center": {
                            "lng": 107.88057,
                            "lat": 25.402528
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522727",
                        "name": "平塘县",
                        "center": {
                            "lng": 107.322635,
                            "lat": 25.822395
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522702",
                        "name": "福泉市",
                        "center": {
                            "lng": 107.520371,
                            "lat": 26.686773
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522725",
                        "name": "瓮安县",
                        "center": {
                            "lng": 107.471307,
                            "lat": 27.07838
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522701",
                        "name": "都匀市",
                        "center": {
                            "lng": 107.518628,
                            "lat": 26.259456
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522729",
                        "name": "长顺县",
                        "center": {
                            "lng": 106.44057,
                            "lat": 26.003187
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522723",
                        "name": "贵定县",
                        "center": {
                            "lng": 107.232208,
                            "lat": 26.557205
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522730",
                        "name": "龙里县",
                        "center": {
                            "lng": 106.979177,
                            "lat": 26.453546
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522731",
                        "name": "惠水县",
                        "center": {
                            "lng": 106.656993,
                            "lat": 26.132045
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522726",
                        "name": "独山县",
                        "center": {
                            "lng": 107.557591,
                            "lat": 25.865418
                        }
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522732",
                        "name": "三都水族自治县",
                        "center": {
                            "lng": 107.869489,
                            "lat": 25.983572
                        }
                    }
                ]
            },
            {
                "citycode": "0853",
                "adcode": "520400",
                "name": "安顺市",
                "center": {
                    "lng": 105.9476,
                    "lat": 26.253103
                },
                "districtList": [
                    {
                        "citycode": "0853",
                        "adcode": "520402",
                        "name": "西秀区",
                        "center": {
                            "lng": 105.966086,
                            "lat": 26.243928
                        }
                    },
                    {
                        "citycode": "0853",
                        "adcode": "520425",
                        "name": "紫云苗族布依族自治县",
                        "center": {
                            "lng": 106.084441,
                            "lat": 25.751047
                        }
                    },
                    {
                        "citycode": "0853",
                        "adcode": "520422",
                        "name": "普定县",
                        "center": {
                            "lng": 105.743156,
                            "lat": 26.301876
                        }
                    },
                    {
                        "citycode": "0853",
                        "adcode": "520423",
                        "name": "镇宁布依族苗族自治县",
                        "center": {
                            "lng": 105.770543,
                            "lat": 26.057248
                        }
                    },
                    {
                        "citycode": "0853",
                        "adcode": "520403",
                        "name": "平坝区",
                        "center": {
                            "lng": 106.255768,
                            "lat": 26.405968
                        }
                    },
                    {
                        "citycode": "0853",
                        "adcode": "520424",
                        "name": "关岭布依族苗族自治县",
                        "center": {
                            "lng": 105.538335,
                            "lat": 25.953518
                        }
                    }
                ]
            },
            {
                "citycode": "0859",
                "adcode": "522300",
                "name": "黔西南布依族苗族自治州",
                "center": {
                    "lng": 104.906419,
                    "lat": 25.087733
                },
                "districtList": [
                    {
                        "citycode": "0859",
                        "adcode": "522302",
                        "name": "兴仁市",
                        "center": {
                            "lng": 105.186132,
                            "lat": 25.43509
                        }
                    },
                    {
                        "citycode": "0859",
                        "adcode": "522328",
                        "name": "安龙县",
                        "center": {
                            "lng": 105.442702,
                            "lat": 25.099014
                        }
                    },
                    {
                        "citycode": "0859",
                        "adcode": "522327",
                        "name": "册亨县",
                        "center": {
                            "lng": 105.811592,
                            "lat": 24.983663
                        }
                    },
                    {
                        "citycode": "0859",
                        "adcode": "522325",
                        "name": "贞丰县",
                        "center": {
                            "lng": 105.64976,
                            "lat": 25.38558
                        }
                    },
                    {
                        "citycode": "0859",
                        "adcode": "522326",
                        "name": "望谟县",
                        "center": {
                            "lng": 106.094864,
                            "lat": 25.174204
                        }
                    },
                    {
                        "citycode": "0859",
                        "adcode": "522301",
                        "name": "兴义市",
                        "center": {
                            "lng": 104.895503,
                            "lat": 25.09196
                        }
                    },
                    {
                        "citycode": "0859",
                        "adcode": "522323",
                        "name": "普安县",
                        "center": {
                            "lng": 104.953289,
                            "lat": 25.784225
                        }
                    },
                    {
                        "citycode": "0859",
                        "adcode": "522324",
                        "name": "晴隆县",
                        "center": {
                            "lng": 105.218956,
                            "lat": 25.834729
                        }
                    }
                ]
            },
            {
                "citycode": "0855",
                "adcode": "522600",
                "name": "黔东南苗族侗族自治州",
                "center": {
                    "lng": 107.982838,
                    "lat": 26.583759
                },
                "districtList": [
                    {
                        "citycode": "0855",
                        "adcode": "522634",
                        "name": "雷山县",
                        "center": {
                            "lng": 108.078217,
                            "lat": 26.378892
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522632",
                        "name": "榕江县",
                        "center": {
                            "lng": 108.52188,
                            "lat": 25.931893
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522627",
                        "name": "天柱县",
                        "center": {
                            "lng": 109.207826,
                            "lat": 26.909548
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522623",
                        "name": "施秉县",
                        "center": {
                            "lng": 108.124531,
                            "lat": 27.033107
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522625",
                        "name": "镇远县",
                        "center": {
                            "lng": 108.429536,
                            "lat": 27.049033
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522601",
                        "name": "凯里市",
                        "center": {
                            "lng": 107.981409,
                            "lat": 26.5662
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522631",
                        "name": "黎平县",
                        "center": {
                            "lng": 109.125826,
                            "lat": 26.213304
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522633",
                        "name": "从江县",
                        "center": {
                            "lng": 108.904998,
                            "lat": 25.754638
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522628",
                        "name": "锦屏县",
                        "center": {
                            "lng": 109.200808,
                            "lat": 26.675919
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522630",
                        "name": "台江县",
                        "center": {
                            "lng": 108.321244,
                            "lat": 26.667525
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522635",
                        "name": "麻江县",
                        "center": {
                            "lng": 107.589455,
                            "lat": 26.49129
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522629",
                        "name": "剑河县",
                        "center": {
                            "lng": 108.441501,
                            "lat": 26.728274
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522624",
                        "name": "三穗县",
                        "center": {
                            "lng": 108.675265,
                            "lat": 26.953359
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522626",
                        "name": "岑巩县",
                        "center": {
                            "lng": 108.815855,
                            "lat": 27.174124
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522622",
                        "name": "黄平县",
                        "center": {
                            "lng": 107.916651,
                            "lat": 26.905278
                        }
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522636",
                        "name": "丹寨县",
                        "center": {
                            "lng": 107.789301,
                            "lat": 26.19857
                        }
                    }
                ]
            },
            {
                "citycode": "0857",
                "adcode": "520500",
                "name": "毕节市",
                "center": {
                    "lng": 105.291544,
                    "lat": 27.283615
                },
                "districtList": [
                    {
                        "citycode": "0857",
                        "adcode": "520581",
                        "name": "黔西市",
                        "center": {
                            "lng": 106.032277,
                            "lat": 27.008681
                        }
                    },
                    {
                        "citycode": "0857",
                        "adcode": "520523",
                        "name": "金沙县",
                        "center": {
                            "lng": 106.220112,
                            "lat": 27.458601
                        }
                    },
                    {
                        "citycode": "0857",
                        "adcode": "520524",
                        "name": "织金县",
                        "center": {
                            "lng": 105.770249,
                            "lat": 26.663649
                        }
                    },
                    {
                        "citycode": "0857",
                        "adcode": "520521",
                        "name": "大方县",
                        "center": {
                            "lng": 105.601963,
                            "lat": 27.14443
                        }
                    },
                    {
                        "citycode": "0857",
                        "adcode": "520525",
                        "name": "纳雍县",
                        "center": {
                            "lng": 105.414578,
                            "lat": 26.779344
                        }
                    },
                    {
                        "citycode": "0857",
                        "adcode": "520502",
                        "name": "七星关区",
                        "center": {
                            "lng": 105.305219,
                            "lat": 27.298304
                        }
                    },
                    {
                        "citycode": "0857",
                        "adcode": "520527",
                        "name": "赫章县",
                        "center": {
                            "lng": 104.728011,
                            "lat": 27.117933
                        }
                    },
                    {
                        "citycode": "0857",
                        "adcode": "520526",
                        "name": "威宁彝族回族苗族自治县",
                        "center": {
                            "lng": 104.252787,
                            "lat": 26.873872
                        }
                    }
                ]
            },
            {
                "citycode": "0851",
                "adcode": "520100",
                "name": "贵阳市",
                "center": {
                    "lng": 106.628201,
                    "lat": 26.646694
                },
                "districtList": [
                    {
                        "citycode": "0851",
                        "adcode": "520121",
                        "name": "开阳县",
                        "center": {
                            "lng": 106.964716,
                            "lat": 27.057823
                        }
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520113",
                        "name": "白云区",
                        "center": {
                            "lng": 106.623069,
                            "lat": 26.677932
                        }
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520123",
                        "name": "修文县",
                        "center": {
                            "lng": 106.591958,
                            "lat": 26.836048
                        }
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520181",
                        "name": "清镇市",
                        "center": {
                            "lng": 106.468686,
                            "lat": 26.570435
                        }
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520102",
                        "name": "南明区",
                        "center": {
                            "lng": 106.714305,
                            "lat": 26.568055
                        }
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520103",
                        "name": "云岩区",
                        "center": {
                            "lng": 106.724394,
                            "lat": 26.604604
                        }
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520115",
                        "name": "观山湖区",
                        "center": {
                            "lng": 106.598978,
                            "lat": 26.616134
                        }
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520112",
                        "name": "乌当区",
                        "center": {
                            "lng": 106.75069,
                            "lat": 26.630911
                        }
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520111",
                        "name": "花溪区",
                        "center": {
                            "lng": 106.67026,
                            "lat": 26.409817
                        }
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520122",
                        "name": "息烽县",
                        "center": {
                            "lng": 106.740407,
                            "lat": 27.090479
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": "023",
        "adcode": "500000",
        "name": "重庆市",
        "center": {
            "lng": 106.550483,
            "lat": 29.563707
        },
        "districtList": [
            {
                "citycode": "023",
                "adcode": "500200",
                "name": "重庆郊县",
                "center": {
                    "lng": 108.170255,
                    "lat": 29.291965
                },
                "districtList": [
                    {
                        "citycode": "023",
                        "adcode": "500236",
                        "name": "奉节县",
                        "center": {
                            "lng": 109.401056,
                            "lat": 31.018505
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500238",
                        "name": "巫溪县",
                        "center": {
                            "lng": 109.570038,
                            "lat": 31.398619
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500243",
                        "name": "彭水苗族土家族自治县",
                        "center": {
                            "lng": 108.165571,
                            "lat": 29.293748
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500241",
                        "name": "秀山土家族苗族自治县",
                        "center": {
                            "lng": 109.007096,
                            "lat": 28.448248
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500235",
                        "name": "云阳县",
                        "center": {
                            "lng": 108.6975,
                            "lat": 30.930628
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500240",
                        "name": "石柱土家族自治县",
                        "center": {
                            "lng": 108.114251,
                            "lat": 29.999066
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500237",
                        "name": "巫山县",
                        "center": {
                            "lng": 109.878995,
                            "lat": 31.07478
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500230",
                        "name": "丰都县",
                        "center": {
                            "lng": 107.731056,
                            "lat": 29.863785
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500229",
                        "name": "城口县",
                        "center": {
                            "lng": 108.664349,
                            "lat": 31.947319
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500242",
                        "name": "酉阳土家族苗族自治县",
                        "center": {
                            "lng": 108.76726,
                            "lat": 28.841409
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500233",
                        "name": "忠县",
                        "center": {
                            "lng": 108.038073,
                            "lat": 30.299817
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500231",
                        "name": "垫江县",
                        "center": {
                            "lng": 107.332511,
                            "lat": 30.327548
                        }
                    }
                ]
            },
            {
                "citycode": "023",
                "adcode": "500100",
                "name": "重庆城区",
                "center": {
                    "lng": 106.504962,
                    "lat": 29.533155
                },
                "districtList": [
                    {
                        "citycode": "023",
                        "adcode": "500117",
                        "name": "合川区",
                        "center": {
                            "lng": 106.27617,
                            "lat": 29.971968
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500152",
                        "name": "潼南区",
                        "center": {
                            "lng": 105.840487,
                            "lat": 30.191077
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500115",
                        "name": "长寿区",
                        "center": {
                            "lng": 107.080945,
                            "lat": 29.857916
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500151",
                        "name": "铜梁区",
                        "center": {
                            "lng": 106.056265,
                            "lat": 29.845248
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500111",
                        "name": "大足区",
                        "center": {
                            "lng": 105.721825,
                            "lat": 29.707555
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500104",
                        "name": "大渡口区",
                        "center": {
                            "lng": 106.482299,
                            "lat": 29.484464
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500107",
                        "name": "九龙坡区",
                        "center": {
                            "lng": 106.510515,
                            "lat": 29.502325
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500114",
                        "name": "黔江区",
                        "center": {
                            "lng": 108.770677,
                            "lat": 29.533609
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500108",
                        "name": "南岸区",
                        "center": {
                            "lng": 106.644254,
                            "lat": 29.50109
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500156",
                        "name": "武隆区",
                        "center": {
                            "lng": 107.759955,
                            "lat": 29.325707
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500110",
                        "name": "綦江区",
                        "center": {
                            "lng": 106.651213,
                            "lat": 29.028117
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500102",
                        "name": "涪陵区",
                        "center": {
                            "lng": 107.246521,
                            "lat": 29.752475
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500109",
                        "name": "北碚区",
                        "center": {
                            "lng": 106.395593,
                            "lat": 29.805197
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500119",
                        "name": "南川区",
                        "center": {
                            "lng": 107.099147,
                            "lat": 29.157879
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500118",
                        "name": "永川区",
                        "center": {
                            "lng": 105.926951,
                            "lat": 29.356384
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500101",
                        "name": "万州区",
                        "center": {
                            "lng": 108.408591,
                            "lat": 30.807621
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500153",
                        "name": "荣昌区",
                        "center": {
                            "lng": 105.6118,
                            "lat": 29.416892
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500112",
                        "name": "渝北区",
                        "center": {
                            "lng": 106.631155,
                            "lat": 29.718087
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500105",
                        "name": "江北区",
                        "center": {
                            "lng": 106.574395,
                            "lat": 29.606224
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500154",
                        "name": "开州区",
                        "center": {
                            "lng": 108.39336,
                            "lat": 31.160416
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500113",
                        "name": "巴南区",
                        "center": {
                            "lng": 106.540603,
                            "lat": 29.402348
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500116",
                        "name": "江津区",
                        "center": {
                            "lng": 106.264435,
                            "lat": 29.319984
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500120",
                        "name": "璧山区",
                        "center": {
                            "lng": 106.204885,
                            "lat": 29.577455
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500106",
                        "name": "沙坪坝区",
                        "center": {
                            "lng": 106.456939,
                            "lat": 29.541017
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500103",
                        "name": "渝中区",
                        "center": {
                            "lng": 106.568955,
                            "lat": 29.552642
                        }
                    },
                    {
                        "citycode": "023",
                        "adcode": "500155",
                        "name": "梁平区",
                        "center": {
                            "lng": 107.769568,
                            "lat": 30.654233
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "340000",
        "name": "安徽省",
        "center": {
            "lng": 117.330139,
            "lat": 31.734559
        },
        "districtList": [
            {
                "citycode": "0562",
                "adcode": "340700",
                "name": "铜陵市",
                "center": {
                    "lng": 117.811298,
                    "lat": 30.945214
                },
                "districtList": [
                    {
                        "citycode": "0562",
                        "adcode": "340711",
                        "name": "郊区",
                        "center": {
                            "lng": 117.767919,
                            "lat": 30.821699
                        }
                    },
                    {
                        "citycode": "0562",
                        "adcode": "340705",
                        "name": "铜官区",
                        "center": {
                            "lng": 117.856541,
                            "lat": 30.936772
                        }
                    },
                    {
                        "citycode": "0562",
                        "adcode": "340722",
                        "name": "枞阳县",
                        "center": {
                            "lng": 117.250191,
                            "lat": 30.705466
                        }
                    },
                    {
                        "citycode": "0562",
                        "adcode": "340706",
                        "name": "义安区",
                        "center": {
                            "lng": 117.937405,
                            "lat": 30.950619
                        }
                    }
                ]
            },
            {
                "citycode": "0566",
                "adcode": "341700",
                "name": "池州市",
                "center": {
                    "lng": 117.495663,
                    "lat": 30.674264
                },
                "districtList": [
                    {
                        "citycode": "0566",
                        "adcode": "341702",
                        "name": "贵池区",
                        "center": {
                            "lng": 117.568432,
                            "lat": 30.687389
                        }
                    },
                    {
                        "citycode": "0566",
                        "adcode": "341723",
                        "name": "青阳县",
                        "center": {
                            "lng": 117.847366,
                            "lat": 30.639006
                        }
                    },
                    {
                        "citycode": "0566",
                        "adcode": "341721",
                        "name": "东至县",
                        "center": {
                            "lng": 117.027533,
                            "lat": 30.111182
                        }
                    },
                    {
                        "citycode": "0566",
                        "adcode": "341722",
                        "name": "石台县",
                        "center": {
                            "lng": 117.486211,
                            "lat": 30.210218
                        }
                    }
                ]
            },
            {
                "citycode": "0556",
                "adcode": "340800",
                "name": "安庆市",
                "center": {
                    "lng": 117.115349,
                    "lat": 30.531828
                },
                "districtList": [
                    {
                        "citycode": "0556",
                        "adcode": "340828",
                        "name": "岳西县",
                        "center": {
                            "lng": 116.359732,
                            "lat": 30.849716
                        }
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340802",
                        "name": "迎江区",
                        "center": {
                            "lng": 117.090878,
                            "lat": 30.512768
                        }
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340811",
                        "name": "宜秀区",
                        "center": {
                            "lng": 116.987469,
                            "lat": 30.613189
                        }
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340881",
                        "name": "桐城市",
                        "center": {
                            "lng": 116.936588,
                            "lat": 31.035476
                        }
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340803",
                        "name": "大观区",
                        "center": {
                            "lng": 117.013469,
                            "lat": 30.553697
                        }
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340825",
                        "name": "太湖县",
                        "center": {
                            "lng": 116.30881,
                            "lat": 30.454198
                        }
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340827",
                        "name": "望江县",
                        "center": {
                            "lng": 116.70641,
                            "lat": 30.128404
                        }
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340826",
                        "name": "宿松县",
                        "center": {
                            "lng": 116.134485,
                            "lat": 30.171663
                        }
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340822",
                        "name": "怀宁县",
                        "center": {
                            "lng": 116.829612,
                            "lat": 30.73484
                        }
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340882",
                        "name": "潜山市",
                        "center": {
                            "lng": 116.581224,
                            "lat": 30.631022
                        }
                    }
                ]
            },
            {
                "citycode": "0561",
                "adcode": "340600",
                "name": "淮北市",
                "center": {
                    "lng": 116.798362,
                    "lat": 33.956264
                },
                "districtList": [
                    {
                        "citycode": "0561",
                        "adcode": "340602",
                        "name": "杜集区",
                        "center": {
                            "lng": 116.827949,
                            "lat": 33.991412
                        }
                    },
                    {
                        "citycode": "0561",
                        "adcode": "340603",
                        "name": "相山区",
                        "center": {
                            "lng": 116.795233,
                            "lat": 33.959927
                        }
                    },
                    {
                        "citycode": "0561",
                        "adcode": "340604",
                        "name": "烈山区",
                        "center": {
                            "lng": 116.813221,
                            "lat": 33.895407
                        }
                    },
                    {
                        "citycode": "0561",
                        "adcode": "340621",
                        "name": "濉溪县",
                        "center": {
                            "lng": 116.76616,
                            "lat": 33.915612
                        }
                    }
                ]
            },
            {
                "citycode": "0555",
                "adcode": "340500",
                "name": "马鞍山市",
                "center": {
                    "lng": 118.50685,
                    "lat": 31.668765
                },
                "districtList": [
                    {
                        "citycode": "0555",
                        "adcode": "340506",
                        "name": "博望区",
                        "center": {
                            "lng": 118.818276,
                            "lat": 31.55117
                        }
                    },
                    {
                        "citycode": "0555",
                        "adcode": "340523",
                        "name": "和县",
                        "center": {
                            "lng": 118.353668,
                            "lat": 31.74248
                        }
                    },
                    {
                        "citycode": "0555",
                        "adcode": "340522",
                        "name": "含山县",
                        "center": {
                            "lng": 118.101448,
                            "lat": 31.735559
                        }
                    },
                    {
                        "citycode": "0555",
                        "adcode": "340504",
                        "name": "雨山区",
                        "center": {
                            "lng": 118.498675,
                            "lat": 31.682374
                        }
                    },
                    {
                        "citycode": "0555",
                        "adcode": "340521",
                        "name": "当涂县",
                        "center": {
                            "lng": 118.497873,
                            "lat": 31.570857
                        }
                    },
                    {
                        "citycode": "0555",
                        "adcode": "340503",
                        "name": "花山区",
                        "center": {
                            "lng": 118.511366,
                            "lat": 31.700127
                        }
                    }
                ]
            },
            {
                "citycode": "0558",
                "adcode": "341600",
                "name": "亳州市",
                "center": {
                    "lng": 115.778588,
                    "lat": 33.846285
                },
                "districtList": [
                    {
                        "citycode": "0558",
                        "adcode": "341602",
                        "name": "谯城区",
                        "center": {
                            "lng": 115.779081,
                            "lat": 33.876436
                        }
                    },
                    {
                        "citycode": "0558",
                        "adcode": "341623",
                        "name": "利辛县",
                        "center": {
                            "lng": 116.206396,
                            "lat": 33.158424
                        }
                    },
                    {
                        "citycode": "0558",
                        "adcode": "341622",
                        "name": "蒙城县",
                        "center": {
                            "lng": 116.56434,
                            "lat": 33.265671
                        }
                    },
                    {
                        "citycode": "0558",
                        "adcode": "341621",
                        "name": "涡阳县",
                        "center": {
                            "lng": 116.21665,
                            "lat": 33.494134
                        }
                    }
                ]
            },
            {
                "citycode": "0559",
                "adcode": "341000",
                "name": "黄山市",
                "center": {
                    "lng": 118.337643,
                    "lat": 29.714886
                },
                "districtList": [
                    {
                        "citycode": "0559",
                        "adcode": "341003",
                        "name": "黄山区",
                        "center": {
                            "lng": 118.141632,
                            "lat": 30.272991
                        }
                    },
                    {
                        "citycode": "0559",
                        "adcode": "341002",
                        "name": "屯溪区",
                        "center": {
                            "lng": 118.315012,
                            "lat": 29.69655
                        }
                    },
                    {
                        "citycode": "0559",
                        "adcode": "341022",
                        "name": "休宁县",
                        "center": {
                            "lng": 118.193533,
                            "lat": 29.784532
                        }
                    },
                    {
                        "citycode": "0559",
                        "adcode": "341021",
                        "name": "歙县",
                        "center": {
                            "lng": 118.415258,
                            "lat": 29.861354
                        }
                    },
                    {
                        "citycode": "0559",
                        "adcode": "341004",
                        "name": "徽州区",
                        "center": {
                            "lng": 118.336799,
                            "lat": 29.827291
                        }
                    },
                    {
                        "citycode": "0559",
                        "adcode": "341023",
                        "name": "黟县",
                        "center": {
                            "lng": 117.938139,
                            "lat": 29.92477
                        }
                    },
                    {
                        "citycode": "0559",
                        "adcode": "341024",
                        "name": "祁门县",
                        "center": {
                            "lng": 117.717452,
                            "lat": 29.854179
                        }
                    }
                ]
            },
            {
                "citycode": "0552",
                "adcode": "340300",
                "name": "蚌埠市",
                "center": {
                    "lng": 117.388566,
                    "lat": 32.91682
                },
                "districtList": [
                    {
                        "citycode": "0552",
                        "adcode": "340311",
                        "name": "淮上区",
                        "center": {
                            "lng": 117.359352,
                            "lat": 32.96557
                        }
                    },
                    {
                        "citycode": "0552",
                        "adcode": "340322",
                        "name": "五河县",
                        "center": {
                            "lng": 117.881312,
                            "lat": 33.126532
                        }
                    },
                    {
                        "citycode": "0552",
                        "adcode": "340304",
                        "name": "禹会区",
                        "center": {
                            "lng": 117.34186,
                            "lat": 32.929715
                        }
                    },
                    {
                        "citycode": "0552",
                        "adcode": "340302",
                        "name": "龙子湖区",
                        "center": {
                            "lng": 117.454544,
                            "lat": 32.90863
                        }
                    },
                    {
                        "citycode": "0552",
                        "adcode": "340303",
                        "name": "蚌山区",
                        "center": {
                            "lng": 117.373347,
                            "lat": 32.916393
                        }
                    },
                    {
                        "citycode": "0552",
                        "adcode": "340321",
                        "name": "怀远县",
                        "center": {
                            "lng": 117.205083,
                            "lat": 32.971543
                        }
                    },
                    {
                        "citycode": "0552",
                        "adcode": "340323",
                        "name": "固镇县",
                        "center": {
                            "lng": 117.316585,
                            "lat": 33.318371
                        }
                    }
                ]
            },
            {
                "citycode": "0554",
                "adcode": "340400",
                "name": "淮南市",
                "center": {
                    "lng": 117.018603,
                    "lat": 32.585384
                },
                "districtList": [
                    {
                        "citycode": "0554",
                        "adcode": "340406",
                        "name": "潘集区",
                        "center": {
                            "lng": 116.834715,
                            "lat": 32.77208
                        }
                    },
                    {
                        "citycode": "0554",
                        "adcode": "340405",
                        "name": "八公山区",
                        "center": {
                            "lng": 116.832979,
                            "lat": 32.630922
                        }
                    },
                    {
                        "citycode": "0554",
                        "adcode": "340404",
                        "name": "谢家集区",
                        "center": {
                            "lng": 116.860026,
                            "lat": 32.599173
                        }
                    },
                    {
                        "citycode": "0554",
                        "adcode": "340421",
                        "name": "凤台县",
                        "center": {
                            "lng": 116.710947,
                            "lat": 32.710536
                        }
                    },
                    {
                        "citycode": "0554",
                        "adcode": "340403",
                        "name": "田家庵区",
                        "center": {
                            "lng": 117.017263,
                            "lat": 32.647456
                        }
                    },
                    {
                        "citycode": "0554",
                        "adcode": "340402",
                        "name": "大通区",
                        "center": {
                            "lng": 117.053314,
                            "lat": 32.631519
                        }
                    },
                    {
                        "citycode": "0554",
                        "adcode": "340422",
                        "name": "寿县",
                        "center": {
                            "lng": 116.798203,
                            "lat": 32.545027
                        }
                    }
                ]
            },
            {
                "citycode": "1558",
                "adcode": "341200",
                "name": "阜阳市",
                "center": {
                    "lng": 115.814252,
                    "lat": 32.891032
                },
                "districtList": [
                    {
                        "citycode": "1558",
                        "adcode": "341202",
                        "name": "颍州区",
                        "center": {
                            "lng": 115.806916,
                            "lat": 32.883322
                        }
                    },
                    {
                        "citycode": "1558",
                        "adcode": "341221",
                        "name": "临泉县",
                        "center": {
                            "lng": 115.26312,
                            "lat": 33.038884
                        }
                    },
                    {
                        "citycode": "1558",
                        "adcode": "341204",
                        "name": "颍泉区",
                        "center": {
                            "lng": 115.807415,
                            "lat": 32.925461
                        }
                    },
                    {
                        "citycode": "1558",
                        "adcode": "341226",
                        "name": "颍上县",
                        "center": {
                            "lng": 116.256772,
                            "lat": 32.653211
                        }
                    },
                    {
                        "citycode": "1558",
                        "adcode": "341203",
                        "name": "颍东区",
                        "center": {
                            "lng": 115.856728,
                            "lat": 32.91173
                        }
                    },
                    {
                        "citycode": "1558",
                        "adcode": "341225",
                        "name": "阜南县",
                        "center": {
                            "lng": 115.596003,
                            "lat": 32.659681
                        }
                    },
                    {
                        "citycode": "1558",
                        "adcode": "341282",
                        "name": "界首市",
                        "center": {
                            "lng": 115.374688,
                            "lat": 33.257799
                        }
                    },
                    {
                        "citycode": "1558",
                        "adcode": "341222",
                        "name": "太和县",
                        "center": {
                            "lng": 115.621941,
                            "lat": 33.160327
                        }
                    }
                ]
            },
            {
                "citycode": "0564",
                "adcode": "341500",
                "name": "六安市",
                "center": {
                    "lng": 116.519729,
                    "lat": 31.735892
                },
                "districtList": [
                    {
                        "citycode": "0564",
                        "adcode": "341503",
                        "name": "裕安区",
                        "center": {
                            "lng": 116.479505,
                            "lat": 31.738789
                        }
                    },
                    {
                        "citycode": "0564",
                        "adcode": "341522",
                        "name": "霍邱县",
                        "center": {
                            "lng": 116.277966,
                            "lat": 32.353362
                        }
                    },
                    {
                        "citycode": "0564",
                        "adcode": "341504",
                        "name": "叶集区",
                        "center": {
                            "lng": 115.925271,
                            "lat": 31.863693
                        }
                    },
                    {
                        "citycode": "0564",
                        "adcode": "341525",
                        "name": "霍山县",
                        "center": {
                            "lng": 116.348274,
                            "lat": 31.409668
                        }
                    },
                    {
                        "citycode": "0564",
                        "adcode": "341524",
                        "name": "金寨县",
                        "center": {
                            "lng": 115.934253,
                            "lat": 31.727295
                        }
                    },
                    {
                        "citycode": "0564",
                        "adcode": "341523",
                        "name": "舒城县",
                        "center": {
                            "lng": 116.94863,
                            "lat": 31.462036
                        }
                    },
                    {
                        "citycode": "0564",
                        "adcode": "341502",
                        "name": "金安区",
                        "center": {
                            "lng": 116.539458,
                            "lat": 31.75014
                        }
                    }
                ]
            },
            {
                "citycode": "0563",
                "adcode": "341800",
                "name": "宣城市",
                "center": {
                    "lng": 118.759127,
                    "lat": 30.939278
                },
                "districtList": [
                    {
                        "citycode": "0563",
                        "adcode": "341825",
                        "name": "旌德县",
                        "center": {
                            "lng": 118.550043,
                            "lat": 30.298287
                        }
                    },
                    {
                        "citycode": "0563",
                        "adcode": "341881",
                        "name": "宁国市",
                        "center": {
                            "lng": 118.983085,
                            "lat": 30.634032
                        }
                    },
                    {
                        "citycode": "0563",
                        "adcode": "341802",
                        "name": "宣州区",
                        "center": {
                            "lng": 118.786098,
                            "lat": 30.944356
                        }
                    },
                    {
                        "citycode": "0563",
                        "adcode": "341824",
                        "name": "绩溪县",
                        "center": {
                            "lng": 118.578519,
                            "lat": 30.067533
                        }
                    },
                    {
                        "citycode": "0563",
                        "adcode": "341821",
                        "name": "郎溪县",
                        "center": {
                            "lng": 119.184326,
                            "lat": 31.142995
                        }
                    },
                    {
                        "citycode": "0563",
                        "adcode": "341823",
                        "name": "泾县",
                        "center": {
                            "lng": 118.419552,
                            "lat": 30.688793
                        }
                    },
                    {
                        "citycode": "0563",
                        "adcode": "341882",
                        "name": "广德市",
                        "center": {
                            "lng": 119.420799,
                            "lat": 30.877608
                        }
                    }
                ]
            },
            {
                "citycode": "0553",
                "adcode": "340200",
                "name": "芜湖市",
                "center": {
                    "lng": 118.433065,
                    "lat": 31.352614
                },
                "districtList": [
                    {
                        "citycode": "0553",
                        "adcode": "340202",
                        "name": "镜湖区",
                        "center": {
                            "lng": 118.385133,
                            "lat": 31.34056
                        }
                    },
                    {
                        "citycode": "0553",
                        "adcode": "340209",
                        "name": "弋江区",
                        "center": {
                            "lng": 118.372664,
                            "lat": 31.311421
                        }
                    },
                    {
                        "citycode": "0553",
                        "adcode": "340212",
                        "name": "繁昌区",
                        "center": {
                            "lng": 118.198536,
                            "lat": 31.101766
                        }
                    },
                    {
                        "citycode": "0553",
                        "adcode": "340207",
                        "name": "鸠江区",
                        "center": {
                            "lng": 118.392337,
                            "lat": 31.369752
                        }
                    },
                    {
                        "citycode": "0553",
                        "adcode": "340210",
                        "name": "湾沚区",
                        "center": {
                            "lng": 118.576124,
                            "lat": 31.134809
                        }
                    },
                    {
                        "citycode": "0553",
                        "adcode": "340223",
                        "name": "南陵县",
                        "center": {
                            "lng": 118.334083,
                            "lat": 30.914621
                        }
                    },
                    {
                        "citycode": "0553",
                        "adcode": "340281",
                        "name": "无为市",
                        "center": {
                            "lng": 117.902265,
                            "lat": 31.304462
                        }
                    }
                ]
            },
            {
                "citycode": "0557",
                "adcode": "341300",
                "name": "宿州市",
                "center": {
                    "lng": 116.96419,
                    "lat": 33.647726
                },
                "districtList": [
                    {
                        "citycode": "0557",
                        "adcode": "341324",
                        "name": "泗县",
                        "center": {
                            "lng": 117.910277,
                            "lat": 33.483686
                        }
                    },
                    {
                        "citycode": "0557",
                        "adcode": "341323",
                        "name": "灵璧县",
                        "center": {
                            "lng": 117.549321,
                            "lat": 33.554464
                        }
                    },
                    {
                        "citycode": "0557",
                        "adcode": "341302",
                        "name": "埇桥区",
                        "center": {
                            "lng": 116.977039,
                            "lat": 33.640205
                        }
                    },
                    {
                        "citycode": "0557",
                        "adcode": "341322",
                        "name": "萧县",
                        "center": {
                            "lng": 116.947289,
                            "lat": 34.18884
                        }
                    },
                    {
                        "citycode": "0557",
                        "adcode": "341321",
                        "name": "砀山县",
                        "center": {
                            "lng": 116.366257,
                            "lat": 34.442139
                        }
                    }
                ]
            },
            {
                "citycode": "0551",
                "adcode": "340100",
                "name": "合肥市",
                "center": {
                    "lng": 117.227267,
                    "lat": 31.820567
                },
                "districtList": [
                    {
                        "citycode": "0551",
                        "adcode": "340111",
                        "name": "包河区",
                        "center": {
                            "lng": 117.310133,
                            "lat": 31.793801
                        }
                    },
                    {
                        "citycode": "0551",
                        "adcode": "340103",
                        "name": "庐阳区",
                        "center": {
                            "lng": 117.265088,
                            "lat": 31.878722
                        }
                    },
                    {
                        "citycode": "0551",
                        "adcode": "340181",
                        "name": "巢湖市",
                        "center": {
                            "lng": 117.890236,
                            "lat": 31.624464
                        }
                    },
                    {
                        "citycode": "0551",
                        "adcode": "340102",
                        "name": "瑶海区",
                        "center": {
                            "lng": 117.30944,
                            "lat": 31.858111
                        }
                    },
                    {
                        "citycode": "0551",
                        "adcode": "340104",
                        "name": "蜀山区",
                        "center": {
                            "lng": 117.26053,
                            "lat": 31.851211
                        }
                    },
                    {
                        "citycode": "0551",
                        "adcode": "340123",
                        "name": "肥西县",
                        "center": {
                            "lng": 117.158416,
                            "lat": 31.707006
                        }
                    },
                    {
                        "citycode": "0551",
                        "adcode": "340121",
                        "name": "长丰县",
                        "center": {
                            "lng": 117.167632,
                            "lat": 32.478347
                        }
                    },
                    {
                        "citycode": "0551",
                        "adcode": "340124",
                        "name": "庐江县",
                        "center": {
                            "lng": 117.288165,
                            "lat": 31.256978
                        }
                    },
                    {
                        "citycode": "0551",
                        "adcode": "340122",
                        "name": "肥东县",
                        "center": {
                            "lng": 117.4779,
                            "lat": 31.878601
                        }
                    }
                ]
            },
            {
                "citycode": "0550",
                "adcode": "341100",
                "name": "滁州市",
                "center": {
                    "lng": 118.333439,
                    "lat": 32.255904
                },
                "districtList": [
                    {
                        "citycode": "0550",
                        "adcode": "341181",
                        "name": "天长市",
                        "center": {
                            "lng": 119.004838,
                            "lat": 32.667409
                        }
                    },
                    {
                        "citycode": "0550",
                        "adcode": "341126",
                        "name": "凤阳县",
                        "center": {
                            "lng": 117.531791,
                            "lat": 32.875714
                        }
                    },
                    {
                        "citycode": "0550",
                        "adcode": "341125",
                        "name": "定远县",
                        "center": {
                            "lng": 117.698528,
                            "lat": 32.530741
                        }
                    },
                    {
                        "citycode": "0550",
                        "adcode": "341182",
                        "name": "明光市",
                        "center": {
                            "lng": 118.018197,
                            "lat": 32.78193
                        }
                    },
                    {
                        "citycode": "0550",
                        "adcode": "341102",
                        "name": "琅琊区",
                        "center": {
                            "lng": 118.32115,
                            "lat": 32.334475
                        }
                    },
                    {
                        "citycode": "0550",
                        "adcode": "341124",
                        "name": "全椒县",
                        "center": {
                            "lng": 118.274149,
                            "lat": 32.08593
                        }
                    },
                    {
                        "citycode": "0550",
                        "adcode": "341122",
                        "name": "来安县",
                        "center": {
                            "lng": 118.432581,
                            "lat": 32.423072
                        }
                    },
                    {
                        "citycode": "0550",
                        "adcode": "341103",
                        "name": "南谯区",
                        "center": {
                            "lng": 118.416715,
                            "lat": 32.200084
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "350000",
        "name": "福建省",
        "center": {
            "lng": 119.296194,
            "lat": 26.101082
        },
        "districtList": [
            {
                "citycode": "0593",
                "adcode": "350900",
                "name": "宁德市",
                "center": {
                    "lng": 119.547729,
                    "lat": 26.666222
                },
                "districtList": [
                    {
                        "citycode": "0593",
                        "adcode": "350922",
                        "name": "古田县",
                        "center": {
                            "lng": 118.74603,
                            "lat": 26.578134
                        }
                    },
                    {
                        "citycode": "0593",
                        "adcode": "350982",
                        "name": "福鼎市",
                        "center": {
                            "lng": 120.216559,
                            "lat": 27.324796
                        }
                    },
                    {
                        "citycode": "0593",
                        "adcode": "350902",
                        "name": "蕉城区",
                        "center": {
                            "lng": 119.526284,
                            "lat": 26.660658
                        }
                    },
                    {
                        "citycode": "0593",
                        "adcode": "350921",
                        "name": "霞浦县",
                        "center": {
                            "lng": 120.005267,
                            "lat": 26.885971
                        }
                    },
                    {
                        "citycode": "0593",
                        "adcode": "350981",
                        "name": "福安市",
                        "center": {
                            "lng": 119.647871,
                            "lat": 27.088274
                        }
                    },
                    {
                        "citycode": "0593",
                        "adcode": "350926",
                        "name": "柘荣县",
                        "center": {
                            "lng": 119.900597,
                            "lat": 27.23421
                        }
                    },
                    {
                        "citycode": "0593",
                        "adcode": "350923",
                        "name": "屏南县",
                        "center": {
                            "lng": 118.985759,
                            "lat": 26.908256
                        }
                    },
                    {
                        "citycode": "0593",
                        "adcode": "350925",
                        "name": "周宁县",
                        "center": {
                            "lng": 119.338998,
                            "lat": 27.104797
                        }
                    },
                    {
                        "citycode": "0593",
                        "adcode": "350924",
                        "name": "寿宁县",
                        "center": {
                            "lng": 119.514589,
                            "lat": 27.45467
                        }
                    }
                ]
            },
            {
                "citycode": "0591",
                "adcode": "350100",
                "name": "福州市",
                "center": {
                    "lng": 119.296411,
                    "lat": 26.074286
                },
                "districtList": [
                    {
                        "citycode": "0591",
                        "adcode": "350123",
                        "name": "罗源县",
                        "center": {
                            "lng": 119.549129,
                            "lat": 26.490215
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350124",
                        "name": "闽清县",
                        "center": {
                            "lng": 118.863334,
                            "lat": 26.221099
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350122",
                        "name": "连江县",
                        "center": {
                            "lng": 119.539542,
                            "lat": 26.197737
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350181",
                        "name": "福清市",
                        "center": {
                            "lng": 119.384388,
                            "lat": 25.720081
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350112",
                        "name": "长乐区",
                        "center": {
                            "lng": 119.522952,
                            "lat": 25.962925
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350128",
                        "name": "平潭县",
                        "center": {
                            "lng": 119.789893,
                            "lat": 25.498767
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350103",
                        "name": "台江区",
                        "center": {
                            "lng": 119.31419,
                            "lat": 26.052826
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350125",
                        "name": "永泰县",
                        "center": {
                            "lng": 118.932746,
                            "lat": 25.867198
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350111",
                        "name": "晋安区",
                        "center": {
                            "lng": 119.328591,
                            "lat": 26.081963
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350102",
                        "name": "鼓楼区",
                        "center": {
                            "lng": 119.304507,
                            "lat": 26.082666
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350121",
                        "name": "闽侯县",
                        "center": {
                            "lng": 119.131362,
                            "lat": 26.150428
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350105",
                        "name": "马尾区",
                        "center": {
                            "lng": 119.439259,
                            "lat": 25.998657
                        }
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350104",
                        "name": "仓山区",
                        "center": {
                            "lng": 119.27322,
                            "lat": 26.047027
                        }
                    }
                ]
            },
            {
                "citycode": "0594",
                "adcode": "350300",
                "name": "莆田市",
                "center": {
                    "lng": 119.007662,
                    "lat": 25.454202
                },
                "districtList": [
                    {
                        "citycode": "0594",
                        "adcode": "350305",
                        "name": "秀屿区",
                        "center": {
                            "lng": 119.105177,
                            "lat": 25.318649
                        }
                    },
                    {
                        "citycode": "0594",
                        "adcode": "350304",
                        "name": "荔城区",
                        "center": {
                            "lng": 119.014821,
                            "lat": 25.432268
                        }
                    },
                    {
                        "citycode": "0594",
                        "adcode": "350322",
                        "name": "仙游县",
                        "center": {
                            "lng": 118.689745,
                            "lat": 25.373373
                        }
                    },
                    {
                        "citycode": "0594",
                        "adcode": "350303",
                        "name": "涵江区",
                        "center": {
                            "lng": 119.116173,
                            "lat": 25.459057
                        }
                    },
                    {
                        "citycode": "0594",
                        "adcode": "350302",
                        "name": "城厢区",
                        "center": {
                            "lng": 118.994261,
                            "lat": 25.419062
                        }
                    }
                ]
            },
            {
                "citycode": "0595",
                "adcode": "350500",
                "name": "泉州市",
                "center": {
                    "lng": 118.675724,
                    "lat": 24.874452
                },
                "districtList": [
                    {
                        "citycode": "0595",
                        "adcode": "350521",
                        "name": "惠安县",
                        "center": {
                            "lng": 118.781037,
                            "lat": 25.012449
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350582",
                        "name": "晋江市",
                        "center": {
                            "lng": 118.551659,
                            "lat": 24.781635
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350504",
                        "name": "洛江区",
                        "center": {
                            "lng": 118.671168,
                            "lat": 24.939319
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350583",
                        "name": "南安市",
                        "center": {
                            "lng": 118.385929,
                            "lat": 24.960056
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350527",
                        "name": "金门县",
                        "center": {
                            "lng": 118.319179,
                            "lat": 24.437147
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350581",
                        "name": "石狮市",
                        "center": {
                            "lng": 118.647945,
                            "lat": 24.731969
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350505",
                        "name": "泉港区",
                        "center": {
                            "lng": 118.915804,
                            "lat": 25.120399
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350525",
                        "name": "永春县",
                        "center": {
                            "lng": 118.29416,
                            "lat": 25.321849
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350524",
                        "name": "安溪县",
                        "center": {
                            "lng": 118.186295,
                            "lat": 25.056065
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350502",
                        "name": "鲤城区",
                        "center": {
                            "lng": 118.58652,
                            "lat": 24.908133
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350526",
                        "name": "德化县",
                        "center": {
                            "lng": 118.241104,
                            "lat": 25.492102
                        }
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350503",
                        "name": "丰泽区",
                        "center": {
                            "lng": 118.613007,
                            "lat": 24.890373
                        }
                    }
                ]
            },
            {
                "citycode": "0592",
                "adcode": "350200",
                "name": "厦门市",
                "center": {
                    "lng": 118.08891,
                    "lat": 24.479627
                },
                "districtList": [
                    {
                        "citycode": "0592",
                        "adcode": "350206",
                        "name": "湖里区",
                        "center": {
                            "lng": 118.146825,
                            "lat": 24.512858
                        }
                    },
                    {
                        "citycode": "0592",
                        "adcode": "350203",
                        "name": "思明区",
                        "center": {
                            "lng": 118.082745,
                            "lat": 24.445676
                        }
                    },
                    {
                        "citycode": "0592",
                        "adcode": "350213",
                        "name": "翔安区",
                        "center": {
                            "lng": 118.247911,
                            "lat": 24.618583
                        }
                    },
                    {
                        "citycode": "0592",
                        "adcode": "350205",
                        "name": "海沧区",
                        "center": {
                            "lng": 118.032883,
                            "lat": 24.484688
                        }
                    },
                    {
                        "citycode": "0592",
                        "adcode": "350211",
                        "name": "集美区",
                        "center": {
                            "lng": 118.097407,
                            "lat": 24.575976
                        }
                    },
                    {
                        "citycode": "0592",
                        "adcode": "350212",
                        "name": "同安区",
                        "center": {
                            "lng": 118.150823,
                            "lat": 24.723299
                        }
                    }
                ]
            },
            {
                "citycode": "0596",
                "adcode": "350600",
                "name": "漳州市",
                "center": {
                    "lng": 117.647298,
                    "lat": 24.515297
                },
                "districtList": [
                    {
                        "citycode": "0596",
                        "adcode": "350604",
                        "name": "龙海区",
                        "center": {
                            "lng": 117.818485,
                            "lat": 24.446839
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350623",
                        "name": "漳浦县",
                        "center": {
                            "lng": 117.613783,
                            "lat": 24.11741
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350626",
                        "name": "东山县",
                        "center": {
                            "lng": 117.4295,
                            "lat": 23.702034
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350627",
                        "name": "南靖县",
                        "center": {
                            "lng": 117.357061,
                            "lat": 24.5151
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350628",
                        "name": "平和县",
                        "center": {
                            "lng": 117.314798,
                            "lat": 24.363831
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350629",
                        "name": "华安县",
                        "center": {
                            "lng": 117.53411,
                            "lat": 25.00445
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350605",
                        "name": "长泰区",
                        "center": {
                            "lng": 117.759119,
                            "lat": 24.625989
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350602",
                        "name": "芗城区",
                        "center": {
                            "lng": 117.653727,
                            "lat": 24.510937
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350603",
                        "name": "龙文区",
                        "center": {
                            "lng": 117.711188,
                            "lat": 24.503523
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350622",
                        "name": "云霄县",
                        "center": {
                            "lng": 117.334351,
                            "lat": 23.935433
                        }
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350624",
                        "name": "诏安县",
                        "center": {
                            "lng": 117.175314,
                            "lat": 23.711674
                        }
                    }
                ]
            },
            {
                "citycode": "0597",
                "adcode": "350800",
                "name": "龙岩市",
                "center": {
                    "lng": 117.017362,
                    "lat": 25.075884
                },
                "districtList": [
                    {
                        "citycode": "0597",
                        "adcode": "350824",
                        "name": "武平县",
                        "center": {
                            "lng": 116.100216,
                            "lat": 25.096139
                        }
                    },
                    {
                        "citycode": "0597",
                        "adcode": "350821",
                        "name": "长汀县",
                        "center": {
                            "lng": 116.357581,
                            "lat": 25.833531
                        }
                    },
                    {
                        "citycode": "0597",
                        "adcode": "350802",
                        "name": "新罗区",
                        "center": {
                            "lng": 117.036816,
                            "lat": 25.098942
                        }
                    },
                    {
                        "citycode": "0597",
                        "adcode": "350881",
                        "name": "漳平市",
                        "center": {
                            "lng": 117.419823,
                            "lat": 25.290481
                        }
                    },
                    {
                        "citycode": "0597",
                        "adcode": "350803",
                        "name": "永定区",
                        "center": {
                            "lng": 116.732216,
                            "lat": 24.724148
                        }
                    },
                    {
                        "citycode": "0597",
                        "adcode": "350825",
                        "name": "连城县",
                        "center": {
                            "lng": 116.754472,
                            "lat": 25.710538
                        }
                    },
                    {
                        "citycode": "0597",
                        "adcode": "350823",
                        "name": "上杭县",
                        "center": {
                            "lng": 116.419447,
                            "lat": 25.049867
                        }
                    }
                ]
            },
            {
                "citycode": "0598",
                "adcode": "350400",
                "name": "三明市",
                "center": {
                    "lng": 117.638919,
                    "lat": 26.263455
                },
                "districtList": [
                    {
                        "citycode": "0598",
                        "adcode": "350405",
                        "name": "沙县区",
                        "center": {
                            "lng": 117.792551,
                            "lat": 26.396843
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350430",
                        "name": "建宁县",
                        "center": {
                            "lng": 116.848488,
                            "lat": 26.833566
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350421",
                        "name": "明溪县",
                        "center": {
                            "lng": 117.202119,
                            "lat": 26.355938
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350428",
                        "name": "将乐县",
                        "center": {
                            "lng": 117.471127,
                            "lat": 26.728917
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350424",
                        "name": "宁化县",
                        "center": {
                            "lng": 116.654369,
                            "lat": 26.262298
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350404",
                        "name": "三元区",
                        "center": {
                            "lng": 117.646153,
                            "lat": 26.271653
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350423",
                        "name": "清流县",
                        "center": {
                            "lng": 116.816772,
                            "lat": 26.177658
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350481",
                        "name": "永安市",
                        "center": {
                            "lng": 117.365046,
                            "lat": 25.941671
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350426",
                        "name": "尤溪县",
                        "center": {
                            "lng": 118.190515,
                            "lat": 26.169942
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350429",
                        "name": "泰宁县",
                        "center": {
                            "lng": 117.175448,
                            "lat": 26.900244
                        }
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350425",
                        "name": "大田县",
                        "center": {
                            "lng": 117.846828,
                            "lat": 25.692535
                        }
                    }
                ]
            },
            {
                "citycode": "0599",
                "adcode": "350700",
                "name": "南平市",
                "center": {
                    "lng": 118.081325,
                    "lat": 27.382829
                },
                "districtList": [
                    {
                        "citycode": "0599",
                        "adcode": "350722",
                        "name": "浦城县",
                        "center": {
                            "lng": 118.541079,
                            "lat": 27.917804
                        }
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350723",
                        "name": "光泽县",
                        "center": {
                            "lng": 117.333812,
                            "lat": 27.541061
                        }
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350724",
                        "name": "松溪县",
                        "center": {
                            "lng": 118.785429,
                            "lat": 27.526028
                        }
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350703",
                        "name": "建阳区",
                        "center": {
                            "lng": 118.120392,
                            "lat": 27.331996
                        }
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350725",
                        "name": "政和县",
                        "center": {
                            "lng": 118.857703,
                            "lat": 27.366122
                        }
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350783",
                        "name": "建瓯市",
                        "center": {
                            "lng": 118.304712,
                            "lat": 27.023233
                        }
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350721",
                        "name": "顺昌县",
                        "center": {
                            "lng": 117.809433,
                            "lat": 26.793455
                        }
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350702",
                        "name": "延平区",
                        "center": {
                            "lng": 118.181806,
                            "lat": 26.637503
                        }
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350782",
                        "name": "武夷山市",
                        "center": {
                            "lng": 118.035321,
                            "lat": 27.756422
                        }
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350781",
                        "name": "邵武市",
                        "center": {
                            "lng": 117.492778,
                            "lat": 27.340672
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "430000",
        "name": "湖南省",
        "center": {
            "lng": 112.982951,
            "lat": 28.116007
        },
        "districtList": [
            {
                "citycode": "0730",
                "adcode": "430600",
                "name": "岳阳市",
                "center": {
                    "lng": 113.128922,
                    "lat": 29.35648
                },
                "districtList": [
                    {
                        "citycode": "0730",
                        "adcode": "430623",
                        "name": "华容县",
                        "center": {
                            "lng": 112.540448,
                            "lat": 29.530775
                        }
                    },
                    {
                        "citycode": "0730",
                        "adcode": "430603",
                        "name": "云溪区",
                        "center": {
                            "lng": 113.272312,
                            "lat": 29.472745
                        }
                    },
                    {
                        "citycode": "0730",
                        "adcode": "430602",
                        "name": "岳阳楼区",
                        "center": {
                            "lng": 113.129362,
                            "lat": 29.371356
                        }
                    },
                    {
                        "citycode": "0730",
                        "adcode": "430626",
                        "name": "平江县",
                        "center": {
                            "lng": 113.581296,
                            "lat": 28.702018
                        }
                    },
                    {
                        "citycode": "0730",
                        "adcode": "430621",
                        "name": "岳阳县",
                        "center": {
                            "lng": 113.116152,
                            "lat": 29.144681
                        }
                    },
                    {
                        "citycode": "0730",
                        "adcode": "430611",
                        "name": "君山区",
                        "center": {
                            "lng": 113.006434,
                            "lat": 29.461017
                        }
                    },
                    {
                        "citycode": "0730",
                        "adcode": "430682",
                        "name": "临湘市",
                        "center": {
                            "lng": 113.450461,
                            "lat": 29.476687
                        }
                    },
                    {
                        "citycode": "0730",
                        "adcode": "430681",
                        "name": "汨罗市",
                        "center": {
                            "lng": 113.067097,
                            "lat": 28.806937
                        }
                    },
                    {
                        "citycode": "0730",
                        "adcode": "430624",
                        "name": "湘阴县",
                        "center": {
                            "lng": 112.909248,
                            "lat": 28.690123
                        }
                    }
                ]
            },
            {
                "citycode": "0745",
                "adcode": "431200",
                "name": "怀化市",
                "center": {
                    "lng": 110.001598,
                    "lat": 27.569813
                },
                "districtList": [
                    {
                        "citycode": "0745",
                        "adcode": "431228",
                        "name": "芷江侗族自治县",
                        "center": {
                            "lng": 109.684696,
                            "lat": 27.443429
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431230",
                        "name": "通道侗族自治县",
                        "center": {
                            "lng": 109.784409,
                            "lat": 26.158032
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431222",
                        "name": "沅陵县",
                        "center": {
                            "lng": 110.393782,
                            "lat": 28.452103
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431223",
                        "name": "辰溪县",
                        "center": {
                            "lng": 110.183159,
                            "lat": 28.006235
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431225",
                        "name": "会同县",
                        "center": {
                            "lng": 109.734724,
                            "lat": 26.887156
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431224",
                        "name": "溆浦县",
                        "center": {
                            "lng": 110.594419,
                            "lat": 27.908869
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431229",
                        "name": "靖州苗族侗族自治县",
                        "center": {
                            "lng": 109.696249,
                            "lat": 26.575111
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431226",
                        "name": "麻阳苗族自治县",
                        "center": {
                            "lng": 109.817703,
                            "lat": 27.857666
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431221",
                        "name": "中方县",
                        "center": {
                            "lng": 109.945436,
                            "lat": 27.440554
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431202",
                        "name": "鹤城区",
                        "center": {
                            "lng": 110.040099,
                            "lat": 27.578581
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431281",
                        "name": "洪江市",
                        "center": {
                            "lng": 109.836475,
                            "lat": 27.209385
                        }
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431227",
                        "name": "新晃侗族自治县",
                        "center": {
                            "lng": 109.174808,
                            "lat": 27.352094
                        }
                    }
                ]
            },
            {
                "citycode": "0743",
                "adcode": "433100",
                "name": "湘西土家族苗族自治州",
                "center": {
                    "lng": 109.737428,
                    "lat": 28.312592
                },
                "districtList": [
                    {
                        "citycode": "0743",
                        "adcode": "433127",
                        "name": "永顺县",
                        "center": {
                            "lng": 109.857142,
                            "lat": 28.979819
                        }
                    },
                    {
                        "citycode": "0743",
                        "adcode": "433125",
                        "name": "保靖县",
                        "center": {
                            "lng": 109.660433,
                            "lat": 28.699939
                        }
                    },
                    {
                        "citycode": "0743",
                        "adcode": "433101",
                        "name": "吉首市",
                        "center": {
                            "lng": 109.698348,
                            "lat": 28.261948
                        }
                    },
                    {
                        "citycode": "0743",
                        "adcode": "433126",
                        "name": "古丈县",
                        "center": {
                            "lng": 109.95072,
                            "lat": 28.616971
                        }
                    },
                    {
                        "citycode": "0743",
                        "adcode": "433122",
                        "name": "泸溪县",
                        "center": {
                            "lng": 110.219619,
                            "lat": 28.216109
                        }
                    },
                    {
                        "citycode": "0743",
                        "adcode": "433130",
                        "name": "龙山县",
                        "center": {
                            "lng": 109.443974,
                            "lat": 29.457623
                        }
                    },
                    {
                        "citycode": "0743",
                        "adcode": "433124",
                        "name": "花垣县",
                        "center": {
                            "lng": 109.482378,
                            "lat": 28.57191
                        }
                    },
                    {
                        "citycode": "0743",
                        "adcode": "433123",
                        "name": "凤凰县",
                        "center": {
                            "lng": 109.580815,
                            "lat": 27.957441
                        }
                    }
                ]
            },
            {
                "citycode": "0737",
                "adcode": "430900",
                "name": "益阳市",
                "center": {
                    "lng": 112.355994,
                    "lat": 28.554853
                },
                "districtList": [
                    {
                        "citycode": "0737",
                        "adcode": "430902",
                        "name": "资阳区",
                        "center": {
                            "lng": 112.324286,
                            "lat": 28.59149
                        }
                    },
                    {
                        "citycode": "0737",
                        "adcode": "430922",
                        "name": "桃江县",
                        "center": {
                            "lng": 112.156432,
                            "lat": 28.518215
                        }
                    },
                    {
                        "citycode": "0737",
                        "adcode": "430923",
                        "name": "安化县",
                        "center": {
                            "lng": 111.213296,
                            "lat": 28.374223
                        }
                    },
                    {
                        "citycode": "0737",
                        "adcode": "430921",
                        "name": "南县",
                        "center": {
                            "lng": 112.396323,
                            "lat": 29.362396
                        }
                    },
                    {
                        "citycode": "0737",
                        "adcode": "430981",
                        "name": "沅江市",
                        "center": {
                            "lng": 112.354657,
                            "lat": 28.845755
                        }
                    },
                    {
                        "citycode": "0737",
                        "adcode": "430903",
                        "name": "赫山区",
                        "center": {
                            "lng": 112.373895,
                            "lat": 28.58011
                        }
                    }
                ]
            },
            {
                "citycode": "0734",
                "adcode": "430400",
                "name": "衡阳市",
                "center": {
                    "lng": 112.572016,
                    "lat": 26.894216
                },
                "districtList": [
                    {
                        "citycode": "0734",
                        "adcode": "430412",
                        "name": "南岳区",
                        "center": {
                            "lng": 112.737678,
                            "lat": 27.231846
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430423",
                        "name": "衡山县",
                        "center": {
                            "lng": 112.868361,
                            "lat": 27.230225
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430421",
                        "name": "衡阳县",
                        "center": {
                            "lng": 112.370649,
                            "lat": 26.970258
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430407",
                        "name": "石鼓区",
                        "center": {
                            "lng": 112.597937,
                            "lat": 26.944257
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430406",
                        "name": "雁峰区",
                        "center": {
                            "lng": 112.613914,
                            "lat": 26.840335
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430405",
                        "name": "珠晖区",
                        "center": {
                            "lng": 112.620653,
                            "lat": 26.894796
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430408",
                        "name": "蒸湘区",
                        "center": {
                            "lng": 112.567333,
                            "lat": 26.912388
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430482",
                        "name": "常宁市",
                        "center": {
                            "lng": 112.399894,
                            "lat": 26.421717
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430424",
                        "name": "衡东县",
                        "center": {
                            "lng": 112.953113,
                            "lat": 27.081086
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430426",
                        "name": "祁东县",
                        "center": {
                            "lng": 112.090319,
                            "lat": 26.799284
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430481",
                        "name": "耒阳市",
                        "center": {
                            "lng": 112.859806,
                            "lat": 26.422149
                        }
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430422",
                        "name": "衡南县",
                        "center": {
                            "lng": 112.677572,
                            "lat": 26.739665
                        }
                    }
                ]
            },
            {
                "citycode": "0732",
                "adcode": "430300",
                "name": "湘潭市",
                "center": {
                    "lng": 112.945439,
                    "lat": 27.83136
                },
                "districtList": [
                    {
                        "citycode": "0732",
                        "adcode": "430304",
                        "name": "岳塘区",
                        "center": {
                            "lng": 112.969444,
                            "lat": 27.872013
                        }
                    },
                    {
                        "citycode": "0732",
                        "adcode": "430302",
                        "name": "雨湖区",
                        "center": {
                            "lng": 112.907334,
                            "lat": 27.856115
                        }
                    },
                    {
                        "citycode": "0732",
                        "adcode": "430382",
                        "name": "韶山市",
                        "center": {
                            "lng": 112.525364,
                            "lat": 27.914796
                        }
                    },
                    {
                        "citycode": "0732",
                        "adcode": "430321",
                        "name": "湘潭县",
                        "center": {
                            "lng": 112.950767,
                            "lat": 27.779669
                        }
                    },
                    {
                        "citycode": "0732",
                        "adcode": "430381",
                        "name": "湘乡市",
                        "center": {
                            "lng": 112.550268,
                            "lat": 27.718655
                        }
                    }
                ]
            },
            {
                "citycode": "0746",
                "adcode": "431100",
                "name": "永州市",
                "center": {
                    "lng": 111.613482,
                    "lat": 26.419861
                },
                "districtList": [
                    {
                        "citycode": "0746",
                        "adcode": "431122",
                        "name": "东安县",
                        "center": {
                            "lng": 111.315893,
                            "lat": 26.392173
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431103",
                        "name": "冷水滩区",
                        "center": {
                            "lng": 111.592373,
                            "lat": 26.461313
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431102",
                        "name": "零陵区",
                        "center": {
                            "lng": 111.629806,
                            "lat": 26.222278
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431126",
                        "name": "宁远县",
                        "center": {
                            "lng": 111.945925,
                            "lat": 25.570817
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431128",
                        "name": "新田县",
                        "center": {
                            "lng": 112.203396,
                            "lat": 25.903965
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431123",
                        "name": "双牌县",
                        "center": {
                            "lng": 111.659967,
                            "lat": 25.961909
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431125",
                        "name": "江永县",
                        "center": {
                            "lng": 111.343543,
                            "lat": 25.274461
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431124",
                        "name": "道县",
                        "center": {
                            "lng": 111.600866,
                            "lat": 25.526282
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431129",
                        "name": "江华瑶族自治县",
                        "center": {
                            "lng": 111.57951,
                            "lat": 25.185257
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431181",
                        "name": "祁阳市",
                        "center": {
                            "lng": 111.840253,
                            "lat": 26.580292
                        }
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431127",
                        "name": "蓝山县",
                        "center": {
                            "lng": 112.195842,
                            "lat": 25.369575
                        }
                    }
                ]
            },
            {
                "citycode": "0735",
                "adcode": "431000",
                "name": "郴州市",
                "center": {
                    "lng": 113.015517,
                    "lat": 25.770117
                },
                "districtList": [
                    {
                        "citycode": "0735",
                        "adcode": "431081",
                        "name": "资兴市",
                        "center": {
                            "lng": 113.235841,
                            "lat": 25.977226
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431027",
                        "name": "桂东县",
                        "center": {
                            "lng": 113.944792,
                            "lat": 26.077609
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431025",
                        "name": "临武县",
                        "center": {
                            "lng": 112.563833,
                            "lat": 25.276459
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431003",
                        "name": "苏仙区",
                        "center": {
                            "lng": 113.042364,
                            "lat": 25.799624
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431023",
                        "name": "永兴县",
                        "center": {
                            "lng": 113.116587,
                            "lat": 26.127155
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431024",
                        "name": "嘉禾县",
                        "center": {
                            "lng": 112.379216,
                            "lat": 25.616025
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431028",
                        "name": "安仁县",
                        "center": {
                            "lng": 113.269703,
                            "lat": 26.708569
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431002",
                        "name": "北湖区",
                        "center": {
                            "lng": 113.010606,
                            "lat": 25.784632
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431021",
                        "name": "桂阳县",
                        "center": {
                            "lng": 112.733804,
                            "lat": 25.75382
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431026",
                        "name": "汝城县",
                        "center": {
                            "lng": 113.685193,
                            "lat": 25.533024
                        }
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431022",
                        "name": "宜章县",
                        "center": {
                            "lng": 112.948806,
                            "lat": 25.40059
                        }
                    }
                ]
            },
            {
                "citycode": "0733",
                "adcode": "430200",
                "name": "株洲市",
                "center": {
                    "lng": 113.132783,
                    "lat": 27.828862
                },
                "districtList": [
                    {
                        "citycode": "0733",
                        "adcode": "430202",
                        "name": "荷塘区",
                        "center": {
                            "lng": 113.173169,
                            "lat": 27.856314
                        }
                    },
                    {
                        "citycode": "0733",
                        "adcode": "430223",
                        "name": "攸县",
                        "center": {
                            "lng": 113.397152,
                            "lat": 27.01516
                        }
                    },
                    {
                        "citycode": "0733",
                        "adcode": "430225",
                        "name": "炎陵县",
                        "center": {
                            "lng": 113.772665,
                            "lat": 26.489847
                        }
                    },
                    {
                        "citycode": "0733",
                        "adcode": "430211",
                        "name": "天元区",
                        "center": {
                            "lng": 113.082227,
                            "lat": 27.826738
                        }
                    },
                    {
                        "citycode": "0733",
                        "adcode": "430212",
                        "name": "渌口区",
                        "center": {
                            "lng": 113.143832,
                            "lat": 27.699361
                        }
                    },
                    {
                        "citycode": "0733",
                        "adcode": "430203",
                        "name": "芦淞区",
                        "center": {
                            "lng": 113.153455,
                            "lat": 27.785198
                        }
                    },
                    {
                        "citycode": "0733",
                        "adcode": "430204",
                        "name": "石峰区",
                        "center": {
                            "lng": 113.117763,
                            "lat": 27.875513
                        }
                    },
                    {
                        "citycode": "0733",
                        "adcode": "430224",
                        "name": "茶陵县",
                        "center": {
                            "lng": 113.537907,
                            "lat": 26.777957
                        }
                    },
                    {
                        "citycode": "0733",
                        "adcode": "430281",
                        "name": "醴陵市",
                        "center": {
                            "lng": 113.497119,
                            "lat": 27.6457
                        }
                    }
                ]
            },
            {
                "citycode": "0744",
                "adcode": "430800",
                "name": "张家界市",
                "center": {
                    "lng": 110.478887,
                    "lat": 29.117343
                },
                "districtList": [
                    {
                        "citycode": "0744",
                        "adcode": "430802",
                        "name": "永定区",
                        "center": {
                            "lng": 110.537379,
                            "lat": 29.119662
                        }
                    },
                    {
                        "citycode": "0744",
                        "adcode": "430822",
                        "name": "桑植县",
                        "center": {
                            "lng": 110.204804,
                            "lat": 29.414112
                        }
                    },
                    {
                        "citycode": "0744",
                        "adcode": "430811",
                        "name": "武陵源区",
                        "center": {
                            "lng": 110.550309,
                            "lat": 29.345721
                        }
                    },
                    {
                        "citycode": "0744",
                        "adcode": "430821",
                        "name": "慈利县",
                        "center": {
                            "lng": 111.139424,
                            "lat": 29.430429
                        }
                    }
                ]
            },
            {
                "citycode": "0736",
                "adcode": "430700",
                "name": "常德市",
                "center": {
                    "lng": 111.69905,
                    "lat": 29.031446
                },
                "districtList": [
                    {
                        "citycode": "0736",
                        "adcode": "430703",
                        "name": "鼎城区",
                        "center": {
                            "lng": 111.679896,
                            "lat": 29.017596
                        }
                    },
                    {
                        "citycode": "0736",
                        "adcode": "430723",
                        "name": "澧县",
                        "center": {
                            "lng": 111.758806,
                            "lat": 29.633138
                        }
                    },
                    {
                        "citycode": "0736",
                        "adcode": "430781",
                        "name": "津市市",
                        "center": {
                            "lng": 111.877957,
                            "lat": 29.606512
                        }
                    },
                    {
                        "citycode": "0736",
                        "adcode": "430721",
                        "name": "安乡县",
                        "center": {
                            "lng": 112.171107,
                            "lat": 29.41131
                        }
                    },
                    {
                        "citycode": "0736",
                        "adcode": "430724",
                        "name": "临澧县",
                        "center": {
                            "lng": 111.647547,
                            "lat": 29.440813
                        }
                    },
                    {
                        "citycode": "0736",
                        "adcode": "430702",
                        "name": "武陵区",
                        "center": {
                            "lng": 111.683043,
                            "lat": 29.055332
                        }
                    },
                    {
                        "citycode": "0736",
                        "adcode": "430725",
                        "name": "桃源县",
                        "center": {
                            "lng": 111.488985,
                            "lat": 28.90232
                        }
                    },
                    {
                        "citycode": "0736",
                        "adcode": "430726",
                        "name": "石门县",
                        "center": {
                            "lng": 111.380056,
                            "lat": 29.584344
                        }
                    },
                    {
                        "citycode": "0736",
                        "adcode": "430722",
                        "name": "汉寿县",
                        "center": {
                            "lng": 111.970725,
                            "lat": 28.906063
                        }
                    }
                ]
            },
            {
                "citycode": "0731",
                "adcode": "430100",
                "name": "长沙市",
                "center": {
                    "lng": 112.938882,
                    "lat": 28.228304
                },
                "districtList": [
                    {
                        "citycode": "0731",
                        "adcode": "430104",
                        "name": "岳麓区",
                        "center": {
                            "lng": 112.930116,
                            "lat": 28.234202
                        }
                    },
                    {
                        "citycode": "0731",
                        "adcode": "430121",
                        "name": "长沙县",
                        "center": {
                            "lng": 113.080555,
                            "lat": 28.246821
                        }
                    },
                    {
                        "citycode": "0731",
                        "adcode": "430102",
                        "name": "芙蓉区",
                        "center": {
                            "lng": 113.032605,
                            "lat": 28.185351
                        }
                    },
                    {
                        "citycode": "0731",
                        "adcode": "430103",
                        "name": "天心区",
                        "center": {
                            "lng": 112.98978,
                            "lat": 28.114544
                        }
                    },
                    {
                        "citycode": "0731",
                        "adcode": "430111",
                        "name": "雨花区",
                        "center": {
                            "lng": 113.03853,
                            "lat": 28.135795
                        }
                    },
                    {
                        "citycode": "0731",
                        "adcode": "430181",
                        "name": "浏阳市",
                        "center": {
                            "lng": 113.64328,
                            "lat": 28.163866
                        }
                    },
                    {
                        "citycode": "0731",
                        "adcode": "430182",
                        "name": "宁乡市",
                        "center": {
                            "lng": 112.551887,
                            "lat": 28.277709
                        }
                    },
                    {
                        "citycode": "0731",
                        "adcode": "430112",
                        "name": "望城区",
                        "center": {
                            "lng": 112.83125,
                            "lat": 28.353221
                        }
                    },
                    {
                        "citycode": "0731",
                        "adcode": "430105",
                        "name": "开福区",
                        "center": {
                            "lng": 112.985284,
                            "lat": 28.257286
                        }
                    }
                ]
            },
            {
                "citycode": "0739",
                "adcode": "430500",
                "name": "邵阳市",
                "center": {
                    "lng": 111.467855,
                    "lat": 27.239528
                },
                "districtList": [
                    {
                        "citycode": "0739",
                        "adcode": "430524",
                        "name": "隆回县",
                        "center": {
                            "lng": 111.032437,
                            "lat": 27.113978
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430502",
                        "name": "双清区",
                        "center": {
                            "lng": 111.496946,
                            "lat": 27.232286
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430511",
                        "name": "北塔区",
                        "center": {
                            "lng": 111.451988,
                            "lat": 27.246244
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430523",
                        "name": "邵阳县",
                        "center": {
                            "lng": 111.273872,
                            "lat": 26.990785
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430503",
                        "name": "大祥区",
                        "center": {
                            "lng": 111.438892,
                            "lat": 27.222078
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430527",
                        "name": "绥宁县",
                        "center": {
                            "lng": 110.155532,
                            "lat": 26.582027
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430582",
                        "name": "邵东市",
                        "center": {
                            "lng": 111.744268,
                            "lat": 27.259812
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430528",
                        "name": "新宁县",
                        "center": {
                            "lng": 110.857294,
                            "lat": 26.432913
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430581",
                        "name": "武冈市",
                        "center": {
                            "lng": 110.632286,
                            "lat": 26.727414
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430525",
                        "name": "洞口县",
                        "center": {
                            "lng": 110.575962,
                            "lat": 27.060274
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430529",
                        "name": "城步苗族自治县",
                        "center": {
                            "lng": 110.322239,
                            "lat": 26.390598
                        }
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430522",
                        "name": "新邵县",
                        "center": {
                            "lng": 111.458656,
                            "lat": 27.320917
                        }
                    }
                ]
            },
            {
                "citycode": "0738",
                "adcode": "431300",
                "name": "娄底市",
                "center": {
                    "lng": 111.994468,
                    "lat": 27.699838
                },
                "districtList": [
                    {
                        "citycode": "0738",
                        "adcode": "431321",
                        "name": "双峰县",
                        "center": {
                            "lng": 112.174623,
                            "lat": 27.457437
                        }
                    },
                    {
                        "citycode": "0738",
                        "adcode": "431302",
                        "name": "娄星区",
                        "center": {
                            "lng": 112.001922,
                            "lat": 27.730208
                        }
                    },
                    {
                        "citycode": "0738",
                        "adcode": "431382",
                        "name": "涟源市",
                        "center": {
                            "lng": 111.663837,
                            "lat": 27.693813
                        }
                    },
                    {
                        "citycode": "0738",
                        "adcode": "431322",
                        "name": "新化县",
                        "center": {
                            "lng": 111.327674,
                            "lat": 27.725416
                        }
                    },
                    {
                        "citycode": "0738",
                        "adcode": "431381",
                        "name": "冷水江市",
                        "center": {
                            "lng": 111.459199,
                            "lat": 27.656017
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "460000",
        "name": "海南省",
        "center": {
            "lng": 110.348781,
            "lat": 20.018639
        },
        "districtList": [
            {
                "citycode": "1896",
                "adcode": "469024",
                "name": "临高县",
                "center": {
                    "lng": 109.690508,
                    "lat": 19.912025
                },
                "districtList": [
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "博厚镇",
                        "center": {
                            "lng": 109.807195,
                            "lat": 19.989365
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "南宝镇",
                        "center": {
                            "lng": 109.638149,
                            "lat": 19.751609
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "和舍镇",
                        "center": {
                            "lng": 109.714907,
                            "lat": 19.671698
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "调楼镇",
                        "center": {
                            "lng": 109.609769,
                            "lat": 19.923138
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "东英镇",
                        "center": {
                            "lng": 109.612973,
                            "lat": 19.934938
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "加来镇",
                        "center": {
                            "lng": 109.650909,
                            "lat": 19.759074
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "临城镇",
                        "center": {
                            "lng": 109.632657,
                            "lat": 19.753184
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "多文镇",
                        "center": {
                            "lng": 109.751742,
                            "lat": 19.67362
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "新盈镇",
                        "center": {
                            "lng": 109.619413,
                            "lat": 19.864946
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "波莲镇",
                        "center": {
                            "lng": 109.614806,
                            "lat": 19.855541
                        }
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "皇桐镇",
                        "center": {
                            "lng": 109.856872,
                            "lat": 19.732264
                        }
                    }
                ]
            },
            {
                "citycode": "0802",
                "adcode": "469025",
                "name": "白沙黎族自治县",
                "center": {
                    "lng": 109.4429,
                    "lat": 19.221641
                },
                "districtList": [
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "南开乡",
                        "center": {
                            "lng": 109.293018,
                            "lat": 19.059602
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "阜龙乡",
                        "center": {
                            "lng": 109.436387,
                            "lat": 19.33165
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "细水乡",
                        "center": {
                            "lng": 109.526636,
                            "lat": 19.201248
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "牙叉镇",
                        "center": {
                            "lng": 109.399183,
                            "lat": 19.138439
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "元门乡",
                        "center": {
                            "lng": 109.449713,
                            "lat": 19.095705
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "打安镇",
                        "center": {
                            "lng": 109.358207,
                            "lat": 19.378075
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "金波乡",
                        "center": {
                            "lng": 109.171689,
                            "lat": 19.276555
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "青松乡",
                        "center": {
                            "lng": 109.293018,
                            "lat": 19.059602
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "七坊镇",
                        "center": {
                            "lng": 109.139587,
                            "lat": 19.311855
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "邦溪镇",
                        "center": {
                            "lng": 109.043497,
                            "lat": 19.419968
                        }
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "荣邦乡",
                        "center": {
                            "lng": 109.047772,
                            "lat": 19.432678
                        }
                    }
                ]
            },
            {
                "citycode": "1892",
                "adcode": "469022",
                "name": "屯昌县",
                "center": {
                    "lng": 110.101667,
                    "lat": 19.351662
                },
                "districtList": [
                    {
                        "citycode": "1892",
                        "adcode": "469022",
                        "name": "坡心镇",
                        "center": {
                            "lng": 110.214429,
                            "lat": 19.310397
                        }
                    },
                    {
                        "citycode": "1892",
                        "adcode": "469022",
                        "name": "南吕镇",
                        "center": {
                            "lng": 110.042989,
                            "lat": 19.268166
                        }
                    },
                    {
                        "citycode": "1892",
                        "adcode": "469022",
                        "name": "屯城镇",
                        "center": {
                            "lng": 110.180636,
                            "lat": 19.319861
                        }
                    },
                    {
                        "citycode": "1892",
                        "adcode": "469022",
                        "name": "新兴镇",
                        "center": {
                            "lng": 110.136198,
                            "lat": 19.558967
                        }
                    },
                    {
                        "citycode": "1892",
                        "adcode": "469022",
                        "name": "枫木镇",
                        "center": {
                            "lng": 109.973395,
                            "lat": 19.190743
                        }
                    },
                    {
                        "citycode": "1892",
                        "adcode": "469022",
                        "name": "南坤镇",
                        "center": {
                            "lng": 110.034905,
                            "lat": 19.407514
                        }
                    },
                    {
                        "citycode": "1892",
                        "adcode": "469022",
                        "name": "乌坡镇",
                        "center": {
                            "lng": 110.083261,
                            "lat": 19.206717
                        }
                    },
                    {
                        "citycode": "1892",
                        "adcode": "469022",
                        "name": "西昌镇",
                        "center": {
                            "lng": 109.953863,
                            "lat": 19.41544
                        }
                    }
                ]
            },
            {
                "citycode": "1898",
                "adcode": "469006",
                "name": "万宁市",
                "center": {
                    "lng": 110.392605,
                    "lat": 18.793697
                },
                "districtList": [
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "后安镇",
                        "center": {
                            "lng": 110.374318,
                            "lat": 18.908719
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "和乐镇",
                        "center": {
                            "lng": 110.41586,
                            "lat": 18.962463
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "东澳镇",
                        "center": {
                            "lng": 110.429479,
                            "lat": 18.640771
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "龙滚镇",
                        "center": {
                            "lng": 110.475633,
                            "lat": 18.993293
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "山根镇",
                        "center": {
                            "lng": 110.451557,
                            "lat": 18.990371
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "南桥镇",
                        "center": {
                            "lng": 110.030918,
                            "lat": 18.747164
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "北大镇",
                        "center": {
                            "lng": 110.418437,
                            "lat": 18.985185
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "三更罗镇",
                        "center": {
                            "lng": 110.113025,
                            "lat": 18.948777
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "大茂镇",
                        "center": {
                            "lng": 110.391696,
                            "lat": 18.876747
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "万城镇",
                        "center": {
                            "lng": 110.412512,
                            "lat": 18.826291
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "礼纪镇",
                        "center": {
                            "lng": 110.265921,
                            "lat": 18.748523
                        }
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "长丰镇",
                        "center": {
                            "lng": 110.281098,
                            "lat": 18.85558
                        }
                    }
                ]
            },
            {
                "citycode": "1894",
                "adcode": "469002",
                "name": "琼海市",
                "center": {
                    "lng": 110.474524,
                    "lat": 19.259112
                },
                "districtList": [
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "长坡镇",
                        "center": {
                            "lng": 110.497644,
                            "lat": 19.427753
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "龙江镇",
                        "center": {
                            "lng": 110.377839,
                            "lat": 19.152396
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "阳江镇",
                        "center": {
                            "lng": 110.343829,
                            "lat": 19.128946
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "石壁镇",
                        "center": {
                            "lng": 110.330819,
                            "lat": 19.151644
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "会山镇",
                        "center": {
                            "lng": 110.153445,
                            "lat": 19.012397
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "中原镇",
                        "center": {
                            "lng": 110.431959,
                            "lat": 19.060809
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "塔洋镇",
                        "center": {
                            "lng": 110.472088,
                            "lat": 19.325894
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "万泉镇",
                        "center": {
                            "lng": 110.414108,
                            "lat": 19.355227
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "潭门镇",
                        "center": {
                            "lng": 110.539051,
                            "lat": 19.210843
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "嘉积镇",
                        "center": {
                            "lng": 110.421334,
                            "lat": 19.291689
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "大路镇",
                        "center": {
                            "lng": 110.529076,
                            "lat": 19.373803
                        }
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "博鳌镇",
                        "center": {
                            "lng": 110.492863,
                            "lat": 19.177047
                        }
                    }
                ]
            },
            {
                "citycode": "1899",
                "adcode": "469030",
                "name": "琼中黎族苗族自治县",
                "center": {
                    "lng": 109.838423,
                    "lat": 19.03327
                },
                "districtList": [
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "什运乡",
                        "center": {
                            "lng": 109.583026,
                            "lat": 18.923692
                        }
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "黎母山镇",
                        "center": {
                            "lng": 109.824353,
                            "lat": 19.190837
                        }
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "湾岭镇",
                        "center": {
                            "lng": 109.865175,
                            "lat": 19.096504
                        }
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "红毛镇",
                        "center": {
                            "lng": 109.608031,
                            "lat": 19.033716
                        }
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "和平镇",
                        "center": {
                            "lng": 110.052562,
                            "lat": 18.755917
                        }
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "中平镇",
                        "center": {
                            "lng": 110.032689,
                            "lat": 18.966494
                        }
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "上安乡",
                        "center": {
                            "lng": 109.712993,
                            "lat": 18.899738
                        }
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "吊罗山乡",
                        "center": {
                            "lng": 109.930063,
                            "lat": 18.865272
                        }
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "长征镇",
                        "center": {
                            "lng": 109.793068,
                            "lat": 18.896296
                        }
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "营根镇",
                        "center": {
                            "lng": 109.930582,
                            "lat": 19.089045
                        }
                    }
                ]
            },
            {
                "citycode": "0807",
                "adcode": "469007",
                "name": "东方市",
                "center": {
                    "lng": 108.651829,
                    "lat": 19.095187
                },
                "districtList": [
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "大田镇",
                        "center": {
                            "lng": 108.771554,
                            "lat": 19.042603
                        }
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "三家镇",
                        "center": {
                            "lng": 108.833188,
                            "lat": 19.259935
                        }
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "四更镇",
                        "center": {
                            "lng": 108.596055,
                            "lat": 19.187648
                        }
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "新龙镇",
                        "center": {
                            "lng": 108.678972,
                            "lat": 19.017898
                        }
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "八所镇",
                        "center": {
                            "lng": 108.780679,
                            "lat": 19.124742
                        }
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "感城镇",
                        "center": {
                            "lng": 108.787859,
                            "lat": 18.842201
                        }
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "天安乡",
                        "center": {
                            "lng": 108.804715,
                            "lat": 18.97548
                        }
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "板桥镇",
                        "center": {
                            "lng": 108.910695,
                            "lat": 18.807162
                        }
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "东河镇",
                        "center": {
                            "lng": 109.015044,
                            "lat": 19.084384
                        }
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "江边乡",
                        "center": {
                            "lng": 109.091697,
                            "lat": 18.906129
                        }
                    }
                ]
            },
            {
                "citycode": "0809",
                "adcode": "469028",
                "name": "陵水黎族自治县",
                "center": {
                    "lng": 110.037553,
                    "lat": 18.506045
                },
                "districtList": [
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "椰林镇",
                        "center": {
                            "lng": 110.01969,
                            "lat": 18.482546
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "文罗镇",
                        "center": {
                            "lng": 109.914457,
                            "lat": 18.573364
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "新村镇",
                        "center": {
                            "lng": 110.026125,
                            "lat": 18.445965
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "黎安镇",
                        "center": {
                            "lng": 110.027365,
                            "lat": 18.450385
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "群英乡",
                        "center": {
                            "lng": 109.847456,
                            "lat": 18.569653
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "提蒙乡",
                        "center": {
                            "lng": 110.013235,
                            "lat": 18.640359
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "隆广镇",
                        "center": {
                            "lng": 109.857549,
                            "lat": 18.480188
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "三才镇",
                        "center": {
                            "lng": 109.963149,
                            "lat": 18.491519
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "本号镇",
                        "center": {
                            "lng": 109.83713,
                            "lat": 18.632318
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "英州镇",
                        "center": {
                            "lng": 109.875526,
                            "lat": 18.473898
                        }
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "光坡镇",
                        "center": {
                            "lng": 110.036496,
                            "lat": 18.559416
                        }
                    }
                ]
            },
            {
                "citycode": "2802",
                "adcode": "469027",
                "name": "乐东黎族自治县",
                "center": {
                    "lng": 109.173384,
                    "lat": 18.750063
                },
                "districtList": [
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "莺歌海镇",
                        "center": {
                            "lng": 108.7546,
                            "lat": 18.546375
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "黄流镇",
                        "center": {
                            "lng": 108.804819,
                            "lat": 18.594264
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "利国镇",
                        "center": {
                            "lng": 108.938223,
                            "lat": 18.495361
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "万冲镇",
                        "center": {
                            "lng": 109.33172,
                            "lat": 18.913271
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "佛罗镇",
                        "center": {
                            "lng": 108.789451,
                            "lat": 18.579735
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "尖峰镇",
                        "center": {
                            "lng": 108.843833,
                            "lat": 18.624901
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "大安镇",
                        "center": {
                            "lng": 109.231993,
                            "lat": 18.734953
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "千家镇",
                        "center": {
                            "lng": 109.149747,
                            "lat": 18.465259
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "九所镇",
                        "center": {
                            "lng": 109.080605,
                            "lat": 18.45065
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "抱由镇",
                        "center": {
                            "lng": 109.027958,
                            "lat": 18.797154
                        }
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "志仲镇",
                        "center": {
                            "lng": 109.38681,
                            "lat": 18.60959
                        }
                    }
                ]
            },
            {
                "citycode": "2898",
                "adcode": "460300",
                "name": "三沙市",
                "center": {
                    "lng": 112.338649,
                    "lat": 16.831004
                },
                "districtList": [
                    {
                        "citycode": "2898",
                        "adcode": "460302",
                        "name": "南沙区",
                        "center": {
                            "lng": 112.896229,
                            "lat": 9.548531
                        }
                    },
                    {
                        "citycode": "2898",
                        "adcode": "460301",
                        "name": "西沙区",
                        "center": {
                            "lng": 112.346961,
                            "lat": 16.834372
                        }
                    }
                ]
            },
            {
                "citycode": "1893",
                "adcode": "469005",
                "name": "文昌市",
                "center": {
                    "lng": 110.797473,
                    "lat": 19.544234
                },
                "districtList": [
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "文教镇",
                        "center": {
                            "lng": 110.855856,
                            "lat": 19.70832
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "铺前镇",
                        "center": {
                            "lng": 110.675271,
                            "lat": 20.037734
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "龙楼镇",
                        "center": {
                            "lng": 110.938472,
                            "lat": 19.660636
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "东郊镇",
                        "center": {
                            "lng": 110.910447,
                            "lat": 19.629115
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "昌洒镇",
                        "center": {
                            "lng": 110.89478,
                            "lat": 19.826152
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "锦山镇",
                        "center": {
                            "lng": 110.664,
                            "lat": 20.027062
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "文城镇",
                        "center": {
                            "lng": 110.702595,
                            "lat": 19.503784
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "潭牛镇",
                        "center": {
                            "lng": 110.773474,
                            "lat": 19.744417
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "公坡镇",
                        "center": {
                            "lng": 110.826694,
                            "lat": 19.852259
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "东路镇",
                        "center": {
                            "lng": 110.716883,
                            "lat": 19.7226
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "蓬莱镇",
                        "center": {
                            "lng": 110.509637,
                            "lat": 19.558919
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "抱罗镇",
                        "center": {
                            "lng": 110.739711,
                            "lat": 19.888896
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "翁田镇",
                        "center": {
                            "lng": 110.808995,
                            "lat": 19.920147
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "东阁镇",
                        "center": {
                            "lng": 110.855599,
                            "lat": 19.705977
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "冯坡镇",
                        "center": {
                            "lng": 110.79095,
                            "lat": 20.028869
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "重兴镇",
                        "center": {
                            "lng": 110.569437,
                            "lat": 19.477879
                        }
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "会文镇",
                        "center": {
                            "lng": 110.722572,
                            "lat": 19.484181
                        }
                    }
                ]
            },
            {
                "citycode": "0899",
                "adcode": "460200",
                "name": "三亚市",
                "center": {
                    "lng": 109.511709,
                    "lat": 18.252865
                },
                "districtList": [
                    {
                        "citycode": "0899",
                        "adcode": "460205",
                        "name": "崖州区",
                        "center": {
                            "lng": 109.172298,
                            "lat": 18.357572
                        }
                    },
                    {
                        "citycode": "0899",
                        "adcode": "460202",
                        "name": "海棠区",
                        "center": {
                            "lng": 109.735676,
                            "lat": 18.384177
                        }
                    },
                    {
                        "citycode": "0899",
                        "adcode": "460204",
                        "name": "天涯区",
                        "center": {
                            "lng": 109.452325,
                            "lat": 18.298975
                        }
                    },
                    {
                        "citycode": "0899",
                        "adcode": "460203",
                        "name": "吉阳区",
                        "center": {
                            "lng": 109.578238,
                            "lat": 18.28146
                        }
                    }
                ]
            },
            {
                "citycode": "0805",
                "adcode": "460400",
                "name": "儋州市",
                "center": {
                    "lng": 109.580812,
                    "lat": 19.520948
                },
                "districtList": [
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "光村镇",
                        "center": {
                            "lng": 109.46734,
                            "lat": 19.903531
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "新州镇",
                        "center": {
                            "lng": 109.320933,
                            "lat": 19.752347
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "海头镇",
                        "center": {
                            "lng": 109.028046,
                            "lat": 19.432317
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "中和镇",
                        "center": {
                            "lng": 109.351017,
                            "lat": 19.774675
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "峨蔓镇",
                        "center": {
                            "lng": 109.332639,
                            "lat": 19.843794
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "三都镇",
                        "center": {
                            "lng": 109.204266,
                            "lat": 19.83005
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "木棠镇",
                        "center": {
                            "lng": 109.346666,
                            "lat": 19.900381
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "排浦镇",
                        "center": {
                            "lng": 109.219523,
                            "lat": 19.631492
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "王五镇",
                        "center": {
                            "lng": 109.277591,
                            "lat": 19.624562
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "白马井镇",
                        "center": {
                            "lng": 109.232173,
                            "lat": 19.580719
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "兰洋镇",
                        "center": {
                            "lng": 109.73577,
                            "lat": 19.40836
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "那大镇",
                        "center": {
                            "lng": 109.559561,
                            "lat": 19.50011
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "大成镇",
                        "center": {
                            "lng": 109.371806,
                            "lat": 19.478206
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "东成镇",
                        "center": {
                            "lng": 109.597935,
                            "lat": 19.726594
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "雅星镇",
                        "center": {
                            "lng": 109.305133,
                            "lat": 19.393438
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "和庆镇",
                        "center": {
                            "lng": 109.739681,
                            "lat": 19.587333
                        }
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "南丰镇",
                        "center": {
                            "lng": 109.543297,
                            "lat": 19.504378
                        }
                    }
                ]
            },
            {
                "citycode": "0801",
                "adcode": "469029",
                "name": "保亭黎族苗族自治县",
                "center": {
                    "lng": 109.700279,
                    "lat": 18.640339
                },
                "districtList": [
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "南林乡",
                        "center": {
                            "lng": 109.576563,
                            "lat": 18.389262
                        }
                    },
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "毛感乡",
                        "center": {
                            "lng": 109.503131,
                            "lat": 18.556288
                        }
                    },
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "六弓乡",
                        "center": {
                            "lng": 109.74474,
                            "lat": 18.574041
                        }
                    },
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "什玲镇",
                        "center": {
                            "lng": 109.736545,
                            "lat": 18.697785
                        }
                    },
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "保城镇",
                        "center": {
                            "lng": 109.773883,
                            "lat": 18.600774
                        }
                    },
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "新政镇",
                        "center": {
                            "lng": 109.603989,
                            "lat": 18.435464
                        }
                    },
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "响水镇",
                        "center": {
                            "lng": 109.550646,
                            "lat": 18.610753
                        }
                    },
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "三道镇",
                        "center": {
                            "lng": 109.702909,
                            "lat": 18.430953
                        }
                    },
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "加茂镇",
                        "center": {
                            "lng": 109.674549,
                            "lat": 18.516922
                        }
                    }
                ]
            },
            {
                "citycode": "1897",
                "adcode": "469001",
                "name": "五指山市",
                "center": {
                    "lng": 109.516784,
                    "lat": 18.774827
                },
                "districtList": [
                    {
                        "citycode": "1897",
                        "adcode": "469001",
                        "name": "毛阳镇",
                        "center": {
                            "lng": 109.449705,
                            "lat": 18.881089
                        }
                    },
                    {
                        "citycode": "1897",
                        "adcode": "469001",
                        "name": "毛道乡",
                        "center": {
                            "lng": 109.356022,
                            "lat": 18.713388
                        }
                    },
                    {
                        "citycode": "1897",
                        "adcode": "469001",
                        "name": "水满乡",
                        "center": {
                            "lng": 109.600698,
                            "lat": 18.899478
                        }
                    },
                    {
                        "citycode": "1897",
                        "adcode": "469001",
                        "name": "番阳镇",
                        "center": {
                            "lng": 109.333537,
                            "lat": 18.913174
                        }
                    },
                    {
                        "citycode": "1897",
                        "adcode": "469001",
                        "name": "南圣镇",
                        "center": {
                            "lng": 109.684604,
                            "lat": 18.822608
                        }
                    },
                    {
                        "citycode": "1897",
                        "adcode": "469001",
                        "name": "畅好乡",
                        "center": {
                            "lng": 109.383431,
                            "lat": 18.682307
                        }
                    },
                    {
                        "citycode": "1897",
                        "adcode": "469001",
                        "name": "通什镇",
                        "center": {
                            "lng": 109.623006,
                            "lat": 18.822353
                        }
                    }
                ]
            },
            {
                "citycode": "0803",
                "adcode": "469026",
                "name": "昌江黎族自治县",
                "center": {
                    "lng": 109.055783,
                    "lat": 19.298139
                },
                "districtList": [
                    {
                        "citycode": "0803",
                        "adcode": "469026",
                        "name": "乌烈镇",
                        "center": {
                            "lng": 108.809852,
                            "lat": 19.352543
                        }
                    },
                    {
                        "citycode": "0803",
                        "adcode": "469026",
                        "name": "石碌镇",
                        "center": {
                            "lng": 108.997547,
                            "lat": 19.244929
                        }
                    },
                    {
                        "citycode": "0803",
                        "adcode": "469026",
                        "name": "叉河镇",
                        "center": {
                            "lng": 108.997547,
                            "lat": 19.244929
                        }
                    },
                    {
                        "citycode": "0803",
                        "adcode": "469026",
                        "name": "昌化镇",
                        "center": {
                            "lng": 108.73172,
                            "lat": 19.383636
                        }
                    },
                    {
                        "citycode": "0803",
                        "adcode": "469026",
                        "name": "王下乡",
                        "center": {
                            "lng": 109.094025,
                            "lat": 18.905182
                        }
                    },
                    {
                        "citycode": "0803",
                        "adcode": "469026",
                        "name": "十月田镇",
                        "center": {
                            "lng": 108.842173,
                            "lat": 19.252501
                        }
                    },
                    {
                        "citycode": "0803",
                        "adcode": "469026",
                        "name": "七叉镇",
                        "center": {
                            "lng": 109.077512,
                            "lat": 19.190357
                        }
                    },
                    {
                        "citycode": "0803",
                        "adcode": "469026",
                        "name": "海尾镇",
                        "center": {
                            "lng": 108.952319,
                            "lat": 19.494543
                        }
                    }
                ]
            },
            {
                "citycode": "0806",
                "adcode": "469021",
                "name": "定安县",
                "center": {
                    "lng": 110.358001,
                    "lat": 19.681215
                },
                "districtList": [
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "岭口镇",
                        "center": {
                            "lng": 110.276026,
                            "lat": 19.360104
                        }
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "龙门镇",
                        "center": {
                            "lng": 110.297826,
                            "lat": 19.499676
                        }
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "定城镇",
                        "center": {
                            "lng": 110.317065,
                            "lat": 19.701678
                        }
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "新竹镇",
                        "center": {
                            "lng": 110.165312,
                            "lat": 19.577271
                        }
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "雷鸣镇",
                        "center": {
                            "lng": 110.30053,
                            "lat": 19.498361
                        }
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "黄竹镇",
                        "center": {
                            "lng": 110.348146,
                            "lat": 19.445919
                        }
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "龙湖镇",
                        "center": {
                            "lng": 110.401131,
                            "lat": 19.606699
                        }
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "龙河镇",
                        "center": {
                            "lng": 110.258715,
                            "lat": 19.361056
                        }
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "富文镇",
                        "center": {
                            "lng": 110.223762,
                            "lat": 19.422974
                        }
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "翰林镇",
                        "center": {
                            "lng": 110.28587,
                            "lat": 19.349021
                        }
                    }
                ]
            },
            {
                "citycode": "0804",
                "adcode": "469023",
                "name": "澄迈县",
                "center": {
                    "lng": 110.007497,
                    "lat": 19.738885
                },
                "districtList": [
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "老城镇",
                        "center": {
                            "lng": 110.152799,
                            "lat": 19.872233
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "瑞溪镇",
                        "center": {
                            "lng": 110.111302,
                            "lat": 19.789006
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "大丰镇",
                        "center": {
                            "lng": 109.988855,
                            "lat": 19.904039
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "加乐镇",
                        "center": {
                            "lng": 110.061273,
                            "lat": 19.617646
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "仁兴镇",
                        "center": {
                            "lng": 109.776963,
                            "lat": 19.382054
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "中兴镇",
                        "center": {
                            "lng": 109.760023,
                            "lat": 19.528937
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "金江镇",
                        "center": {
                            "lng": 109.976112,
                            "lat": 19.774256
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "福山镇",
                        "center": {
                            "lng": 109.919175,
                            "lat": 19.929023
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "桥头镇",
                        "center": {
                            "lng": 109.936766,
                            "lat": 19.914013
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "文儒镇",
                        "center": {
                            "lng": 110.134745,
                            "lat": 19.633652
                        }
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "永发镇",
                        "center": {
                            "lng": 110.186668,
                            "lat": 19.641706
                        }
                    }
                ]
            },
            {
                "citycode": "0898",
                "adcode": "460100",
                "name": "海口市",
                "center": {
                    "lng": 110.198418,
                    "lat": 20.045805
                },
                "districtList": [
                    {
                        "citycode": "0898",
                        "adcode": "460108",
                        "name": "美兰区",
                        "center": {
                            "lng": 110.366359,
                            "lat": 20.028983
                        }
                    },
                    {
                        "citycode": "0898",
                        "adcode": "460107",
                        "name": "琼山区",
                        "center": {
                            "lng": 110.384318,
                            "lat": 19.984293
                        }
                    },
                    {
                        "citycode": "0898",
                        "adcode": "460106",
                        "name": "龙华区",
                        "center": {
                            "lng": 110.328628,
                            "lat": 20.030843
                        }
                    },
                    {
                        "citycode": "0898",
                        "adcode": "460105",
                        "name": "秀英区",
                        "center": {
                            "lng": 110.293566,
                            "lat": 20.007703
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "320000",
        "name": "江苏省",
        "center": {
            "lng": 118.763563,
            "lat": 32.061377
        },
        "districtList": [
            {
                "citycode": "0518",
                "adcode": "320700",
                "name": "连云港市",
                "center": {
                    "lng": 119.221487,
                    "lat": 34.596639
                },
                "districtList": [
                    {
                        "citycode": "0518",
                        "adcode": "320724",
                        "name": "灌南县",
                        "center": {
                            "lng": 119.315583,
                            "lat": 34.087251
                        }
                    },
                    {
                        "citycode": "0518",
                        "adcode": "320707",
                        "name": "赣榆区",
                        "center": {
                            "lng": 119.173173,
                            "lat": 34.841336
                        }
                    },
                    {
                        "citycode": "0518",
                        "adcode": "320703",
                        "name": "连云区",
                        "center": {
                            "lng": 119.338901,
                            "lat": 34.760317
                        }
                    },
                    {
                        "citycode": "0518",
                        "adcode": "320723",
                        "name": "灌云县",
                        "center": {
                            "lng": 119.239426,
                            "lat": 34.284074
                        }
                    },
                    {
                        "citycode": "0518",
                        "adcode": "320706",
                        "name": "海州区",
                        "center": {
                            "lng": 119.163492,
                            "lat": 34.572506
                        }
                    },
                    {
                        "citycode": "0518",
                        "adcode": "320722",
                        "name": "东海县",
                        "center": {
                            "lng": 118.752869,
                            "lat": 34.542194
                        }
                    }
                ]
            },
            {
                "citycode": "0513",
                "adcode": "320600",
                "name": "南通市",
                "center": {
                    "lng": 120.894522,
                    "lat": 31.981269
                },
                "districtList": [
                    {
                        "citycode": "0513",
                        "adcode": "320623",
                        "name": "如东县",
                        "center": {
                            "lng": 121.18495,
                            "lat": 32.331584
                        }
                    },
                    {
                        "citycode": "0513",
                        "adcode": "320613",
                        "name": "崇川区",
                        "center": {
                            "lng": 120.857253,
                            "lat": 32.010277
                        }
                    },
                    {
                        "citycode": "0513",
                        "adcode": "320681",
                        "name": "启东市",
                        "center": {
                            "lng": 121.65523,
                            "lat": 31.792831
                        }
                    },
                    {
                        "citycode": "0513",
                        "adcode": "320612",
                        "name": "通州区",
                        "center": {
                            "lng": 121.073742,
                            "lat": 32.065972
                        }
                    },
                    {
                        "citycode": "0513",
                        "adcode": "320614",
                        "name": "海门区",
                        "center": {
                            "lng": 121.182016,
                            "lat": 31.869418
                        }
                    },
                    {
                        "citycode": "0513",
                        "adcode": "320682",
                        "name": "如皋市",
                        "center": {
                            "lng": 120.574028,
                            "lat": 32.371493
                        }
                    },
                    {
                        "citycode": "0513",
                        "adcode": "320685",
                        "name": "海安市",
                        "center": {
                            "lng": 120.46779,
                            "lat": 32.532853
                        }
                    }
                ]
            },
            {
                "citycode": "0527",
                "adcode": "321300",
                "name": "宿迁市",
                "center": {
                    "lng": 118.275228,
                    "lat": 33.963186
                },
                "districtList": [
                    {
                        "citycode": "0527",
                        "adcode": "321323",
                        "name": "泗阳县",
                        "center": {
                            "lng": 118.703636,
                            "lat": 33.723576
                        }
                    },
                    {
                        "citycode": "0527",
                        "adcode": "321324",
                        "name": "泗洪县",
                        "center": {
                            "lng": 118.223941,
                            "lat": 33.476575
                        }
                    },
                    {
                        "citycode": "0527",
                        "adcode": "321311",
                        "name": "宿豫区",
                        "center": {
                            "lng": 118.330423,
                            "lat": 33.94813
                        }
                    },
                    {
                        "citycode": "0527",
                        "adcode": "321302",
                        "name": "宿城区",
                        "center": {
                            "lng": 118.242048,
                            "lat": 33.963891
                        }
                    },
                    {
                        "citycode": "0527",
                        "adcode": "321322",
                        "name": "沭阳县",
                        "center": {
                            "lng": 118.804321,
                            "lat": 34.110642
                        }
                    }
                ]
            },
            {
                "citycode": "0517",
                "adcode": "320800",
                "name": "淮安市",
                "center": {
                    "lng": 119.113166,
                    "lat": 33.551495
                },
                "districtList": [
                    {
                        "citycode": "0517",
                        "adcode": "320804",
                        "name": "淮阴区",
                        "center": {
                            "lng": 119.034895,
                            "lat": 33.632588
                        }
                    },
                    {
                        "citycode": "0517",
                        "adcode": "320830",
                        "name": "盱眙县",
                        "center": {
                            "lng": 118.544545,
                            "lat": 33.011905
                        }
                    },
                    {
                        "citycode": "0517",
                        "adcode": "320826",
                        "name": "涟水县",
                        "center": {
                            "lng": 119.260589,
                            "lat": 33.781648
                        }
                    },
                    {
                        "citycode": "0517",
                        "adcode": "320831",
                        "name": "金湖县",
                        "center": {
                            "lng": 119.020432,
                            "lat": 33.024663
                        }
                    },
                    {
                        "citycode": "0517",
                        "adcode": "320813",
                        "name": "洪泽区",
                        "center": {
                            "lng": 118.873132,
                            "lat": 33.294095
                        }
                    },
                    {
                        "citycode": "0517",
                        "adcode": "320812",
                        "name": "清江浦区",
                        "center": {
                            "lng": 119.026662,
                            "lat": 33.552579
                        }
                    },
                    {
                        "citycode": "0517",
                        "adcode": "320803",
                        "name": "淮安区",
                        "center": {
                            "lng": 119.141183,
                            "lat": 33.50296
                        }
                    }
                ]
            },
            {
                "citycode": "0511",
                "adcode": "321100",
                "name": "镇江市",
                "center": {
                    "lng": 119.424441,
                    "lat": 32.188141
                },
                "districtList": [
                    {
                        "citycode": "0511",
                        "adcode": "321182",
                        "name": "扬中市",
                        "center": {
                            "lng": 119.796816,
                            "lat": 32.236476
                        }
                    },
                    {
                        "citycode": "0511",
                        "adcode": "321111",
                        "name": "润州区",
                        "center": {
                            "lng": 119.411383,
                            "lat": 32.195146
                        }
                    },
                    {
                        "citycode": "0511",
                        "adcode": "321112",
                        "name": "丹徒区",
                        "center": {
                            "lng": 119.433854,
                            "lat": 32.132118
                        }
                    },
                    {
                        "citycode": "0511",
                        "adcode": "321183",
                        "name": "句容市",
                        "center": {
                            "lng": 119.168693,
                            "lat": 31.945732
                        }
                    },
                    {
                        "citycode": "0511",
                        "adcode": "321181",
                        "name": "丹阳市",
                        "center": {
                            "lng": 119.606071,
                            "lat": 32.010035
                        }
                    },
                    {
                        "citycode": "0511",
                        "adcode": "321102",
                        "name": "京口区",
                        "center": {
                            "lng": 119.470186,
                            "lat": 32.198285
                        }
                    }
                ]
            },
            {
                "citycode": "025",
                "adcode": "320100",
                "name": "南京市",
                "center": {
                    "lng": 118.796624,
                    "lat": 32.059344
                },
                "districtList": [
                    {
                        "citycode": "025",
                        "adcode": "320114",
                        "name": "雨花台区",
                        "center": {
                            "lng": 118.779087,
                            "lat": 31.991291
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320115",
                        "name": "江宁区",
                        "center": {
                            "lng": 118.83951,
                            "lat": 31.953195
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320118",
                        "name": "高淳区",
                        "center": {
                            "lng": 118.892074,
                            "lat": 31.328678
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320117",
                        "name": "溧水区",
                        "center": {
                            "lng": 119.028414,
                            "lat": 31.651108
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320105",
                        "name": "建邺区",
                        "center": {
                            "lng": 118.731642,
                            "lat": 32.003343
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320116",
                        "name": "六合区",
                        "center": {
                            "lng": 118.822241,
                            "lat": 32.323235
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320106",
                        "name": "鼓楼区",
                        "center": {
                            "lng": 118.769943,
                            "lat": 32.066814
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320104",
                        "name": "秦淮区",
                        "center": {
                            "lng": 118.794792,
                            "lat": 32.039065
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320111",
                        "name": "浦口区",
                        "center": {
                            "lng": 118.627165,
                            "lat": 32.059796
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320102",
                        "name": "玄武区",
                        "center": {
                            "lng": 118.797779,
                            "lat": 32.048644
                        }
                    },
                    {
                        "citycode": "025",
                        "adcode": "320113",
                        "name": "栖霞区",
                        "center": {
                            "lng": 118.909117,
                            "lat": 32.096423
                        }
                    }
                ]
            },
            {
                "citycode": "0515",
                "adcode": "320900",
                "name": "盐城市",
                "center": {
                    "lng": 120.16263,
                    "lat": 33.348176
                },
                "districtList": [
                    {
                        "citycode": "0515",
                        "adcode": "320924",
                        "name": "射阳县",
                        "center": {
                            "lng": 120.326338,
                            "lat": 33.766277
                        }
                    },
                    {
                        "citycode": "0515",
                        "adcode": "320922",
                        "name": "滨海县",
                        "center": {
                            "lng": 119.820713,
                            "lat": 33.990372
                        }
                    },
                    {
                        "citycode": "0515",
                        "adcode": "320921",
                        "name": "响水县",
                        "center": {
                            "lng": 119.578332,
                            "lat": 34.199172
                        }
                    },
                    {
                        "citycode": "0515",
                        "adcode": "320981",
                        "name": "东台市",
                        "center": {
                            "lng": 120.320308,
                            "lat": 32.867845
                        }
                    },
                    {
                        "citycode": "0515",
                        "adcode": "320925",
                        "name": "建湖县",
                        "center": {
                            "lng": 119.788743,
                            "lat": 33.438931
                        }
                    },
                    {
                        "citycode": "0515",
                        "adcode": "320923",
                        "name": "阜宁县",
                        "center": {
                            "lng": 119.802271,
                            "lat": 33.758857
                        }
                    },
                    {
                        "citycode": "0515",
                        "adcode": "320903",
                        "name": "盐都区",
                        "center": {
                            "lng": 120.153567,
                            "lat": 33.338538
                        }
                    },
                    {
                        "citycode": "0515",
                        "adcode": "320904",
                        "name": "大丰区",
                        "center": {
                            "lng": 120.500761,
                            "lat": 33.200047
                        }
                    },
                    {
                        "citycode": "0515",
                        "adcode": "320902",
                        "name": "亭湖区",
                        "center": {
                            "lng": 120.196148,
                            "lat": 33.391414
                        }
                    }
                ]
            },
            {
                "citycode": "0519",
                "adcode": "320400",
                "name": "常州市",
                "center": {
                    "lng": 119.974092,
                    "lat": 31.811313
                },
                "districtList": [
                    {
                        "citycode": "0519",
                        "adcode": "320413",
                        "name": "金坛区",
                        "center": {
                            "lng": 119.587503,
                            "lat": 31.722384
                        }
                    },
                    {
                        "citycode": "0519",
                        "adcode": "320481",
                        "name": "溧阳市",
                        "center": {
                            "lng": 119.484164,
                            "lat": 31.416967
                        }
                    },
                    {
                        "citycode": "0519",
                        "adcode": "320411",
                        "name": "新北区",
                        "center": {
                            "lng": 119.960925,
                            "lat": 31.86355
                        }
                    },
                    {
                        "citycode": "0519",
                        "adcode": "320404",
                        "name": "钟楼区",
                        "center": {
                            "lng": 119.902081,
                            "lat": 31.802608
                        }
                    },
                    {
                        "citycode": "0519",
                        "adcode": "320412",
                        "name": "武进区",
                        "center": {
                            "lng": 119.942441,
                            "lat": 31.701252
                        }
                    },
                    {
                        "citycode": "0519",
                        "adcode": "320402",
                        "name": "天宁区",
                        "center": {
                            "lng": 119.999439,
                            "lat": 31.79232
                        }
                    }
                ]
            },
            {
                "citycode": "0523",
                "adcode": "321200",
                "name": "泰州市",
                "center": {
                    "lng": 119.922883,
                    "lat": 32.456692
                },
                "districtList": [
                    {
                        "citycode": "0523",
                        "adcode": "321202",
                        "name": "海陵区",
                        "center": {
                            "lng": 119.923825,
                            "lat": 32.49248
                        }
                    },
                    {
                        "citycode": "0523",
                        "adcode": "321282",
                        "name": "靖江市",
                        "center": {
                            "lng": 120.277124,
                            "lat": 31.98325
                        }
                    },
                    {
                        "citycode": "0523",
                        "adcode": "321204",
                        "name": "姜堰区",
                        "center": {
                            "lng": 120.12807,
                            "lat": 32.51029
                        }
                    },
                    {
                        "citycode": "0523",
                        "adcode": "321283",
                        "name": "泰兴市",
                        "center": {
                            "lng": 120.051475,
                            "lat": 32.173072
                        }
                    },
                    {
                        "citycode": "0523",
                        "adcode": "321203",
                        "name": "高港区",
                        "center": {
                            "lng": 119.88154,
                            "lat": 32.31923
                        }
                    },
                    {
                        "citycode": "0523",
                        "adcode": "321281",
                        "name": "兴化市",
                        "center": {
                            "lng": 119.85255,
                            "lat": 32.911952
                        }
                    }
                ]
            },
            {
                "citycode": "0514",
                "adcode": "321000",
                "name": "扬州市",
                "center": {
                    "lng": 119.412834,
                    "lat": 32.394404
                },
                "districtList": [
                    {
                        "citycode": "0514",
                        "adcode": "321002",
                        "name": "广陵区",
                        "center": {
                            "lng": 119.431785,
                            "lat": 32.395654
                        }
                    },
                    {
                        "citycode": "0514",
                        "adcode": "321081",
                        "name": "仪征市",
                        "center": {
                            "lng": 119.184468,
                            "lat": 32.272833
                        }
                    },
                    {
                        "citycode": "0514",
                        "adcode": "321003",
                        "name": "邗江区",
                        "center": {
                            "lng": 119.397935,
                            "lat": 32.37741
                        }
                    },
                    {
                        "citycode": "0514",
                        "adcode": "321012",
                        "name": "江都区",
                        "center": {
                            "lng": 119.569684,
                            "lat": 32.43571
                        }
                    },
                    {
                        "citycode": "0514",
                        "adcode": "321023",
                        "name": "宝应县",
                        "center": {
                            "lng": 119.358389,
                            "lat": 33.241125
                        }
                    },
                    {
                        "citycode": "0514",
                        "adcode": "321084",
                        "name": "高邮市",
                        "center": {
                            "lng": 119.45892,
                            "lat": 32.781606
                        }
                    }
                ]
            },
            {
                "citycode": "0516",
                "adcode": "320300",
                "name": "徐州市",
                "center": {
                    "lng": 117.283752,
                    "lat": 34.204224
                },
                "districtList": [
                    {
                        "citycode": "0516",
                        "adcode": "320305",
                        "name": "贾汪区",
                        "center": {
                            "lng": 117.465137,
                            "lat": 34.436492
                        }
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320312",
                        "name": "铜山区",
                        "center": {
                            "lng": 117.169698,
                            "lat": 34.181162
                        }
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320311",
                        "name": "泉山区",
                        "center": {
                            "lng": 117.194405,
                            "lat": 34.22655
                        }
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320302",
                        "name": "鼓楼区",
                        "center": {
                            "lng": 117.185643,
                            "lat": 34.288736
                        }
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320303",
                        "name": "云龙区",
                        "center": {
                            "lng": 117.251515,
                            "lat": 34.253638
                        }
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320322",
                        "name": "沛县",
                        "center": {
                            "lng": 116.936353,
                            "lat": 34.760761
                        }
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320321",
                        "name": "丰县",
                        "center": {
                            "lng": 116.658111,
                            "lat": 34.697232
                        }
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320381",
                        "name": "新沂市",
                        "center": {
                            "lng": 118.354747,
                            "lat": 34.369585
                        }
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320324",
                        "name": "睢宁县",
                        "center": {
                            "lng": 117.941364,
                            "lat": 33.913727
                        }
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320382",
                        "name": "邳州市",
                        "center": {
                            "lng": 118.012511,
                            "lat": 34.339208
                        }
                    }
                ]
            },
            {
                "citycode": "0510",
                "adcode": "320200",
                "name": "无锡市",
                "center": {
                    "lng": 120.311889,
                    "lat": 31.491064
                },
                "districtList": [
                    {
                        "citycode": "0510",
                        "adcode": "320282",
                        "name": "宜兴市",
                        "center": {
                            "lng": 119.821873,
                            "lat": 31.338429
                        }
                    },
                    {
                        "citycode": "0510",
                        "adcode": "320281",
                        "name": "江阴市",
                        "center": {
                            "lng": 120.284794,
                            "lat": 31.921642
                        }
                    },
                    {
                        "citycode": "0510",
                        "adcode": "320205",
                        "name": "锡山区",
                        "center": {
                            "lng": 120.357732,
                            "lat": 31.589484
                        }
                    },
                    {
                        "citycode": "0510",
                        "adcode": "320211",
                        "name": "滨湖区",
                        "center": {
                            "lng": 120.284381,
                            "lat": 31.527846
                        }
                    },
                    {
                        "citycode": "0510",
                        "adcode": "320206",
                        "name": "惠山区",
                        "center": {
                            "lng": 120.29843,
                            "lat": 31.680282
                        }
                    },
                    {
                        "citycode": "0510",
                        "adcode": "320214",
                        "name": "新吴区",
                        "center": {
                            "lng": 120.364303,
                            "lat": 31.49085
                        }
                    },
                    {
                        "citycode": "0510",
                        "adcode": "320213",
                        "name": "梁溪区",
                        "center": {
                            "lng": 120.303551,
                            "lat": 31.566226
                        }
                    }
                ]
            },
            {
                "citycode": "0512",
                "adcode": "320500",
                "name": "苏州市",
                "center": {
                    "lng": 120.585294,
                    "lat": 31.299758
                },
                "districtList": [
                    {
                        "citycode": "0512",
                        "adcode": "320505",
                        "name": "虎丘区",
                        "center": {
                            "lng": 120.434238,
                            "lat": 31.329601
                        }
                    },
                    {
                        "citycode": "0512",
                        "adcode": "320585",
                        "name": "太仓市",
                        "center": {
                            "lng": 121.130344,
                            "lat": 31.458043
                        }
                    },
                    {
                        "citycode": "0512",
                        "adcode": "320507",
                        "name": "相城区",
                        "center": {
                            "lng": 120.642391,
                            "lat": 31.369189
                        }
                    },
                    {
                        "citycode": "0512",
                        "adcode": "320509",
                        "name": "吴江区",
                        "center": {
                            "lng": 120.645728,
                            "lat": 31.138525
                        }
                    },
                    {
                        "citycode": "0512",
                        "adcode": "320508",
                        "name": "姑苏区",
                        "center": {
                            "lng": 120.617367,
                            "lat": 31.335648
                        }
                    },
                    {
                        "citycode": "0512",
                        "adcode": "320581",
                        "name": "常熟市",
                        "center": {
                            "lng": 120.752512,
                            "lat": 31.656016
                        }
                    },
                    {
                        "citycode": "0512",
                        "adcode": "320582",
                        "name": "张家港市",
                        "center": {
                            "lng": 120.555979,
                            "lat": 31.876739
                        }
                    },
                    {
                        "citycode": "0512",
                        "adcode": "320583",
                        "name": "昆山市",
                        "center": {
                            "lng": 120.980795,
                            "lat": 31.385476
                        }
                    },
                    {
                        "citycode": "0512",
                        "adcode": "320506",
                        "name": "吴中区",
                        "center": {
                            "lng": 120.632094,
                            "lat": 31.263604
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "630000",
        "name": "青海省",
        "center": {
            "lng": 101.780482,
            "lat": 36.622538
        },
        "districtList": [
            {
                "citycode": "0974",
                "adcode": "632500",
                "name": "海南藏族自治州",
                "center": {
                    "lng": 100.622647,
                    "lat": 36.296399
                },
                "districtList": [
                    {
                        "citycode": "0974",
                        "adcode": "632523",
                        "name": "贵德县",
                        "center": {
                            "lng": 101.43403,
                            "lat": 36.039672
                        }
                    },
                    {
                        "citycode": "0974",
                        "adcode": "632525",
                        "name": "贵南县",
                        "center": {
                            "lng": 100.747731,
                            "lat": 35.587239
                        }
                    },
                    {
                        "citycode": "0974",
                        "adcode": "632522",
                        "name": "同德县",
                        "center": {
                            "lng": 100.577859,
                            "lat": 35.254297
                        }
                    },
                    {
                        "citycode": "0974",
                        "adcode": "632521",
                        "name": "共和县",
                        "center": {
                            "lng": 100.619405,
                            "lat": 36.284158
                        }
                    },
                    {
                        "citycode": "0974",
                        "adcode": "632524",
                        "name": "兴海县",
                        "center": {
                            "lng": 99.987799,
                            "lat": 35.589086
                        }
                    }
                ]
            },
            {
                "citycode": "0972",
                "adcode": "630200",
                "name": "海东市",
                "center": {
                    "lng": 102.41064,
                    "lat": 36.473448
                },
                "districtList": [
                    {
                        "citycode": "0972",
                        "adcode": "630202",
                        "name": "乐都区",
                        "center": {
                            "lng": 102.401614,
                            "lat": 36.482242
                        }
                    },
                    {
                        "citycode": "0972",
                        "adcode": "630222",
                        "name": "民和回族土族自治县",
                        "center": {
                            "lng": 102.830775,
                            "lat": 36.320038
                        }
                    },
                    {
                        "citycode": "0972",
                        "adcode": "630225",
                        "name": "循化撒拉族自治县",
                        "center": {
                            "lng": 102.488958,
                            "lat": 35.851079
                        }
                    },
                    {
                        "citycode": "0972",
                        "adcode": "630203",
                        "name": "平安区",
                        "center": {
                            "lng": 102.108538,
                            "lat": 36.500166
                        }
                    },
                    {
                        "citycode": "0972",
                        "adcode": "630223",
                        "name": "互助土族自治县",
                        "center": {
                            "lng": 101.958519,
                            "lat": 36.844027
                        }
                    },
                    {
                        "citycode": "0972",
                        "adcode": "630224",
                        "name": "化隆回族自治县",
                        "center": {
                            "lng": 102.266007,
                            "lat": 36.096124
                        }
                    }
                ]
            },
            {
                "citycode": "0977",
                "adcode": "632800",
                "name": "海西蒙古族藏族自治州",
                "center": {
                    "lng": 97.33197,
                    "lat": 37.348114
                },
                "districtList": [
                    {
                        "citycode": "0977",
                        "adcode": "632823",
                        "name": "天峻县",
                        "center": {
                            "lng": 99.02297,
                            "lat": 37.301206
                        }
                    },
                    {
                        "citycode": "0977",
                        "adcode": "632802",
                        "name": "德令哈市",
                        "center": {
                            "lng": 97.361528,
                            "lat": 37.369865
                        }
                    },
                    {
                        "citycode": "0977",
                        "adcode": "632801",
                        "name": "格尔木市",
                        "center": {
                            "lng": 94.928293,
                            "lat": 36.407272
                        }
                    },
                    {
                        "citycode": "0977",
                        "adcode": "632822",
                        "name": "都兰县",
                        "center": {
                            "lng": 98.095889,
                            "lat": 36.302098
                        }
                    },
                    {
                        "citycode": "0977",
                        "adcode": "632821",
                        "name": "乌兰县",
                        "center": {
                            "lng": 98.47988,
                            "lat": 36.941279
                        }
                    },
                    {
                        "citycode": "0977",
                        "adcode": "632825",
                        "name": "海西蒙古族藏族自治州直辖",
                        "center": {
                            "lng": 95.357233,
                            "lat": 37.853631
                        }
                    },
                    {
                        "citycode": "0977",
                        "adcode": "632803",
                        "name": "茫崖市",
                        "center": {
                            "lng": 90.856372,
                            "lat": 38.247537
                        }
                    }
                ]
            },
            {
                "citycode": "0976",
                "adcode": "632700",
                "name": "玉树藏族自治州",
                "center": {
                    "lng": 97.006292,
                    "lat": 33.006308
                },
                "districtList": [
                    {
                        "citycode": "0976",
                        "adcode": "632724",
                        "name": "治多县",
                        "center": {
                            "lng": 95.618954,
                            "lat": 33.844854
                        }
                    },
                    {
                        "citycode": "0976",
                        "adcode": "632726",
                        "name": "曲麻莱县",
                        "center": {
                            "lng": 95.805463,
                            "lat": 34.137353
                        }
                    },
                    {
                        "citycode": "0976",
                        "adcode": "632723",
                        "name": "称多县",
                        "center": {
                            "lng": 97.109487,
                            "lat": 33.377504
                        }
                    },
                    {
                        "citycode": "0976",
                        "adcode": "632722",
                        "name": "杂多县",
                        "center": {
                            "lng": 95.300723,
                            "lat": 32.893185
                        }
                    },
                    {
                        "citycode": "0976",
                        "adcode": "632701",
                        "name": "玉树市",
                        "center": {
                            "lng": 97.009184,
                            "lat": 32.992934
                        }
                    },
                    {
                        "citycode": "0976",
                        "adcode": "632725",
                        "name": "囊谦县",
                        "center": {
                            "lng": 96.489538,
                            "lat": 32.203193
                        }
                    }
                ]
            },
            {
                "citycode": "0973",
                "adcode": "632300",
                "name": "黄南藏族自治州",
                "center": {
                    "lng": 102.015397,
                    "lat": 35.519317
                },
                "districtList": [
                    {
                        "citycode": "0973",
                        "adcode": "632301",
                        "name": "同仁市",
                        "center": {
                            "lng": 102.018663,
                            "lat": 35.515769
                        }
                    },
                    {
                        "citycode": "0973",
                        "adcode": "632323",
                        "name": "泽库县",
                        "center": {
                            "lng": 101.466565,
                            "lat": 35.035322
                        }
                    },
                    {
                        "citycode": "0973",
                        "adcode": "632322",
                        "name": "尖扎县",
                        "center": {
                            "lng": 102.040094,
                            "lat": 35.943253
                        }
                    },
                    {
                        "citycode": "0973",
                        "adcode": "632324",
                        "name": "河南蒙古族自治县",
                        "center": {
                            "lng": 101.617719,
                            "lat": 34.734777
                        }
                    }
                ]
            },
            {
                "citycode": "0975",
                "adcode": "632600",
                "name": "果洛藏族自治州",
                "center": {
                    "lng": 100.245161,
                    "lat": 34.472179
                },
                "districtList": [
                    {
                        "citycode": "0975",
                        "adcode": "632621",
                        "name": "玛沁县",
                        "center": {
                            "lng": 100.238873,
                            "lat": 34.478049
                        }
                    },
                    {
                        "citycode": "0975",
                        "adcode": "632623",
                        "name": "甘德县",
                        "center": {
                            "lng": 99.900923,
                            "lat": 33.969216
                        }
                    },
                    {
                        "citycode": "0975",
                        "adcode": "632624",
                        "name": "达日县",
                        "center": {
                            "lng": 99.651863,
                            "lat": 33.739293
                        }
                    },
                    {
                        "citycode": "0975",
                        "adcode": "632625",
                        "name": "久治县",
                        "center": {
                            "lng": 101.482831,
                            "lat": 33.429471
                        }
                    },
                    {
                        "citycode": "0975",
                        "adcode": "632622",
                        "name": "班玛县",
                        "center": {
                            "lng": 100.737138,
                            "lat": 32.932723
                        }
                    },
                    {
                        "citycode": "0975",
                        "adcode": "632626",
                        "name": "玛多县",
                        "center": {
                            "lng": 98.209217,
                            "lat": 34.915645
                        }
                    }
                ]
            },
            {
                "citycode": "0971",
                "adcode": "630100",
                "name": "西宁市",
                "center": {
                    "lng": 101.777795,
                    "lat": 36.616621
                },
                "districtList": [
                    {
                        "citycode": "0971",
                        "adcode": "630123",
                        "name": "湟源县",
                        "center": {
                            "lng": 101.256464,
                            "lat": 36.682426
                        }
                    },
                    {
                        "citycode": "0971",
                        "adcode": "630121",
                        "name": "大通回族土族自治县",
                        "center": {
                            "lng": 101.685503,
                            "lat": 36.926872
                        }
                    },
                    {
                        "citycode": "0971",
                        "adcode": "630104",
                        "name": "城西区",
                        "center": {
                            "lng": 101.765915,
                            "lat": 36.628288
                        }
                    },
                    {
                        "citycode": "0971",
                        "adcode": "630105",
                        "name": "城北区",
                        "center": {
                            "lng": 101.766308,
                            "lat": 36.650064
                        }
                    },
                    {
                        "citycode": "0971",
                        "adcode": "630102",
                        "name": "城东区",
                        "center": {
                            "lng": 101.803717,
                            "lat": 36.599744
                        }
                    },
                    {
                        "citycode": "0971",
                        "adcode": "630106",
                        "name": "湟中区",
                        "center": {
                            "lng": 101.571683,
                            "lat": 36.501291
                        }
                    },
                    {
                        "citycode": "0971",
                        "adcode": "630103",
                        "name": "城中区",
                        "center": {
                            "lng": 101.705357,
                            "lat": 36.545545
                        }
                    }
                ]
            },
            {
                "citycode": "0970",
                "adcode": "632200",
                "name": "海北藏族自治州",
                "center": {
                    "lng": 100.900944,
                    "lat": 36.954612
                },
                "districtList": [
                    {
                        "citycode": "0970",
                        "adcode": "632223",
                        "name": "海晏县",
                        "center": {
                            "lng": 100.994521,
                            "lat": 36.896667
                        }
                    },
                    {
                        "citycode": "0970",
                        "adcode": "632221",
                        "name": "门源回族自治县",
                        "center": {
                            "lng": 101.611524,
                            "lat": 37.388567
                        }
                    },
                    {
                        "citycode": "0970",
                        "adcode": "632224",
                        "name": "刚察县",
                        "center": {
                            "lng": 100.145662,
                            "lat": 37.325096
                        }
                    },
                    {
                        "citycode": "0970",
                        "adcode": "632222",
                        "name": "祁连县",
                        "center": {
                            "lng": 100.253211,
                            "lat": 38.177112
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "450000",
        "name": "广西壮族自治区",
        "center": {
            "lng": 108.327537,
            "lat": 22.816659
        },
        "districtList": [
            {
                "citycode": "0776",
                "adcode": "451000",
                "name": "百色市",
                "center": {
                    "lng": 106.61869,
                    "lat": 23.90307
                },
                "districtList": [
                    {
                        "citycode": "0776",
                        "adcode": "451028",
                        "name": "乐业县",
                        "center": {
                            "lng": 106.556564,
                            "lat": 24.776812
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451030",
                        "name": "西林县",
                        "center": {
                            "lng": 105.097229,
                            "lat": 24.50762
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451027",
                        "name": "凌云县",
                        "center": {
                            "lng": 106.56114,
                            "lat": 24.347444
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451031",
                        "name": "隆林各族自治县",
                        "center": {
                            "lng": 105.343816,
                            "lat": 24.770649
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451002",
                        "name": "右江区",
                        "center": {
                            "lng": 106.618151,
                            "lat": 23.900804
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451082",
                        "name": "平果市",
                        "center": {
                            "lng": 107.589768,
                            "lat": 23.329815
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451081",
                        "name": "靖西市",
                        "center": {
                            "lng": 106.417666,
                            "lat": 23.134375
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451029",
                        "name": "田林县",
                        "center": {
                            "lng": 106.22874,
                            "lat": 24.294627
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451024",
                        "name": "德保县",
                        "center": {
                            "lng": 106.615087,
                            "lat": 23.324084
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451026",
                        "name": "那坡县",
                        "center": {
                            "lng": 105.83234,
                            "lat": 23.387997
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451003",
                        "name": "田阳区",
                        "center": {
                            "lng": 106.915424,
                            "lat": 23.735631
                        }
                    },
                    {
                        "citycode": "0776",
                        "adcode": "451022",
                        "name": "田东县",
                        "center": {
                            "lng": 107.125609,
                            "lat": 23.596706
                        }
                    }
                ]
            },
            {
                "citycode": "0777",
                "adcode": "450700",
                "name": "钦州市",
                "center": {
                    "lng": 108.654355,
                    "lat": 21.980894
                },
                "districtList": [
                    {
                        "citycode": "0777",
                        "adcode": "450702",
                        "name": "钦南区",
                        "center": {
                            "lng": 108.657427,
                            "lat": 21.940438
                        }
                    },
                    {
                        "citycode": "0777",
                        "adcode": "450703",
                        "name": "钦北区",
                        "center": {
                            "lng": 108.638738,
                            "lat": 22.0024
                        }
                    },
                    {
                        "citycode": "0777",
                        "adcode": "450722",
                        "name": "浦北县",
                        "center": {
                            "lng": 109.556232,
                            "lat": 22.271902
                        }
                    },
                    {
                        "citycode": "0777",
                        "adcode": "450721",
                        "name": "灵山县",
                        "center": {
                            "lng": 109.290698,
                            "lat": 22.416671
                        }
                    }
                ]
            },
            {
                "citycode": "0779",
                "adcode": "450500",
                "name": "北海市",
                "center": {
                    "lng": 109.120248,
                    "lat": 21.481305
                },
                "districtList": [
                    {
                        "citycode": "0779",
                        "adcode": "450503",
                        "name": "银海区",
                        "center": {
                            "lng": 109.139689,
                            "lat": 21.449729
                        }
                    },
                    {
                        "citycode": "0779",
                        "adcode": "450512",
                        "name": "铁山港区",
                        "center": {
                            "lng": 109.422099,
                            "lat": 21.529878
                        }
                    },
                    {
                        "citycode": "0779",
                        "adcode": "450502",
                        "name": "海城区",
                        "center": {
                            "lng": 109.117256,
                            "lat": 21.474914
                        }
                    },
                    {
                        "citycode": "0779",
                        "adcode": "450521",
                        "name": "合浦县",
                        "center": {
                            "lng": 109.207236,
                            "lat": 21.66132
                        }
                    }
                ]
            },
            {
                "citycode": "0774",
                "adcode": "450400",
                "name": "梧州市",
                "center": {
                    "lng": 111.279022,
                    "lat": 23.476733
                },
                "districtList": [
                    {
                        "citycode": "0774",
                        "adcode": "450423",
                        "name": "蒙山县",
                        "center": {
                            "lng": 110.525003,
                            "lat": 24.193567
                        }
                    },
                    {
                        "citycode": "0774",
                        "adcode": "450406",
                        "name": "龙圩区",
                        "center": {
                            "lng": 111.247514,
                            "lat": 23.414869
                        }
                    },
                    {
                        "citycode": "0774",
                        "adcode": "450481",
                        "name": "岑溪市",
                        "center": {
                            "lng": 110.994955,
                            "lat": 22.918327
                        }
                    },
                    {
                        "citycode": "0774",
                        "adcode": "450405",
                        "name": "长洲区",
                        "center": {
                            "lng": 111.274276,
                            "lat": 23.486279
                        }
                    },
                    {
                        "citycode": "0774",
                        "adcode": "450422",
                        "name": "藤县",
                        "center": {
                            "lng": 110.914606,
                            "lat": 23.375538
                        }
                    },
                    {
                        "citycode": "0774",
                        "adcode": "450403",
                        "name": "万秀区",
                        "center": {
                            "lng": 111.318065,
                            "lat": 23.470543
                        }
                    },
                    {
                        "citycode": "0774",
                        "adcode": "450421",
                        "name": "苍梧县",
                        "center": {
                            "lng": 111.547244,
                            "lat": 23.868208
                        }
                    }
                ]
            },
            {
                "citycode": "0770",
                "adcode": "450600",
                "name": "防城港市",
                "center": {
                    "lng": 108.35467,
                    "lat": 21.686732
                },
                "districtList": [
                    {
                        "citycode": "0770",
                        "adcode": "450602",
                        "name": "港口区",
                        "center": {
                            "lng": 108.380273,
                            "lat": 21.643426
                        }
                    },
                    {
                        "citycode": "0770",
                        "adcode": "450681",
                        "name": "东兴市",
                        "center": {
                            "lng": 107.971828,
                            "lat": 21.547821
                        }
                    },
                    {
                        "citycode": "0770",
                        "adcode": "450621",
                        "name": "上思县",
                        "center": {
                            "lng": 107.983627,
                            "lat": 22.153671
                        }
                    },
                    {
                        "citycode": "0770",
                        "adcode": "450603",
                        "name": "防城区",
                        "center": {
                            "lng": 108.353978,
                            "lat": 21.768826
                        }
                    }
                ]
            },
            {
                "citycode": "0773",
                "adcode": "450300",
                "name": "桂林市",
                "center": {
                    "lng": 110.179752,
                    "lat": 25.235615
                },
                "districtList": [
                    {
                        "citycode": "0773",
                        "adcode": "450305",
                        "name": "七星区",
                        "center": {
                            "lng": 110.317576,
                            "lat": 25.253093
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450327",
                        "name": "灌阳县",
                        "center": {
                            "lng": 111.160764,
                            "lat": 25.489419
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450330",
                        "name": "平乐县",
                        "center": {
                            "lng": 110.632867,
                            "lat": 24.622814
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450332",
                        "name": "恭城瑶族自治县",
                        "center": {
                            "lng": 110.82841,
                            "lat": 24.831581
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450324",
                        "name": "全州县",
                        "center": {
                            "lng": 111.087089,
                            "lat": 25.94939
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450326",
                        "name": "永福县",
                        "center": {
                            "lng": 109.982974,
                            "lat": 24.980447
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450328",
                        "name": "龙胜各族自治县",
                        "center": {
                            "lng": 110.011662,
                            "lat": 25.79803
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450321",
                        "name": "阳朔县",
                        "center": {
                            "lng": 110.496305,
                            "lat": 24.778785
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450381",
                        "name": "荔浦市",
                        "center": {
                            "lng": 110.395232,
                            "lat": 24.48843
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450312",
                        "name": "临桂区",
                        "center": {
                            "lng": 110.212425,
                            "lat": 25.238556
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450302",
                        "name": "秀峰区",
                        "center": {
                            "lng": 110.264102,
                            "lat": 25.273954
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450311",
                        "name": "雁山区",
                        "center": {
                            "lng": 110.286611,
                            "lat": 25.101798
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450304",
                        "name": "象山区",
                        "center": {
                            "lng": 110.281223,
                            "lat": 25.261585
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450303",
                        "name": "叠彩区",
                        "center": {
                            "lng": 110.301489,
                            "lat": 25.314158
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450323",
                        "name": "灵川县",
                        "center": {
                            "lng": 110.319837,
                            "lat": 25.3948
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450325",
                        "name": "兴安县",
                        "center": {
                            "lng": 110.672013,
                            "lat": 25.612576
                        }
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450329",
                        "name": "资源县",
                        "center": {
                            "lng": 110.652612,
                            "lat": 26.042452
                        }
                    }
                ]
            },
            {
                "citycode": "1772",
                "adcode": "451300",
                "name": "来宾市",
                "center": {
                    "lng": 109.221243,
                    "lat": 23.750105
                },
                "districtList": [
                    {
                        "citycode": "1772",
                        "adcode": "451322",
                        "name": "象州县",
                        "center": {
                            "lng": 109.704852,
                            "lat": 23.973832
                        }
                    },
                    {
                        "citycode": "1772",
                        "adcode": "451324",
                        "name": "金秀瑶族自治县",
                        "center": {
                            "lng": 110.190354,
                            "lat": 24.130509
                        }
                    },
                    {
                        "citycode": "1772",
                        "adcode": "451381",
                        "name": "合山市",
                        "center": {
                            "lng": 108.885829,
                            "lat": 23.807032
                        }
                    },
                    {
                        "citycode": "1772",
                        "adcode": "451323",
                        "name": "武宣县",
                        "center": {
                            "lng": 109.663153,
                            "lat": 23.594444
                        }
                    },
                    {
                        "citycode": "1772",
                        "adcode": "451321",
                        "name": "忻城县",
                        "center": {
                            "lng": 108.665641,
                            "lat": 24.066176
                        }
                    },
                    {
                        "citycode": "1772",
                        "adcode": "451302",
                        "name": "兴宾区",
                        "center": {
                            "lng": 109.183284,
                            "lat": 23.727647
                        }
                    }
                ]
            },
            {
                "citycode": "1774",
                "adcode": "451100",
                "name": "贺州市",
                "center": {
                    "lng": 111.567216,
                    "lat": 24.404182
                },
                "districtList": [
                    {
                        "citycode": "1774",
                        "adcode": "451123",
                        "name": "富川瑶族自治县",
                        "center": {
                            "lng": 111.296012,
                            "lat": 24.811601
                        }
                    },
                    {
                        "citycode": "1774",
                        "adcode": "451122",
                        "name": "钟山县",
                        "center": {
                            "lng": 111.303085,
                            "lat": 24.526041
                        }
                    },
                    {
                        "citycode": "1774",
                        "adcode": "451102",
                        "name": "八步区",
                        "center": {
                            "lng": 111.552029,
                            "lat": 24.411822
                        }
                    },
                    {
                        "citycode": "1774",
                        "adcode": "451103",
                        "name": "平桂区",
                        "center": {
                            "lng": 111.479839,
                            "lat": 24.453094
                        }
                    },
                    {
                        "citycode": "1774",
                        "adcode": "451121",
                        "name": "昭平县",
                        "center": {
                            "lng": 110.811158,
                            "lat": 24.169675
                        }
                    }
                ]
            },
            {
                "citycode": "1755",
                "adcode": "450800",
                "name": "贵港市",
                "center": {
                    "lng": 109.598903,
                    "lat": 23.11182
                },
                "districtList": [
                    {
                        "citycode": "1755",
                        "adcode": "450803",
                        "name": "港南区",
                        "center": {
                            "lng": 109.599357,
                            "lat": 23.075816
                        }
                    },
                    {
                        "citycode": "1755",
                        "adcode": "450802",
                        "name": "港北区",
                        "center": {
                            "lng": 109.572227,
                            "lat": 23.11136
                        }
                    },
                    {
                        "citycode": "1755",
                        "adcode": "450804",
                        "name": "覃塘区",
                        "center": {
                            "lng": 109.452668,
                            "lat": 23.127405
                        }
                    },
                    {
                        "citycode": "1755",
                        "adcode": "450881",
                        "name": "桂平市",
                        "center": {
                            "lng": 110.079315,
                            "lat": 23.394208
                        }
                    },
                    {
                        "citycode": "1755",
                        "adcode": "450821",
                        "name": "平南县",
                        "center": {
                            "lng": 110.392489,
                            "lat": 23.540413
                        }
                    }
                ]
            },
            {
                "citycode": "0778",
                "adcode": "451200",
                "name": "河池市",
                "center": {
                    "lng": 108.63639,
                    "lat": 24.48523
                },
                "districtList": [
                    {
                        "citycode": "0778",
                        "adcode": "451222",
                        "name": "天峨县",
                        "center": {
                            "lng": 107.172287,
                            "lat": 24.999181
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451225",
                        "name": "罗城仫佬族自治县",
                        "center": {
                            "lng": 108.904613,
                            "lat": 24.777501
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451223",
                        "name": "凤山县",
                        "center": {
                            "lng": 107.042157,
                            "lat": 24.546913
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451224",
                        "name": "东兰县",
                        "center": {
                            "lng": 107.374259,
                            "lat": 24.510698
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451229",
                        "name": "大化瑶族自治县",
                        "center": {
                            "lng": 107.998151,
                            "lat": 23.735699
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451228",
                        "name": "都安瑶族自治县",
                        "center": {
                            "lng": 108.105229,
                            "lat": 23.932704
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451226",
                        "name": "环江毛南族自治县",
                        "center": {
                            "lng": 108.258426,
                            "lat": 24.825923
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451221",
                        "name": "南丹县",
                        "center": {
                            "lng": 107.540578,
                            "lat": 24.975066
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451202",
                        "name": "金城江区",
                        "center": {
                            "lng": 108.085166,
                            "lat": 24.692865
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451203",
                        "name": "宜州区",
                        "center": {
                            "lng": 108.611303,
                            "lat": 24.500981
                        }
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451227",
                        "name": "巴马瑶族自治县",
                        "center": {
                            "lng": 107.258671,
                            "lat": 24.142216
                        }
                    }
                ]
            },
            {
                "citycode": "0772",
                "adcode": "450200",
                "name": "柳州市",
                "center": {
                    "lng": 109.428071,
                    "lat": 24.326442
                },
                "districtList": [
                    {
                        "citycode": "0772",
                        "adcode": "450225",
                        "name": "融水苗族自治县",
                        "center": {
                            "lng": 109.256609,
                            "lat": 25.066624
                        }
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450226",
                        "name": "三江侗族自治县",
                        "center": {
                            "lng": 109.607675,
                            "lat": 25.783197
                        }
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450224",
                        "name": "融安县",
                        "center": {
                            "lng": 109.397538,
                            "lat": 25.224549
                        }
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450222",
                        "name": "柳城县",
                        "center": {
                            "lng": 109.267125,
                            "lat": 24.654329
                        }
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450206",
                        "name": "柳江区",
                        "center": {
                            "lng": 109.326365,
                            "lat": 24.255644
                        }
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450223",
                        "name": "鹿寨县",
                        "center": {
                            "lng": 109.750527,
                            "lat": 24.472897
                        }
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450202",
                        "name": "城中区",
                        "center": {
                            "lng": 109.427398,
                            "lat": 24.366964
                        }
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450205",
                        "name": "柳北区",
                        "center": {
                            "lng": 109.402009,
                            "lat": 24.362611
                        }
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450203",
                        "name": "鱼峰区",
                        "center": {
                            "lng": 109.452781,
                            "lat": 24.318276
                        }
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450204",
                        "name": "柳南区",
                        "center": {
                            "lng": 109.385504,
                            "lat": 24.336229
                        }
                    }
                ]
            },
            {
                "citycode": "0771",
                "adcode": "450100",
                "name": "南宁市",
                "center": {
                    "lng": 108.366407,
                    "lat": 22.8177
                },
                "districtList": [
                    {
                        "citycode": "0771",
                        "adcode": "450124",
                        "name": "马山县",
                        "center": {
                            "lng": 108.177764,
                            "lat": 23.708448
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450110",
                        "name": "武鸣区",
                        "center": {
                            "lng": 108.274869,
                            "lat": 23.159257
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450125",
                        "name": "上林县",
                        "center": {
                            "lng": 108.605089,
                            "lat": 23.432451
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450105",
                        "name": "江南区",
                        "center": {
                            "lng": 108.273206,
                            "lat": 22.781166
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450109",
                        "name": "邕宁区",
                        "center": {
                            "lng": 108.487438,
                            "lat": 22.758633
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450108",
                        "name": "良庆区",
                        "center": {
                            "lng": 108.393889,
                            "lat": 22.753613
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450107",
                        "name": "西乡塘区",
                        "center": {
                            "lng": 108.31344,
                            "lat": 22.833852
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450123",
                        "name": "隆安县",
                        "center": {
                            "lng": 107.695721,
                            "lat": 23.166356
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450181",
                        "name": "横州市",
                        "center": {
                            "lng": 109.262448,
                            "lat": 22.681257
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450102",
                        "name": "兴宁区",
                        "center": {
                            "lng": 108.368071,
                            "lat": 22.85354
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450103",
                        "name": "青秀区",
                        "center": {
                            "lng": 108.495204,
                            "lat": 22.785833
                        }
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450126",
                        "name": "宾阳县",
                        "center": {
                            "lng": 108.810336,
                            "lat": 23.217771
                        }
                    }
                ]
            },
            {
                "citycode": "0775",
                "adcode": "450900",
                "name": "玉林市",
                "center": {
                    "lng": 110.18097,
                    "lat": 22.654001
                },
                "districtList": [
                    {
                        "citycode": "0775",
                        "adcode": "450903",
                        "name": "福绵区",
                        "center": {
                            "lng": 110.059564,
                            "lat": 22.585316
                        }
                    },
                    {
                        "citycode": "0775",
                        "adcode": "450902",
                        "name": "玉州区",
                        "center": {
                            "lng": 110.150717,
                            "lat": 22.628476
                        }
                    },
                    {
                        "citycode": "0775",
                        "adcode": "450923",
                        "name": "博白县",
                        "center": {
                            "lng": 109.975856,
                            "lat": 22.273539
                        }
                    },
                    {
                        "citycode": "0775",
                        "adcode": "450921",
                        "name": "容县",
                        "center": {
                            "lng": 110.558093,
                            "lat": 22.85844
                        }
                    },
                    {
                        "citycode": "0775",
                        "adcode": "450924",
                        "name": "兴业县",
                        "center": {
                            "lng": 109.875223,
                            "lat": 22.736395
                        }
                    },
                    {
                        "citycode": "0775",
                        "adcode": "450981",
                        "name": "北流市",
                        "center": {
                            "lng": 110.353765,
                            "lat": 22.708415
                        }
                    },
                    {
                        "citycode": "0775",
                        "adcode": "450922",
                        "name": "陆川县",
                        "center": {
                            "lng": 110.26412,
                            "lat": 22.321563
                        }
                    }
                ]
            },
            {
                "citycode": "1771",
                "adcode": "451400",
                "name": "崇左市",
                "center": {
                    "lng": 107.364973,
                    "lat": 22.377139
                },
                "districtList": [
                    {
                        "citycode": "1771",
                        "adcode": "451421",
                        "name": "扶绥县",
                        "center": {
                            "lng": 107.90389,
                            "lat": 22.635542
                        }
                    },
                    {
                        "citycode": "1771",
                        "adcode": "451402",
                        "name": "江州区",
                        "center": {
                            "lng": 107.353694,
                            "lat": 22.40609
                        }
                    },
                    {
                        "citycode": "1771",
                        "adcode": "451423",
                        "name": "龙州县",
                        "center": {
                            "lng": 106.854001,
                            "lat": 22.343591
                        }
                    },
                    {
                        "citycode": "1771",
                        "adcode": "451481",
                        "name": "凭祥市",
                        "center": {
                            "lng": 106.766715,
                            "lat": 22.094421
                        }
                    },
                    {
                        "citycode": "1771",
                        "adcode": "451422",
                        "name": "宁明县",
                        "center": {
                            "lng": 107.076394,
                            "lat": 22.140242
                        }
                    },
                    {
                        "citycode": "1771",
                        "adcode": "451424",
                        "name": "大新县",
                        "center": {
                            "lng": 107.200654,
                            "lat": 22.829287
                        }
                    },
                    {
                        "citycode": "1771",
                        "adcode": "451425",
                        "name": "天等县",
                        "center": {
                            "lng": 107.143539,
                            "lat": 23.080818
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "640000",
        "name": "宁夏回族自治区",
        "center": {
            "lng": 106.258889,
            "lat": 38.472273
        },
        "districtList": [
            {
                "citycode": "0954",
                "adcode": "640400",
                "name": "固原市",
                "center": {
                    "lng": 106.24267,
                    "lat": 36.01628
                },
                "districtList": [
                    {
                        "citycode": "0954",
                        "adcode": "640423",
                        "name": "隆德县",
                        "center": {
                            "lng": 106.111321,
                            "lat": 35.62592
                        }
                    },
                    {
                        "citycode": "0954",
                        "adcode": "640425",
                        "name": "彭阳县",
                        "center": {
                            "lng": 106.632151,
                            "lat": 35.860067
                        }
                    },
                    {
                        "citycode": "0954",
                        "adcode": "640424",
                        "name": "泾源县",
                        "center": {
                            "lng": 106.330569,
                            "lat": 35.497887
                        }
                    },
                    {
                        "citycode": "0954",
                        "adcode": "640422",
                        "name": "西吉县",
                        "center": {
                            "lng": 105.729189,
                            "lat": 35.963885
                        }
                    },
                    {
                        "citycode": "0954",
                        "adcode": "640402",
                        "name": "原州区",
                        "center": {
                            "lng": 106.28784,
                            "lat": 36.003777
                        }
                    }
                ]
            },
            {
                "citycode": "0952",
                "adcode": "640200",
                "name": "石嘴山市",
                "center": {
                    "lng": 106.382792,
                    "lat": 38.984632
                },
                "districtList": [
                    {
                        "citycode": "0952",
                        "adcode": "640205",
                        "name": "惠农区",
                        "center": {
                            "lng": 106.781013,
                            "lat": 39.239292
                        }
                    },
                    {
                        "citycode": "0952",
                        "adcode": "640202",
                        "name": "大武口区",
                        "center": {
                            "lng": 106.368128,
                            "lat": 39.019375
                        }
                    },
                    {
                        "citycode": "0952",
                        "adcode": "640221",
                        "name": "平罗县",
                        "center": {
                            "lng": 106.523411,
                            "lat": 38.913923
                        }
                    }
                ]
            },
            {
                "citycode": "0953",
                "adcode": "640300",
                "name": "吴忠市",
                "center": {
                    "lng": 106.198613,
                    "lat": 37.997755
                },
                "districtList": [
                    {
                        "citycode": "0953",
                        "adcode": "640381",
                        "name": "青铜峡市",
                        "center": {
                            "lng": 106.07906,
                            "lat": 38.021579
                        }
                    },
                    {
                        "citycode": "0953",
                        "adcode": "640323",
                        "name": "盐池县",
                        "center": {
                            "lng": 107.407184,
                            "lat": 37.783276
                        }
                    },
                    {
                        "citycode": "0953",
                        "adcode": "640324",
                        "name": "同心县",
                        "center": {
                            "lng": 105.895412,
                            "lat": 36.954635
                        }
                    },
                    {
                        "citycode": "0953",
                        "adcode": "640302",
                        "name": "利通区",
                        "center": {
                            "lng": 106.212479,
                            "lat": 37.984586
                        }
                    },
                    {
                        "citycode": "0953",
                        "adcode": "640303",
                        "name": "红寺堡区",
                        "center": {
                            "lng": 106.06216,
                            "lat": 37.425494
                        }
                    }
                ]
            },
            {
                "citycode": "0951",
                "adcode": "640100",
                "name": "银川市",
                "center": {
                    "lng": 106.230977,
                    "lat": 38.487783
                },
                "districtList": [
                    {
                        "citycode": "0951",
                        "adcode": "640105",
                        "name": "西夏区",
                        "center": {
                            "lng": 106.161208,
                            "lat": 38.502325
                        }
                    },
                    {
                        "citycode": "0951",
                        "adcode": "640121",
                        "name": "永宁县",
                        "center": {
                            "lng": 106.25337,
                            "lat": 38.277376
                        }
                    },
                    {
                        "citycode": "0951",
                        "adcode": "640181",
                        "name": "灵武市",
                        "center": {
                            "lng": 106.339978,
                            "lat": 38.102456
                        }
                    },
                    {
                        "citycode": "0951",
                        "adcode": "640106",
                        "name": "金凤区",
                        "center": {
                            "lng": 106.239339,
                            "lat": 38.474277
                        }
                    },
                    {
                        "citycode": "0951",
                        "adcode": "640104",
                        "name": "兴庆区",
                        "center": {
                            "lng": 106.288452,
                            "lat": 38.473972
                        }
                    },
                    {
                        "citycode": "0951",
                        "adcode": "640122",
                        "name": "贺兰县",
                        "center": {
                            "lng": 106.365074,
                            "lat": 38.579147
                        }
                    }
                ]
            },
            {
                "citycode": "1953",
                "adcode": "640500",
                "name": "中卫市",
                "center": {
                    "lng": 105.19677,
                    "lat": 37.500185
                },
                "districtList": [
                    {
                        "citycode": "1953",
                        "adcode": "640522",
                        "name": "海原县",
                        "center": {
                            "lng": 105.643449,
                            "lat": 36.565189
                        }
                    },
                    {
                        "citycode": "1953",
                        "adcode": "640521",
                        "name": "中宁县",
                        "center": {
                            "lng": 105.684729,
                            "lat": 37.492092
                        }
                    },
                    {
                        "citycode": "1953",
                        "adcode": "640502",
                        "name": "沙坡头区",
                        "center": {
                            "lng": 105.173875,
                            "lat": 37.516859
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "330000",
        "name": "浙江省",
        "center": {
            "lng": 120.152575,
            "lat": 30.266619
        },
        "districtList": [
            {
                "citycode": "0580",
                "adcode": "330900",
                "name": "舟山市",
                "center": {
                    "lng": 122.207395,
                    "lat": 29.985578
                },
                "districtList": [
                    {
                        "citycode": "0580",
                        "adcode": "330922",
                        "name": "嵊泗县",
                        "center": {
                            "lng": 122.45132,
                            "lat": 30.725677
                        }
                    },
                    {
                        "citycode": "0580",
                        "adcode": "330921",
                        "name": "岱山县",
                        "center": {
                            "lng": 122.225718,
                            "lat": 30.264533
                        }
                    },
                    {
                        "citycode": "0580",
                        "adcode": "330902",
                        "name": "定海区",
                        "center": {
                            "lng": 122.106844,
                            "lat": 30.019795
                        }
                    },
                    {
                        "citycode": "0580",
                        "adcode": "330903",
                        "name": "普陀区",
                        "center": {
                            "lng": 122.323297,
                            "lat": 29.970571
                        }
                    }
                ]
            },
            {
                "citycode": "0573",
                "adcode": "330400",
                "name": "嘉兴市",
                "center": {
                    "lng": 120.755623,
                    "lat": 30.746814
                },
                "districtList": [
                    {
                        "citycode": "0573",
                        "adcode": "330482",
                        "name": "平湖市",
                        "center": {
                            "lng": 121.015619,
                            "lat": 30.677804
                        }
                    },
                    {
                        "citycode": "0573",
                        "adcode": "330411",
                        "name": "秀洲区",
                        "center": {
                            "lng": 120.709047,
                            "lat": 30.764811
                        }
                    },
                    {
                        "citycode": "0573",
                        "adcode": "330481",
                        "name": "海宁市",
                        "center": {
                            "lng": 120.680224,
                            "lat": 30.511536
                        }
                    },
                    {
                        "citycode": "0573",
                        "adcode": "330424",
                        "name": "海盐县",
                        "center": {
                            "lng": 120.94628,
                            "lat": 30.52664
                        }
                    },
                    {
                        "citycode": "0573",
                        "adcode": "330402",
                        "name": "南湖区",
                        "center": {
                            "lng": 120.782952,
                            "lat": 30.747738
                        }
                    },
                    {
                        "citycode": "0573",
                        "adcode": "330421",
                        "name": "嘉善县",
                        "center": {
                            "lng": 120.926031,
                            "lat": 30.83085
                        }
                    },
                    {
                        "citycode": "0573",
                        "adcode": "330483",
                        "name": "桐乡市",
                        "center": {
                            "lng": 120.565127,
                            "lat": 30.630375
                        }
                    }
                ]
            },
            {
                "citycode": "0574",
                "adcode": "330200",
                "name": "宁波市",
                "center": {
                    "lng": 121.62454,
                    "lat": 29.860258
                },
                "districtList": [
                    {
                        "citycode": "0574",
                        "adcode": "330206",
                        "name": "北仑区",
                        "center": {
                            "lng": 121.844601,
                            "lat": 29.899548
                        }
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330225",
                        "name": "象山县",
                        "center": {
                            "lng": 121.869251,
                            "lat": 29.476826
                        }
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330211",
                        "name": "镇海区",
                        "center": {
                            "lng": 121.596686,
                            "lat": 29.965212
                        }
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330205",
                        "name": "江北区",
                        "center": {
                            "lng": 121.555067,
                            "lat": 29.88673
                        }
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330203",
                        "name": "海曙区",
                        "center": {
                            "lng": 121.550485,
                            "lat": 29.873705
                        }
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330212",
                        "name": "鄞州区",
                        "center": {
                            "lng": 121.546617,
                            "lat": 29.817302
                        }
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330213",
                        "name": "奉化区",
                        "center": {
                            "lng": 121.406151,
                            "lat": 29.655292
                        }
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330282",
                        "name": "慈溪市",
                        "center": {
                            "lng": 121.266525,
                            "lat": 30.170695
                        }
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330226",
                        "name": "宁海县",
                        "center": {
                            "lng": 121.429729,
                            "lat": 29.287929
                        }
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330281",
                        "name": "余姚市",
                        "center": {
                            "lng": 121.154572,
                            "lat": 30.037967
                        }
                    }
                ]
            },
            {
                "citycode": "0576",
                "adcode": "331000",
                "name": "台州市",
                "center": {
                    "lng": 121.42079,
                    "lat": 28.655716
                },
                "districtList": [
                    {
                        "citycode": "0576",
                        "adcode": "331082",
                        "name": "临海市",
                        "center": {
                            "lng": 121.144625,
                            "lat": 28.859042
                        }
                    },
                    {
                        "citycode": "0576",
                        "adcode": "331002",
                        "name": "椒江区",
                        "center": {
                            "lng": 121.442859,
                            "lat": 28.673334
                        }
                    },
                    {
                        "citycode": "0576",
                        "adcode": "331004",
                        "name": "路桥区",
                        "center": {
                            "lng": 121.337874,
                            "lat": 28.578244
                        }
                    },
                    {
                        "citycode": "0576",
                        "adcode": "331083",
                        "name": "玉环市",
                        "center": {
                            "lng": 121.231915,
                            "lat": 28.136703
                        }
                    },
                    {
                        "citycode": "0576",
                        "adcode": "331081",
                        "name": "温岭市",
                        "center": {
                            "lng": 121.385435,
                            "lat": 28.372805
                        }
                    },
                    {
                        "citycode": "0576",
                        "adcode": "331022",
                        "name": "三门县",
                        "center": {
                            "lng": 121.39561,
                            "lat": 29.104888
                        }
                    },
                    {
                        "citycode": "0576",
                        "adcode": "331024",
                        "name": "仙居县",
                        "center": {
                            "lng": 120.728733,
                            "lat": 28.846856
                        }
                    },
                    {
                        "citycode": "0576",
                        "adcode": "331023",
                        "name": "天台县",
                        "center": {
                            "lng": 121.006657,
                            "lat": 29.144594
                        }
                    },
                    {
                        "citycode": "0576",
                        "adcode": "331003",
                        "name": "黄岩区",
                        "center": {
                            "lng": 121.261804,
                            "lat": 28.649433
                        }
                    }
                ]
            },
            {
                "citycode": "0577",
                "adcode": "330300",
                "name": "温州市",
                "center": {
                    "lng": 120.699279,
                    "lat": 27.993849
                },
                "districtList": [
                    {
                        "citycode": "0577",
                        "adcode": "330305",
                        "name": "洞头区",
                        "center": {
                            "lng": 121.157406,
                            "lat": 27.836412
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330327",
                        "name": "苍南县",
                        "center": {
                            "lng": 120.425957,
                            "lat": 27.518636
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330326",
                        "name": "平阳县",
                        "center": {
                            "lng": 120.565161,
                            "lat": 27.662394
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330329",
                        "name": "泰顺县",
                        "center": {
                            "lng": 119.717643,
                            "lat": 27.556578
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330381",
                        "name": "瑞安市",
                        "center": {
                            "lng": 120.655245,
                            "lat": 27.778967
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330328",
                        "name": "文成县",
                        "center": {
                            "lng": 120.090929,
                            "lat": 27.786856
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330383",
                        "name": "龙港市",
                        "center": {
                            "lng": 120.552952,
                            "lat": 27.578379
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330324",
                        "name": "永嘉县",
                        "center": {
                            "lng": 120.69136,
                            "lat": 28.153914
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330382",
                        "name": "乐清市",
                        "center": {
                            "lng": 120.986297,
                            "lat": 28.112519
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330302",
                        "name": "鹿城区",
                        "center": {
                            "lng": 120.655199,
                            "lat": 28.015776
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330304",
                        "name": "瓯海区",
                        "center": {
                            "lng": 120.615149,
                            "lat": 27.967445
                        }
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330303",
                        "name": "龙湾区",
                        "center": {
                            "lng": 120.812333,
                            "lat": 27.933261
                        }
                    }
                ]
            },
            {
                "citycode": "0579",
                "adcode": "330700",
                "name": "金华市",
                "center": {
                    "lng": 119.647265,
                    "lat": 29.079195
                },
                "districtList": [
                    {
                        "citycode": "0579",
                        "adcode": "330784",
                        "name": "永康市",
                        "center": {
                            "lng": 120.047356,
                            "lat": 28.88899
                        }
                    },
                    {
                        "citycode": "0579",
                        "adcode": "330723",
                        "name": "武义县",
                        "center": {
                            "lng": 119.816341,
                            "lat": 28.892562
                        }
                    },
                    {
                        "citycode": "0579",
                        "adcode": "330782",
                        "name": "义乌市",
                        "center": {
                            "lng": 120.075679,
                            "lat": 29.306296
                        }
                    },
                    {
                        "citycode": "0579",
                        "adcode": "330703",
                        "name": "金东区",
                        "center": {
                            "lng": 119.692821,
                            "lat": 29.099822
                        }
                    },
                    {
                        "citycode": "0579",
                        "adcode": "330702",
                        "name": "婺城区",
                        "center": {
                            "lng": 119.571574,
                            "lat": 29.087311
                        }
                    },
                    {
                        "citycode": "0579",
                        "adcode": "330783",
                        "name": "东阳市",
                        "center": {
                            "lng": 120.24179,
                            "lat": 29.290158
                        }
                    },
                    {
                        "citycode": "0579",
                        "adcode": "330727",
                        "name": "磐安县",
                        "center": {
                            "lng": 120.449937,
                            "lat": 29.054491
                        }
                    },
                    {
                        "citycode": "0579",
                        "adcode": "330726",
                        "name": "浦江县",
                        "center": {
                            "lng": 119.89259,
                            "lat": 29.453363
                        }
                    },
                    {
                        "citycode": "0579",
                        "adcode": "330781",
                        "name": "兰溪市",
                        "center": {
                            "lng": 119.460404,
                            "lat": 29.209059
                        }
                    }
                ]
            },
            {
                "citycode": "0571",
                "adcode": "330100",
                "name": "杭州市",
                "center": {
                    "lng": 120.210792,
                    "lat": 30.246026
                },
                "districtList": [
                    {
                        "citycode": "0571",
                        "adcode": "330122",
                        "name": "桐庐县",
                        "center": {
                            "lng": 119.691755,
                            "lat": 29.79418
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330111",
                        "name": "富阳区",
                        "center": {
                            "lng": 119.96022,
                            "lat": 30.048803
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330102",
                        "name": "上城区",
                        "center": {
                            "lng": 120.19732,
                            "lat": 30.226543
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330114",
                        "name": "钱塘区",
                        "center": {
                            "lng": 120.493941,
                            "lat": 30.32304
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330182",
                        "name": "建德市",
                        "center": {
                            "lng": 119.281195,
                            "lat": 29.474964
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330113",
                        "name": "临平区",
                        "center": {
                            "lng": 120.299222,
                            "lat": 30.419154
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330127",
                        "name": "淳安县",
                        "center": {
                            "lng": 119.042015,
                            "lat": 29.609678
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330112",
                        "name": "临安区",
                        "center": {
                            "lng": 119.724457,
                            "lat": 30.234375
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330110",
                        "name": "余杭区",
                        "center": {
                            "lng": 119.978742,
                            "lat": 30.273705
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330106",
                        "name": "西湖区",
                        "center": {
                            "lng": 120.130396,
                            "lat": 30.259242
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330105",
                        "name": "拱墅区",
                        "center": {
                            "lng": 120.141503,
                            "lat": 30.319126
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330108",
                        "name": "滨江区",
                        "center": {
                            "lng": 120.211981,
                            "lat": 30.208332
                        }
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330109",
                        "name": "萧山区",
                        "center": {
                            "lng": 120.264263,
                            "lat": 30.184119
                        }
                    }
                ]
            },
            {
                "citycode": "0572",
                "adcode": "330500",
                "name": "湖州市",
                "center": {
                    "lng": 120.086881,
                    "lat": 30.894178
                },
                "districtList": [
                    {
                        "citycode": "0572",
                        "adcode": "330523",
                        "name": "安吉县",
                        "center": {
                            "lng": 119.680261,
                            "lat": 30.638803
                        }
                    },
                    {
                        "citycode": "0572",
                        "adcode": "330502",
                        "name": "吴兴区",
                        "center": {
                            "lng": 120.185608,
                            "lat": 30.857184
                        }
                    },
                    {
                        "citycode": "0572",
                        "adcode": "330522",
                        "name": "长兴县",
                        "center": {
                            "lng": 119.911212,
                            "lat": 31.026962
                        }
                    },
                    {
                        "citycode": "0572",
                        "adcode": "330503",
                        "name": "南浔区",
                        "center": {
                            "lng": 120.418244,
                            "lat": 30.850835
                        }
                    },
                    {
                        "citycode": "0572",
                        "adcode": "330521",
                        "name": "德清县",
                        "center": {
                            "lng": 119.9774,
                            "lat": 30.54251
                        }
                    }
                ]
            },
            {
                "citycode": "0578",
                "adcode": "331100",
                "name": "丽水市",
                "center": {
                    "lng": 119.923249,
                    "lat": 28.467694
                },
                "districtList": [
                    {
                        "citycode": "0578",
                        "adcode": "331124",
                        "name": "松阳县",
                        "center": {
                            "lng": 119.481406,
                            "lat": 28.448883
                        }
                    },
                    {
                        "citycode": "0578",
                        "adcode": "331181",
                        "name": "龙泉市",
                        "center": {
                            "lng": 119.14126,
                            "lat": 28.074916
                        }
                    },
                    {
                        "citycode": "0578",
                        "adcode": "331125",
                        "name": "云和县",
                        "center": {
                            "lng": 119.573454,
                            "lat": 28.116024
                        }
                    },
                    {
                        "citycode": "0578",
                        "adcode": "331127",
                        "name": "景宁畲族自治县",
                        "center": {
                            "lng": 119.635686,
                            "lat": 27.973594
                        }
                    },
                    {
                        "citycode": "0578",
                        "adcode": "331122",
                        "name": "缙云县",
                        "center": {
                            "lng": 120.091685,
                            "lat": 28.659294
                        }
                    },
                    {
                        "citycode": "0578",
                        "adcode": "331121",
                        "name": "青田县",
                        "center": {
                            "lng": 120.289693,
                            "lat": 28.1396
                        }
                    },
                    {
                        "citycode": "0578",
                        "adcode": "331102",
                        "name": "莲都区",
                        "center": {
                            "lng": 119.912266,
                            "lat": 28.4461
                        }
                    },
                    {
                        "citycode": "0578",
                        "adcode": "331126",
                        "name": "庆元县",
                        "center": {
                            "lng": 119.062572,
                            "lat": 27.619213
                        }
                    },
                    {
                        "citycode": "0578",
                        "adcode": "331123",
                        "name": "遂昌县",
                        "center": {
                            "lng": 119.275865,
                            "lat": 28.592388
                        }
                    }
                ]
            },
            {
                "citycode": "0570",
                "adcode": "330800",
                "name": "衢州市",
                "center": {
                    "lng": 118.859307,
                    "lat": 28.970229
                },
                "districtList": [
                    {
                        "citycode": "0570",
                        "adcode": "330802",
                        "name": "柯城区",
                        "center": {
                            "lng": 118.874138,
                            "lat": 28.936937
                        }
                    },
                    {
                        "citycode": "0570",
                        "adcode": "330881",
                        "name": "江山市",
                        "center": {
                            "lng": 118.627228,
                            "lat": 28.73796
                        }
                    },
                    {
                        "citycode": "0570",
                        "adcode": "330822",
                        "name": "常山县",
                        "center": {
                            "lng": 118.511224,
                            "lat": 28.902446
                        }
                    },
                    {
                        "citycode": "0570",
                        "adcode": "330803",
                        "name": "衢江区",
                        "center": {
                            "lng": 118.959139,
                            "lat": 28.980356
                        }
                    },
                    {
                        "citycode": "0570",
                        "adcode": "330824",
                        "name": "开化县",
                        "center": {
                            "lng": 118.415756,
                            "lat": 29.136729
                        }
                    },
                    {
                        "citycode": "0570",
                        "adcode": "330825",
                        "name": "龙游县",
                        "center": {
                            "lng": 119.1723,
                            "lat": 29.028214
                        }
                    }
                ]
            },
            {
                "citycode": "0575",
                "adcode": "330600",
                "name": "绍兴市",
                "center": {
                    "lng": 120.582886,
                    "lat": 30.051549
                },
                "districtList": [
                    {
                        "citycode": "0575",
                        "adcode": "330681",
                        "name": "诸暨市",
                        "center": {
                            "lng": 120.246602,
                            "lat": 29.709398
                        }
                    },
                    {
                        "citycode": "0575",
                        "adcode": "330683",
                        "name": "嵊州市",
                        "center": {
                            "lng": 120.830505,
                            "lat": 29.561519
                        }
                    },
                    {
                        "citycode": "0575",
                        "adcode": "330624",
                        "name": "新昌县",
                        "center": {
                            "lng": 120.903918,
                            "lat": 29.500525
                        }
                    },
                    {
                        "citycode": "0575",
                        "adcode": "330604",
                        "name": "上虞区",
                        "center": {
                            "lng": 120.868571,
                            "lat": 30.033862
                        }
                    },
                    {
                        "citycode": "0575",
                        "adcode": "330602",
                        "name": "越城区",
                        "center": {
                            "lng": 120.582338,
                            "lat": 29.989092
                        }
                    },
                    {
                        "citycode": "0575",
                        "adcode": "330603",
                        "name": "柯桥区",
                        "center": {
                            "lng": 120.495532,
                            "lat": 30.083039
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "130000",
        "name": "河北省",
        "center": {
            "lng": 114.530399,
            "lat": 38.037707
        },
        "districtList": [
            {
                "citycode": "0315",
                "adcode": "130200",
                "name": "唐山市",
                "center": {
                    "lng": 118.180149,
                    "lat": 39.63068
                },
                "districtList": [
                    {
                        "citycode": "0315",
                        "adcode": "130225",
                        "name": "乐亭县",
                        "center": {
                            "lng": 118.91245,
                            "lat": 39.425748
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130229",
                        "name": "玉田县",
                        "center": {
                            "lng": 117.738196,
                            "lat": 39.901827
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130202",
                        "name": "路南区",
                        "center": {
                            "lng": 118.154348,
                            "lat": 39.624988
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130209",
                        "name": "曹妃甸区",
                        "center": {
                            "lng": 118.460197,
                            "lat": 39.273528
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130224",
                        "name": "滦南县",
                        "center": {
                            "lng": 118.68363,
                            "lat": 39.520272
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130205",
                        "name": "开平区",
                        "center": {
                            "lng": 118.262246,
                            "lat": 39.671634
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130204",
                        "name": "古冶区",
                        "center": {
                            "lng": 118.447134,
                            "lat": 39.73392
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130227",
                        "name": "迁西县",
                        "center": {
                            "lng": 118.31467,
                            "lat": 40.141486
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130284",
                        "name": "滦州市",
                        "center": {
                            "lng": 118.70301,
                            "lat": 39.740963
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130281",
                        "name": "遵化市",
                        "center": {
                            "lng": 117.965878,
                            "lat": 40.189119
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130207",
                        "name": "丰南区",
                        "center": {
                            "lng": 118.085169,
                            "lat": 39.576031
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130208",
                        "name": "丰润区",
                        "center": {
                            "lng": 118.162426,
                            "lat": 39.832919
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130203",
                        "name": "路北区",
                        "center": {
                            "lng": 118.201085,
                            "lat": 39.625079
                        }
                    },
                    {
                        "citycode": "0315",
                        "adcode": "130283",
                        "name": "迁安市",
                        "center": {
                            "lng": 118.701021,
                            "lat": 39.998861
                        }
                    }
                ]
            },
            {
                "citycode": "0335",
                "adcode": "130300",
                "name": "秦皇岛市",
                "center": {
                    "lng": 119.52022,
                    "lat": 39.888243
                },
                "districtList": [
                    {
                        "citycode": "0335",
                        "adcode": "130303",
                        "name": "山海关区",
                        "center": {
                            "lng": 119.775187,
                            "lat": 39.978882
                        }
                    },
                    {
                        "citycode": "0335",
                        "adcode": "130306",
                        "name": "抚宁区",
                        "center": {
                            "lng": 119.244847,
                            "lat": 39.876253
                        }
                    },
                    {
                        "citycode": "0335",
                        "adcode": "130302",
                        "name": "海港区",
                        "center": {
                            "lng": 119.564962,
                            "lat": 39.94756
                        }
                    },
                    {
                        "citycode": "0335",
                        "adcode": "130304",
                        "name": "北戴河区",
                        "center": {
                            "lng": 119.48449,
                            "lat": 39.834912
                        }
                    },
                    {
                        "citycode": "0335",
                        "adcode": "130321",
                        "name": "青龙满族自治县",
                        "center": {
                            "lng": 118.94985,
                            "lat": 40.407473
                        }
                    },
                    {
                        "citycode": "0335",
                        "adcode": "130322",
                        "name": "昌黎县",
                        "center": {
                            "lng": 119.199846,
                            "lat": 39.699677
                        }
                    },
                    {
                        "citycode": "0335",
                        "adcode": "130324",
                        "name": "卢龙县",
                        "center": {
                            "lng": 118.891931,
                            "lat": 39.892564
                        }
                    }
                ]
            },
            {
                "citycode": "0314",
                "adcode": "130800",
                "name": "承德市",
                "center": {
                    "lng": 117.962749,
                    "lat": 40.952942
                },
                "districtList": [
                    {
                        "citycode": "0314",
                        "adcode": "130828",
                        "name": "围场满族蒙古族自治县",
                        "center": {
                            "lng": 117.75934,
                            "lat": 41.938372
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130826",
                        "name": "丰宁满族自治县",
                        "center": {
                            "lng": 116.645798,
                            "lat": 41.209951
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130825",
                        "name": "隆化县",
                        "center": {
                            "lng": 117.739026,
                            "lat": 41.314402
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130827",
                        "name": "宽城满族自治县",
                        "center": {
                            "lng": 118.485472,
                            "lat": 40.611333
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130804",
                        "name": "鹰手营子矿区",
                        "center": {
                            "lng": 117.659341,
                            "lat": 40.546424
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130824",
                        "name": "滦平县",
                        "center": {
                            "lng": 117.332652,
                            "lat": 40.941644
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130803",
                        "name": "双滦区",
                        "center": {
                            "lng": 117.799588,
                            "lat": 40.959426
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130802",
                        "name": "双桥区",
                        "center": {
                            "lng": 117.943121,
                            "lat": 40.974679
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130821",
                        "name": "承德县",
                        "center": {
                            "lng": 118.174166,
                            "lat": 40.768082
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130822",
                        "name": "兴隆县",
                        "center": {
                            "lng": 117.500558,
                            "lat": 40.417358
                        }
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130881",
                        "name": "平泉市",
                        "center": {
                            "lng": 118.702032,
                            "lat": 41.018482
                        }
                    }
                ]
            },
            {
                "citycode": "0311",
                "adcode": "130100",
                "name": "石家庄市",
                "center": {
                    "lng": 114.514976,
                    "lat": 38.042007
                },
                "districtList": [
                    {
                        "citycode": "0311",
                        "adcode": "130126",
                        "name": "灵寿县",
                        "center": {
                            "lng": 114.383013,
                            "lat": 38.307908
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130183",
                        "name": "晋州市",
                        "center": {
                            "lng": 115.044141,
                            "lat": 38.033937
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130132",
                        "name": "元氏县",
                        "center": {
                            "lng": 114.525508,
                            "lat": 37.767332
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130127",
                        "name": "高邑县",
                        "center": {
                            "lng": 114.611659,
                            "lat": 37.615905
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130123",
                        "name": "正定县",
                        "center": {
                            "lng": 114.57043,
                            "lat": 38.14699
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130184",
                        "name": "新乐市",
                        "center": {
                            "lng": 114.683745,
                            "lat": 38.343952
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130181",
                        "name": "辛集市",
                        "center": {
                            "lng": 115.217626,
                            "lat": 37.943239
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130107",
                        "name": "井陉矿区",
                        "center": {
                            "lng": 114.062258,
                            "lat": 38.065446
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130121",
                        "name": "井陉县",
                        "center": {
                            "lng": 114.145669,
                            "lat": 38.032366
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130128",
                        "name": "深泽县",
                        "center": {
                            "lng": 115.20089,
                            "lat": 38.184572
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130133",
                        "name": "赵县",
                        "center": {
                            "lng": 114.775914,
                            "lat": 37.756935
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130125",
                        "name": "行唐县",
                        "center": {
                            "lng": 114.553044,
                            "lat": 38.437535
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130105",
                        "name": "新华区",
                        "center": {
                            "lng": 114.463904,
                            "lat": 38.050749
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130110",
                        "name": "鹿泉区",
                        "center": {
                            "lng": 114.313559,
                            "lat": 38.086536
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130131",
                        "name": "平山县",
                        "center": {
                            "lng": 114.186007,
                            "lat": 38.260288
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130104",
                        "name": "桥西区",
                        "center": {
                            "lng": 114.45004,
                            "lat": 38.025245
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130111",
                        "name": "栾城区",
                        "center": {
                            "lng": 114.647922,
                            "lat": 37.900915
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130108",
                        "name": "裕华区",
                        "center": {
                            "lng": 114.531599,
                            "lat": 38.007002
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130109",
                        "name": "藁城区",
                        "center": {
                            "lng": 114.846562,
                            "lat": 38.022177
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130102",
                        "name": "长安区",
                        "center": {
                            "lng": 114.538955,
                            "lat": 38.03682
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130130",
                        "name": "无极县",
                        "center": {
                            "lng": 114.976256,
                            "lat": 38.178852
                        }
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130129",
                        "name": "赞皇县",
                        "center": {
                            "lng": 114.386114,
                            "lat": 37.666549
                        }
                    }
                ]
            },
            {
                "citycode": "0316",
                "adcode": "131000",
                "name": "廊坊市",
                "center": {
                    "lng": 116.683546,
                    "lat": 39.538304
                },
                "districtList": [
                    {
                        "citycode": "0316",
                        "adcode": "131028",
                        "name": "大厂回族自治县",
                        "center": {
                            "lng": 116.98961,
                            "lat": 39.886569
                        }
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131026",
                        "name": "文安县",
                        "center": {
                            "lng": 116.457628,
                            "lat": 38.873185
                        }
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131082",
                        "name": "三河市",
                        "center": {
                            "lng": 117.078269,
                            "lat": 39.982933
                        }
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131081",
                        "name": "霸州市",
                        "center": {
                            "lng": 116.391488,
                            "lat": 39.125238
                        }
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131022",
                        "name": "固安县",
                        "center": {
                            "lng": 116.298696,
                            "lat": 39.438797
                        }
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131025",
                        "name": "大城县",
                        "center": {
                            "lng": 116.653917,
                            "lat": 38.705232
                        }
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131023",
                        "name": "永清县",
                        "center": {
                            "lng": 116.50608,
                            "lat": 39.330983
                        }
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131002",
                        "name": "安次区",
                        "center": {
                            "lng": 116.694544,
                            "lat": 39.502569
                        }
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131003",
                        "name": "广阳区",
                        "center": {
                            "lng": 116.710667,
                            "lat": 39.52343
                        }
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131024",
                        "name": "香河县",
                        "center": {
                            "lng": 117.006072,
                            "lat": 39.763772
                        }
                    }
                ]
            },
            {
                "citycode": "0318",
                "adcode": "131100",
                "name": "衡水市",
                "center": {
                    "lng": 115.668987,
                    "lat": 37.739367
                },
                "districtList": [
                    {
                        "citycode": "0318",
                        "adcode": "131102",
                        "name": "桃城区",
                        "center": {
                            "lng": 115.675208,
                            "lat": 37.735152
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131182",
                        "name": "深州市",
                        "center": {
                            "lng": 115.559576,
                            "lat": 38.001535
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131128",
                        "name": "阜城县",
                        "center": {
                            "lng": 116.175424,
                            "lat": 37.862984
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131103",
                        "name": "冀州区",
                        "center": {
                            "lng": 115.579392,
                            "lat": 37.550922
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131126",
                        "name": "故城县",
                        "center": {
                            "lng": 115.965877,
                            "lat": 37.347873
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131122",
                        "name": "武邑县",
                        "center": {
                            "lng": 115.887498,
                            "lat": 37.802036
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131123",
                        "name": "武强县",
                        "center": {
                            "lng": 115.982119,
                            "lat": 38.041447
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131121",
                        "name": "枣强县",
                        "center": {
                            "lng": 115.724365,
                            "lat": 37.514217
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131124",
                        "name": "饶阳县",
                        "center": {
                            "lng": 115.725898,
                            "lat": 38.235313
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131125",
                        "name": "安平县",
                        "center": {
                            "lng": 115.518918,
                            "lat": 38.234769
                        }
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131127",
                        "name": "景县",
                        "center": {
                            "lng": 116.270558,
                            "lat": 37.692831
                        }
                    }
                ]
            },
            {
                "citycode": "0313",
                "adcode": "130700",
                "name": "张家口市",
                "center": {
                    "lng": 114.885895,
                    "lat": 40.768931
                },
                "districtList": [
                    {
                        "citycode": "0313",
                        "adcode": "130723",
                        "name": "康保县",
                        "center": {
                            "lng": 114.60018,
                            "lat": 41.853016
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130732",
                        "name": "赤城县",
                        "center": {
                            "lng": 115.831256,
                            "lat": 40.913348
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130709",
                        "name": "崇礼区",
                        "center": {
                            "lng": 115.282345,
                            "lat": 40.974741
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130706",
                        "name": "下花园区",
                        "center": {
                            "lng": 115.287127,
                            "lat": 40.502628
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130731",
                        "name": "涿鹿县",
                        "center": {
                            "lng": 115.196835,
                            "lat": 40.382681
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130702",
                        "name": "桥东区",
                        "center": {
                            "lng": 114.894114,
                            "lat": 40.788472
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130705",
                        "name": "宣化区",
                        "center": {
                            "lng": 115.099515,
                            "lat": 40.609444
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130726",
                        "name": "蔚县",
                        "center": {
                            "lng": 114.589136,
                            "lat": 39.840154
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130728",
                        "name": "怀安县",
                        "center": {
                            "lng": 114.386488,
                            "lat": 40.67527
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130703",
                        "name": "桥西区",
                        "center": {
                            "lng": 114.868604,
                            "lat": 40.819553
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130725",
                        "name": "尚义县",
                        "center": {
                            "lng": 113.968763,
                            "lat": 41.076588
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130722",
                        "name": "张北县",
                        "center": {
                            "lng": 114.719927,
                            "lat": 41.159039
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130708",
                        "name": "万全区",
                        "center": {
                            "lng": 114.740584,
                            "lat": 40.767377
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130730",
                        "name": "怀来县",
                        "center": {
                            "lng": 115.517868,
                            "lat": 40.415625
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130727",
                        "name": "阳原县",
                        "center": {
                            "lng": 114.150267,
                            "lat": 40.104303
                        }
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130724",
                        "name": "沽源县",
                        "center": {
                            "lng": 115.688544,
                            "lat": 41.670497
                        }
                    }
                ]
            },
            {
                "citycode": "0312",
                "adcode": "130600",
                "name": "保定市",
                "center": {
                    "lng": 115.464523,
                    "lat": 38.874476
                },
                "districtList": [
                    {
                        "citycode": "0312",
                        "adcode": "130636",
                        "name": "顺平县",
                        "center": {
                            "lng": 115.135133,
                            "lat": 38.837988
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130632",
                        "name": "安新县",
                        "center": {
                            "lng": 115.935688,
                            "lat": 38.936102
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130683",
                        "name": "安国市",
                        "center": {
                            "lng": 115.327088,
                            "lat": 38.418985
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130623",
                        "name": "涞水县",
                        "center": {
                            "lng": 115.713651,
                            "lat": 39.394305
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130624",
                        "name": "阜平县",
                        "center": {
                            "lng": 114.195118,
                            "lat": 38.849221
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130631",
                        "name": "望都县",
                        "center": {
                            "lng": 115.15542,
                            "lat": 38.696221
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130627",
                        "name": "唐县",
                        "center": {
                            "lng": 114.982968,
                            "lat": 38.748477
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130684",
                        "name": "高碑店市",
                        "center": {
                            "lng": 115.873612,
                            "lat": 39.327233
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130626",
                        "name": "定兴县",
                        "center": {
                            "lng": 115.808183,
                            "lat": 39.263219
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130629",
                        "name": "容城县",
                        "center": {
                            "lng": 115.861635,
                            "lat": 39.043321
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130638",
                        "name": "雄县",
                        "center": {
                            "lng": 116.108624,
                            "lat": 38.994825
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130634",
                        "name": "曲阳县",
                        "center": {
                            "lng": 114.740476,
                            "lat": 38.614409
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130637",
                        "name": "博野县",
                        "center": {
                            "lng": 115.464295,
                            "lat": 38.458048
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130628",
                        "name": "高阳县",
                        "center": {
                            "lng": 115.779149,
                            "lat": 38.700846
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130635",
                        "name": "蠡县",
                        "center": {
                            "lng": 115.583701,
                            "lat": 38.488064
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130681",
                        "name": "涿州市",
                        "center": {
                            "lng": 115.97444,
                            "lat": 39.485684
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130630",
                        "name": "涞源县",
                        "center": {
                            "lng": 114.694416,
                            "lat": 39.360622
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130606",
                        "name": "莲池区",
                        "center": {
                            "lng": 115.497153,
                            "lat": 38.883528
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130608",
                        "name": "清苑区",
                        "center": {
                            "lng": 115.48988,
                            "lat": 38.76527
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130682",
                        "name": "定州市",
                        "center": {
                            "lng": 114.990321,
                            "lat": 38.516746
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130609",
                        "name": "徐水区",
                        "center": {
                            "lng": 115.655772,
                            "lat": 39.018781
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130633",
                        "name": "易县",
                        "center": {
                            "lng": 115.497487,
                            "lat": 39.350219
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130607",
                        "name": "满城区",
                        "center": {
                            "lng": 115.322246,
                            "lat": 38.949732
                        }
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130602",
                        "name": "竞秀区",
                        "center": {
                            "lng": 115.458671,
                            "lat": 38.877318
                        }
                    }
                ]
            },
            {
                "citycode": "0319",
                "adcode": "130500",
                "name": "邢台市",
                "center": {
                    "lng": 114.49742,
                    "lat": 37.060227
                },
                "districtList": [
                    {
                        "citycode": "0319",
                        "adcode": "130581",
                        "name": "南宫市",
                        "center": {
                            "lng": 115.40866,
                            "lat": 37.358907
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130506",
                        "name": "南和区",
                        "center": {
                            "lng": 114.683683,
                            "lat": 37.005626
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130530",
                        "name": "新河县",
                        "center": {
                            "lng": 115.251005,
                            "lat": 37.520891
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130524",
                        "name": "柏乡县",
                        "center": {
                            "lng": 114.693447,
                            "lat": 37.48288
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130534",
                        "name": "清河县",
                        "center": {
                            "lng": 115.665081,
                            "lat": 37.0451
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130533",
                        "name": "威县",
                        "center": {
                            "lng": 115.266829,
                            "lat": 36.975164
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130535",
                        "name": "临西县",
                        "center": {
                            "lng": 115.501258,
                            "lat": 36.871312
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130582",
                        "name": "沙河市",
                        "center": {
                            "lng": 114.503023,
                            "lat": 36.855548
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130523",
                        "name": "内丘县",
                        "center": {
                            "lng": 114.512226,
                            "lat": 37.287612
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130505",
                        "name": "任泽区",
                        "center": {
                            "lng": 114.671339,
                            "lat": 37.121958
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130522",
                        "name": "临城县",
                        "center": {
                            "lng": 114.498651,
                            "lat": 37.444512
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130529",
                        "name": "巨鹿县",
                        "center": {
                            "lng": 115.037884,
                            "lat": 37.221293
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130525",
                        "name": "隆尧县",
                        "center": {
                            "lng": 114.770509,
                            "lat": 37.351232
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130531",
                        "name": "广宗县",
                        "center": {
                            "lng": 115.142766,
                            "lat": 37.074795
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130532",
                        "name": "平乡县",
                        "center": {
                            "lng": 115.03008,
                            "lat": 37.063771
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130502",
                        "name": "襄都区",
                        "center": {
                            "lng": 114.507443,
                            "lat": 37.071314
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130503",
                        "name": "信都区",
                        "center": {
                            "lng": 114.468229,
                            "lat": 37.093798
                        }
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130528",
                        "name": "宁晋县",
                        "center": {
                            "lng": 114.940006,
                            "lat": 37.624524
                        }
                    }
                ]
            },
            {
                "citycode": "0310",
                "adcode": "130400",
                "name": "邯郸市",
                "center": {
                    "lng": 114.53915,
                    "lat": 36.625849
                },
                "districtList": [
                    {
                        "citycode": "0310",
                        "adcode": "130407",
                        "name": "肥乡区",
                        "center": {
                            "lng": 114.800199,
                            "lat": 36.548545
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130431",
                        "name": "鸡泽县",
                        "center": {
                            "lng": 114.889951,
                            "lat": 36.911525
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130408",
                        "name": "永年区",
                        "center": {
                            "lng": 114.536626,
                            "lat": 36.74188
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130423",
                        "name": "临漳县",
                        "center": {
                            "lng": 114.585514,
                            "lat": 36.322504
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130402",
                        "name": "邯山区",
                        "center": {
                            "lng": 114.531062,
                            "lat": 36.59457
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130425",
                        "name": "大名县",
                        "center": {
                            "lng": 115.147985,
                            "lat": 36.286406
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130403",
                        "name": "丛台区",
                        "center": {
                            "lng": 114.492875,
                            "lat": 36.636434
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130404",
                        "name": "复兴区",
                        "center": {
                            "lng": 114.462581,
                            "lat": 36.638879
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130435",
                        "name": "曲周县",
                        "center": {
                            "lng": 114.957549,
                            "lat": 36.766347
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130481",
                        "name": "武安市",
                        "center": {
                            "lng": 114.203685,
                            "lat": 36.69759
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130432",
                        "name": "广平县",
                        "center": {
                            "lng": 114.921185,
                            "lat": 36.476727
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130424",
                        "name": "成安县",
                        "center": {
                            "lng": 114.670094,
                            "lat": 36.445331
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130433",
                        "name": "馆陶县",
                        "center": {
                            "lng": 115.281818,
                            "lat": 36.548295
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130430",
                        "name": "邱县",
                        "center": {
                            "lng": 115.200049,
                            "lat": 36.811783
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130426",
                        "name": "涉县",
                        "center": {
                            "lng": 113.692157,
                            "lat": 36.586073
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130434",
                        "name": "魏县",
                        "center": {
                            "lng": 114.939217,
                            "lat": 36.35926
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130406",
                        "name": "峰峰矿区",
                        "center": {
                            "lng": 114.212571,
                            "lat": 36.419298
                        }
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130427",
                        "name": "磁县",
                        "center": {
                            "lng": 114.373965,
                            "lat": 36.37507
                        }
                    }
                ]
            },
            {
                "citycode": "0317",
                "adcode": "130900",
                "name": "沧州市",
                "center": {
                    "lng": 116.838715,
                    "lat": 38.304676
                },
                "districtList": [
                    {
                        "citycode": "0317",
                        "adcode": "130924",
                        "name": "海兴县",
                        "center": {
                            "lng": 117.497545,
                            "lat": 38.143308
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130982",
                        "name": "任丘市",
                        "center": {
                            "lng": 116.084412,
                            "lat": 38.685325
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130923",
                        "name": "东光县",
                        "center": {
                            "lng": 116.537138,
                            "lat": 37.888844
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130928",
                        "name": "吴桥县",
                        "center": {
                            "lng": 116.391557,
                            "lat": 37.628225
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130902",
                        "name": "新华区",
                        "center": {
                            "lng": 116.866309,
                            "lat": 38.314094
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130903",
                        "name": "运河区",
                        "center": {
                            "lng": 116.842964,
                            "lat": 38.283456
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130921",
                        "name": "沧县",
                        "center": {
                            "lng": 117.007478,
                            "lat": 38.219856
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130930",
                        "name": "孟村回族自治县",
                        "center": {
                            "lng": 117.104514,
                            "lat": 38.053438
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130925",
                        "name": "盐山县",
                        "center": {
                            "lng": 117.230681,
                            "lat": 38.058074
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130927",
                        "name": "南皮县",
                        "center": {
                            "lng": 116.708603,
                            "lat": 38.038761
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130922",
                        "name": "青县",
                        "center": {
                            "lng": 116.804137,
                            "lat": 38.583657
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130926",
                        "name": "肃宁县",
                        "center": {
                            "lng": 115.829619,
                            "lat": 38.423044
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130984",
                        "name": "河间市",
                        "center": {
                            "lng": 116.099362,
                            "lat": 38.446656
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130981",
                        "name": "泊头市",
                        "center": {
                            "lng": 116.578322,
                            "lat": 38.084262
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130929",
                        "name": "献县",
                        "center": {
                            "lng": 116.122767,
                            "lat": 38.189924
                        }
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130983",
                        "name": "黄骅市",
                        "center": {
                            "lng": 117.330043,
                            "lat": 38.372266
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": "1852",
        "adcode": "810000",
        "name": "香港特别行政区",
        "center": {
            "lng": 114.171203,
            "lat": 22.277468
        },
        "districtList": [
            {
                "citycode": "1852",
                "adcode": "810013",
                "name": "北区",
                "center": {
                    "lng": 114.147364,
                    "lat": 22.496104
                }
            },
            {
                "citycode": "1852",
                "adcode": "810015",
                "name": "西贡区",
                "center": {
                    "lng": 114.264645,
                    "lat": 22.314213
                }
            },
            {
                "citycode": "1852",
                "adcode": "810014",
                "name": "大埔区",
                "center": {
                    "lng": 114.171743,
                    "lat": 22.445653
                }
            },
            {
                "citycode": "1852",
                "adcode": "810011",
                "name": "屯门区",
                "center": {
                    "lng": 113.976574,
                    "lat": 22.393844
                }
            },
            {
                "citycode": "1852",
                "adcode": "810016",
                "name": "沙田区",
                "center": {
                    "lng": 114.195365,
                    "lat": 22.379532
                }
            },
            {
                "citycode": "1852",
                "adcode": "810008",
                "name": "黄大仙区",
                "center": {
                    "lng": 114.203886,
                    "lat": 22.336321
                }
            },
            {
                "citycode": "1852",
                "adcode": "810003",
                "name": "东区",
                "center": {
                    "lng": 114.226003,
                    "lat": 22.279693
                }
            },
            {
                "citycode": "1852",
                "adcode": "810009",
                "name": "观塘区",
                "center": {
                    "lng": 114.214054,
                    "lat": 22.320838
                }
            },
            {
                "citycode": "1852",
                "adcode": "810018",
                "name": "离岛区",
                "center": {
                    "lng": 113.94612,
                    "lat": 22.286408
                }
            },
            {
                "citycode": "1852",
                "adcode": "810004",
                "name": "南区",
                "center": {
                    "lng": 114.160012,
                    "lat": 22.245897
                }
            },
            {
                "citycode": "1852",
                "adcode": "810001",
                "name": "中西区",
                "center": {
                    "lng": 114.154373,
                    "lat": 22.281981
                }
            },
            {
                "citycode": "1852",
                "adcode": "810007",
                "name": "九龙城区",
                "center": {
                    "lng": 114.192847,
                    "lat": 22.31251
                }
            },
            {
                "citycode": "1852",
                "adcode": "810006",
                "name": "深水埗区",
                "center": {
                    "lng": 114.163242,
                    "lat": 22.333854
                }
            },
            {
                "citycode": "1852",
                "adcode": "810005",
                "name": "油尖旺区",
                "center": {
                    "lng": 114.173332,
                    "lat": 22.311704
                }
            },
            {
                "citycode": "1852",
                "adcode": "810002",
                "name": "湾仔区",
                "center": {
                    "lng": 114.182915,
                    "lat": 22.276389
                }
            },
            {
                "citycode": "1852",
                "adcode": "810012",
                "name": "元朗区",
                "center": {
                    "lng": 114.032438,
                    "lat": 22.441428
                }
            },
            {
                "citycode": "1852",
                "adcode": "810010",
                "name": "荃湾区",
                "center": {
                    "lng": 114.121079,
                    "lat": 22.368307
                }
            },
            {
                "citycode": "1852",
                "adcode": "810017",
                "name": "葵青区",
                "center": {
                    "lng": 114.139319,
                    "lat": 22.363877
                }
            }
        ]
    },
    {
        "citycode": "1886",
        "adcode": "710000",
        "name": "台湾省",
        "center": {
            "lng": 121.509062,
            "lat": 25.044332
        }
    },
    {
        "citycode": "1853",
        "adcode": "820000",
        "name": "澳门特别行政区",
        "center": {
            "lng": 113.543076,
            "lat": 22.186927
        },
        "districtList": [
            {
                "citycode": "1853",
                "adcode": "820002",
                "name": "花王堂区",
                "center": {
                    "lng": 113.548961,
                    "lat": 22.199208
                }
            },
            {
                "citycode": "1853",
                "adcode": "820008",
                "name": "圣方济各堂区",
                "center": {
                    "lng": 113.559954,
                    "lat": 22.123486
                }
            },
            {
                "citycode": "1853",
                "adcode": "820007",
                "name": "路氹填海区",
                "center": {
                    "lng": 113.569599,
                    "lat": 22.13663
                }
            },
            {
                "citycode": "1853",
                "adcode": "820005",
                "name": "风顺堂区",
                "center": {
                    "lng": 113.541928,
                    "lat": 22.187368
                }
            },
            {
                "citycode": "1853",
                "adcode": "820003",
                "name": "望德堂区",
                "center": {
                    "lng": 113.550183,
                    "lat": 22.193721
                }
            },
            {
                "citycode": "1853",
                "adcode": "820001",
                "name": "花地玛堂区",
                "center": {
                    "lng": 113.552896,
                    "lat": 22.20787
                }
            },
            {
                "citycode": "1853",
                "adcode": "820006",
                "name": "嘉模堂区",
                "center": {
                    "lng": 113.558704,
                    "lat": 22.153759
                }
            },
            {
                "citycode": "1853",
                "adcode": "820004",
                "name": "大堂区",
                "center": {
                    "lng": 113.553648,
                    "lat": 22.188539
                }
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "620000",
        "name": "甘肃省",
        "center": {
            "lng": 103.826777,
            "lat": 36.060634
        },
        "districtList": [
            {
                "citycode": "1937",
                "adcode": "620200",
                "name": "嘉峪关市",
                "center": {
                    "lng": 98.2882,
                    "lat": 39.77325
                },
                "districtList": [
                    {
                        "citycode": "1937",
                        "adcode": "620200",
                        "name": "峪泉镇",
                        "center": {
                            "lng": 98.32041,
                            "lat": 39.958254
                        }
                    },
                    {
                        "citycode": "1937",
                        "adcode": "620200",
                        "name": "新城镇",
                        "center": {
                            "lng": 98.362748,
                            "lat": 39.958127
                        }
                    },
                    {
                        "citycode": "1937",
                        "adcode": "620200",
                        "name": "文殊镇",
                        "center": {
                            "lng": 98.157893,
                            "lat": 39.696861
                        }
                    },
                    {
                        "citycode": "1937",
                        "adcode": "620200",
                        "name": "雄关街道",
                        "center": {
                            "lng": 98.239097,
                            "lat": 39.892952
                        }
                    },
                    {
                        "citycode": "1937",
                        "adcode": "620200",
                        "name": "钢城街道",
                        "center": {
                            "lng": 98.292606,
                            "lat": 39.75577
                        }
                    }
                ]
            },
            {
                "citycode": "0935",
                "adcode": "620300",
                "name": "金昌市",
                "center": {
                    "lng": 102.187972,
                    "lat": 38.521468
                },
                "districtList": [
                    {
                        "citycode": "0935",
                        "adcode": "620302",
                        "name": "金川区",
                        "center": {
                            "lng": 102.1939,
                            "lat": 38.520373
                        }
                    },
                    {
                        "citycode": "0935",
                        "adcode": "620321",
                        "name": "永昌县",
                        "center": {
                            "lng": 101.984642,
                            "lat": 38.243534
                        }
                    }
                ]
            },
            {
                "citycode": "0937",
                "adcode": "620900",
                "name": "酒泉市",
                "center": {
                    "lng": 98.49432,
                    "lat": 39.733416
                },
                "districtList": [
                    {
                        "citycode": "0937",
                        "adcode": "620923",
                        "name": "肃北蒙古族自治县",
                        "center": {
                            "lng": 94.876533,
                            "lat": 39.512158
                        }
                    },
                    {
                        "citycode": "0937",
                        "adcode": "620982",
                        "name": "敦煌市",
                        "center": {
                            "lng": 94.66201,
                            "lat": 40.142141
                        }
                    },
                    {
                        "citycode": "0937",
                        "adcode": "620902",
                        "name": "肃州区",
                        "center": {
                            "lng": 98.507834,
                            "lat": 39.74511
                        }
                    },
                    {
                        "citycode": "0937",
                        "adcode": "620921",
                        "name": "金塔县",
                        "center": {
                            "lng": 98.901523,
                            "lat": 39.984146
                        }
                    },
                    {
                        "citycode": "0937",
                        "adcode": "620981",
                        "name": "玉门市",
                        "center": {
                            "lng": 97.045617,
                            "lat": 40.292344
                        }
                    },
                    {
                        "citycode": "0937",
                        "adcode": "620922",
                        "name": "瓜州县",
                        "center": {
                            "lng": 95.782255,
                            "lat": 40.520457
                        }
                    },
                    {
                        "citycode": "0937",
                        "adcode": "620924",
                        "name": "阿克塞哈萨克族自治县",
                        "center": {
                            "lng": 94.340202,
                            "lat": 39.633944
                        }
                    }
                ]
            },
            {
                "citycode": "0931",
                "adcode": "620100",
                "name": "兰州市",
                "center": {
                    "lng": 103.834228,
                    "lat": 36.060798
                },
                "districtList": [
                    {
                        "citycode": "0931",
                        "adcode": "620111",
                        "name": "红古区",
                        "center": {
                            "lng": 102.859338,
                            "lat": 36.345768
                        }
                    },
                    {
                        "citycode": "0931",
                        "adcode": "620104",
                        "name": "西固区",
                        "center": {
                            "lng": 103.627966,
                            "lat": 36.08845
                        }
                    },
                    {
                        "citycode": "0931",
                        "adcode": "620103",
                        "name": "七里河区",
                        "center": {
                            "lng": 103.786261,
                            "lat": 36.066249
                        }
                    },
                    {
                        "citycode": "0931",
                        "adcode": "620123",
                        "name": "榆中县",
                        "center": {
                            "lng": 104.112541,
                            "lat": 35.843354
                        }
                    },
                    {
                        "citycode": "0931",
                        "adcode": "620105",
                        "name": "安宁区",
                        "center": {
                            "lng": 103.718953,
                            "lat": 36.104493
                        }
                    },
                    {
                        "citycode": "0931",
                        "adcode": "620102",
                        "name": "城关区",
                        "center": {
                            "lng": 103.825315,
                            "lat": 36.056948
                        }
                    },
                    {
                        "citycode": "0931",
                        "adcode": "620122",
                        "name": "皋兰县",
                        "center": {
                            "lng": 103.947345,
                            "lat": 36.332434
                        }
                    },
                    {
                        "citycode": "0931",
                        "adcode": "620121",
                        "name": "永登县",
                        "center": {
                            "lng": 103.260273,
                            "lat": 36.736457
                        }
                    }
                ]
            },
            {
                "citycode": "0933",
                "adcode": "620800",
                "name": "平凉市",
                "center": {
                    "lng": 106.664913,
                    "lat": 35.542417
                },
                "districtList": [
                    {
                        "citycode": "0933",
                        "adcode": "620823",
                        "name": "崇信县",
                        "center": {
                            "lng": 107.025762,
                            "lat": 35.305648
                        }
                    },
                    {
                        "citycode": "0933",
                        "adcode": "620825",
                        "name": "庄浪县",
                        "center": {
                            "lng": 106.036201,
                            "lat": 35.20266
                        }
                    },
                    {
                        "citycode": "0933",
                        "adcode": "620802",
                        "name": "崆峒区",
                        "center": {
                            "lng": 106.67489,
                            "lat": 35.542437
                        }
                    },
                    {
                        "citycode": "0933",
                        "adcode": "620881",
                        "name": "华亭市",
                        "center": {
                            "lng": 106.628899,
                            "lat": 35.207695
                        }
                    },
                    {
                        "citycode": "0933",
                        "adcode": "620826",
                        "name": "静宁县",
                        "center": {
                            "lng": 105.732165,
                            "lat": 35.522035
                        }
                    },
                    {
                        "citycode": "0933",
                        "adcode": "620822",
                        "name": "灵台县",
                        "center": {
                            "lng": 107.595874,
                            "lat": 35.070027
                        }
                    },
                    {
                        "citycode": "0933",
                        "adcode": "620821",
                        "name": "泾川县",
                        "center": {
                            "lng": 107.367608,
                            "lat": 35.332992
                        }
                    }
                ]
            },
            {
                "citycode": "0936",
                "adcode": "620700",
                "name": "张掖市",
                "center": {
                    "lng": 100.449858,
                    "lat": 38.924766
                },
                "districtList": [
                    {
                        "citycode": "0936",
                        "adcode": "620721",
                        "name": "肃南裕固族自治县",
                        "center": {
                            "lng": 99.615601,
                            "lat": 38.836931
                        }
                    },
                    {
                        "citycode": "0936",
                        "adcode": "620724",
                        "name": "高台县",
                        "center": {
                            "lng": 99.819265,
                            "lat": 39.378294
                        }
                    },
                    {
                        "citycode": "0936",
                        "adcode": "620722",
                        "name": "民乐县",
                        "center": {
                            "lng": 100.812047,
                            "lat": 38.430318
                        }
                    },
                    {
                        "citycode": "0936",
                        "adcode": "620725",
                        "name": "山丹县",
                        "center": {
                            "lng": 101.088611,
                            "lat": 38.7846
                        }
                    },
                    {
                        "citycode": "0936",
                        "adcode": "620702",
                        "name": "甘州区",
                        "center": {
                            "lng": 100.415324,
                            "lat": 38.944315
                        }
                    },
                    {
                        "citycode": "0936",
                        "adcode": "620723",
                        "name": "临泽县",
                        "center": {
                            "lng": 100.164333,
                            "lat": 39.15224
                        }
                    }
                ]
            },
            {
                "citycode": "1935",
                "adcode": "620600",
                "name": "武威市",
                "center": {
                    "lng": 102.637821,
                    "lat": 37.92898
                },
                "districtList": [
                    {
                        "citycode": "1935",
                        "adcode": "620622",
                        "name": "古浪县",
                        "center": {
                            "lng": 102.897542,
                            "lat": 37.470882
                        }
                    },
                    {
                        "citycode": "1935",
                        "adcode": "620602",
                        "name": "凉州区",
                        "center": {
                            "lng": 102.641959,
                            "lat": 37.928217
                        }
                    },
                    {
                        "citycode": "1935",
                        "adcode": "620621",
                        "name": "民勤县",
                        "center": {
                            "lng": 103.093671,
                            "lat": 38.624293
                        }
                    },
                    {
                        "citycode": "1935",
                        "adcode": "620623",
                        "name": "天祝藏族自治县",
                        "center": {
                            "lng": 103.142416,
                            "lat": 36.971978
                        }
                    }
                ]
            },
            {
                "citycode": "0941",
                "adcode": "623000",
                "name": "甘南藏族自治州",
                "center": {
                    "lng": 102.911736,
                    "lat": 34.983266
                },
                "districtList": [
                    {
                        "citycode": "0941",
                        "adcode": "623027",
                        "name": "夏河县",
                        "center": {
                            "lng": 102.548303,
                            "lat": 35.203857
                        }
                    },
                    {
                        "citycode": "0941",
                        "adcode": "623001",
                        "name": "合作市",
                        "center": {
                            "lng": 102.910305,
                            "lat": 35.000228
                        }
                    },
                    {
                        "citycode": "0941",
                        "adcode": "623022",
                        "name": "卓尼县",
                        "center": {
                            "lng": 103.506849,
                            "lat": 34.589476
                        }
                    },
                    {
                        "citycode": "0941",
                        "adcode": "623021",
                        "name": "临潭县",
                        "center": {
                            "lng": 103.353665,
                            "lat": 34.693009
                        }
                    },
                    {
                        "citycode": "0941",
                        "adcode": "623024",
                        "name": "迭部县",
                        "center": {
                            "lng": 103.221735,
                            "lat": 34.055888
                        }
                    },
                    {
                        "citycode": "0941",
                        "adcode": "623026",
                        "name": "碌曲县",
                        "center": {
                            "lng": 102.487512,
                            "lat": 34.591084
                        }
                    },
                    {
                        "citycode": "0941",
                        "adcode": "623025",
                        "name": "玛曲县",
                        "center": {
                            "lng": 102.072608,
                            "lat": 33.998145
                        }
                    },
                    {
                        "citycode": "0941",
                        "adcode": "623023",
                        "name": "舟曲县",
                        "center": {
                            "lng": 104.251543,
                            "lat": 33.793695
                        }
                    }
                ]
            },
            {
                "citycode": "2935",
                "adcode": "621200",
                "name": "陇南市",
                "center": {
                    "lng": 104.960296,
                    "lat": 33.370174
                },
                "districtList": [
                    {
                        "citycode": "2935",
                        "adcode": "621202",
                        "name": "武都区",
                        "center": {
                            "lng": 104.921861,
                            "lat": 33.400685
                        }
                    },
                    {
                        "citycode": "2935",
                        "adcode": "621222",
                        "name": "文县",
                        "center": {
                            "lng": 104.6835,
                            "lat": 32.944031
                        }
                    },
                    {
                        "citycode": "2935",
                        "adcode": "621225",
                        "name": "西和县",
                        "center": {
                            "lng": 105.298756,
                            "lat": 34.014215
                        }
                    },
                    {
                        "citycode": "2935",
                        "adcode": "621224",
                        "name": "康县",
                        "center": {
                            "lng": 105.608609,
                            "lat": 33.329212
                        }
                    },
                    {
                        "citycode": "2935",
                        "adcode": "621223",
                        "name": "宕昌县",
                        "center": {
                            "lng": 104.393385,
                            "lat": 34.047261
                        }
                    },
                    {
                        "citycode": "2935",
                        "adcode": "621228",
                        "name": "两当县",
                        "center": {
                            "lng": 106.304973,
                            "lat": 33.908952
                        }
                    },
                    {
                        "citycode": "2935",
                        "adcode": "621227",
                        "name": "徽县",
                        "center": {
                            "lng": 106.087156,
                            "lat": 33.769927
                        }
                    },
                    {
                        "citycode": "2935",
                        "adcode": "621226",
                        "name": "礼县",
                        "center": {
                            "lng": 105.17864,
                            "lat": 34.189345
                        }
                    },
                    {
                        "citycode": "2935",
                        "adcode": "621221",
                        "name": "成县",
                        "center": {
                            "lng": 105.729569,
                            "lat": 33.740547
                        }
                    }
                ]
            },
            {
                "citycode": "0938",
                "adcode": "620500",
                "name": "天水市",
                "center": {
                    "lng": 105.724828,
                    "lat": 34.581514
                },
                "districtList": [
                    {
                        "citycode": "0938",
                        "adcode": "620525",
                        "name": "张家川回族自治县",
                        "center": {
                            "lng": 106.20513,
                            "lat": 34.988676
                        }
                    },
                    {
                        "citycode": "0938",
                        "adcode": "620524",
                        "name": "武山县",
                        "center": {
                            "lng": 104.89121,
                            "lat": 34.72183
                        }
                    },
                    {
                        "citycode": "0938",
                        "adcode": "620503",
                        "name": "麦积区",
                        "center": {
                            "lng": 105.889452,
                            "lat": 34.571143
                        }
                    },
                    {
                        "citycode": "0938",
                        "adcode": "620502",
                        "name": "秦州区",
                        "center": {
                            "lng": 105.724914,
                            "lat": 34.581187
                        }
                    },
                    {
                        "citycode": "0938",
                        "adcode": "620523",
                        "name": "甘谷县",
                        "center": {
                            "lng": 105.340789,
                            "lat": 34.745447
                        }
                    },
                    {
                        "citycode": "0938",
                        "adcode": "620521",
                        "name": "清水县",
                        "center": {
                            "lng": 106.137318,
                            "lat": 34.749906
                        }
                    },
                    {
                        "citycode": "0938",
                        "adcode": "620522",
                        "name": "秦安县",
                        "center": {
                            "lng": 105.675799,
                            "lat": 34.859094
                        }
                    }
                ]
            },
            {
                "citycode": "0932",
                "adcode": "621100",
                "name": "定西市",
                "center": {
                    "lng": 104.592342,
                    "lat": 35.607947
                },
                "districtList": [
                    {
                        "citycode": "0932",
                        "adcode": "621123",
                        "name": "渭源县",
                        "center": {
                            "lng": 104.215092,
                            "lat": 35.137028
                        }
                    },
                    {
                        "citycode": "0932",
                        "adcode": "621124",
                        "name": "临洮县",
                        "center": {
                            "lng": 103.859446,
                            "lat": 35.394993
                        }
                    },
                    {
                        "citycode": "0932",
                        "adcode": "621126",
                        "name": "岷县",
                        "center": {
                            "lng": 104.036731,
                            "lat": 34.43833
                        }
                    },
                    {
                        "citycode": "0932",
                        "adcode": "621125",
                        "name": "漳县",
                        "center": {
                            "lng": 104.471722,
                            "lat": 34.84854
                        }
                    },
                    {
                        "citycode": "0932",
                        "adcode": "621102",
                        "name": "安定区",
                        "center": {
                            "lng": 104.610647,
                            "lat": 35.580918
                        }
                    },
                    {
                        "citycode": "0932",
                        "adcode": "621122",
                        "name": "陇西县",
                        "center": {
                            "lng": 104.634928,
                            "lat": 35.003899
                        }
                    },
                    {
                        "citycode": "0932",
                        "adcode": "621121",
                        "name": "通渭县",
                        "center": {
                            "lng": 105.242312,
                            "lat": 35.211311
                        }
                    }
                ]
            },
            {
                "citycode": "0930",
                "adcode": "622900",
                "name": "临夏回族自治州",
                "center": {
                    "lng": 103.210386,
                    "lat": 35.601792
                },
                "districtList": [
                    {
                        "citycode": "0930",
                        "adcode": "622924",
                        "name": "广河县",
                        "center": {
                            "lng": 103.575582,
                            "lat": 35.488248
                        }
                    },
                    {
                        "citycode": "0930",
                        "adcode": "622925",
                        "name": "和政县",
                        "center": {
                            "lng": 103.350996,
                            "lat": 35.424602
                        }
                    },
                    {
                        "citycode": "0930",
                        "adcode": "622923",
                        "name": "永靖县",
                        "center": {
                            "lng": 103.285853,
                            "lat": 35.958306
                        }
                    },
                    {
                        "citycode": "0930",
                        "adcode": "622927",
                        "name": "积石山保安族东乡族撒拉族自治县",
                        "center": {
                            "lng": 102.875939,
                            "lat": 35.717697
                        }
                    },
                    {
                        "citycode": "0930",
                        "adcode": "622901",
                        "name": "临夏市",
                        "center": {
                            "lng": 103.24222,
                            "lat": 35.604682
                        }
                    },
                    {
                        "citycode": "0930",
                        "adcode": "622921",
                        "name": "临夏县",
                        "center": {
                            "lng": 103.04068,
                            "lat": 35.478726
                        }
                    },
                    {
                        "citycode": "0930",
                        "adcode": "622922",
                        "name": "康乐县",
                        "center": {
                            "lng": 103.708507,
                            "lat": 35.370296
                        }
                    },
                    {
                        "citycode": "0930",
                        "adcode": "622926",
                        "name": "东乡族自治县",
                        "center": {
                            "lng": 103.388122,
                            "lat": 35.664409
                        }
                    }
                ]
            },
            {
                "citycode": "0934",
                "adcode": "621000",
                "name": "庆阳市",
                "center": {
                    "lng": 107.643433,
                    "lat": 35.709459
                },
                "districtList": [
                    {
                        "citycode": "0934",
                        "adcode": "621025",
                        "name": "正宁县",
                        "center": {
                            "lng": 108.359964,
                            "lat": 35.492158
                        }
                    },
                    {
                        "citycode": "0934",
                        "adcode": "621027",
                        "name": "镇原县",
                        "center": {
                            "lng": 107.200888,
                            "lat": 35.677705
                        }
                    },
                    {
                        "citycode": "0934",
                        "adcode": "621022",
                        "name": "环县",
                        "center": {
                            "lng": 107.308788,
                            "lat": 36.568566
                        }
                    },
                    {
                        "citycode": "0934",
                        "adcode": "621026",
                        "name": "宁县",
                        "center": {
                            "lng": 107.913463,
                            "lat": 35.509252
                        }
                    },
                    {
                        "citycode": "0934",
                        "adcode": "621024",
                        "name": "合水县",
                        "center": {
                            "lng": 108.021859,
                            "lat": 35.833908
                        }
                    },
                    {
                        "citycode": "0934",
                        "adcode": "621002",
                        "name": "西峰区",
                        "center": {
                            "lng": 107.650563,
                            "lat": 35.730318
                        }
                    },
                    {
                        "citycode": "0934",
                        "adcode": "621021",
                        "name": "庆城县",
                        "center": {
                            "lng": 107.881706,
                            "lat": 36.016125
                        }
                    },
                    {
                        "citycode": "0934",
                        "adcode": "621023",
                        "name": "华池县",
                        "center": {
                            "lng": 107.98972,
                            "lat": 36.461474
                        }
                    }
                ]
            },
            {
                "citycode": "0943",
                "adcode": "620400",
                "name": "白银市",
                "center": {
                    "lng": 104.138872,
                    "lat": 36.545123
                },
                "districtList": [
                    {
                        "citycode": "0943",
                        "adcode": "620402",
                        "name": "白银区",
                        "center": {
                            "lng": 104.14956,
                            "lat": 36.53469
                        }
                    },
                    {
                        "citycode": "0943",
                        "adcode": "620421",
                        "name": "靖远县",
                        "center": {
                            "lng": 104.676202,
                            "lat": 36.571736
                        }
                    },
                    {
                        "citycode": "0943",
                        "adcode": "620403",
                        "name": "平川区",
                        "center": {
                            "lng": 104.825275,
                            "lat": 36.728494
                        }
                    },
                    {
                        "citycode": "0943",
                        "adcode": "620423",
                        "name": "景泰县",
                        "center": {
                            "lng": 104.063125,
                            "lat": 37.18351
                        }
                    },
                    {
                        "citycode": "0943",
                        "adcode": "620422",
                        "name": "会宁县",
                        "center": {
                            "lng": 105.052883,
                            "lat": 35.693241
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "510000",
        "name": "四川省",
        "center": {
            "lng": 104.076452,
            "lat": 30.651696
        },
        "districtList": [
            {
                "citycode": "0839",
                "adcode": "510800",
                "name": "广元市",
                "center": {
                    "lng": 105.844004,
                    "lat": 32.435774
                },
                "districtList": [
                    {
                        "citycode": "0839",
                        "adcode": "510812",
                        "name": "朝天区",
                        "center": {
                            "lng": 105.882848,
                            "lat": 32.651352
                        }
                    },
                    {
                        "citycode": "0839",
                        "adcode": "510824",
                        "name": "苍溪县",
                        "center": {
                            "lng": 105.934756,
                            "lat": 31.731709
                        }
                    },
                    {
                        "citycode": "0839",
                        "adcode": "510811",
                        "name": "昭化区",
                        "center": {
                            "lng": 105.957612,
                            "lat": 32.333173
                        }
                    },
                    {
                        "citycode": "0839",
                        "adcode": "510823",
                        "name": "剑阁县",
                        "center": {
                            "lng": 105.524699,
                            "lat": 32.288681
                        }
                    },
                    {
                        "citycode": "0839",
                        "adcode": "510822",
                        "name": "青川县",
                        "center": {
                            "lng": 105.238498,
                            "lat": 32.575821
                        }
                    },
                    {
                        "citycode": "0839",
                        "adcode": "510821",
                        "name": "旺苍县",
                        "center": {
                            "lng": 106.290124,
                            "lat": 32.229074
                        }
                    },
                    {
                        "citycode": "0839",
                        "adcode": "510802",
                        "name": "利州区",
                        "center": {
                            "lng": 105.845307,
                            "lat": 32.433756
                        }
                    }
                ]
            },
            {
                "citycode": "0817",
                "adcode": "511300",
                "name": "南充市",
                "center": {
                    "lng": 106.110565,
                    "lat": 30.837235
                },
                "districtList": [
                    {
                        "citycode": "0817",
                        "adcode": "511321",
                        "name": "南部县",
                        "center": {
                            "lng": 106.036349,
                            "lat": 31.348255
                        }
                    },
                    {
                        "citycode": "0817",
                        "adcode": "511322",
                        "name": "营山县",
                        "center": {
                            "lng": 106.565524,
                            "lat": 31.077057
                        }
                    },
                    {
                        "citycode": "0817",
                        "adcode": "511304",
                        "name": "嘉陵区",
                        "center": {
                            "lng": 106.07208,
                            "lat": 30.758831
                        }
                    },
                    {
                        "citycode": "0817",
                        "adcode": "511325",
                        "name": "西充县",
                        "center": {
                            "lng": 105.900894,
                            "lat": 30.995546
                        }
                    },
                    {
                        "citycode": "0817",
                        "adcode": "511324",
                        "name": "仪陇县",
                        "center": {
                            "lng": 106.303082,
                            "lat": 31.271693
                        }
                    },
                    {
                        "citycode": "0817",
                        "adcode": "511302",
                        "name": "顺庆区",
                        "center": {
                            "lng": 106.092327,
                            "lat": 30.797366
                        }
                    },
                    {
                        "citycode": "0817",
                        "adcode": "511381",
                        "name": "阆中市",
                        "center": {
                            "lng": 106.005046,
                            "lat": 31.558356
                        }
                    },
                    {
                        "citycode": "0817",
                        "adcode": "511323",
                        "name": "蓬安县",
                        "center": {
                            "lng": 106.412156,
                            "lat": 31.028537
                        }
                    },
                    {
                        "citycode": "0817",
                        "adcode": "511303",
                        "name": "高坪区",
                        "center": {
                            "lng": 106.118931,
                            "lat": 30.781284
                        }
                    }
                ]
            },
            {
                "citycode": "0827",
                "adcode": "511900",
                "name": "巴中市",
                "center": {
                    "lng": 106.747548,
                    "lat": 31.867853
                },
                "districtList": [
                    {
                        "citycode": "0827",
                        "adcode": "511921",
                        "name": "通江县",
                        "center": {
                            "lng": 107.245033,
                            "lat": 31.911705
                        }
                    },
                    {
                        "citycode": "0827",
                        "adcode": "511902",
                        "name": "巴州区",
                        "center": {
                            "lng": 106.76887,
                            "lat": 31.851458
                        }
                    },
                    {
                        "citycode": "0827",
                        "adcode": "511922",
                        "name": "南江县",
                        "center": {
                            "lng": 106.828697,
                            "lat": 32.346589
                        }
                    },
                    {
                        "citycode": "0827",
                        "adcode": "511923",
                        "name": "平昌县",
                        "center": {
                            "lng": 107.103613,
                            "lat": 31.560436
                        }
                    },
                    {
                        "citycode": "0827",
                        "adcode": "511903",
                        "name": "恩阳区",
                        "center": {
                            "lng": 106.634651,
                            "lat": 31.796476
                        }
                    }
                ]
            },
            {
                "citycode": "0838",
                "adcode": "510600",
                "name": "德阳市",
                "center": {
                    "lng": 104.397795,
                    "lat": 31.127449
                },
                "districtList": [
                    {
                        "citycode": "0838",
                        "adcode": "510623",
                        "name": "中江县",
                        "center": {
                            "lng": 104.678601,
                            "lat": 31.03327
                        }
                    },
                    {
                        "citycode": "0838",
                        "adcode": "510682",
                        "name": "什邡市",
                        "center": {
                            "lng": 104.167345,
                            "lat": 31.12655
                        }
                    },
                    {
                        "citycode": "0838",
                        "adcode": "510604",
                        "name": "罗江区",
                        "center": {
                            "lng": 104.510457,
                            "lat": 31.317388
                        }
                    },
                    {
                        "citycode": "0838",
                        "adcode": "510683",
                        "name": "绵竹市",
                        "center": {
                            "lng": 104.220679,
                            "lat": 31.339251
                        }
                    },
                    {
                        "citycode": "0838",
                        "adcode": "510681",
                        "name": "广汉市",
                        "center": {
                            "lng": 104.282204,
                            "lat": 30.977264
                        }
                    },
                    {
                        "citycode": "0838",
                        "adcode": "510603",
                        "name": "旌阳区",
                        "center": {
                            "lng": 104.417061,
                            "lat": 31.143335
                        }
                    }
                ]
            },
            {
                "citycode": "0816",
                "adcode": "510700",
                "name": "绵阳市",
                "center": {
                    "lng": 104.679127,
                    "lat": 31.467673
                },
                "districtList": [
                    {
                        "citycode": "0816",
                        "adcode": "510781",
                        "name": "江油市",
                        "center": {
                            "lng": 104.74564,
                            "lat": 31.778572
                        }
                    },
                    {
                        "citycode": "0816",
                        "adcode": "510725",
                        "name": "梓潼县",
                        "center": {
                            "lng": 105.170746,
                            "lat": 31.642635
                        }
                    },
                    {
                        "citycode": "0816",
                        "adcode": "510704",
                        "name": "游仙区",
                        "center": {
                            "lng": 104.766136,
                            "lat": 31.473788
                        }
                    },
                    {
                        "citycode": "0816",
                        "adcode": "510722",
                        "name": "三台县",
                        "center": {
                            "lng": 105.093722,
                            "lat": 31.095826
                        }
                    },
                    {
                        "citycode": "0816",
                        "adcode": "510703",
                        "name": "涪城区",
                        "center": {
                            "lng": 104.756917,
                            "lat": 31.455192
                        }
                    },
                    {
                        "citycode": "0816",
                        "adcode": "510727",
                        "name": "平武县",
                        "center": {
                            "lng": 104.555481,
                            "lat": 32.409684
                        }
                    },
                    {
                        "citycode": "0816",
                        "adcode": "510726",
                        "name": "北川羌族自治县",
                        "center": {
                            "lng": 104.468163,
                            "lat": 31.617192
                        }
                    },
                    {
                        "citycode": "0816",
                        "adcode": "510723",
                        "name": "盐亭县",
                        "center": {
                            "lng": 105.389453,
                            "lat": 31.208362
                        }
                    },
                    {
                        "citycode": "0816",
                        "adcode": "510705",
                        "name": "安州区",
                        "center": {
                            "lng": 104.567543,
                            "lat": 31.534319
                        }
                    }
                ]
            },
            {
                "citycode": "028",
                "adcode": "510100",
                "name": "成都市",
                "center": {
                    "lng": 104.066301,
                    "lat": 30.572961
                },
                "districtList": [
                    {
                        "citycode": "028",
                        "adcode": "510182",
                        "name": "彭州市",
                        "center": {
                            "lng": 103.957706,
                            "lat": 30.990463
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510185",
                        "name": "简阳市",
                        "center": {
                            "lng": 104.547644,
                            "lat": 30.410937
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510131",
                        "name": "蒲江县",
                        "center": {
                            "lng": 103.506478,
                            "lat": 30.197558
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510116",
                        "name": "双流区",
                        "center": {
                            "lng": 103.92342,
                            "lat": 30.574884
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510181",
                        "name": "都江堰市",
                        "center": {
                            "lng": 103.647193,
                            "lat": 30.988763
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510117",
                        "name": "郫都区",
                        "center": {
                            "lng": 103.900486,
                            "lat": 30.795113
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510115",
                        "name": "温江区",
                        "center": {
                            "lng": 103.856423,
                            "lat": 30.681956
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510105",
                        "name": "青羊区",
                        "center": {
                            "lng": 104.062415,
                            "lat": 30.674583
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510108",
                        "name": "成华区",
                        "center": {
                            "lng": 104.101452,
                            "lat": 30.659966
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510107",
                        "name": "武侯区",
                        "center": {
                            "lng": 104.043246,
                            "lat": 30.641849
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510113",
                        "name": "青白江区",
                        "center": {
                            "lng": 104.251342,
                            "lat": 30.8786
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510184",
                        "name": "崇州市",
                        "center": {
                            "lng": 103.673025,
                            "lat": 30.630183
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510104",
                        "name": "锦江区",
                        "center": {
                            "lng": 104.117262,
                            "lat": 30.598726
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510112",
                        "name": "龙泉驿区",
                        "center": {
                            "lng": 104.27536,
                            "lat": 30.556808
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510118",
                        "name": "新津区",
                        "center": {
                            "lng": 103.810906,
                            "lat": 30.410404
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510183",
                        "name": "邛崃市",
                        "center": {
                            "lng": 103.464176,
                            "lat": 30.41029
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510129",
                        "name": "大邑县",
                        "center": {
                            "lng": 103.51226,
                            "lat": 30.573004
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510121",
                        "name": "金堂县",
                        "center": {
                            "lng": 104.411871,
                            "lat": 30.86203
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510106",
                        "name": "金牛区",
                        "center": {
                            "lng": 104.052236,
                            "lat": 30.691359
                        }
                    },
                    {
                        "citycode": "028",
                        "adcode": "510114",
                        "name": "新都区",
                        "center": {
                            "lng": 104.158593,
                            "lat": 30.823568
                        }
                    }
                ]
            },
            {
                "citycode": "0826",
                "adcode": "511600",
                "name": "广安市",
                "center": {
                    "lng": 106.632647,
                    "lat": 30.456354
                },
                "districtList": [
                    {
                        "citycode": "0826",
                        "adcode": "511623",
                        "name": "邻水县",
                        "center": {
                            "lng": 106.930242,
                            "lat": 30.334911
                        }
                    },
                    {
                        "citycode": "0826",
                        "adcode": "511602",
                        "name": "广安区",
                        "center": {
                            "lng": 106.641628,
                            "lat": 30.473943
                        }
                    },
                    {
                        "citycode": "0826",
                        "adcode": "511621",
                        "name": "岳池县",
                        "center": {
                            "lng": 106.440056,
                            "lat": 30.538656
                        }
                    },
                    {
                        "citycode": "0826",
                        "adcode": "511622",
                        "name": "武胜县",
                        "center": {
                            "lng": 106.295945,
                            "lat": 30.349493
                        }
                    },
                    {
                        "citycode": "0826",
                        "adcode": "511681",
                        "name": "华蓥市",
                        "center": {
                            "lng": 106.783151,
                            "lat": 30.390439
                        }
                    },
                    {
                        "citycode": "0826",
                        "adcode": "511603",
                        "name": "前锋区",
                        "center": {
                            "lng": 106.886039,
                            "lat": 30.496059
                        }
                    }
                ]
            },
            {
                "citycode": "0818",
                "adcode": "511700",
                "name": "达州市",
                "center": {
                    "lng": 107.46778,
                    "lat": 31.209278
                },
                "districtList": [
                    {
                        "citycode": "0818",
                        "adcode": "511724",
                        "name": "大竹县",
                        "center": {
                            "lng": 107.204702,
                            "lat": 30.736222
                        }
                    },
                    {
                        "citycode": "0818",
                        "adcode": "511725",
                        "name": "渠县",
                        "center": {
                            "lng": 106.973114,
                            "lat": 30.836504
                        }
                    },
                    {
                        "citycode": "0818",
                        "adcode": "511702",
                        "name": "通川区",
                        "center": {
                            "lng": 107.505053,
                            "lat": 31.214665
                        }
                    },
                    {
                        "citycode": "0818",
                        "adcode": "511703",
                        "name": "达川区",
                        "center": {
                            "lng": 107.511736,
                            "lat": 31.196573
                        }
                    },
                    {
                        "citycode": "0818",
                        "adcode": "511722",
                        "name": "宣汉县",
                        "center": {
                            "lng": 107.727198,
                            "lat": 31.353845
                        }
                    },
                    {
                        "citycode": "0818",
                        "adcode": "511781",
                        "name": "万源市",
                        "center": {
                            "lng": 108.034393,
                            "lat": 32.081698
                        }
                    },
                    {
                        "citycode": "0818",
                        "adcode": "511723",
                        "name": "开江县",
                        "center": {
                            "lng": 107.868609,
                            "lat": 31.082945
                        }
                    }
                ]
            },
            {
                "citycode": "0825",
                "adcode": "510900",
                "name": "遂宁市",
                "center": {
                    "lng": 105.592602,
                    "lat": 30.53268
                },
                "districtList": [
                    {
                        "citycode": "0825",
                        "adcode": "510981",
                        "name": "射洪市",
                        "center": {
                            "lng": 105.388366,
                            "lat": 30.871079
                        }
                    },
                    {
                        "citycode": "0825",
                        "adcode": "510923",
                        "name": "大英县",
                        "center": {
                            "lng": 105.236852,
                            "lat": 30.594472
                        }
                    },
                    {
                        "citycode": "0825",
                        "adcode": "510921",
                        "name": "蓬溪县",
                        "center": {
                            "lng": 105.707498,
                            "lat": 30.75763
                        }
                    },
                    {
                        "citycode": "0825",
                        "adcode": "510904",
                        "name": "安居区",
                        "center": {
                            "lng": 105.45636,
                            "lat": 30.355091
                        }
                    },
                    {
                        "citycode": "0825",
                        "adcode": "510903",
                        "name": "船山区",
                        "center": {
                            "lng": 105.568359,
                            "lat": 30.526201
                        }
                    }
                ]
            },
            {
                "citycode": "0832",
                "adcode": "512000",
                "name": "资阳市",
                "center": {
                    "lng": 104.627265,
                    "lat": 30.129236
                },
                "districtList": [
                    {
                        "citycode": "0832",
                        "adcode": "512022",
                        "name": "乐至县",
                        "center": {
                            "lng": 105.019823,
                            "lat": 30.275418
                        }
                    },
                    {
                        "citycode": "0832",
                        "adcode": "512002",
                        "name": "雁江区",
                        "center": {
                            "lng": 104.676814,
                            "lat": 30.107778
                        }
                    },
                    {
                        "citycode": "0832",
                        "adcode": "512021",
                        "name": "安岳县",
                        "center": {
                            "lng": 105.35551,
                            "lat": 30.103623
                        }
                    }
                ]
            },
            {
                "citycode": "1833",
                "adcode": "511400",
                "name": "眉山市",
                "center": {
                    "lng": 103.848417,
                    "lat": 30.077113
                },
                "districtList": [
                    {
                        "citycode": "1833",
                        "adcode": "511421",
                        "name": "仁寿县",
                        "center": {
                            "lng": 104.133931,
                            "lat": 29.995638
                        }
                    },
                    {
                        "citycode": "1833",
                        "adcode": "511424",
                        "name": "丹棱县",
                        "center": {
                            "lng": 103.512859,
                            "lat": 30.014398
                        }
                    },
                    {
                        "citycode": "1833",
                        "adcode": "511423",
                        "name": "洪雅县",
                        "center": {
                            "lng": 103.365035,
                            "lat": 29.915828
                        }
                    },
                    {
                        "citycode": "1833",
                        "adcode": "511403",
                        "name": "彭山区",
                        "center": {
                            "lng": 103.872852,
                            "lat": 30.193278
                        }
                    },
                    {
                        "citycode": "1833",
                        "adcode": "511425",
                        "name": "青神县",
                        "center": {
                            "lng": 103.846596,
                            "lat": 29.831302
                        }
                    },
                    {
                        "citycode": "1833",
                        "adcode": "511402",
                        "name": "东坡区",
                        "center": {
                            "lng": 103.831868,
                            "lat": 30.041956
                        }
                    }
                ]
            },
            {
                "citycode": "1832",
                "adcode": "511000",
                "name": "内江市",
                "center": {
                    "lng": 105.057992,
                    "lat": 29.58021
                },
                "districtList": [
                    {
                        "citycode": "1832",
                        "adcode": "511025",
                        "name": "资中县",
                        "center": {
                            "lng": 104.851874,
                            "lat": 29.763419
                        }
                    },
                    {
                        "citycode": "1832",
                        "adcode": "511024",
                        "name": "威远县",
                        "center": {
                            "lng": 104.669032,
                            "lat": 29.527456
                        }
                    },
                    {
                        "citycode": "1832",
                        "adcode": "511011",
                        "name": "东兴区",
                        "center": {
                            "lng": 105.076107,
                            "lat": 29.593528
                        }
                    },
                    {
                        "citycode": "1832",
                        "adcode": "511083",
                        "name": "隆昌市",
                        "center": {
                            "lng": 105.287507,
                            "lat": 29.339408
                        }
                    },
                    {
                        "citycode": "1832",
                        "adcode": "511002",
                        "name": "市中区",
                        "center": {
                            "lng": 105.06759,
                            "lat": 29.587091
                        }
                    }
                ]
            },
            {
                "citycode": "0833",
                "adcode": "511100",
                "name": "乐山市",
                "center": {
                    "lng": 103.766085,
                    "lat": 29.552275
                },
                "districtList": [
                    {
                        "citycode": "0833",
                        "adcode": "511126",
                        "name": "夹江县",
                        "center": {
                            "lng": 103.571313,
                            "lat": 29.738143
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511111",
                        "name": "沙湾区",
                        "center": {
                            "lng": 103.550118,
                            "lat": 29.412404
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511112",
                        "name": "五通桥区",
                        "center": {
                            "lng": 103.818024,
                            "lat": 29.406837
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511124",
                        "name": "井研县",
                        "center": {
                            "lng": 104.06968,
                            "lat": 29.65165
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511113",
                        "name": "金口河区",
                        "center": {
                            "lng": 103.078597,
                            "lat": 29.244345
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511123",
                        "name": "犍为县",
                        "center": {
                            "lng": 103.949231,
                            "lat": 29.208118
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511132",
                        "name": "峨边彝族自治县",
                        "center": {
                            "lng": 103.262048,
                            "lat": 29.230426
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511129",
                        "name": "沐川县",
                        "center": {
                            "lng": 103.902691,
                            "lat": 28.956394
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511133",
                        "name": "马边彝族自治县",
                        "center": {
                            "lng": 103.546347,
                            "lat": 28.83552
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511102",
                        "name": "市中区",
                        "center": {
                            "lng": 103.761329,
                            "lat": 29.555374
                        }
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511181",
                        "name": "峨眉山市",
                        "center": {
                            "lng": 103.484557,
                            "lat": 29.601189
                        }
                    }
                ]
            },
            {
                "citycode": "0813",
                "adcode": "510300",
                "name": "自贡市",
                "center": {
                    "lng": 104.779307,
                    "lat": 29.33924
                },
                "districtList": [
                    {
                        "citycode": "0813",
                        "adcode": "510321",
                        "name": "荣县",
                        "center": {
                            "lng": 104.417438,
                            "lat": 29.445461
                        }
                    },
                    {
                        "citycode": "0813",
                        "adcode": "510322",
                        "name": "富顺县",
                        "center": {
                            "lng": 104.975193,
                            "lat": 29.181779
                        }
                    },
                    {
                        "citycode": "0813",
                        "adcode": "510304",
                        "name": "大安区",
                        "center": {
                            "lng": 104.773982,
                            "lat": 29.36371
                        }
                    },
                    {
                        "citycode": "0813",
                        "adcode": "510311",
                        "name": "沿滩区",
                        "center": {
                            "lng": 104.873826,
                            "lat": 29.27208
                        }
                    },
                    {
                        "citycode": "0813",
                        "adcode": "510302",
                        "name": "自流井区",
                        "center": {
                            "lng": 104.777182,
                            "lat": 29.337295
                        }
                    },
                    {
                        "citycode": "0813",
                        "adcode": "510303",
                        "name": "贡井区",
                        "center": {
                            "lng": 104.715294,
                            "lat": 29.345481
                        }
                    }
                ]
            },
            {
                "citycode": "0830",
                "adcode": "510500",
                "name": "泸州市",
                "center": {
                    "lng": 105.441866,
                    "lat": 28.87098
                },
                "districtList": [
                    {
                        "citycode": "0830",
                        "adcode": "510521",
                        "name": "泸县",
                        "center": {
                            "lng": 105.381879,
                            "lat": 29.1516
                        }
                    },
                    {
                        "citycode": "0830",
                        "adcode": "510504",
                        "name": "龙马潭区",
                        "center": {
                            "lng": 105.437751,
                            "lat": 28.913257
                        }
                    },
                    {
                        "citycode": "0830",
                        "adcode": "510503",
                        "name": "纳溪区",
                        "center": {
                            "lng": 105.371324,
                            "lat": 28.772888
                        }
                    },
                    {
                        "citycode": "0830",
                        "adcode": "510524",
                        "name": "叙永县",
                        "center": {
                            "lng": 105.444777,
                            "lat": 28.155631
                        }
                    },
                    {
                        "citycode": "0830",
                        "adcode": "510525",
                        "name": "古蔺县",
                        "center": {
                            "lng": 105.812694,
                            "lat": 28.038763
                        }
                    },
                    {
                        "citycode": "0830",
                        "adcode": "510502",
                        "name": "江阳区",
                        "center": {
                            "lng": 105.434982,
                            "lat": 28.87881
                        }
                    },
                    {
                        "citycode": "0830",
                        "adcode": "510522",
                        "name": "合江县",
                        "center": {
                            "lng": 105.831011,
                            "lat": 28.811278
                        }
                    }
                ]
            },
            {
                "citycode": "0831",
                "adcode": "511500",
                "name": "宜宾市",
                "center": {
                    "lng": 104.642826,
                    "lat": 28.752354
                },
                "districtList": [
                    {
                        "citycode": "0831",
                        "adcode": "511524",
                        "name": "长宁县",
                        "center": {
                            "lng": 104.920643,
                            "lat": 28.582866
                        }
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511503",
                        "name": "南溪区",
                        "center": {
                            "lng": 104.969147,
                            "lat": 28.846366
                        }
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511526",
                        "name": "珙县",
                        "center": {
                            "lng": 104.708986,
                            "lat": 28.439514
                        }
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511527",
                        "name": "筠连县",
                        "center": {
                            "lng": 104.511159,
                            "lat": 28.167981
                        }
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511523",
                        "name": "江安县",
                        "center": {
                            "lng": 105.066982,
                            "lat": 28.723797
                        }
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511528",
                        "name": "兴文县",
                        "center": {
                            "lng": 105.236207,
                            "lat": 28.303669
                        }
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511502",
                        "name": "翠屏区",
                        "center": {
                            "lng": 104.619853,
                            "lat": 28.766537
                        }
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511529",
                        "name": "屏山县",
                        "center": {
                            "lng": 104.346138,
                            "lat": 28.82867
                        }
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511525",
                        "name": "高县",
                        "center": {
                            "lng": 104.517748,
                            "lat": 28.436166
                        }
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511504",
                        "name": "叙州区",
                        "center": {
                            "lng": 104.533244,
                            "lat": 28.690068
                        }
                    }
                ]
            },
            {
                "citycode": "0834",
                "adcode": "513400",
                "name": "凉山彝族自治州",
                "center": {
                    "lng": 102.267713,
                    "lat": 27.881396
                },
                "districtList": [
                    {
                        "citycode": "0834",
                        "adcode": "513435",
                        "name": "甘洛县",
                        "center": {
                            "lng": 102.771441,
                            "lat": 28.959131
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513436",
                        "name": "美姑县",
                        "center": {
                            "lng": 103.132359,
                            "lat": 28.328591
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513434",
                        "name": "越西县",
                        "center": {
                            "lng": 102.507467,
                            "lat": 28.639874
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513422",
                        "name": "木里藏族自治县",
                        "center": {
                            "lng": 101.280216,
                            "lat": 27.928736
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513437",
                        "name": "雷波县",
                        "center": {
                            "lng": 103.571705,
                            "lat": 28.263202
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513423",
                        "name": "盐源县",
                        "center": {
                            "lng": 101.509038,
                            "lat": 27.422593
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513433",
                        "name": "冕宁县",
                        "center": {
                            "lng": 102.176622,
                            "lat": 28.550145
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513430",
                        "name": "金阳县",
                        "center": {
                            "lng": 103.248786,
                            "lat": 27.696735
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513429",
                        "name": "布拖县",
                        "center": {
                            "lng": 102.809157,
                            "lat": 27.7121
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513428",
                        "name": "普格县",
                        "center": {
                            "lng": 102.540901,
                            "lat": 27.376413
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513402",
                        "name": "会理市",
                        "center": {
                            "lng": 102.244774,
                            "lat": 26.655047
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513424",
                        "name": "德昌县",
                        "center": {
                            "lng": 102.175661,
                            "lat": 27.402832
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513401",
                        "name": "西昌市",
                        "center": {
                            "lng": 102.264166,
                            "lat": 27.89441
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513431",
                        "name": "昭觉县",
                        "center": {
                            "lng": 102.839849,
                            "lat": 28.015301
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513426",
                        "name": "会东县",
                        "center": {
                            "lng": 102.577979,
                            "lat": 26.634744
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513432",
                        "name": "喜德县",
                        "center": {
                            "lng": 102.412451,
                            "lat": 28.306429
                        }
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513427",
                        "name": "宁南县",
                        "center": {
                            "lng": 102.751587,
                            "lat": 27.061431
                        }
                    }
                ]
            },
            {
                "citycode": "0812",
                "adcode": "510400",
                "name": "攀枝花市",
                "center": {
                    "lng": 101.71846,
                    "lat": 26.582417
                },
                "districtList": [
                    {
                        "citycode": "0812",
                        "adcode": "510421",
                        "name": "米易县",
                        "center": {
                            "lng": 102.111073,
                            "lat": 26.896372
                        }
                    },
                    {
                        "citycode": "0812",
                        "adcode": "510422",
                        "name": "盐边县",
                        "center": {
                            "lng": 101.854027,
                            "lat": 26.682611
                        }
                    },
                    {
                        "citycode": "0812",
                        "adcode": "510411",
                        "name": "仁和区",
                        "center": {
                            "lng": 101.738615,
                            "lat": 26.497796
                        }
                    },
                    {
                        "citycode": "0812",
                        "adcode": "510402",
                        "name": "东区",
                        "center": {
                            "lng": 101.704129,
                            "lat": 26.546484
                        }
                    },
                    {
                        "citycode": "0812",
                        "adcode": "510403",
                        "name": "西区",
                        "center": {
                            "lng": 101.630557,
                            "lat": 26.5977
                        }
                    }
                ]
            },
            {
                "citycode": "0836",
                "adcode": "513300",
                "name": "甘孜藏族自治州",
                "center": {
                    "lng": 101.96231,
                    "lat": 30.04952
                },
                "districtList": [
                    {
                        "citycode": "0836",
                        "adcode": "513332",
                        "name": "石渠县",
                        "center": {
                            "lng": 98.102938,
                            "lat": 32.978728
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513328",
                        "name": "甘孜县",
                        "center": {
                            "lng": 99.991683,
                            "lat": 31.622731
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513330",
                        "name": "德格县",
                        "center": {
                            "lng": 98.580914,
                            "lat": 31.806118
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513331",
                        "name": "白玉县",
                        "center": {
                            "lng": 98.824025,
                            "lat": 31.209669
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513327",
                        "name": "炉霍县",
                        "center": {
                            "lng": 100.676014,
                            "lat": 31.390657
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513329",
                        "name": "新龙县",
                        "center": {
                            "lng": 100.311569,
                            "lat": 30.93917
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513326",
                        "name": "道孚县",
                        "center": {
                            "lng": 101.125157,
                            "lat": 30.979486
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513301",
                        "name": "康定市",
                        "center": {
                            "lng": 101.95687,
                            "lat": 29.998544
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513334",
                        "name": "理塘县",
                        "center": {
                            "lng": 100.269145,
                            "lat": 29.994228
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513335",
                        "name": "巴塘县",
                        "center": {
                            "lng": 99.110555,
                            "lat": 30.00533
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513325",
                        "name": "雅江县",
                        "center": {
                            "lng": 101.014366,
                            "lat": 30.031498
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513336",
                        "name": "乡城县",
                        "center": {
                            "lng": 99.798116,
                            "lat": 28.931081
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513337",
                        "name": "稻城县",
                        "center": {
                            "lng": 100.297369,
                            "lat": 29.03791
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513324",
                        "name": "九龙县",
                        "center": {
                            "lng": 101.507294,
                            "lat": 29.000347
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513338",
                        "name": "得荣县",
                        "center": {
                            "lng": 99.286366,
                            "lat": 28.713085
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513323",
                        "name": "丹巴县",
                        "center": {
                            "lng": 101.89054,
                            "lat": 30.878618
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513333",
                        "name": "色达县",
                        "center": {
                            "lng": 100.333011,
                            "lat": 32.268541
                        }
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513322",
                        "name": "泸定县",
                        "center": {
                            "lng": 102.234814,
                            "lat": 29.914103
                        }
                    }
                ]
            },
            {
                "citycode": "0837",
                "adcode": "513200",
                "name": "阿坝藏族羌族自治州",
                "center": {
                    "lng": 102.224504,
                    "lat": 31.899427
                },
                "districtList": [
                    {
                        "citycode": "0837",
                        "adcode": "513231",
                        "name": "阿坝县",
                        "center": {
                            "lng": 101.706548,
                            "lat": 32.902387
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513225",
                        "name": "九寨沟县",
                        "center": {
                            "lng": 104.2426,
                            "lat": 33.252008
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513233",
                        "name": "红原县",
                        "center": {
                            "lng": 102.544395,
                            "lat": 32.790841
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513228",
                        "name": "黑水县",
                        "center": {
                            "lng": 102.987592,
                            "lat": 32.069268
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513201",
                        "name": "马尔康市",
                        "center": {
                            "lng": 102.206386,
                            "lat": 31.905799
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513226",
                        "name": "金川县",
                        "center": {
                            "lng": 102.063821,
                            "lat": 31.47625
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513222",
                        "name": "理县",
                        "center": {
                            "lng": 103.163284,
                            "lat": 31.435831
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513224",
                        "name": "松潘县",
                        "center": {
                            "lng": 103.60428,
                            "lat": 32.655685
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513227",
                        "name": "小金县",
                        "center": {
                            "lng": 102.362984,
                            "lat": 30.995823
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513230",
                        "name": "壤塘县",
                        "center": {
                            "lng": 100.978526,
                            "lat": 32.265796
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513221",
                        "name": "汶川县",
                        "center": {
                            "lng": 103.590185,
                            "lat": 31.476875
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513223",
                        "name": "茂县",
                        "center": {
                            "lng": 103.85332,
                            "lat": 31.681727
                        }
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513232",
                        "name": "若尔盖县",
                        "center": {
                            "lng": 102.96738,
                            "lat": 33.578503
                        }
                    }
                ]
            },
            {
                "citycode": "0835",
                "adcode": "511800",
                "name": "雅安市",
                "center": {
                    "lng": 103.041538,
                    "lat": 30.009998
                },
                "districtList": [
                    {
                        "citycode": "0835",
                        "adcode": "511827",
                        "name": "宝兴县",
                        "center": {
                            "lng": 102.814156,
                            "lat": 30.382154
                        }
                    },
                    {
                        "citycode": "0835",
                        "adcode": "511822",
                        "name": "荥经县",
                        "center": {
                            "lng": 102.846537,
                            "lat": 29.793254
                        }
                    },
                    {
                        "citycode": "0835",
                        "adcode": "511802",
                        "name": "雨城区",
                        "center": {
                            "lng": 103.032868,
                            "lat": 30.005718
                        }
                    },
                    {
                        "citycode": "0835",
                        "adcode": "511824",
                        "name": "石棉县",
                        "center": {
                            "lng": 102.358364,
                            "lat": 29.230963
                        }
                    },
                    {
                        "citycode": "0835",
                        "adcode": "511803",
                        "name": "名山区",
                        "center": {
                            "lng": 103.109238,
                            "lat": 30.069837
                        }
                    },
                    {
                        "citycode": "0835",
                        "adcode": "511823",
                        "name": "汉源县",
                        "center": {
                            "lng": 102.650417,
                            "lat": 29.344275
                        }
                    },
                    {
                        "citycode": "0835",
                        "adcode": "511825",
                        "name": "天全县",
                        "center": {
                            "lng": 102.771745,
                            "lat": 30.05728
                        }
                    },
                    {
                        "citycode": "0835",
                        "adcode": "511826",
                        "name": "芦山县",
                        "center": {
                            "lng": 102.933618,
                            "lat": 30.145077
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": "022",
        "adcode": "120000",
        "name": "天津市",
        "center": {
            "lng": 117.201509,
            "lat": 39.085318
        },
        "districtList": [
            {
                "citycode": "022",
                "adcode": "120100",
                "name": "天津城区",
                "center": {
                    "lng": 117.190182,
                    "lat": 39.125596
                },
                "districtList": [
                    {
                        "citycode": "022",
                        "adcode": "120115",
                        "name": "宝坻区",
                        "center": {
                            "lng": 117.309748,
                            "lat": 39.717054
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120105",
                        "name": "河北区",
                        "center": {
                            "lng": 117.196874,
                            "lat": 39.148018
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120118",
                        "name": "静海区",
                        "center": {
                            "lng": 116.975474,
                            "lat": 38.947772
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120119",
                        "name": "蓟州区",
                        "center": {
                            "lng": 117.408432,
                            "lat": 40.046544
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120117",
                        "name": "宁河区",
                        "center": {
                            "lng": 117.826674,
                            "lat": 39.329749
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120101",
                        "name": "和平区",
                        "center": {
                            "lng": 117.214713,
                            "lat": 39.116884
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120113",
                        "name": "北辰区",
                        "center": {
                            "lng": 117.135614,
                            "lat": 39.224638
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120106",
                        "name": "红桥区",
                        "center": {
                            "lng": 117.151566,
                            "lat": 39.167349
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120114",
                        "name": "武清区",
                        "center": {
                            "lng": 117.04456,
                            "lat": 39.384108
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120104",
                        "name": "南开区",
                        "center": {
                            "lng": 117.150638,
                            "lat": 39.138551
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120111",
                        "name": "西青区",
                        "center": {
                            "lng": 117.008994,
                            "lat": 39.141811
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120102",
                        "name": "河东区",
                        "center": {
                            "lng": 117.251584,
                            "lat": 39.128294
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120110",
                        "name": "东丽区",
                        "center": {
                            "lng": 117.313567,
                            "lat": 39.086789
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120116",
                        "name": "滨海新区",
                        "center": {
                            "lng": 117.69641,
                            "lat": 39.017809
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120103",
                        "name": "河西区",
                        "center": {
                            "lng": 117.223379,
                            "lat": 39.109679
                        }
                    },
                    {
                        "citycode": "022",
                        "adcode": "120112",
                        "name": "津南区",
                        "center": {
                            "lng": 117.356683,
                            "lat": 38.936971
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "140000",
        "name": "山西省",
        "center": {
            "lng": 112.578781,
            "lat": 37.813948
        },
        "districtList": [
            {
                "citycode": "0353",
                "adcode": "140300",
                "name": "阳泉市",
                "center": {
                    "lng": 113.580426,
                    "lat": 37.857094
                },
                "districtList": [
                    {
                        "citycode": "0353",
                        "adcode": "140321",
                        "name": "平定县",
                        "center": {
                            "lng": 113.629777,
                            "lat": 37.804986
                        }
                    },
                    {
                        "citycode": "0353",
                        "adcode": "140322",
                        "name": "盂县",
                        "center": {
                            "lng": 113.412279,
                            "lat": 38.086041
                        }
                    },
                    {
                        "citycode": "0353",
                        "adcode": "140311",
                        "name": "郊区",
                        "center": {
                            "lng": 113.593998,
                            "lat": 37.943703
                        }
                    },
                    {
                        "citycode": "0353",
                        "adcode": "140302",
                        "name": "城区",
                        "center": {
                            "lng": 113.600694,
                            "lat": 37.847457
                        }
                    },
                    {
                        "citycode": "0353",
                        "adcode": "140303",
                        "name": "矿区",
                        "center": {
                            "lng": 113.555279,
                            "lat": 37.868494
                        }
                    }
                ]
            },
            {
                "citycode": "0355",
                "adcode": "140400",
                "name": "长治市",
                "center": {
                    "lng": 113.117394,
                    "lat": 36.195142
                },
                "districtList": [
                    {
                        "citycode": "0355",
                        "adcode": "140425",
                        "name": "平顺县",
                        "center": {
                            "lng": 113.435859,
                            "lat": 36.20037
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140428",
                        "name": "长子县",
                        "center": {
                            "lng": 112.877922,
                            "lat": 36.122258
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140405",
                        "name": "屯留区",
                        "center": {
                            "lng": 112.892301,
                            "lat": 36.3162
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140426",
                        "name": "黎城县",
                        "center": {
                            "lng": 113.387025,
                            "lat": 36.502258
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140427",
                        "name": "壶关县",
                        "center": {
                            "lng": 113.206836,
                            "lat": 36.115645
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140404",
                        "name": "上党区",
                        "center": {
                            "lng": 113.051416,
                            "lat": 36.053104
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140403",
                        "name": "潞州区",
                        "center": {
                            "lng": 113.122725,
                            "lat": 36.203305
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140406",
                        "name": "潞城区",
                        "center": {
                            "lng": 113.228897,
                            "lat": 36.334597
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140423",
                        "name": "襄垣县",
                        "center": {
                            "lng": 113.051298,
                            "lat": 36.535629
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140429",
                        "name": "武乡县",
                        "center": {
                            "lng": 112.86396,
                            "lat": 36.837865
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140431",
                        "name": "沁源县",
                        "center": {
                            "lng": 112.337726,
                            "lat": 36.499989
                        }
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140430",
                        "name": "沁县",
                        "center": {
                            "lng": 112.699176,
                            "lat": 36.756152
                        }
                    }
                ]
            },
            {
                "citycode": "0349",
                "adcode": "140600",
                "name": "朔州市",
                "center": {
                    "lng": 112.432906,
                    "lat": 39.331734
                },
                "districtList": [
                    {
                        "citycode": "0349",
                        "adcode": "140623",
                        "name": "右玉县",
                        "center": {
                            "lng": 112.466926,
                            "lat": 39.989198
                        }
                    },
                    {
                        "citycode": "0349",
                        "adcode": "140681",
                        "name": "怀仁市",
                        "center": {
                            "lng": 113.133061,
                            "lat": 39.820522
                        }
                    },
                    {
                        "citycode": "0349",
                        "adcode": "140602",
                        "name": "朔城区",
                        "center": {
                            "lng": 112.432071,
                            "lat": 39.320196
                        }
                    },
                    {
                        "citycode": "0349",
                        "adcode": "140603",
                        "name": "平鲁区",
                        "center": {
                            "lng": 112.28827,
                            "lat": 39.512219
                        }
                    },
                    {
                        "citycode": "0349",
                        "adcode": "140622",
                        "name": "应县",
                        "center": {
                            "lng": 113.190952,
                            "lat": 39.554471
                        }
                    },
                    {
                        "citycode": "0349",
                        "adcode": "140621",
                        "name": "山阴县",
                        "center": {
                            "lng": 112.816421,
                            "lat": 39.527445
                        }
                    }
                ]
            },
            {
                "citycode": "0356",
                "adcode": "140500",
                "name": "晋城市",
                "center": {
                    "lng": 112.852022,
                    "lat": 35.491315
                },
                "districtList": [
                    {
                        "citycode": "0356",
                        "adcode": "140502",
                        "name": "城区",
                        "center": {
                            "lng": 112.853452,
                            "lat": 35.50248
                        }
                    },
                    {
                        "citycode": "0356",
                        "adcode": "140525",
                        "name": "泽州县",
                        "center": {
                            "lng": 112.922243,
                            "lat": 35.507061
                        }
                    },
                    {
                        "citycode": "0356",
                        "adcode": "140581",
                        "name": "高平市",
                        "center": {
                            "lng": 112.923798,
                            "lat": 35.798775
                        }
                    },
                    {
                        "citycode": "0356",
                        "adcode": "140524",
                        "name": "陵川县",
                        "center": {
                            "lng": 113.280755,
                            "lat": 35.775239
                        }
                    },
                    {
                        "citycode": "0356",
                        "adcode": "140522",
                        "name": "阳城县",
                        "center": {
                            "lng": 112.414798,
                            "lat": 35.486275
                        }
                    },
                    {
                        "citycode": "0356",
                        "adcode": "140521",
                        "name": "沁水县",
                        "center": {
                            "lng": 112.186726,
                            "lat": 35.690119
                        }
                    }
                ]
            },
            {
                "citycode": "0350",
                "adcode": "140900",
                "name": "忻州市",
                "center": {
                    "lng": 112.734149,
                    "lat": 38.415958
                },
                "districtList": [
                    {
                        "citycode": "0350",
                        "adcode": "140928",
                        "name": "五寨县",
                        "center": {
                            "lng": 111.846808,
                            "lat": 38.91111
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140925",
                        "name": "宁武县",
                        "center": {
                            "lng": 112.304734,
                            "lat": 39.001498
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140922",
                        "name": "五台县",
                        "center": {
                            "lng": 113.255419,
                            "lat": 38.728056
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140929",
                        "name": "岢岚县",
                        "center": {
                            "lng": 111.572964,
                            "lat": 38.703989
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140902",
                        "name": "忻府区",
                        "center": {
                            "lng": 112.746357,
                            "lat": 38.403498
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140926",
                        "name": "静乐县",
                        "center": {
                            "lng": 111.939498,
                            "lat": 38.359306
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140921",
                        "name": "定襄县",
                        "center": {
                            "lng": 112.957234,
                            "lat": 38.471725
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140927",
                        "name": "神池县",
                        "center": {
                            "lng": 112.210997,
                            "lat": 39.091079
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140924",
                        "name": "繁峙县",
                        "center": {
                            "lng": 113.265464,
                            "lat": 39.188835
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140931",
                        "name": "保德县",
                        "center": {
                            "lng": 111.085944,
                            "lat": 39.022616
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140930",
                        "name": "河曲县",
                        "center": {
                            "lng": 111.138247,
                            "lat": 39.38452
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140981",
                        "name": "原平市",
                        "center": {
                            "lng": 112.711025,
                            "lat": 38.731412
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140923",
                        "name": "代县",
                        "center": {
                            "lng": 112.960102,
                            "lat": 39.066831
                        }
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140932",
                        "name": "偏关县",
                        "center": {
                            "lng": 111.508922,
                            "lat": 39.436917
                        }
                    }
                ]
            },
            {
                "citycode": "0359",
                "adcode": "140800",
                "name": "运城市",
                "center": {
                    "lng": 111.007051,
                    "lat": 35.02667
                },
                "districtList": [
                    {
                        "citycode": "0359",
                        "adcode": "140802",
                        "name": "盐湖区",
                        "center": {
                            "lng": 110.998135,
                            "lat": 35.015549
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140821",
                        "name": "临猗县",
                        "center": {
                            "lng": 110.774553,
                            "lat": 35.144406
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140828",
                        "name": "夏县",
                        "center": {
                            "lng": 111.219946,
                            "lat": 35.140733
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140829",
                        "name": "平陆县",
                        "center": {
                            "lng": 111.193957,
                            "lat": 34.829595
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140822",
                        "name": "万荣县",
                        "center": {
                            "lng": 110.837957,
                            "lat": 35.415805
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140823",
                        "name": "闻喜县",
                        "center": {
                            "lng": 111.224485,
                            "lat": 35.356664
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140827",
                        "name": "垣曲县",
                        "center": {
                            "lng": 111.670215,
                            "lat": 35.298297
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140824",
                        "name": "稷山县",
                        "center": {
                            "lng": 110.983273,
                            "lat": 35.604515
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140882",
                        "name": "河津市",
                        "center": {
                            "lng": 110.712032,
                            "lat": 35.596357
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140881",
                        "name": "永济市",
                        "center": {
                            "lng": 110.447771,
                            "lat": 34.866499
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140826",
                        "name": "绛县",
                        "center": {
                            "lng": 111.568849,
                            "lat": 35.491764
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140830",
                        "name": "芮城县",
                        "center": {
                            "lng": 110.694418,
                            "lat": 34.694173
                        }
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140825",
                        "name": "新绛县",
                        "center": {
                            "lng": 111.224767,
                            "lat": 35.616007
                        }
                    }
                ]
            },
            {
                "citycode": "0352",
                "adcode": "140200",
                "name": "大同市",
                "center": {
                    "lng": 113.366749,
                    "lat": 40.09711
                },
                "districtList": [
                    {
                        "citycode": "0352",
                        "adcode": "140223",
                        "name": "广灵县",
                        "center": {
                            "lng": 114.282703,
                            "lat": 39.760404
                        }
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140225",
                        "name": "浑源县",
                        "center": {
                            "lng": 113.69183,
                            "lat": 39.706485
                        }
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140221",
                        "name": "阳高县",
                        "center": {
                            "lng": 113.748944,
                            "lat": 40.361059
                        }
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140215",
                        "name": "云州区",
                        "center": {
                            "lng": 113.612496,
                            "lat": 40.040156
                        }
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140226",
                        "name": "左云县",
                        "center": {
                            "lng": 112.703008,
                            "lat": 40.013442
                        }
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140224",
                        "name": "灵丘县",
                        "center": {
                            "lng": 114.234452,
                            "lat": 39.442459
                        }
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140214",
                        "name": "云冈区",
                        "center": {
                            "lng": 113.150035,
                            "lat": 40.005844
                        }
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140212",
                        "name": "新荣区",
                        "center": {
                            "lng": 113.139628,
                            "lat": 40.256355
                        }
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140213",
                        "name": "平城区",
                        "center": {
                            "lng": 113.300179,
                            "lat": 40.076991
                        }
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140222",
                        "name": "天镇县",
                        "center": {
                            "lng": 114.090871,
                            "lat": 40.42087
                        }
                    }
                ]
            },
            {
                "citycode": "0354",
                "adcode": "140700",
                "name": "晋中市",
                "center": {
                    "lng": 112.752633,
                    "lat": 37.688006
                },
                "districtList": [
                    {
                        "citycode": "0354",
                        "adcode": "140724",
                        "name": "昔阳县",
                        "center": {
                            "lng": 113.707151,
                            "lat": 37.612577
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140725",
                        "name": "寿阳县",
                        "center": {
                            "lng": 113.176373,
                            "lat": 37.895191
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140721",
                        "name": "榆社县",
                        "center": {
                            "lng": 112.975378,
                            "lat": 37.071209
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140722",
                        "name": "左权县",
                        "center": {
                            "lng": 113.379412,
                            "lat": 37.082746
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140723",
                        "name": "和顺县",
                        "center": {
                            "lng": 113.570295,
                            "lat": 37.329696
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140727",
                        "name": "祁县",
                        "center": {
                            "lng": 112.335226,
                            "lat": 37.358425
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140703",
                        "name": "太谷区",
                        "center": {
                            "lng": 112.551297,
                            "lat": 37.421392
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140702",
                        "name": "榆次区",
                        "center": {
                            "lng": 112.707564,
                            "lat": 37.698637
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140728",
                        "name": "平遥县",
                        "center": {
                            "lng": 112.175825,
                            "lat": 37.189614
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140781",
                        "name": "介休市",
                        "center": {
                            "lng": 111.916451,
                            "lat": 37.027538
                        }
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140729",
                        "name": "灵石县",
                        "center": {
                            "lng": 111.778692,
                            "lat": 36.848085
                        }
                    }
                ]
            },
            {
                "citycode": "0358",
                "adcode": "141100",
                "name": "吕梁市",
                "center": {
                    "lng": 111.14454,
                    "lat": 37.518996
                },
                "districtList": [
                    {
                        "citycode": "0358",
                        "adcode": "141127",
                        "name": "岚县",
                        "center": {
                            "lng": 111.672156,
                            "lat": 38.279587
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141130",
                        "name": "交口县",
                        "center": {
                            "lng": 111.181241,
                            "lat": 36.982205
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141128",
                        "name": "方山县",
                        "center": {
                            "lng": 111.244309,
                            "lat": 37.895017
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141129",
                        "name": "中阳县",
                        "center": {
                            "lng": 111.178841,
                            "lat": 37.357816
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141123",
                        "name": "兴县",
                        "center": {
                            "lng": 111.127486,
                            "lat": 38.461818
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141126",
                        "name": "石楼县",
                        "center": {
                            "lng": 110.834712,
                            "lat": 36.998461
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141102",
                        "name": "离石区",
                        "center": {
                            "lng": 111.150325,
                            "lat": 37.517797
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141125",
                        "name": "柳林县",
                        "center": {
                            "lng": 110.888993,
                            "lat": 37.429816
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141124",
                        "name": "临县",
                        "center": {
                            "lng": 110.992712,
                            "lat": 37.951008
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141181",
                        "name": "孝义市",
                        "center": {
                            "lng": 111.778935,
                            "lat": 37.146051
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141182",
                        "name": "汾阳市",
                        "center": {
                            "lng": 111.770834,
                            "lat": 37.261493
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141121",
                        "name": "文水县",
                        "center": {
                            "lng": 112.028866,
                            "lat": 37.438101
                        }
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141122",
                        "name": "交城县",
                        "center": {
                            "lng": 112.155857,
                            "lat": 37.55169
                        }
                    }
                ]
            },
            {
                "citycode": "0351",
                "adcode": "140100",
                "name": "太原市",
                "center": {
                    "lng": 112.549656,
                    "lat": 37.870451
                },
                "districtList": [
                    {
                        "citycode": "0351",
                        "adcode": "140123",
                        "name": "娄烦县",
                        "center": {
                            "lng": 111.79715,
                            "lat": 38.067569
                        }
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140122",
                        "name": "阳曲县",
                        "center": {
                            "lng": 112.67292,
                            "lat": 38.058511
                        }
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140181",
                        "name": "古交市",
                        "center": {
                            "lng": 112.175034,
                            "lat": 37.907414
                        }
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140107",
                        "name": "杏花岭区",
                        "center": {
                            "lng": 112.570412,
                            "lat": 37.894241
                        }
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140106",
                        "name": "迎泽区",
                        "center": {
                            "lng": 112.563373,
                            "lat": 37.863308
                        }
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140110",
                        "name": "晋源区",
                        "center": {
                            "lng": 112.477869,
                            "lat": 37.715519
                        }
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140121",
                        "name": "清徐县",
                        "center": {
                            "lng": 112.359367,
                            "lat": 37.608751
                        }
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140105",
                        "name": "小店区",
                        "center": {
                            "lng": 112.565524,
                            "lat": 37.736865
                        }
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140109",
                        "name": "万柏林区",
                        "center": {
                            "lng": 112.515638,
                            "lat": 37.859738
                        }
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140108",
                        "name": "尖草坪区",
                        "center": {
                            "lng": 112.486141,
                            "lat": 37.940052
                        }
                    }
                ]
            },
            {
                "citycode": "0357",
                "adcode": "141000",
                "name": "临汾市",
                "center": {
                    "lng": 111.51931,
                    "lat": 36.088581
                },
                "districtList": [
                    {
                        "citycode": "0357",
                        "adcode": "141025",
                        "name": "古县",
                        "center": {
                            "lng": 111.92031,
                            "lat": 36.266767
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141031",
                        "name": "隰县",
                        "center": {
                            "lng": 110.940752,
                            "lat": 36.693345
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141026",
                        "name": "安泽县",
                        "center": {
                            "lng": 112.250242,
                            "lat": 36.147921
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141030",
                        "name": "大宁县",
                        "center": {
                            "lng": 110.752914,
                            "lat": 36.465126
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141028",
                        "name": "吉县",
                        "center": {
                            "lng": 110.680513,
                            "lat": 36.096833
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141032",
                        "name": "永和县",
                        "center": {
                            "lng": 110.631981,
                            "lat": 36.759524
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141029",
                        "name": "乡宁县",
                        "center": {
                            "lng": 110.846585,
                            "lat": 35.970834
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141033",
                        "name": "蒲县",
                        "center": {
                            "lng": 111.096457,
                            "lat": 36.41183
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141027",
                        "name": "浮山县",
                        "center": {
                            "lng": 111.848883,
                            "lat": 35.968124
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141021",
                        "name": "曲沃县",
                        "center": {
                            "lng": 111.475783,
                            "lat": 35.641883
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141034",
                        "name": "汾西县",
                        "center": {
                            "lng": 111.563993,
                            "lat": 36.652833
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141022",
                        "name": "翼城县",
                        "center": {
                            "lng": 111.719048,
                            "lat": 35.739706
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141081",
                        "name": "侯马市",
                        "center": {
                            "lng": 111.372002,
                            "lat": 35.619105
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141024",
                        "name": "洪洞县",
                        "center": {
                            "lng": 111.67571,
                            "lat": 36.254087
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141082",
                        "name": "霍州市",
                        "center": {
                            "lng": 111.755111,
                            "lat": 36.569046
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141002",
                        "name": "尧都区",
                        "center": {
                            "lng": 111.578797,
                            "lat": 36.082463
                        }
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141023",
                        "name": "襄汾县",
                        "center": {
                            "lng": 111.441725,
                            "lat": 35.876293
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "540000",
        "name": "西藏自治区",
        "center": {
            "lng": 91.117449,
            "lat": 29.648694
        },
        "districtList": [
            {
                "citycode": "0895",
                "adcode": "540300",
                "name": "昌都市",
                "center": {
                    "lng": 97.170425,
                    "lat": 31.142879
                },
                "districtList": [
                    {
                        "citycode": "0895",
                        "adcode": "540321",
                        "name": "江达县",
                        "center": {
                            "lng": 98.218336,
                            "lat": 31.499176
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540324",
                        "name": "丁青县",
                        "center": {
                            "lng": 95.619868,
                            "lat": 31.409024
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540302",
                        "name": "卡若区",
                        "center": {
                            "lng": 97.196021,
                            "lat": 31.112087
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540323",
                        "name": "类乌齐县",
                        "center": {
                            "lng": 96.600246,
                            "lat": 31.211601
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540330",
                        "name": "边坝县",
                        "center": {
                            "lng": 94.7078,
                            "lat": 30.933652
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540329",
                        "name": "洛隆县",
                        "center": {
                            "lng": 95.825169,
                            "lat": 30.741988
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540325",
                        "name": "察雅县",
                        "center": {
                            "lng": 97.568752,
                            "lat": 30.653943
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540322",
                        "name": "贡觉县",
                        "center": {
                            "lng": 98.27097,
                            "lat": 30.860099
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540326",
                        "name": "八宿县",
                        "center": {
                            "lng": 96.917836,
                            "lat": 30.053209
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540327",
                        "name": "左贡县",
                        "center": {
                            "lng": 97.841176,
                            "lat": 29.671488
                        }
                    },
                    {
                        "citycode": "0895",
                        "adcode": "540328",
                        "name": "芒康县",
                        "center": {
                            "lng": 98.593493,
                            "lat": 29.679957
                        }
                    }
                ]
            },
            {
                "citycode": "0896",
                "adcode": "540600",
                "name": "那曲市",
                "center": {
                    "lng": 92.05151,
                    "lat": 31.477905
                },
                "districtList": [
                    {
                        "citycode": "0896",
                        "adcode": "540624",
                        "name": "安多县",
                        "center": {
                            "lng": 91.68195,
                            "lat": 32.265016
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540623",
                        "name": "聂荣县",
                        "center": {
                            "lng": 92.303377,
                            "lat": 32.10775
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540628",
                        "name": "巴青县",
                        "center": {
                            "lng": 94.053438,
                            "lat": 31.91847
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540625",
                        "name": "申扎县",
                        "center": {
                            "lng": 88.709936,
                            "lat": 30.93045
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540627",
                        "name": "班戈县",
                        "center": {
                            "lng": 90.009822,
                            "lat": 31.392157
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540626",
                        "name": "索县",
                        "center": {
                            "lng": 93.785068,
                            "lat": 31.888045
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540622",
                        "name": "比如县",
                        "center": {
                            "lng": 93.681302,
                            "lat": 31.477914
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540602",
                        "name": "色尼区",
                        "center": {
                            "lng": 92.053498,
                            "lat": 31.469645
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540621",
                        "name": "嘉黎县",
                        "center": {
                            "lng": 93.232347,
                            "lat": 30.641543
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540629",
                        "name": "尼玛县",
                        "center": {
                            "lng": 87.236772,
                            "lat": 31.784701
                        }
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540630",
                        "name": "双湖县",
                        "center": {
                            "lng": 88.838017,
                            "lat": 33.188355
                        }
                    }
                ]
            },
            {
                "citycode": "0891",
                "adcode": "540100",
                "name": "拉萨市",
                "center": {
                    "lng": 91.171924,
                    "lat": 29.653491
                },
                "districtList": [
                    {
                        "citycode": "0891",
                        "adcode": "540122",
                        "name": "当雄县",
                        "center": {
                            "lng": 91.101186,
                            "lat": 30.473134
                        }
                    },
                    {
                        "citycode": "0891",
                        "adcode": "540121",
                        "name": "林周县",
                        "center": {
                            "lng": 91.265287,
                            "lat": 29.893545
                        }
                    },
                    {
                        "citycode": "0891",
                        "adcode": "540127",
                        "name": "墨竹工卡县",
                        "center": {
                            "lng": 91.739134,
                            "lat": 29.850344
                        }
                    },
                    {
                        "citycode": "0891",
                        "adcode": "540102",
                        "name": "城关区",
                        "center": {
                            "lng": 91.140368,
                            "lat": 29.654813
                        }
                    },
                    {
                        "citycode": "0891",
                        "adcode": "540123",
                        "name": "尼木县",
                        "center": {
                            "lng": 90.16446,
                            "lat": 29.43202
                        }
                    },
                    {
                        "citycode": "0891",
                        "adcode": "540103",
                        "name": "堆龙德庆区",
                        "center": {
                            "lng": 91.002866,
                            "lat": 29.646815
                        }
                    },
                    {
                        "citycode": "0891",
                        "adcode": "540104",
                        "name": "达孜区",
                        "center": {
                            "lng": 91.349503,
                            "lat": 29.670173
                        }
                    },
                    {
                        "citycode": "0891",
                        "adcode": "540124",
                        "name": "曲水县",
                        "center": {
                            "lng": 90.743355,
                            "lat": 29.354293
                        }
                    }
                ]
            },
            {
                "citycode": "0892",
                "adcode": "540200",
                "name": "日喀则市",
                "center": {
                    "lng": 88.880423,
                    "lat": 29.266838
                },
                "districtList": [
                    {
                        "citycode": "0892",
                        "adcode": "540232",
                        "name": "仲巴县",
                        "center": {
                            "lng": 84.03153,
                            "lat": 29.770279
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540226",
                        "name": "昂仁县",
                        "center": {
                            "lng": 87.227739,
                            "lat": 29.299444
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540227",
                        "name": "谢通门县",
                        "center": {
                            "lng": 88.255784,
                            "lat": 29.425455
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540221",
                        "name": "南木林县",
                        "center": {
                            "lng": 89.099243,
                            "lat": 29.682331
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540236",
                        "name": "萨嘎县",
                        "center": {
                            "lng": 85.232941,
                            "lat": 29.328818
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540202",
                        "name": "桑珠孜区",
                        "center": {
                            "lng": 88.898503,
                            "lat": 29.247726
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540225",
                        "name": "拉孜县",
                        "center": {
                            "lng": 87.636934,
                            "lat": 29.08188
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540229",
                        "name": "仁布县",
                        "center": {
                            "lng": 89.841983,
                            "lat": 29.230933
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540224",
                        "name": "萨迦县",
                        "center": {
                            "lng": 88.021674,
                            "lat": 28.899664
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540234",
                        "name": "吉隆县",
                        "center": {
                            "lng": 85.298109,
                            "lat": 28.856542
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540230",
                        "name": "康马县",
                        "center": {
                            "lng": 89.681663,
                            "lat": 28.555627
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540223",
                        "name": "定日县",
                        "center": {
                            "lng": 87.12612,
                            "lat": 28.658743
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540228",
                        "name": "白朗县",
                        "center": {
                            "lng": 89.261977,
                            "lat": 29.107688
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540235",
                        "name": "聂拉木县",
                        "center": {
                            "lng": 85.982237,
                            "lat": 28.155186
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540222",
                        "name": "江孜县",
                        "center": {
                            "lng": 89.605654,
                            "lat": 28.91186
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540233",
                        "name": "亚东县",
                        "center": {
                            "lng": 88.907136,
                            "lat": 27.486094
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540237",
                        "name": "岗巴县",
                        "center": {
                            "lng": 88.515318,
                            "lat": 28.271189
                        }
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540231",
                        "name": "定结县",
                        "center": {
                            "lng": 87.765872,
                            "lat": 28.364159
                        }
                    }
                ]
            },
            {
                "citycode": "0893",
                "adcode": "540500",
                "name": "山南市",
                "center": {
                    "lng": 91.771426,
                    "lat": 29.237722
                },
                "districtList": [
                    {
                        "citycode": "0893",
                        "adcode": "540523",
                        "name": "桑日县",
                        "center": {
                            "lng": 92.017723,
                            "lat": 29.259439
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540528",
                        "name": "加查县",
                        "center": {
                            "lng": 92.592701,
                            "lat": 29.140355
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540502",
                        "name": "乃东区",
                        "center": {
                            "lng": 91.761538,
                            "lat": 29.224904
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540521",
                        "name": "扎囊县",
                        "center": {
                            "lng": 91.33725,
                            "lat": 29.245113
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540522",
                        "name": "贡嘎县",
                        "center": {
                            "lng": 90.978425,
                            "lat": 29.290169
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540531",
                        "name": "浪卡子县",
                        "center": {
                            "lng": 90.400251,
                            "lat": 28.96693
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540525",
                        "name": "曲松县",
                        "center": {
                            "lng": 92.203738,
                            "lat": 29.062826
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540524",
                        "name": "琼结县",
                        "center": {
                            "lng": 91.684307,
                            "lat": 29.024492
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540526",
                        "name": "措美县",
                        "center": {
                            "lng": 91.433509,
                            "lat": 28.438202
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540529",
                        "name": "隆子县",
                        "center": {
                            "lng": 92.461774,
                            "lat": 28.40743
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540527",
                        "name": "洛扎县",
                        "center": {
                            "lng": 90.859971,
                            "lat": 28.385811
                        }
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540530",
                        "name": "错那市",
                        "center": {
                            "lng": 91.957155,
                            "lat": 27.991121
                        }
                    }
                ]
            },
            {
                "citycode": "0894",
                "adcode": "540400",
                "name": "林芝市",
                "center": {
                    "lng": 94.361436,
                    "lat": 29.64875
                },
                "districtList": [
                    {
                        "citycode": "0894",
                        "adcode": "540421",
                        "name": "工布江达县",
                        "center": {
                            "lng": 93.246077,
                            "lat": 29.88528
                        }
                    },
                    {
                        "citycode": "0894",
                        "adcode": "540424",
                        "name": "波密县",
                        "center": {
                            "lng": 95.768439,
                            "lat": 29.859751
                        }
                    },
                    {
                        "citycode": "0894",
                        "adcode": "540402",
                        "name": "巴宜区",
                        "center": {
                            "lng": 94.361094,
                            "lat": 29.636576
                        }
                    },
                    {
                        "citycode": "0894",
                        "adcode": "540422",
                        "name": "米林市",
                        "center": {
                            "lng": 94.213059,
                            "lat": 29.215971
                        }
                    },
                    {
                        "citycode": "0894",
                        "adcode": "540423",
                        "name": "墨脱县",
                        "center": {
                            "lng": 95.332108,
                            "lat": 29.325425
                        }
                    },
                    {
                        "citycode": "0894",
                        "adcode": "540425",
                        "name": "察隅县",
                        "center": {
                            "lng": 97.466919,
                            "lat": 28.66128
                        }
                    },
                    {
                        "citycode": "0894",
                        "adcode": "540426",
                        "name": "朗县",
                        "center": {
                            "lng": 93.074702,
                            "lat": 29.046337
                        }
                    }
                ]
            },
            {
                "citycode": "0897",
                "adcode": "542500",
                "name": "阿里地区",
                "center": {
                    "lng": 80.105786,
                    "lat": 32.500987
                },
                "districtList": [
                    {
                        "citycode": "0897",
                        "adcode": "542526",
                        "name": "改则县",
                        "center": {
                            "lng": 84.062612,
                            "lat": 32.303148
                        }
                    },
                    {
                        "citycode": "0897",
                        "adcode": "542522",
                        "name": "札达县",
                        "center": {
                            "lng": 79.807096,
                            "lat": 31.479882
                        }
                    },
                    {
                        "citycode": "0897",
                        "adcode": "542527",
                        "name": "措勤县",
                        "center": {
                            "lng": 85.152773,
                            "lat": 31.015862
                        }
                    },
                    {
                        "citycode": "0897",
                        "adcode": "542521",
                        "name": "普兰县",
                        "center": {
                            "lng": 81.177116,
                            "lat": 30.290467
                        }
                    },
                    {
                        "citycode": "0897",
                        "adcode": "542524",
                        "name": "日土县",
                        "center": {
                            "lng": 79.733552,
                            "lat": 33.382017
                        }
                    },
                    {
                        "citycode": "0897",
                        "adcode": "542523",
                        "name": "噶尔县",
                        "center": {
                            "lng": 80.096591,
                            "lat": 32.492078
                        }
                    },
                    {
                        "citycode": "0897",
                        "adcode": "542525",
                        "name": "革吉县",
                        "center": {
                            "lng": 81.145433,
                            "lat": 32.387233
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "220000",
        "name": "吉林省",
        "center": {
            "lng": 125.325802,
            "lat": 43.896942
        },
        "districtList": [
            {
                "citycode": "0432",
                "adcode": "220200",
                "name": "吉林市",
                "center": {
                    "lng": 126.549719,
                    "lat": 43.838132
                },
                "districtList": [
                    {
                        "citycode": "0432",
                        "adcode": "220283",
                        "name": "舒兰市",
                        "center": {
                            "lng": 126.965515,
                            "lat": 44.405922
                        }
                    },
                    {
                        "citycode": "0432",
                        "adcode": "220282",
                        "name": "桦甸市",
                        "center": {
                            "lng": 126.746245,
                            "lat": 42.972272
                        }
                    },
                    {
                        "citycode": "0432",
                        "adcode": "220281",
                        "name": "蛟河市",
                        "center": {
                            "lng": 127.344773,
                            "lat": 43.72382
                        }
                    },
                    {
                        "citycode": "0432",
                        "adcode": "220221",
                        "name": "永吉县",
                        "center": {
                            "lng": 126.497899,
                            "lat": 43.672198
                        }
                    },
                    {
                        "citycode": "0432",
                        "adcode": "220284",
                        "name": "磐石市",
                        "center": {
                            "lng": 126.060328,
                            "lat": 42.946608
                        }
                    },
                    {
                        "citycode": "0432",
                        "adcode": "220203",
                        "name": "龙潭区",
                        "center": {
                            "lng": 126.562131,
                            "lat": 43.910743
                        }
                    },
                    {
                        "citycode": "0432",
                        "adcode": "220211",
                        "name": "丰满区",
                        "center": {
                            "lng": 126.561351,
                            "lat": 43.821192
                        }
                    },
                    {
                        "citycode": "0432",
                        "adcode": "220204",
                        "name": "船营区",
                        "center": {
                            "lng": 126.540909,
                            "lat": 43.833806
                        }
                    },
                    {
                        "citycode": "0432",
                        "adcode": "220202",
                        "name": "昌邑区",
                        "center": {
                            "lng": 126.574414,
                            "lat": 43.881896
                        }
                    }
                ]
            },
            {
                "citycode": "0431",
                "adcode": "220100",
                "name": "长春市",
                "center": {
                    "lng": 125.323643,
                    "lat": 43.816996
                },
                "districtList": [
                    {
                        "citycode": "0431",
                        "adcode": "220183",
                        "name": "德惠市",
                        "center": {
                            "lng": 125.728552,
                            "lat": 44.521788
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220182",
                        "name": "榆树市",
                        "center": {
                            "lng": 126.533126,
                            "lat": 44.840263
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220112",
                        "name": "双阳区",
                        "center": {
                            "lng": 125.664583,
                            "lat": 43.525367
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220122",
                        "name": "农安县",
                        "center": {
                            "lng": 125.184921,
                            "lat": 44.432829
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220184",
                        "name": "公主岭市",
                        "center": {
                            "lng": 124.79379,
                            "lat": 43.495116
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220106",
                        "name": "绿园区",
                        "center": {
                            "lng": 125.256214,
                            "lat": 43.881047
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220104",
                        "name": "朝阳区",
                        "center": {
                            "lng": 125.288168,
                            "lat": 43.833845
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220105",
                        "name": "二道区",
                        "center": {
                            "lng": 125.37419,
                            "lat": 43.865912
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220113",
                        "name": "九台区",
                        "center": {
                            "lng": 125.839549,
                            "lat": 44.151672
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220103",
                        "name": "宽城区",
                        "center": {
                            "lng": 125.326614,
                            "lat": 43.943522
                        }
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220102",
                        "name": "南关区",
                        "center": {
                            "lng": 125.350341,
                            "lat": 43.86382
                        }
                    }
                ]
            },
            {
                "citycode": "0436",
                "adcode": "220800",
                "name": "白城市",
                "center": {
                    "lng": 122.838102,
                    "lat": 45.620131
                },
                "districtList": [
                    {
                        "citycode": "0436",
                        "adcode": "220881",
                        "name": "洮南市",
                        "center": {
                            "lng": 122.79845,
                            "lat": 45.356849
                        }
                    },
                    {
                        "citycode": "0436",
                        "adcode": "220882",
                        "name": "大安市",
                        "center": {
                            "lng": 124.291032,
                            "lat": 45.507004
                        }
                    },
                    {
                        "citycode": "0436",
                        "adcode": "220822",
                        "name": "通榆县",
                        "center": {
                            "lng": 123.088093,
                            "lat": 44.812912
                        }
                    },
                    {
                        "citycode": "0436",
                        "adcode": "220802",
                        "name": "洮北区",
                        "center": {
                            "lng": 122.851105,
                            "lat": 45.621545
                        }
                    },
                    {
                        "citycode": "0436",
                        "adcode": "220821",
                        "name": "镇赉县",
                        "center": {
                            "lng": 123.19967,
                            "lat": 45.848195
                        }
                    }
                ]
            },
            {
                "citycode": "0438",
                "adcode": "220700",
                "name": "松原市",
                "center": {
                    "lng": 124.825321,
                    "lat": 45.14191
                },
                "districtList": [
                    {
                        "citycode": "0438",
                        "adcode": "220723",
                        "name": "乾安县",
                        "center": {
                            "lng": 124.040651,
                            "lat": 45.003539
                        }
                    },
                    {
                        "citycode": "0438",
                        "adcode": "220722",
                        "name": "长岭县",
                        "center": {
                            "lng": 123.967244,
                            "lat": 44.276293
                        }
                    },
                    {
                        "citycode": "0438",
                        "adcode": "220781",
                        "name": "扶余市",
                        "center": {
                            "lng": 126.049534,
                            "lat": 44.989057
                        }
                    },
                    {
                        "citycode": "0438",
                        "adcode": "220702",
                        "name": "宁江区",
                        "center": {
                            "lng": 124.792839,
                            "lat": 45.186486
                        }
                    },
                    {
                        "citycode": "0438",
                        "adcode": "220721",
                        "name": "前郭尔罗斯蒙古族自治县",
                        "center": {
                            "lng": 124.823417,
                            "lat": 45.118061
                        }
                    }
                ]
            },
            {
                "citycode": "1433",
                "adcode": "222400",
                "name": "延边朝鲜族自治州",
                "center": {
                    "lng": 129.470605,
                    "lat": 42.909426
                },
                "districtList": [
                    {
                        "citycode": "1433",
                        "adcode": "222404",
                        "name": "珲春市",
                        "center": {
                            "lng": 130.365829,
                            "lat": 42.862551
                        }
                    },
                    {
                        "citycode": "1433",
                        "adcode": "222402",
                        "name": "图们市",
                        "center": {
                            "lng": 129.843807,
                            "lat": 42.968039
                        }
                    },
                    {
                        "citycode": "1433",
                        "adcode": "222406",
                        "name": "和龙市",
                        "center": {
                            "lng": 129.010932,
                            "lat": 42.546434
                        }
                    },
                    {
                        "citycode": "1433",
                        "adcode": "222424",
                        "name": "汪清县",
                        "center": {
                            "lng": 129.785137,
                            "lat": 43.317215
                        }
                    },
                    {
                        "citycode": "1433",
                        "adcode": "222401",
                        "name": "延吉市",
                        "center": {
                            "lng": 129.507655,
                            "lat": 42.891034
                        }
                    },
                    {
                        "citycode": "1433",
                        "adcode": "222426",
                        "name": "安图县",
                        "center": {
                            "lng": 128.899744,
                            "lat": 43.111978
                        }
                    },
                    {
                        "citycode": "1433",
                        "adcode": "222403",
                        "name": "敦化市",
                        "center": {
                            "lng": 128.232235,
                            "lat": 43.372669
                        }
                    },
                    {
                        "citycode": "1433",
                        "adcode": "222405",
                        "name": "龙井市",
                        "center": {
                            "lng": 129.426529,
                            "lat": 42.767172
                        }
                    }
                ]
            },
            {
                "citycode": "0434",
                "adcode": "220300",
                "name": "四平市",
                "center": {
                    "lng": 124.350599,
                    "lat": 43.166764
                },
                "districtList": [
                    {
                        "citycode": "0434",
                        "adcode": "220303",
                        "name": "铁东区",
                        "center": {
                            "lng": 124.409852,
                            "lat": 43.162664
                        }
                    },
                    {
                        "citycode": "0434",
                        "adcode": "220382",
                        "name": "双辽市",
                        "center": {
                            "lng": 123.502398,
                            "lat": 43.518301
                        }
                    },
                    {
                        "citycode": "0434",
                        "adcode": "220302",
                        "name": "铁西区",
                        "center": {
                            "lng": 124.345994,
                            "lat": 43.146288
                        }
                    },
                    {
                        "citycode": "0434",
                        "adcode": "220322",
                        "name": "梨树县",
                        "center": {
                            "lng": 124.335389,
                            "lat": 43.30706
                        }
                    },
                    {
                        "citycode": "0434",
                        "adcode": "220323",
                        "name": "伊通满族自治县",
                        "center": {
                            "lng": 125.305393,
                            "lat": 43.345754
                        }
                    }
                ]
            },
            {
                "citycode": "0435",
                "adcode": "220500",
                "name": "通化市",
                "center": {
                    "lng": 125.939721,
                    "lat": 41.728312
                },
                "districtList": [
                    {
                        "citycode": "0435",
                        "adcode": "220503",
                        "name": "二道江区",
                        "center": {
                            "lng": 126.042546,
                            "lat": 41.773989
                        }
                    },
                    {
                        "citycode": "0435",
                        "adcode": "220502",
                        "name": "东昌区",
                        "center": {
                            "lng": 125.927187,
                            "lat": 41.702872
                        }
                    },
                    {
                        "citycode": "0435",
                        "adcode": "220521",
                        "name": "通化县",
                        "center": {
                            "lng": 125.758927,
                            "lat": 41.680135
                        }
                    },
                    {
                        "citycode": "0435",
                        "adcode": "220524",
                        "name": "柳河县",
                        "center": {
                            "lng": 125.744654,
                            "lat": 42.284594
                        }
                    },
                    {
                        "citycode": "0435",
                        "adcode": "220523",
                        "name": "辉南县",
                        "center": {
                            "lng": 126.046006,
                            "lat": 42.684706
                        }
                    },
                    {
                        "citycode": "0435",
                        "adcode": "220581",
                        "name": "梅河口市",
                        "center": {
                            "lng": 125.711129,
                            "lat": 42.539183
                        }
                    },
                    {
                        "citycode": "0435",
                        "adcode": "220582",
                        "name": "集安市",
                        "center": {
                            "lng": 126.193172,
                            "lat": 41.125805
                        }
                    }
                ]
            },
            {
                "citycode": "0439",
                "adcode": "220600",
                "name": "白山市",
                "center": {
                    "lng": 126.414274,
                    "lat": 41.944132
                },
                "districtList": [
                    {
                        "citycode": "0439",
                        "adcode": "220622",
                        "name": "靖宇县",
                        "center": {
                            "lng": 126.813262,
                            "lat": 42.388902
                        }
                    },
                    {
                        "citycode": "0439",
                        "adcode": "220605",
                        "name": "江源区",
                        "center": {
                            "lng": 126.591178,
                            "lat": 42.056747
                        }
                    },
                    {
                        "citycode": "0439",
                        "adcode": "220621",
                        "name": "抚松县",
                        "center": {
                            "lng": 127.449387,
                            "lat": 42.221038
                        }
                    },
                    {
                        "citycode": "0439",
                        "adcode": "220623",
                        "name": "长白朝鲜族自治县",
                        "center": {
                            "lng": 128.20066,
                            "lat": 41.420253
                        }
                    },
                    {
                        "citycode": "0439",
                        "adcode": "220681",
                        "name": "临江市",
                        "center": {
                            "lng": 126.918086,
                            "lat": 41.811979
                        }
                    },
                    {
                        "citycode": "0439",
                        "adcode": "220602",
                        "name": "浑江区",
                        "center": {
                            "lng": 126.416093,
                            "lat": 41.945409
                        }
                    }
                ]
            },
            {
                "citycode": "0437",
                "adcode": "220400",
                "name": "辽源市",
                "center": {
                    "lng": 125.144676,
                    "lat": 42.887961
                },
                "districtList": [
                    {
                        "citycode": "0437",
                        "adcode": "220403",
                        "name": "西安区",
                        "center": {
                            "lng": 125.149488,
                            "lat": 42.927252
                        }
                    },
                    {
                        "citycode": "0437",
                        "adcode": "220422",
                        "name": "东辽县",
                        "center": {
                            "lng": 124.991045,
                            "lat": 42.925636
                        }
                    },
                    {
                        "citycode": "0437",
                        "adcode": "220402",
                        "name": "龙山区",
                        "center": {
                            "lng": 125.13703,
                            "lat": 42.902194
                        }
                    },
                    {
                        "citycode": "0437",
                        "adcode": "220421",
                        "name": "东丰县",
                        "center": {
                            "lng": 125.53096,
                            "lat": 42.677253
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "530000",
        "name": "云南省",
        "center": {
            "lng": 102.709372,
            "lat": 25.046432
        },
        "districtList": [
            {
                "citycode": "0870",
                "adcode": "530600",
                "name": "昭通市",
                "center": {
                    "lng": 103.717078,
                    "lat": 27.338185
                },
                "districtList": [
                    {
                        "citycode": "0870",
                        "adcode": "530626",
                        "name": "绥江县",
                        "center": {
                            "lng": 103.968995,
                            "lat": 28.592119
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530681",
                        "name": "水富市",
                        "center": {
                            "lng": 104.415964,
                            "lat": 28.629951
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530625",
                        "name": "永善县",
                        "center": {
                            "lng": 103.63756,
                            "lat": 28.229018
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530624",
                        "name": "大关县",
                        "center": {
                            "lng": 103.891164,
                            "lat": 27.748054
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530629",
                        "name": "威信县",
                        "center": {
                            "lng": 105.049012,
                            "lat": 27.846839
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530622",
                        "name": "巧家县",
                        "center": {
                            "lng": 102.935343,
                            "lat": 26.896904
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530628",
                        "name": "彝良县",
                        "center": {
                            "lng": 104.055991,
                            "lat": 27.624277
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530621",
                        "name": "鲁甸县",
                        "center": {
                            "lng": 103.557969,
                            "lat": 27.186668
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530623",
                        "name": "盐津县",
                        "center": {
                            "lng": 104.234458,
                            "lat": 28.108475
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530627",
                        "name": "镇雄县",
                        "center": {
                            "lng": 104.873486,
                            "lat": 27.441527
                        }
                    },
                    {
                        "citycode": "0870",
                        "adcode": "530602",
                        "name": "昭阳区",
                        "center": {
                            "lng": 103.706323,
                            "lat": 27.320035
                        }
                    }
                ]
            },
            {
                "citycode": "0874",
                "adcode": "530300",
                "name": "曲靖市",
                "center": {
                    "lng": 103.796288,
                    "lat": 25.490866
                },
                "districtList": [
                    {
                        "citycode": "0874",
                        "adcode": "530326",
                        "name": "会泽县",
                        "center": {
                            "lng": 103.297155,
                            "lat": 26.417116
                        }
                    },
                    {
                        "citycode": "0874",
                        "adcode": "530304",
                        "name": "马龙区",
                        "center": {
                            "lng": 103.578459,
                            "lat": 25.428102
                        }
                    },
                    {
                        "citycode": "0874",
                        "adcode": "530381",
                        "name": "宣威市",
                        "center": {
                            "lng": 104.104255,
                            "lat": 26.218956
                        }
                    },
                    {
                        "citycode": "0874",
                        "adcode": "530325",
                        "name": "富源县",
                        "center": {
                            "lng": 104.255082,
                            "lat": 25.674217
                        }
                    },
                    {
                        "citycode": "0874",
                        "adcode": "530303",
                        "name": "沾益区",
                        "center": {
                            "lng": 103.822104,
                            "lat": 25.600424
                        }
                    },
                    {
                        "citycode": "0874",
                        "adcode": "530323",
                        "name": "师宗县",
                        "center": {
                            "lng": 103.985224,
                            "lat": 24.822471
                        }
                    },
                    {
                        "citycode": "0874",
                        "adcode": "530324",
                        "name": "罗平县",
                        "center": {
                            "lng": 104.297124,
                            "lat": 24.865388
                        }
                    },
                    {
                        "citycode": "0874",
                        "adcode": "530322",
                        "name": "陆良县",
                        "center": {
                            "lng": 103.66671,
                            "lat": 25.0293
                        }
                    },
                    {
                        "citycode": "0874",
                        "adcode": "530302",
                        "name": "麒麟区",
                        "center": {
                            "lng": 103.804406,
                            "lat": 25.496472
                        }
                    }
                ]
            },
            {
                "citycode": "0873",
                "adcode": "532500",
                "name": "红河哈尼族彝族自治州",
                "center": {
                    "lng": 103.374873,
                    "lat": 23.363129
                },
                "districtList": [
                    {
                        "citycode": "0873",
                        "adcode": "532504",
                        "name": "弥勒市",
                        "center": {
                            "lng": 103.414817,
                            "lat": 24.411774
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532524",
                        "name": "建水县",
                        "center": {
                            "lng": 102.826178,
                            "lat": 23.635824
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532502",
                        "name": "开远市",
                        "center": {
                            "lng": 103.266908,
                            "lat": 23.714518
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532529",
                        "name": "红河县",
                        "center": {
                            "lng": 102.420566,
                            "lat": 23.368946
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532523",
                        "name": "屏边苗族自治县",
                        "center": {
                            "lng": 103.675458,
                            "lat": 22.986733
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532528",
                        "name": "元阳县",
                        "center": {
                            "lng": 102.835358,
                            "lat": 23.219671
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532501",
                        "name": "个旧市",
                        "center": {
                            "lng": 103.152663,
                            "lat": 23.389935
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532530",
                        "name": "金平苗族瑶族傣族自治县",
                        "center": {
                            "lng": 103.227982,
                            "lat": 22.769894
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532531",
                        "name": "绿春县",
                        "center": {
                            "lng": 102.392655,
                            "lat": 22.993654
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532532",
                        "name": "河口瑶族自治县",
                        "center": {
                            "lng": 103.939265,
                            "lat": 22.529438
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532525",
                        "name": "石屏县",
                        "center": {
                            "lng": 102.496138,
                            "lat": 23.705707
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532503",
                        "name": "蒙自市",
                        "center": {
                            "lng": 103.364936,
                            "lat": 23.396111
                        }
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532527",
                        "name": "泸西县",
                        "center": {
                            "lng": 103.76615,
                            "lat": 24.531981
                        }
                    }
                ]
            },
            {
                "citycode": "0886",
                "adcode": "533300",
                "name": "怒江傈僳族自治州",
                "center": {
                    "lng": 98.8566,
                    "lat": 25.817555
                },
                "districtList": [
                    {
                        "citycode": "0886",
                        "adcode": "533324",
                        "name": "贡山独龙族怒族自治县",
                        "center": {
                            "lng": 98.666279,
                            "lat": 27.740839
                        }
                    },
                    {
                        "citycode": "0886",
                        "adcode": "533323",
                        "name": "福贡县",
                        "center": {
                            "lng": 98.869132,
                            "lat": 26.901831
                        }
                    },
                    {
                        "citycode": "0886",
                        "adcode": "533325",
                        "name": "兰坪白族普米族自治县",
                        "center": {
                            "lng": 99.416628,
                            "lat": 26.453622
                        }
                    },
                    {
                        "citycode": "0886",
                        "adcode": "533301",
                        "name": "泸水市",
                        "center": {
                            "lng": 98.857723,
                            "lat": 25.822579
                        }
                    }
                ]
            },
            {
                "citycode": "0877",
                "adcode": "530400",
                "name": "玉溪市",
                "center": {
                    "lng": 102.526673,
                    "lat": 24.346786
                },
                "districtList": [
                    {
                        "citycode": "0877",
                        "adcode": "530425",
                        "name": "易门县",
                        "center": {
                            "lng": 102.161947,
                            "lat": 24.672156
                        }
                    },
                    {
                        "citycode": "0877",
                        "adcode": "530424",
                        "name": "华宁县",
                        "center": {
                            "lng": 102.928914,
                            "lat": 24.19322
                        }
                    },
                    {
                        "citycode": "0877",
                        "adcode": "530402",
                        "name": "红塔区",
                        "center": {
                            "lng": 102.540122,
                            "lat": 24.341215
                        }
                    },
                    {
                        "citycode": "0877",
                        "adcode": "530426",
                        "name": "峨山彝族自治县",
                        "center": {
                            "lng": 102.405698,
                            "lat": 24.168899
                        }
                    },
                    {
                        "citycode": "0877",
                        "adcode": "530423",
                        "name": "通海县",
                        "center": {
                            "lng": 102.725538,
                            "lat": 24.11114
                        }
                    },
                    {
                        "citycode": "0877",
                        "adcode": "530403",
                        "name": "江川区",
                        "center": {
                            "lng": 102.748499,
                            "lat": 24.299441
                        }
                    },
                    {
                        "citycode": "0877",
                        "adcode": "530481",
                        "name": "澄江市",
                        "center": {
                            "lng": 102.904181,
                            "lat": 24.675536
                        }
                    },
                    {
                        "citycode": "0877",
                        "adcode": "530428",
                        "name": "元江哈尼族彝族傣族自治县",
                        "center": {
                            "lng": 101.998138,
                            "lat": 23.596068
                        }
                    },
                    {
                        "citycode": "0877",
                        "adcode": "530427",
                        "name": "新平彝族傣族自治县",
                        "center": {
                            "lng": 101.990805,
                            "lat": 24.070436
                        }
                    }
                ]
            },
            {
                "citycode": "0872",
                "adcode": "532900",
                "name": "大理白族自治州",
                "center": {
                    "lng": 100.267608,
                    "lat": 25.606548
                },
                "districtList": [
                    {
                        "citycode": "0872",
                        "adcode": "532932",
                        "name": "鹤庆县",
                        "center": {
                            "lng": 100.176331,
                            "lat": 26.560122
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532931",
                        "name": "剑川县",
                        "center": {
                            "lng": 99.905041,
                            "lat": 26.536889
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532930",
                        "name": "洱源县",
                        "center": {
                            "lng": 99.962294,
                            "lat": 26.11337
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532929",
                        "name": "云龙县",
                        "center": {
                            "lng": 99.371021,
                            "lat": 25.885733
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532924",
                        "name": "宾川县",
                        "center": {
                            "lng": 100.590274,
                            "lat": 25.830491
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532901",
                        "name": "大理市",
                        "center": {
                            "lng": 100.301614,
                            "lat": 25.678466
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532922",
                        "name": "漾濞彝族自治县",
                        "center": {
                            "lng": 99.958089,
                            "lat": 25.669944
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532928",
                        "name": "永平县",
                        "center": {
                            "lng": 99.54063,
                            "lat": 25.464134
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532927",
                        "name": "巍山彝族回族自治县",
                        "center": {
                            "lng": 100.306977,
                            "lat": 25.227065
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532923",
                        "name": "祥云县",
                        "center": {
                            "lng": 100.549961,
                            "lat": 25.483727
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532926",
                        "name": "南涧彝族自治县",
                        "center": {
                            "lng": 100.510333,
                            "lat": 25.032353
                        }
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532925",
                        "name": "弥渡县",
                        "center": {
                            "lng": 100.491038,
                            "lat": 25.343778
                        }
                    }
                ]
            },
            {
                "citycode": "0879",
                "adcode": "530800",
                "name": "普洱市",
                "center": {
                    "lng": 100.966011,
                    "lat": 22.825229
                },
                "districtList": [
                    {
                        "citycode": "0879",
                        "adcode": "530825",
                        "name": "镇沅彝族哈尼族拉祜族自治县",
                        "center": {
                            "lng": 101.108733,
                            "lat": 24.00445
                        }
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530822",
                        "name": "墨江哈尼族自治县",
                        "center": {
                            "lng": 101.692461,
                            "lat": 23.431894
                        }
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530824",
                        "name": "景谷傣族彝族自治县",
                        "center": {
                            "lng": 100.702807,
                            "lat": 23.496987
                        }
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530828",
                        "name": "澜沧拉祜族自治县",
                        "center": {
                            "lng": 99.932045,
                            "lat": 22.555799
                        }
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530829",
                        "name": "西盟佤族自治县",
                        "center": {
                            "lng": 99.59016,
                            "lat": 22.644237
                        }
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530826",
                        "name": "江城哈尼族彝族自治县",
                        "center": {
                            "lng": 101.862344,
                            "lat": 22.585858
                        }
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530823",
                        "name": "景东彝族自治县",
                        "center": {
                            "lng": 100.833877,
                            "lat": 24.446731
                        }
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530827",
                        "name": "孟连傣族拉祜族佤族自治县",
                        "center": {
                            "lng": 99.584225,
                            "lat": 22.329053
                        }
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530821",
                        "name": "宁洱哈尼族彝族自治县",
                        "center": {
                            "lng": 101.045743,
                            "lat": 23.048809
                        }
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530802",
                        "name": "思茅区",
                        "center": {
                            "lng": 100.977069,
                            "lat": 22.786769
                        }
                    }
                ]
            },
            {
                "citycode": "0887",
                "adcode": "533400",
                "name": "迪庆藏族自治州",
                "center": {
                    "lng": 99.70211,
                    "lat": 27.819149
                },
                "districtList": [
                    {
                        "citycode": "0887",
                        "adcode": "533401",
                        "name": "香格里拉市",
                        "center": {
                            "lng": 99.743582,
                            "lat": 27.842185
                        }
                    },
                    {
                        "citycode": "0887",
                        "adcode": "533422",
                        "name": "德钦县",
                        "center": {
                            "lng": 98.917851,
                            "lat": 28.464213
                        }
                    },
                    {
                        "citycode": "0887",
                        "adcode": "533423",
                        "name": "维西傈僳族自治县",
                        "center": {
                            "lng": 99.300937,
                            "lat": 27.163808
                        }
                    }
                ]
            },
            {
                "citycode": "0878",
                "adcode": "532300",
                "name": "楚雄彝族自治州",
                "center": {
                    "lng": 101.528304,
                    "lat": 25.045678
                },
                "districtList": [
                    {
                        "citycode": "0878",
                        "adcode": "532326",
                        "name": "大姚县",
                        "center": {
                            "lng": 101.336576,
                            "lat": 25.729551
                        }
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532328",
                        "name": "元谋县",
                        "center": {
                            "lng": 101.87434,
                            "lat": 25.704499
                        }
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532325",
                        "name": "姚安县",
                        "center": {
                            "lng": 101.241632,
                            "lat": 25.504287
                        }
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532323",
                        "name": "牟定县",
                        "center": {
                            "lng": 101.546898,
                            "lat": 25.312939
                        }
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532301",
                        "name": "楚雄市",
                        "center": {
                            "lng": 101.546242,
                            "lat": 25.032945
                        }
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532302",
                        "name": "禄丰市",
                        "center": {
                            "lng": 102.079082,
                            "lat": 25.151061
                        }
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532322",
                        "name": "双柏县",
                        "center": {
                            "lng": 101.642369,
                            "lat": 24.688814
                        }
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532329",
                        "name": "武定县",
                        "center": {
                            "lng": 102.403949,
                            "lat": 25.530731
                        }
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532327",
                        "name": "永仁县",
                        "center": {
                            "lng": 101.666795,
                            "lat": 26.049522
                        }
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532324",
                        "name": "南华县",
                        "center": {
                            "lng": 101.283236,
                            "lat": 25.200163
                        }
                    }
                ]
            },
            {
                "citycode": "0871",
                "adcode": "530100",
                "name": "昆明市",
                "center": {
                    "lng": 102.833669,
                    "lat": 24.88149
                },
                "districtList": [
                    {
                        "citycode": "0871",
                        "adcode": "530113",
                        "name": "东川区",
                        "center": {
                            "lng": 103.187825,
                            "lat": 26.082997
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530129",
                        "name": "寻甸回族彝族自治县",
                        "center": {
                            "lng": 103.256559,
                            "lat": 25.558163
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530102",
                        "name": "五华区",
                        "center": {
                            "lng": 102.707262,
                            "lat": 25.043635
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530125",
                        "name": "宜良县",
                        "center": {
                            "lng": 103.141674,
                            "lat": 24.91983
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530115",
                        "name": "晋宁区",
                        "center": {
                            "lng": 102.595325,
                            "lat": 24.669077
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530112",
                        "name": "西山区",
                        "center": {
                            "lng": 102.664426,
                            "lat": 25.038039
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530124",
                        "name": "富民县",
                        "center": {
                            "lng": 102.497722,
                            "lat": 25.221924
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530181",
                        "name": "安宁市",
                        "center": {
                            "lng": 102.47865,
                            "lat": 24.919831
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530127",
                        "name": "嵩明县",
                        "center": {
                            "lng": 103.043384,
                            "lat": 25.327273
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530111",
                        "name": "官渡区",
                        "center": {
                            "lng": 102.748888,
                            "lat": 24.950285
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530114",
                        "name": "呈贡区",
                        "center": {
                            "lng": 102.822104,
                            "lat": 24.885738
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530128",
                        "name": "禄劝彝族苗族自治县",
                        "center": {
                            "lng": 102.471993,
                            "lat": 25.551768
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530103",
                        "name": "盘龙区",
                        "center": {
                            "lng": 102.751643,
                            "lat": 25.116512
                        }
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530126",
                        "name": "石林彝族自治县",
                        "center": {
                            "lng": 103.290536,
                            "lat": 24.771761
                        }
                    }
                ]
            },
            {
                "citycode": "0692",
                "adcode": "533100",
                "name": "德宏傣族景颇族自治州",
                "center": {
                    "lng": 98.585621,
                    "lat": 24.433146
                },
                "districtList": [
                    {
                        "citycode": "0692",
                        "adcode": "533122",
                        "name": "梁河县",
                        "center": {
                            "lng": 98.296584,
                            "lat": 24.804275
                        }
                    },
                    {
                        "citycode": "0692",
                        "adcode": "533103",
                        "name": "芒市",
                        "center": {
                            "lng": 98.58809,
                            "lat": 24.433766
                        }
                    },
                    {
                        "citycode": "0692",
                        "adcode": "533123",
                        "name": "盈江县",
                        "center": {
                            "lng": 97.943474,
                            "lat": 24.691325
                        }
                    },
                    {
                        "citycode": "0692",
                        "adcode": "533124",
                        "name": "陇川县",
                        "center": {
                            "lng": 97.793359,
                            "lat": 24.182347
                        }
                    },
                    {
                        "citycode": "0692",
                        "adcode": "533102",
                        "name": "瑞丽市",
                        "center": {
                            "lng": 97.855423,
                            "lat": 24.018377
                        }
                    }
                ]
            },
            {
                "citycode": "0883",
                "adcode": "530900",
                "name": "临沧市",
                "center": {
                    "lng": 100.088837,
                    "lat": 23.884175
                },
                "districtList": [
                    {
                        "citycode": "0883",
                        "adcode": "530921",
                        "name": "凤庆县",
                        "center": {
                            "lng": 99.92873,
                            "lat": 24.580559
                        }
                    },
                    {
                        "citycode": "0883",
                        "adcode": "530922",
                        "name": "云县",
                        "center": {
                            "lng": 100.1303,
                            "lat": 24.444461
                        }
                    },
                    {
                        "citycode": "0883",
                        "adcode": "530902",
                        "name": "临翔区",
                        "center": {
                            "lng": 100.082073,
                            "lat": 23.895298
                        }
                    },
                    {
                        "citycode": "0883",
                        "adcode": "530926",
                        "name": "耿马傣族佤族自治县",
                        "center": {
                            "lng": 99.397126,
                            "lat": 23.538092
                        }
                    },
                    {
                        "citycode": "0883",
                        "adcode": "530925",
                        "name": "双江拉祜族佤族布朗族傣族自治县",
                        "center": {
                            "lng": 99.828225,
                            "lat": 23.472719
                        }
                    },
                    {
                        "citycode": "0883",
                        "adcode": "530927",
                        "name": "沧源佤族自治县",
                        "center": {
                            "lng": 99.245894,
                            "lat": 23.146758
                        }
                    },
                    {
                        "citycode": "0883",
                        "adcode": "530924",
                        "name": "镇康县",
                        "center": {
                            "lng": 98.825389,
                            "lat": 23.762886
                        }
                    },
                    {
                        "citycode": "0883",
                        "adcode": "530923",
                        "name": "永德县",
                        "center": {
                            "lng": 99.258702,
                            "lat": 24.018463
                        }
                    }
                ]
            },
            {
                "citycode": "0875",
                "adcode": "530500",
                "name": "保山市",
                "center": {
                    "lng": 99.161489,
                    "lat": 25.112018
                },
                "districtList": [
                    {
                        "citycode": "0875",
                        "adcode": "530581",
                        "name": "腾冲市",
                        "center": {
                            "lng": 98.490276,
                            "lat": 25.020283
                        }
                    },
                    {
                        "citycode": "0875",
                        "adcode": "530502",
                        "name": "隆阳区",
                        "center": {
                            "lng": 99.165638,
                            "lat": 25.121137
                        }
                    },
                    {
                        "citycode": "0875",
                        "adcode": "530521",
                        "name": "施甸县",
                        "center": {
                            "lng": 99.18919,
                            "lat": 24.723084
                        }
                    },
                    {
                        "citycode": "0875",
                        "adcode": "530523",
                        "name": "龙陵县",
                        "center": {
                            "lng": 98.68941,
                            "lat": 24.586703
                        }
                    },
                    {
                        "citycode": "0875",
                        "adcode": "530524",
                        "name": "昌宁县",
                        "center": {
                            "lng": 99.605105,
                            "lat": 24.827739
                        }
                    }
                ]
            },
            {
                "citycode": "0888",
                "adcode": "530700",
                "name": "丽江市",
                "center": {
                    "lng": 100.225936,
                    "lat": 26.855165
                },
                "districtList": [
                    {
                        "citycode": "0888",
                        "adcode": "530724",
                        "name": "宁蒗彝族自治县",
                        "center": {
                            "lng": 100.851083,
                            "lat": 27.282207
                        }
                    },
                    {
                        "citycode": "0888",
                        "adcode": "530722",
                        "name": "永胜县",
                        "center": {
                            "lng": 100.750907,
                            "lat": 26.684215
                        }
                    },
                    {
                        "citycode": "0888",
                        "adcode": "530702",
                        "name": "古城区",
                        "center": {
                            "lng": 100.22583,
                            "lat": 26.876468
                        }
                    },
                    {
                        "citycode": "0888",
                        "adcode": "530721",
                        "name": "玉龙纳西族自治县",
                        "center": {
                            "lng": 100.236967,
                            "lat": 26.821494
                        }
                    },
                    {
                        "citycode": "0888",
                        "adcode": "530723",
                        "name": "华坪县",
                        "center": {
                            "lng": 101.265373,
                            "lat": 26.629598
                        }
                    }
                ]
            },
            {
                "citycode": "0876",
                "adcode": "532600",
                "name": "文山壮族苗族自治州",
                "center": {
                    "lng": 104.21567,
                    "lat": 23.400983
                },
                "districtList": [
                    {
                        "citycode": "0876",
                        "adcode": "532627",
                        "name": "广南县",
                        "center": {
                            "lng": 105.055075,
                            "lat": 24.046378
                        }
                    },
                    {
                        "citycode": "0876",
                        "adcode": "532626",
                        "name": "丘北县",
                        "center": {
                            "lng": 104.166713,
                            "lat": 24.05064
                        }
                    },
                    {
                        "citycode": "0876",
                        "adcode": "532622",
                        "name": "砚山县",
                        "center": {
                            "lng": 104.336905,
                            "lat": 23.605075
                        }
                    },
                    {
                        "citycode": "0876",
                        "adcode": "532601",
                        "name": "文山市",
                        "center": {
                            "lng": 104.233237,
                            "lat": 23.38683
                        }
                    },
                    {
                        "citycode": "0876",
                        "adcode": "532624",
                        "name": "麻栗坡县",
                        "center": {
                            "lng": 104.702732,
                            "lat": 23.125837
                        }
                    },
                    {
                        "citycode": "0876",
                        "adcode": "532623",
                        "name": "西畴县",
                        "center": {
                            "lng": 104.671802,
                            "lat": 23.437707
                        }
                    },
                    {
                        "citycode": "0876",
                        "adcode": "532625",
                        "name": "马关县",
                        "center": {
                            "lng": 104.394524,
                            "lat": 23.013108
                        }
                    },
                    {
                        "citycode": "0876",
                        "adcode": "532628",
                        "name": "富宁县",
                        "center": {
                            "lng": 105.630921,
                            "lat": 23.625072
                        }
                    }
                ]
            },
            {
                "citycode": "0691",
                "adcode": "532800",
                "name": "西双版纳傣族自治州",
                "center": {
                    "lng": 100.797002,
                    "lat": 22.009037
                },
                "districtList": [
                    {
                        "citycode": "0691",
                        "adcode": "532822",
                        "name": "勐海县",
                        "center": {
                            "lng": 100.452444,
                            "lat": 21.957323
                        }
                    },
                    {
                        "citycode": "0691",
                        "adcode": "532823",
                        "name": "勐腊县",
                        "center": {
                            "lng": 101.564635,
                            "lat": 21.459233
                        }
                    },
                    {
                        "citycode": "0691",
                        "adcode": "532801",
                        "name": "景洪市",
                        "center": {
                            "lng": 100.799595,
                            "lat": 22.011792
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": [],
        "adcode": "360000",
        "name": "江西省",
        "center": {
            "lng": 115.816587,
            "lat": 28.637234
        },
        "districtList": [
            {
                "citycode": "0790",
                "adcode": "360500",
                "name": "新余市",
                "center": {
                    "lng": 114.916665,
                    "lat": 27.818553
                },
                "districtList": [
                    {
                        "citycode": "0790",
                        "adcode": "360502",
                        "name": "渝水区",
                        "center": {
                            "lng": 114.944499,
                            "lat": 27.799526
                        }
                    },
                    {
                        "citycode": "0790",
                        "adcode": "360521",
                        "name": "分宜县",
                        "center": {
                            "lng": 114.69264,
                            "lat": 27.814723
                        }
                    }
                ]
            },
            {
                "citycode": "0791",
                "adcode": "360100",
                "name": "南昌市",
                "center": {
                    "lng": 115.857972,
                    "lat": 28.682976
                },
                "districtList": [
                    {
                        "citycode": "0791",
                        "adcode": "360104",
                        "name": "青云谱区",
                        "center": {
                            "lng": 115.925709,
                            "lat": 28.62182
                        }
                    },
                    {
                        "citycode": "0791",
                        "adcode": "360111",
                        "name": "青山湖区",
                        "center": {
                            "lng": 115.962138,
                            "lat": 28.682867
                        }
                    },
                    {
                        "citycode": "0791",
                        "adcode": "360124",
                        "name": "进贤县",
                        "center": {
                            "lng": 116.242468,
                            "lat": 28.377627
                        }
                    },
                    {
                        "citycode": "0791",
                        "adcode": "360102",
                        "name": "东湖区",
                        "center": {
                            "lng": 115.903576,
                            "lat": 28.698787
                        }
                    },
                    {
                        "citycode": "0791",
                        "adcode": "360113",
                        "name": "红谷滩区",
                        "center": {
                            "lng": 115.858127,
                            "lat": 28.698188
                        }
                    },
                    {
                        "citycode": "0791",
                        "adcode": "360112",
                        "name": "新建区",
                        "center": {
                            "lng": 115.815244,
                            "lat": 28.693192
                        }
                    },
                    {
                        "citycode": "0791",
                        "adcode": "360123",
                        "name": "安义县",
                        "center": {
                            "lng": 115.549158,
                            "lat": 28.845585
                        }
                    },
                    {
                        "citycode": "0791",
                        "adcode": "360121",
                        "name": "南昌县",
                        "center": {
                            "lng": 115.93349,
                            "lat": 28.557921
                        }
                    },
                    {
                        "citycode": "0791",
                        "adcode": "360103",
                        "name": "西湖区",
                        "center": {
                            "lng": 115.876998,
                            "lat": 28.657005
                        }
                    }
                ]
            },
            {
                "citycode": "0796",
                "adcode": "360800",
                "name": "吉安市",
                "center": {
                    "lng": 114.96681,
                    "lat": 27.091243
                },
                "districtList": [
                    {
                        "citycode": "0796",
                        "adcode": "360822",
                        "name": "吉水县",
                        "center": {
                            "lng": 115.135963,
                            "lat": 27.229697
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360825",
                        "name": "永丰县",
                        "center": {
                            "lng": 115.421599,
                            "lat": 27.317301
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360802",
                        "name": "吉州区",
                        "center": {
                            "lng": 114.994991,
                            "lat": 27.144204
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360828",
                        "name": "万安县",
                        "center": {
                            "lng": 114.759746,
                            "lat": 26.456821
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360830",
                        "name": "永新县",
                        "center": {
                            "lng": 114.242425,
                            "lat": 26.945157
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360823",
                        "name": "峡江县",
                        "center": {
                            "lng": 115.316567,
                            "lat": 27.5829
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360881",
                        "name": "井冈山市",
                        "center": {
                            "lng": 114.289563,
                            "lat": 26.748132
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360824",
                        "name": "新干县",
                        "center": {
                            "lng": 115.386853,
                            "lat": 27.740368
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360821",
                        "name": "吉安县",
                        "center": {
                            "lng": 114.908337,
                            "lat": 27.039866
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360827",
                        "name": "遂川县",
                        "center": {
                            "lng": 114.520825,
                            "lat": 26.313413
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360803",
                        "name": "青原区",
                        "center": {
                            "lng": 115.014836,
                            "lat": 27.082012
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360826",
                        "name": "泰和县",
                        "center": {
                            "lng": 114.922987,
                            "lat": 26.801687
                        }
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360829",
                        "name": "安福县",
                        "center": {
                            "lng": 114.619818,
                            "lat": 27.393286
                        }
                    }
                ]
            },
            {
                "citycode": "0795",
                "adcode": "360900",
                "name": "宜春市",
                "center": {
                    "lng": 114.416826,
                    "lat": 27.816245
                },
                "districtList": [
                    {
                        "citycode": "0795",
                        "adcode": "360981",
                        "name": "丰城市",
                        "center": {
                            "lng": 115.771131,
                            "lat": 28.160053
                        }
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360926",
                        "name": "铜鼓县",
                        "center": {
                            "lng": 114.354623,
                            "lat": 28.513291
                        }
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360922",
                        "name": "万载县",
                        "center": {
                            "lng": 114.445477,
                            "lat": 28.106201
                        }
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360902",
                        "name": "袁州区",
                        "center": {
                            "lng": 114.42794,
                            "lat": 27.796344
                        }
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360921",
                        "name": "奉新县",
                        "center": {
                            "lng": 115.400624,
                            "lat": 28.688254
                        }
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360983",
                        "name": "高安市",
                        "center": {
                            "lng": 115.366863,
                            "lat": 28.448054
                        }
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360982",
                        "name": "樟树市",
                        "center": {
                            "lng": 115.546174,
                            "lat": 28.054632
                        }
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360925",
                        "name": "靖安县",
                        "center": {
                            "lng": 115.362635,
                            "lat": 28.861296
                        }
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360924",
                        "name": "宜丰县",
                        "center": {
                            "lng": 114.803036,
                            "lat": 28.394466
                        }
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360923",
                        "name": "上高县",
                        "center": {
                            "lng": 114.948045,
                            "lat": 28.238591
                        }
                    }
                ]
            },
            {
                "citycode": "0797",
                "adcode": "360700",
                "name": "赣州市",
                "center": {
                    "lng": 114.933494,
                    "lat": 25.831139
                },
                "districtList": [
                    {
                        "citycode": "0797",
                        "adcode": "360735",
                        "name": "石城县",
                        "center": {
                            "lng": 116.347611,
                            "lat": 26.31491
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360730",
                        "name": "宁都县",
                        "center": {
                            "lng": 116.009171,
                            "lat": 26.470865
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360731",
                        "name": "于都县",
                        "center": {
                            "lng": 115.415145,
                            "lat": 25.952564
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360781",
                        "name": "瑞金市",
                        "center": {
                            "lng": 116.027114,
                            "lat": 25.88623
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360725",
                        "name": "崇义县",
                        "center": {
                            "lng": 114.308135,
                            "lat": 25.682278
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360734",
                        "name": "寻乌县",
                        "center": {
                            "lng": 115.638534,
                            "lat": 24.969513
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360729",
                        "name": "全南县",
                        "center": {
                            "lng": 114.530148,
                            "lat": 24.742353
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360783",
                        "name": "龙南市",
                        "center": {
                            "lng": 114.804474,
                            "lat": 24.901216
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360726",
                        "name": "安远县",
                        "center": {
                            "lng": 115.393992,
                            "lat": 25.136855
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360733",
                        "name": "会昌县",
                        "center": {
                            "lng": 115.809271,
                            "lat": 25.58734
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360722",
                        "name": "信丰县",
                        "center": {
                            "lng": 114.922485,
                            "lat": 25.38676
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360704",
                        "name": "赣县区",
                        "center": {
                            "lng": 115.021196,
                            "lat": 25.854496
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360728",
                        "name": "定南县",
                        "center": {
                            "lng": 115.027908,
                            "lat": 24.783372
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360724",
                        "name": "上犹县",
                        "center": {
                            "lng": 114.55177,
                            "lat": 25.784754
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360702",
                        "name": "章贡区",
                        "center": {
                            "lng": 114.920426,
                            "lat": 25.818247
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360723",
                        "name": "大余县",
                        "center": {
                            "lng": 114.362306,
                            "lat": 25.401968
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360703",
                        "name": "南康区",
                        "center": {
                            "lng": 114.765044,
                            "lat": 25.661369
                        }
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360732",
                        "name": "兴国县",
                        "center": {
                            "lng": 115.363475,
                            "lat": 26.338129
                        }
                    }
                ]
            },
            {
                "citycode": "0798",
                "adcode": "360200",
                "name": "景德镇市",
                "center": {
                    "lng": 117.184892,
                    "lat": 29.2744
                },
                "districtList": [
                    {
                        "citycode": "0798",
                        "adcode": "360222",
                        "name": "浮梁县",
                        "center": {
                            "lng": 117.214984,
                            "lat": 29.352493
                        }
                    },
                    {
                        "citycode": "0798",
                        "adcode": "360202",
                        "name": "昌江区",
                        "center": {
                            "lng": 117.182648,
                            "lat": 29.273683
                        }
                    },
                    {
                        "citycode": "0798",
                        "adcode": "360203",
                        "name": "珠山区",
                        "center": {
                            "lng": 117.271365,
                            "lat": 29.305191
                        }
                    },
                    {
                        "citycode": "0798",
                        "adcode": "360281",
                        "name": "乐平市",
                        "center": {
                            "lng": 117.151499,
                            "lat": 28.978521
                        }
                    }
                ]
            },
            {
                "citycode": "0793",
                "adcode": "361100",
                "name": "上饶市",
                "center": {
                    "lng": 117.943064,
                    "lat": 28.45513
                },
                "districtList": [
                    {
                        "citycode": "0793",
                        "adcode": "361130",
                        "name": "婺源县",
                        "center": {
                            "lng": 117.861532,
                            "lat": 29.248491
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361125",
                        "name": "横峰县",
                        "center": {
                            "lng": 117.596433,
                            "lat": 28.407116
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361123",
                        "name": "玉山县",
                        "center": {
                            "lng": 118.244736,
                            "lat": 28.681936
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361181",
                        "name": "德兴市",
                        "center": {
                            "lng": 117.594549,
                            "lat": 28.930557
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361124",
                        "name": "铅山县",
                        "center": {
                            "lng": 117.734742,
                            "lat": 28.298415
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361103",
                        "name": "广丰区",
                        "center": {
                            "lng": 118.189729,
                            "lat": 28.463697
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361126",
                        "name": "弋阳县",
                        "center": {
                            "lng": 117.449346,
                            "lat": 28.378039
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361127",
                        "name": "余干县",
                        "center": {
                            "lng": 116.695787,
                            "lat": 28.70283
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361104",
                        "name": "广信区",
                        "center": {
                            "lng": 117.907454,
                            "lat": 28.448893
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361102",
                        "name": "信州区",
                        "center": {
                            "lng": 117.965997,
                            "lat": 28.430694
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361129",
                        "name": "万年县",
                        "center": {
                            "lng": 117.058445,
                            "lat": 28.694582
                        }
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361128",
                        "name": "鄱阳县",
                        "center": {
                            "lng": 116.703731,
                            "lat": 29.005675
                        }
                    }
                ]
            },
            {
                "citycode": "0799",
                "adcode": "360300",
                "name": "萍乡市",
                "center": {
                    "lng": 113.887147,
                    "lat": 27.658721
                },
                "districtList": [
                    {
                        "citycode": "0799",
                        "adcode": "360302",
                        "name": "安源区",
                        "center": {
                            "lng": 113.87072,
                            "lat": 27.615
                        }
                    },
                    {
                        "citycode": "0799",
                        "adcode": "360321",
                        "name": "莲花县",
                        "center": {
                            "lng": 113.961589,
                            "lat": 27.128498
                        }
                    },
                    {
                        "citycode": "0799",
                        "adcode": "360322",
                        "name": "上栗县",
                        "center": {
                            "lng": 113.795294,
                            "lat": 27.880221
                        }
                    },
                    {
                        "citycode": "0799",
                        "adcode": "360323",
                        "name": "芦溪县",
                        "center": {
                            "lng": 114.029351,
                            "lat": 27.631273
                        }
                    },
                    {
                        "citycode": "0799",
                        "adcode": "360313",
                        "name": "湘东区",
                        "center": {
                            "lng": 113.733047,
                            "lat": 27.640075
                        }
                    }
                ]
            },
            {
                "citycode": "0792",
                "adcode": "360400",
                "name": "九江市",
                "center": {
                    "lng": 115.95356,
                    "lat": 29.66116
                },
                "districtList": [
                    {
                        "citycode": "0792",
                        "adcode": "360404",
                        "name": "柴桑区",
                        "center": {
                            "lng": 115.911005,
                            "lat": 29.608775
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360483",
                        "name": "庐山市",
                        "center": {
                            "lng": 116.045118,
                            "lat": 29.448225
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360402",
                        "name": "濂溪区",
                        "center": {
                            "lng": 115.992735,
                            "lat": 29.668008
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360428",
                        "name": "都昌县",
                        "center": {
                            "lng": 116.203999,
                            "lat": 29.273803
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360426",
                        "name": "德安县",
                        "center": {
                            "lng": 115.767114,
                            "lat": 29.298599
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360403",
                        "name": "浔阳区",
                        "center": {
                            "lng": 116.001677,
                            "lat": 29.70547
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360423",
                        "name": "武宁县",
                        "center": {
                            "lng": 115.092649,
                            "lat": 29.246785
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360424",
                        "name": "修水县",
                        "center": {
                            "lng": 114.546536,
                            "lat": 29.026166
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360430",
                        "name": "彭泽县",
                        "center": {
                            "lng": 116.563858,
                            "lat": 29.877404
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360429",
                        "name": "湖口县",
                        "center": {
                            "lng": 116.252206,
                            "lat": 29.731194
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360482",
                        "name": "共青城市",
                        "center": {
                            "lng": 115.784269,
                            "lat": 29.235082
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360425",
                        "name": "永修县",
                        "center": {
                            "lng": 115.83207,
                            "lat": 29.011392
                        }
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360481",
                        "name": "瑞昌市",
                        "center": {
                            "lng": 115.681221,
                            "lat": 29.676026
                        }
                    }
                ]
            },
            {
                "citycode": "0794",
                "adcode": "361000",
                "name": "抚州市",
                "center": {
                    "lng": 116.358054,
                    "lat": 27.948979
                },
                "districtList": [
                    {
                        "citycode": "0794",
                        "adcode": "361025",
                        "name": "乐安县",
                        "center": {
                            "lng": 115.83099,
                            "lat": 27.428682
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361024",
                        "name": "崇仁县",
                        "center": {
                            "lng": 116.076363,
                            "lat": 27.754416
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361028",
                        "name": "资溪县",
                        "center": {
                            "lng": 117.060332,
                            "lat": 27.706088
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361021",
                        "name": "南城县",
                        "center": {
                            "lng": 116.637228,
                            "lat": 27.570031
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361030",
                        "name": "广昌县",
                        "center": {
                            "lng": 116.336556,
                            "lat": 26.843974
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361027",
                        "name": "金溪县",
                        "center": {
                            "lng": 116.755018,
                            "lat": 27.91973
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361026",
                        "name": "宜黄县",
                        "center": {
                            "lng": 116.236174,
                            "lat": 27.554744
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361023",
                        "name": "南丰县",
                        "center": {
                            "lng": 116.525898,
                            "lat": 27.21845
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361022",
                        "name": "黎川县",
                        "center": {
                            "lng": 116.907446,
                            "lat": 27.282729
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361003",
                        "name": "东乡区",
                        "center": {
                            "lng": 116.603159,
                            "lat": 28.249059
                        }
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361002",
                        "name": "临川区",
                        "center": {
                            "lng": 116.311932,
                            "lat": 27.935098
                        }
                    }
                ]
            },
            {
                "citycode": "0701",
                "adcode": "360600",
                "name": "鹰潭市",
                "center": {
                    "lng": 117.039532,
                    "lat": 28.272092
                },
                "districtList": [
                    {
                        "citycode": "0701",
                        "adcode": "360602",
                        "name": "月湖区",
                        "center": {
                            "lng": 117.10247,
                            "lat": 28.266999
                        }
                    },
                    {
                        "citycode": "0701",
                        "adcode": "360681",
                        "name": "贵溪市",
                        "center": {
                            "lng": 117.245178,
                            "lat": 28.292397
                        }
                    },
                    {
                        "citycode": "0701",
                        "adcode": "360603",
                        "name": "余江区",
                        "center": {
                            "lng": 116.854576,
                            "lat": 28.199657
                        }
                    }
                ]
            }
        ]
    },
    {
        "citycode": "010",
        "adcode": "110000",
        "name": "北京市",
        "center": {
            "lng": 116.407387,
            "lat": 39.904179
        },
        "districtList": [
            {
                "citycode": "010",
                "adcode": "110100",
                "name": "北京城区",
                "center": {
                    "lng": 116.405285,
                    "lat": 39.904989
                },
                "districtList": [
                    {
                        "citycode": "010",
                        "adcode": "110116",
                        "name": "怀柔区",
                        "center": {
                            "lng": 116.631974,
                            "lat": 40.317003
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110109",
                        "name": "门头沟区",
                        "center": {
                            "lng": 116.101668,
                            "lat": 39.940842
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110117",
                        "name": "平谷区",
                        "center": {
                            "lng": 117.121589,
                            "lat": 40.140805
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110118",
                        "name": "密云区",
                        "center": {
                            "lng": 116.843351,
                            "lat": 40.377058
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110107",
                        "name": "石景山区",
                        "center": {
                            "lng": 116.223015,
                            "lat": 39.906304
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110102",
                        "name": "西城区",
                        "center": {
                            "lng": 116.36585,
                            "lat": 39.9126
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110108",
                        "name": "海淀区",
                        "center": {
                            "lng": 116.2977,
                            "lat": 39.959893
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110113",
                        "name": "顺义区",
                        "center": {
                            "lng": 116.661474,
                            "lat": 40.149891
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110114",
                        "name": "昌平区",
                        "center": {
                            "lng": 116.231034,
                            "lat": 40.220952
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110119",
                        "name": "延庆区",
                        "center": {
                            "lng": 115.974609,
                            "lat": 40.457033
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110111",
                        "name": "房山区",
                        "center": {
                            "lng": 116.143426,
                            "lat": 39.748889
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110105",
                        "name": "朝阳区",
                        "center": {
                            "lng": 116.443136,
                            "lat": 39.921444
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110106",
                        "name": "丰台区",
                        "center": {
                            "lng": 116.286726,
                            "lat": 39.858538
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110101",
                        "name": "东城区",
                        "center": {
                            "lng": 116.416334,
                            "lat": 39.928359
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110115",
                        "name": "大兴区",
                        "center": {
                            "lng": 116.341483,
                            "lat": 39.726917
                        }
                    },
                    {
                        "citycode": "010",
                        "adcode": "110112",
                        "name": "通州区",
                        "center": {
                            "lng": 116.72923,
                            "lat": 39.916403
                        }
                    }
                ]
            }
        ]
    }
]
export default city;


// WEBPACK FOOTER //
// ./src/util/province/china.js